/* OPLA MVP — front-end statique connecté à Supabase */
(() => {
  "use strict";

  const config = window.OPLA_CONFIG || {};
  const configured = Boolean(config.supabaseUrl && config.supabaseAnonKey);
  const setupScreen = document.querySelector("#setup-screen");
  const authScreen = document.querySelector("#auth-screen");
  const appShell = document.querySelector("#app");
  const content = document.querySelector("#content");
  const topbarActions = document.querySelector("#topbar-actions");
  const pageTitle = document.querySelector("#page-title");
  const pageKicker = document.querySelector("#page-kicker");
  const toastEl = document.querySelector("#toast");
  const modalBackdrop = document.querySelector("#modal-backdrop");
  const modalBody = document.querySelector("#modal-body");
  const modalTitle = document.querySelector("#modal-title");
  const modalKicker = document.querySelector("#modal-kicker");
  const drawerBackdrop = document.querySelector("#drawer-backdrop");
  const drawerBody = document.querySelector("#drawer-body");
  const drawerTitle = document.querySelector("#drawer-title");
  const drawerKicker = document.querySelector("#drawer-kicker");

  if (!configured) {
    setupScreen.classList.remove("hidden");
    return;
  }

  const sb = window.supabase.createClient(config.supabaseUrl, config.supabaseAnonKey);
  let session = null;
  let profile = null;
  let organization = null;
  let currentView = "dashboard";
  let accessRoles = [];

  const RESTRICTABLE_VIEWS = [
    { key: "dashboard", label: "Tableau de bord" }, { key: "tasks", label: "Tâches" },
    { key: "stock", label: "Stock Ingrédients" }, { key: "recipes", label: "Recettes" },
    { key: "productions", label: "Productions" }, { key: "calculator", label: "Calculateur de besoin" },
    { key: "finished-lots", label: "Produits finis" }, { key: "retroplanning", label: "Rétroplanning" }, { key: "movements", label: "Mouvements" }, { key: "cost-history", label: "Historique des coûts" }, { key: "clients", label: "Clients" },
    { key: "deliveries", label: "Livraisons" }, { key: "invoicing", label: "Facturation" },
    { key: "statistics", label: "Statistiques" }, { key: "supplies", label: "Fournitures" },
    { key: "packagings", label: "Conditionnements" },
    { key: "locations", label: "Paramètres · Emplacements" },
    { key: "categories", label: "Paramètres · Produits" },
    { key: "client-categories", label: "Paramètres · Clients" },
    { key: "delivery-settings", label: "Paramètres · Livraison" },
    { key: "sales-targets", label: "Paramètres · Objectifs commerciaux" },
    { key: "suppliers-settings", label: "Paramètres · Fournisseurs" }, { key: "production-settings", label: "Paramètres · Production" },
    { key: "production-constraints", label: "Paramètres · Contraintes de production" }
  ];
  const SETTINGS_VIEWS = ["locations", "categories", "client-categories", "delivery-settings", "sales-targets", "suppliers-settings", "production-settings", "production-constraints"];

  function isSuperAdmin() { return Boolean(profile?.is_super_admin); }

  // ============================================================
  // DROITS : une ligne par page (Aucun / Voir / Modifier), regroupées
  // sous des intitulés, plus deux lignes d'action (Non / Oui).
  // Doit rester identique à _perm_pages() en base (migration 105).
  //   level    : niveau accordé en base par « Modifier » / « Oui »
  //   readOnly : page consultable seulement (Aucun / Voir)
  //   action   : ligne d'action, sans page (Non / Oui)
  //   area     : partie de l'ancienne grille (conversion uniquement)
  // ============================================================
  const PERM_GROUPS = ["Pilotage", "Production", "Stock", "Produits finis", "Ventes", "Configuration"];
  const PERM_PAGES = [
    { key: "dashboard", label: "Tableau de bord", group: "Pilotage", level: null, readOnly: true, area: "dashboard" },
    { key: "tasks", label: "Tâches", desc: "Les actions suivent les droits Livraisons", group: "Pilotage", level: null, readOnly: true, area: "tasks" },
    { key: "statistics", label: "Statistiques", desc: "Modifier : créer et organiser les graphiques partagés", group: "Pilotage", level: "stats", area: "statistics" },
    { key: "productions", label: "Productions", group: "Production", level: "production", area: "productions" },
    { key: "calculator", label: "Calculateur de besoin", group: "Production", level: null, readOnly: true, area: "productions" },
    { key: "retroplanning", label: "Rétroplanning", desc: "Les réglages de prévision suivent les droits Recettes", group: "Production", level: null, readOnly: true, area: "productions" },
    { key: "stock", label: "Stock ingrédients", desc: "Réceptions et lots", group: "Stock", level: "stock", area: "stock" },
    { key: "supplies", label: "Fournitures", group: "Stock", level: "stock", area: "stock" },
    { key: "movements", label: "Mouvements", group: "Stock", level: null, readOnly: true, area: "stock" },
    { key: "stock_transfers", label: "Transférer entre emplacements", desc: "Ingrédients et fournitures", group: "Stock", level: "stock", action: true, area: "stock" },
    { key: "ingredients_catalog", label: "Créer et modifier les ingrédients", desc: "Nom, unité, allergènes, références par emplacement", group: "Stock", level: "stock", action: true, area: "stock" },
    { key: "finished-lots", label: "Produits finis", desc: "Lots, transferts, ajouts manuels, palettes", group: "Produits finis", level: "stock", area: "finished" },
    { key: "deliveries", label: "Livraisons", desc: "Et commandes récurrentes", group: "Ventes", level: "vente", area: "deliveries" },
    { key: "invoicing", label: "Facturation", group: "Ventes", level: "vente", area: "invoicing" },
    { key: "clients", label: "Clients", group: "Ventes", level: "vente", area: "clients" },
    { key: "recipes", label: "Recettes", desc: "Fiches produit, coûts, prévisions", group: "Configuration", level: "admin", area: "config" },
    { key: "packagings", label: "Conditionnements", group: "Configuration", level: "admin", area: "config" },
    { key: "categories", label: "Paramètres produits", group: "Configuration", level: "admin", area: "config" },
    { key: "suppliers-settings", label: "Fournisseurs", group: "Configuration", level: "admin", area: "config" },
    { key: "production-settings", label: "Paramètres production", group: "Configuration", level: "admin", area: "config" },
    { key: "production-constraints", label: "Contraintes de production", group: "Configuration", level: "admin", area: "config" },
    { key: "locations", label: "Emplacements", desc: "Et logisticiens", group: "Configuration", level: "admin", area: "config" },
    { key: "client-categories", label: "Paramètres clients", group: "Configuration", level: "admin", area: "config" },
    { key: "delivery-settings", label: "Paramètres livraison", group: "Configuration", level: "admin", area: "config" },
    { key: "sales-targets", label: "Objectifs commerciaux", group: "Configuration", level: "admin", area: "config" },
    { key: "cost-history", label: "Historique des coûts", group: "Configuration", level: null, readOnly: true, area: "config" }
  ];
  const PERM_RANK = { none: 0, view: 1, edit: 2 };
  // Ancienne grille par parties (migration 103), pour la conversion
  const PERM_AREA_LEGACY = {
    dashboard: { views: ["dashboard"], legacy: [], ro: true }, tasks: { views: ["tasks"], legacy: [], ro: true },
    productions: { views: ["productions", "calculator", "retroplanning"], legacy: ["production"] },
    stock: { views: ["stock", "supplies", "movements"], legacy: ["stock", "production"] },
    finished: { views: ["finished-lots"], legacy: ["stock", "production"] },
    deliveries: { views: ["deliveries"], legacy: ["vente"] }, invoicing: { views: ["invoicing"], legacy: ["vente"] },
    clients: { views: ["clients"], legacy: ["vente"] }, statistics: { views: ["statistics"], legacy: ["vente"] },
    config: { views: ["recipes", "packagings", "categories", "suppliers-settings", "production-settings", "production-constraints", "locations",
      "client-categories", "delivery-settings", "sales-targets", "cost-history"], legacy: ["admin"] }
  };
  // Rôle de l'ancien système -> grille par parties (même règle que _legacy_to_perms)
  function legacyToAreaPermissions(role) {
    const views = role?.allowed_views || [];
    const levels = role?.action_roles?.length ? role.action_roles : (role?.action_role ? [role.action_role] : []);
    const out = {};
    Object.entries(PERM_AREA_LEGACY).forEach(([area, a]) => {
      const seen = a.views.some(v => views.includes(v));
      out[area] = !seen ? "none" : (!a.ro && (a.legacy.some(l => levels.includes(l)) || levels.includes("admin"))) ? "edit" : "view";
    });
    return out;
  }
  // N'importe quel format -> grille par page (même règle que _perms_v2).
  // Une page n'est ouverte que si le rôle la voyait réellement.
  function rolePermissions(role) {
    const p = role?.permissions;
    if (p && typeof p === "object" && p._v === 2) return p;
    const areas = p && typeof p === "object" && Object.keys(p).length ? p : legacyToAreaPermissions(role);
    const views = role?.allowed_views || [];
    const out = { _v: 2 };
    PERM_PAGES.forEach(pg => {
      const a = areas[pg.area] || "none";
      if (pg.action) {
        const okFlag = pg.key === "stock_transfers" ? role?.can_transfer_stock !== false : role?.can_reference_ingredients !== false;
        const base = pg.key === "stock_transfers" ? (areas.stock === "edit" || areas.finished === "edit") : (areas.stock === "edit");
        out[pg.key] = (pg.key === "ingredients_catalog" && areas.config === "edit") || (base && okFlag) ? "edit" : "none";
        return;
      }
      let v = views.includes(pg.key) ? a : "none";
      if (pg.readOnly && v === "edit") v = "view";
      out[pg.key] = v;
    });
    return out;
  }
  // Droits effectifs : le plus élevé de tous les rôles. Super admin : tout. Sans rôle : rien.
  function computeEffectivePermissions(roles, superAdmin) {
    const out = {};
    PERM_PAGES.forEach(pg => {
      if (superAdmin) { out[pg.key] = pg.readOnly ? "view" : "edit"; return; }
      let best = "none";
      (roles || []).forEach(r => { const v = rolePermissions(r)[pg.key]; if (PERM_RANK[v] > PERM_RANK[best]) best = v; });
      if (pg.readOnly && best === "edit") best = "view";
      if (pg.action && best === "view") best = "none";
      out[pg.key] = best;
    });
    return out;
  }
  // Niveaux accordés en base (même règle que _perm_levels)
  function levelsFromPermissions(perms) {
    return [...new Set(PERM_PAGES.filter(pg => pg.level && perms[pg.key] === "edit").map(pg => pg.level))].sort();
  }
  function effectivePermissions() { return computeEffectivePermissions(accessRoles, isSuperAdmin()); }
  function pageSees(key) { return isSuperAdmin() || (effectivePermissions()[key] || "none") !== "none"; }
  function pageCan(key) { return isSuperAdmin() || effectivePermissions()[key] === "edit"; }

  function canSeeView(viewKey) {
    if (!profile) return false;
    // Chacun gère son propre compte, quels que soient ses droits
    if (viewKey === "profile") return true;
    if (viewKey === "users") return isSuperAdmin();
    if (isSuperAdmin()) return true;
    // Sans rôle : rien (plus de rôle caché « admin »). Page inconnue de la grille : fermée.
    return PERM_PAGES.some(pg => pg.key === viewKey && !pg.action) && pageSees(viewKey);
  }

  // Restriction par emplacement : liste vide = tous les emplacements
  function allowedLocationIds() {
    if (isSuperAdmin()) return null;
    // Sans rôle : aucun emplacement (plus de repli « accès à tout »)
    if (!accessRoles.length) return [];
    if (accessRoles.some(r => !(r.allowed_location_ids || []).length)) return null;
    const union = new Set();
    accessRoles.forEach(r => (r.allowed_location_ids || []).forEach(id => union.add(id)));
    return [...union];
  }

  // Résumés limités aux emplacements autorisés : une personne limitée à Nîmes
  // ne voit que les chiffres de Nîmes. Rien à faire pour qui a accès à tous.
  // (Limite de l'affichage : les lectures ne sont pas encore restreintes en base.)
  const NO_LOCATION = "00000000-0000-0000-0000-000000000000";
  function isLocationRestricted() { return Boolean(allowedLocationIds()); }
  function scopeToLocations(query, column = "location_id") {
    const allowed = allowedLocationIds();
    if (!allowed) return query;
    return query.in(column, allowed.length ? allowed : [NO_LOCATION]);
  }
  // Un mouvement concerne un emplacement s'il en part ou s'il y arrive
  function scopeMovementsToLocations(query) {
    const allowed = allowedLocationIds();
    if (!allowed) return query;
    const ids = (allowed.length ? allowed : [NO_LOCATION]).join(",");
    return query.or(`origin_location_id.in.(${ids}),destination_location_id.in.(${ids})`);
  }
  function canSeeLocation(locationId) {
    const allowed = allowedLocationIds();
    if (!allowed) return true;
    return allowed.includes(locationId);
  }

  function firstAllowedView() {
    const order = ["dashboard", "tasks", ...RESTRICTABLE_VIEWS.map(v => v.key)];
    return order.find(v => canSeeView(v)) || null;
  }

  function applyNavVisibility() {
    document.querySelectorAll(".nav-item[data-view]").forEach(btn => {
      btn.hidden = !canSeeView(btn.dataset.view);
    });
    const settingsGroup = document.querySelector(".nav-group");
    if (settingsGroup) settingsGroup.hidden = !SETTINGS_VIEWS.some(v => canSeeView(v));

    // Masque les en-têtes de section (Production, Vente, Conditionnement…)
    // quand aucun onglet visible ne suit, jusqu'au prochain en-tête/groupe.
    document.querySelectorAll(".nav-section").forEach(label => {
      let hasVisibleItem = false;
      let el = label.nextElementSibling;
      while (el && !el.classList.contains("nav-section") && !el.classList.contains("nav-group")) {
        if (el.classList.contains("nav-item") && !el.hidden) { hasVisibleItem = true; break; }
        el = el.nextElementSibling;
      }
      label.hidden = !hasVisibleItem;
    });
  }
  let toastTimer = null;
  let stockLocationKey = null;
  let stockStatusFilter = { critical: false, alert: false };
  let productionsViewMode = "kanban";
  let productionsArchiveFilter = "active";
  // Étapes système : toujours présentes, toujours à la fin. Elles
  // déclenchent quelque chose (sortie de matière, création du lot)
  // et ne peuvent donc être ni supprimées ni déplacées.
  const PRODUCTION_SYSTEM_STAGES = {
    in_progress: { label: "En cours", tone: "warning" },
    completed: { label: "Terminé", tone: "success" }
  };
  // Étapes amont, paramétrables, chargées depuis la base. Valeurs de
  // repli utilisées tant que la migration 83 n'est pas passée.
  let PRODUCTION_CUSTOM_STAGES = [
    { key: "mp_ordered", label: "MP commandée", tone: "warning", sort_order: 10 },
    { key: "mp_received", label: "MP reçue", tone: "info", sort_order: 20 },
    { key: "programmed", label: "Programmé", tone: "info", sort_order: 30 }
  ];
  const PRODUCTION_STATUSES = {};
  let PRODUCTION_STAGE_ORDER = [];

  function rebuildProductionStatuses() {
    Object.keys(PRODUCTION_STATUSES).forEach(k => delete PRODUCTION_STATUSES[k]);
    PRODUCTION_CUSTOM_STAGES.forEach(s => { PRODUCTION_STATUSES[s.key] = { label: s.label, tone: s.tone }; });
    Object.assign(PRODUCTION_STATUSES, PRODUCTION_SYSTEM_STAGES);
    PRODUCTION_STAGE_ORDER = [...PRODUCTION_CUSTOM_STAGES.map(s => s.key), "in_progress", "completed"];
  }
  rebuildProductionStatuses();


  // --- Points de contrôle à la clôture d'une production ---
  async function loadProductionCheckpoints() {
    const [{ data: cps }, { data: org }] = await Promise.all([
      sb.from("production_checkpoints").select("*").eq("organization_id", profile.organization_id).order("sort_order"),
      sb.from("organizations").select("production_checkpoints_enabled").eq("id", profile.organization_id).single()
    ]);
    return { checkpoints: cps || [], enabled: org?.production_checkpoints_enabled !== false };
  }

  const CHECKPOINT_TYPES = { datetime: "Date et heure", number: "Nombre", text: "Texte", boolean: "Oui / non" };

  function formatCheckpointValue(v) {
    if (v.value == null || v.value === "") return "—";
    if (v.field_type === "datetime") return formatDateTime(v.value);
    if (v.field_type === "number") return `${formatNumber(Number(v.value))}${v.unit ? ` ${escapeHtml(v.unit)}` : ""}`;
    if (v.field_type === "boolean") return v.value === "true" ? "Oui" : "Non";
    return escapeHtml(v.value);
  }

  // Regroupe par section en respectant l'ordre d'apparition
  function groupBySection(items) {
    const groups = new Map();
    items.forEach(it => {
      const key = it.section || "";
      if (!groups.has(key)) groups.set(key, []);
      groups.get(key).push(it);
    });
    return [...groups.entries()];
  }

  // Relevés d'une production close, tels qu'ils ont été saisis (copie figée)
  function renderCheckpointBlocks(values) {
    if (!values.length) return "";
    return groupBySection(values).map(([section, items]) => `
      <div class="detail-block">
        <div class="detail-block-title">${escapeHtml(section || "Points de contrôle")}</div>
        <div class="detail-grid">${items.map(v => `<div><small>${escapeHtml(v.label)}</small><div class="detail-value">${formatCheckpointValue(v)}</div></div>`).join("")}</div>
      </div>`).join("");
  }

  async function loadProductionStages() {
    const { data, error } = await sb.from("production_stages").select("*")
      .eq("organization_id", profile.organization_id).order("sort_order");
    // En cas d'erreur (table absente), on garde les valeurs de repli
    if (!error && data?.length) PRODUCTION_CUSTOM_STAGES = data;
    rebuildProductionStatuses();
  }

  // Libellé du bouton qui fait avancer une production depuis une étape amont
  function nextStageLabel(status) {
    const idx = PRODUCTION_CUSTOM_STAGES.findIndex(s => s.key === status);
    if (idx < 0) return null;
    const next = PRODUCTION_CUSTOM_STAGES[idx + 1];
    return next ? `Passer à « ${next.label} »` : "Démarrer la production (sort la matière du stock)";
  }
  // Bouton d'avancement, au même format que les autres actions des cartes
  function advanceStageButton(prodId, status) {
    const label = nextStageLabel(status);
    if (!label) return "";
    return `<button class="icon-button icon-small advance-stage" data-id="${prodId}" title="${escapeHtml(label)}">${ICONS.arrowRight}</button>`;
  }

  function productionReached(status, minimum) {
    const a = PRODUCTION_STAGE_ORDER.indexOf(status);
    const b = PRODUCTION_STAGE_ORDER.indexOf(minimum);
    return a >= 0 && b >= 0 && a >= b;
  }

  const views = {
    dashboard: { title: "Tableau de bord", kicker: "Vue générale", render: renderDashboard },
    tasks: { title: "Tâches", kicker: "Rappels de livraison", render: renderTasks },
    stock: { title: "Stock Ingrédients", kicker: "Ingrédients, entrées, DLC et FIFO", render: renderStock },
    recipes: { title: "Recettes", kicker: "Référentiel", render: renderRecipes },
    productions: { title: "Productions", kicker: "Fabrication et traçabilité", render: renderProductions },
    calculator: { title: "Calculateur de besoin", kicker: "Ingrédients & fournitures", render: renderCalculator },
    "finished-lots": { title: "Produits finis", kicker: "Par emplacement", render: renderFinishedLots },
    retroplanning: { title: "Rétroplanning", kicker: "Prévisionnel et plan de production", render: renderRetroplanning },
    "cost-history": { title: "Historique des coûts", kicker: "Qui a modifié quoi, et quand", render: renderCostHistory },
    movements: { title: "Mouvements", kicker: "Ventes, transferts, pertes, échantillons", render: renderMovements },
    "production-settings": { title: "Paramètres production", kicker: "Étapes et relances", render: renderProductionSettings },
    "suppliers-settings": { title: "Fournisseurs", kicker: "Paramètres — jours de livraison et deadlines", render: renderSuppliersSettings },
    "production-constraints": { title: "Contraintes de production", kicker: "Paramètres — retroplanning", render: renderProductionConstraints },
    clients: { title: "Clients", kicker: "Répertoire commercial", render: renderClients },
    deliveries: { title: "Livraisons", kicker: "Sorties de stock", render: renderDeliveries },
    invoicing: { title: "Facturation", kicker: "Suivi des paiements", render: renderInvoicing },
    supplies: { title: "Fournitures", kicker: "Emballages, moules, cartons…", render: renderSupplies },
    packagings: { title: "Conditionnements", kicker: "Composés de fournitures", render: renderPackagings },
    locations: { title: "Emplacements", kicker: "Paramètres", render: renderLocations },
    categories: { title: "Paramètres produits", kicker: "Paramètres", render: renderCategories },
    "client-categories": { title: "Paramètres clients", kicker: "Paramètres", render: renderClientCategories },
    "delivery-settings": { title: "Paramètres livraison", kicker: "Paramètres", render: renderDeliverySettings },
    "sales-targets": { title: "Objectifs commerciaux", kicker: "Paramètres", render: renderSalesTargets },
    users: { title: "Utilisateurs", kicker: "Accès et rôles", render: renderUsers },
    profile: { title: "Mon profil", kicker: "Compte", render: renderProfile },
    statistics: { title: "Statistiques", kicker: "Rapports personnalisés", render: renderStatistics }
  };

  function escapeHtml(value) {
    return String(value ?? "")
      .replaceAll("&", "&amp;")
      .replaceAll("<", "&lt;")
      .replaceAll(">", "&gt;")
      .replaceAll('"', "&quot;")
      .replaceAll("'", "&#039;");
  }

  function formatDate(value) {
    if (!value) return "—";
    return new Intl.DateTimeFormat("fr-FR").format(new Date(`${value}T12:00:00`));
  }

  function formatDateTime(value) {
    if (!value) return "—";
    return new Intl.DateTimeFormat("fr-FR", { dateStyle: "short", timeStyle: "short" }).format(new Date(value));
  }

  function formatNumber(value, digits = 2) {
    const number = Number(value || 0);
    return new Intl.NumberFormat("fr-FR", { maximumFractionDigits: digits }).format(number);
  }

  function formatMoney(value) {
    return new Intl.NumberFormat("fr-FR", { style: "currency", currency: "EUR" }).format(Number(value || 0));
  }

  function formatMoneyRoundUp(value) {
    return new Intl.NumberFormat("fr-FR", { style: "currency", currency: "EUR", maximumFractionDigits: 0 }).format(Math.ceil(Number(value || 0)));
  }

  function todayISO() {
    return new Date().toISOString().slice(0, 10);
  }

  function plusDaysISO(days, fromDate) {
    const d = fromDate ? new Date(`${fromDate}T12:00:00`) : new Date();
    d.setDate(d.getDate() + days);
    return d.toISOString().slice(0, 10);
  }

  function subtractBusinessDaysISO(fromDate, businessDays) {
    const d = new Date(`${fromDate}T12:00:00`);
    let remaining = Number(businessDays) || 0;
    while (remaining > 0) {
      d.setDate(d.getDate() - 1);
      const day = d.getDay();
      if (day !== 0 && day !== 6) remaining -= 1;
    }
    return d.toISOString().slice(0, 10);
  }

  function slugFileName(name) {
    return String(name || "document")
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .replace(/[^a-zA-Z0-9._-]/g, "-")
      .replace(/-+/g, "-")
      .slice(-110);
  }

  const ALLERGENS_LIST = ["Gluten", "Crustacés", "Œufs", "Poissons", "Arachides", "Soja", "Lait", "Fruits à coque", "Céleri", "Moutarde", "Sésame", "Sulfites", "Lupin", "Mollusques"];

  const ICONS = {
    eye: `<svg class="action-icon" viewBox="0 0 24 24"><path d="M2 12s3.5-7 10-7 10 7 10 7-3.5 7-10 7-10-7-10-7z"/><circle cx="12" cy="12" r="3"/></svg>`,
    tag: `<svg class="action-icon" viewBox="0 0 24 24"><path d="M20.6 12.7L12.7 20.6a2 2 0 01-2.8 0l-8-8A2 2 0 011.4 11l.6-8L10 2.4a2 2 0 012.8 0l7.8 7.8a2 2 0 010 2.8z"/><circle cx="7.5" cy="7.5" r="1.2"/></svg>`,
    arrowLeft: `<svg class="action-icon" viewBox="0 0 24 24"><path d="M19 12H5M11 18l-6-6 6-6"/></svg>`,
    arrowRight: `<svg class="action-icon" viewBox="0 0 24 24"><path d="M5 12h14M13 6l6 6-6 6"/></svg>`,
    sheet: `<svg class="action-icon" viewBox="0 0 24 24"><rect x="5" y="3" width="14" height="18" rx="2"/><path d="M9 3v2h6V3M8.5 10h7M8.5 14h7M8.5 18h4"/></svg>`,
    play: `<svg class="action-icon" viewBox="0 0 24 24"><path d="M7 5l12 7-12 7z"/></svg>`,
    check: `<svg class="action-icon" viewBox="0 0 24 24"><path d="M20 6L9 17l-5-5"/></svg>`,
    archive: `<svg class="action-icon" viewBox="0 0 24 24"><rect x="3" y="4" width="18" height="4" rx="1"/><path d="M5 8v10a2 2 0 002 2h10a2 2 0 002-2V8M10 13h4"/></svg>`,
    edit: `<svg class="action-icon" viewBox="0 0 24 24"><path d="M12 20h9M16.5 3.5a2.1 2.1 0 013 3L7 19l-4 1 1-4L16.5 3.5z"/></svg>`,
    duplicate: `<svg class="action-icon" viewBox="0 0 24 24"><rect x="9" y="9" width="12" height="12" rx="2"/><path d="M5 15H4a1 1 0 01-1-1V4a1 1 0 011-1h10a1 1 0 011 1v1"/></svg>`,
    trash: `<svg class="action-icon" viewBox="0 0 24 24"><path d="M3 6h18M8 6V4a2 2 0 012-2h4a2 2 0 012 2v2m3 0v14a2 2 0 01-2 2H7a2 2 0 01-2-2V6h14z"/></svg>`,
    plus: `<svg class="action-icon" viewBox="0 0 24 24"><path d="M12 5v14M5 12h14"/></svg>`,
    swap: `<svg class="action-icon" viewBox="0 0 24 24"><path d="M17 3l4 4-4 4M21 7H3M7 21l-4-4 4-4M3 17h18"/></svg>`
  };

  const UNIT_GRAMS = { g: 1, kg: 1000, mg: 0.001, ml: 1, l: 1000, cl: 10 };
  function convertQty(qty, fromUnit, toUnit) {
    const f = UNIT_GRAMS[String(fromUnit || "").toLowerCase()];
    const t = UNIT_GRAMS[String(toUnit || "").toLowerCase()];
    if (!f || !t) return null;
    return (Number(qty) || 0) * f / t;
  }

  function initials(name) {
    return String(name || "U")
      .split(/\s+/)
      .filter(Boolean)
      .slice(0, 2)
      .map(part => part[0])
      .join("")
      .toUpperCase();
  }

  function showToast(message, type = "success") {
    clearTimeout(toastTimer);
    toastEl.textContent = message;
    toastEl.className = `toast show${type === "error" ? " error" : ""}`;
    toastTimer = setTimeout(() => { toastEl.className = "toast"; }, 3600);
  }

  function showError(error, fallback = "Une erreur est survenue.") {
    console.error(error);
    showToast(error?.message || fallback, "error");
  }

  function setLoading(message = "Chargement…") {
    content.innerHTML = `<div class="loading"><div><div class="spinner"></div>${escapeHtml(message)}</div></div>`;
  }

  function emptyState(title, text) {
    return `<div class="empty-state"><strong>${escapeHtml(title)}</strong><span>${escapeHtml(text)}</span></div>`;
  }

  function setHeader(viewName, actionHtml = "") {
    const view = views[viewName];
    pageTitle.textContent = view.title;
    pageKicker.textContent = view.kicker;
    topbarActions.innerHTML = actionHtml;
  }

  // Petite pastille "?" avec bulle d'aide au survol — remplace les gros encarts
  // explicatifs pour aerer l'interface sans perdre l'information.
  // Bulles « ? » recadrées si elles débordent de la page ou de la fenêtre
  // ouverte (icône près d'un bord, ou sous la barre latérale)
  function fitHelpTip(tip) {
    const bubble = tip.querySelector(".help-tip-bubble");
    if (!bubble) return;
    bubble.style.setProperty("--tip-shift", "0px");
    const zone = (tip.closest("#modal") || document.querySelector("#content") || document.documentElement).getBoundingClientRect();
    const left = Math.max(zone.left, 0) + 8, right = Math.min(zone.right, document.documentElement.clientWidth) - 8;
    const r = bubble.getBoundingClientRect();
    let shift = 0;
    if (r.left < left) shift = left - r.left;
    else if (r.right > right) shift = right - r.right;
    bubble.style.setProperty("--tip-shift", `${Math.round(shift)}px`);
  }
  ["mouseover", "focusin"].forEach(type => document.addEventListener(type, event => {
    const tip = event.target.closest?.(".help-tip");
    if (tip) fitHelpTip(tip);
  }));

  function helpTip(text) {
    return `<span class="help-tip" tabindex="0" aria-label="Aide"><span class="help-tip-icon">?</span><span class="help-tip-bubble">${escapeHtml(text)}</span></span>`;
  }

  function badge(text, type = "") {
    return `<span class="badge ${type ? `badge-${type}` : ""}"><span class="status-dot"></span>${escapeHtml(text)}</span>`;
  }

  // Ancien nom, conservé pour ne rien casser : répond désormais d'après la grille
  // (niveaux accordés par les parties en « Modifier »)
  function roleCan(...roles) {
    if (!profile) return false;
    if (isSuperAdmin()) return true;
    const levels = levelsFromPermissions(effectivePermissions());
    return roles.some(r => levels.includes(r));
  }

  // Autorisation fine portée par le rôle. Un admin sans rôle d'accès
  // conserve tous les droits ; sinon, il suffit qu'un des rôles l'accorde.
  // Les autorisations fines de l'écran Stock suivent la grille
  function roleAllows(flag) {
    if (!profile) return false;
    if (isSuperAdmin()) return true;
    switch (flag) {
      case "can_view_lots": return pageSees("stock");
      case "can_add_lot": case "can_multi_add_lots": return pageCan("stock");
      // Deux lignes d'action dédiées dans la grille
      case "can_transfer_stock": return pageCan("stock_transfers");
      case "can_reference_ingredients": case "can_edit_location_ref": case "can_edit_ingredient": return pageCan("ingredients_catalog");
      default: return false;
    }
  }

  function canReferenceIngredients() {
    if (!profile) return false;
    return pageCan("ingredients_catalog");
  }

  function openModal({ title, kicker = "", html, width = "760px" }) {
    modalTitle.textContent = title;
    modalKicker.textContent = kicker;
    modalBody.innerHTML = html;
    document.querySelector("#modal").style.width = `min(${width}, 100%)`;
    modalBackdrop.classList.remove("hidden");
    document.body.style.overflow = "hidden";
    setTimeout(() => modalBody.querySelector("input, select, textarea")?.focus(), 30);
  }

  function closeModal() {
    modalBackdrop.classList.add("hidden");
    document.body.style.overflow = "";
    modalBody.innerHTML = "";
  }

  function openDrawer({ title, kicker = "", html, width = "460px" }) {
    drawerTitle.textContent = title;
    drawerKicker.textContent = kicker;
    drawerBody.innerHTML = html;
    document.querySelector("#drawer").style.width = `min(${width}, 100%)`;
    drawerBackdrop.classList.remove("hidden");
    document.body.style.overflow = "hidden";
    setTimeout(() => drawerBody.querySelector("input, select, textarea")?.focus(), 30);
  }

  function closeDrawer() {
    drawerBackdrop.classList.add("hidden");
    document.body.style.overflow = "";
    drawerBody.innerHTML = "";
  }

  function formObject(form) {
    const data = new FormData(form);
    return Object.fromEntries(data.entries());
  }

  async function uploadPrivateFile(bucket, file) {
    if (!file || !file.size) return null;
    if (file.size > 15 * 1024 * 1024) throw new Error("La pièce jointe dépasse 15 Mo.");
    const path = `${profile.organization_id}/${crypto.randomUUID()}-${slugFileName(file.name)}`;
    const { error } = await sb.storage.from(bucket).upload(path, file, { upsert: false });
    if (error) throw error;
    return path;
  }

  async function openPrivateFile(bucket, path) {
    if (!path) return;
    const { data, error } = await sb.storage.from(bucket).createSignedUrl(path, 90);
    if (error) return showError(error);
    window.open(data.signedUrl, "_blank", "noopener,noreferrer");
  }

  function bindSearch(inputId, tableId) {
    const input = document.getElementById(inputId);
    const table = document.getElementById(tableId);
    if (!input || !table) return;
    input.addEventListener("input", () => {
      const q = input.value.trim().toLocaleLowerCase("fr");
      table.querySelectorAll("tbody tr").forEach(row => {
        row.hidden = q && !row.textContent.toLocaleLowerCase("fr").includes(q);
      });
    });
  }

  function submitButtonLoading(button, loading) {
    if (!button) return;
    if (loading) {
      button.dataset.original = button.innerHTML;
      button.disabled = true;
      button.innerHTML = "Enregistrement…";
    } else {
      button.disabled = false;
      button.innerHTML = button.dataset.original || "Enregistrer";
    }
  }

  async function waitForProfile(userId) {
    for (let i = 0; i < 8; i += 1) {
      const { data, error } = await sb
        .from("profiles")
        .select("user_id, organization_id, full_name, role, is_super_admin, access_role_id")
        .eq("user_id", userId)
        .maybeSingle();
      if (data) return data;
      if (error) throw error;
      await new Promise(resolve => setTimeout(resolve, 450));
    }
    throw new Error("Le profil n’a pas encore été créé. Rechargez la page dans quelques secondes.");
  }

  async function bootstrap(nextSession) {
    session = nextSession;
    if (!session) {
      profile = null;
      organization = null;
      appShell.classList.add("hidden");
      authScreen.classList.remove("hidden");
      return;
    }

    authScreen.classList.add("hidden");
    appShell.classList.remove("hidden");
    setLoading("Ouverture de votre espace…");

    try {
      // L'invitation est finalisée AVANT d'exiger un profil : une personne
      // révoquée n'en a plus, et c'est justement l'invitation qui le recrée.
      // (Le super admin est protégé en base : il ne peut pas en accepter.)
      const pendingInvite = localStorage.getItem("fiflow_pending_invite");
      if (pendingInvite) {
        const { error: acceptError } = await sb.rpc("accept_invitation", { p_token: pendingInvite });
        localStorage.removeItem("fiflow_pending_invite");
        if (!acceptError) {
          window.location.reload();
          return;
        }
        // Invitation déjà utilisée, expirée, ou destinée à une autre adresse :
        // on continue normalement avec le profil actuel.
      }

      profile = await waitForProfile(session.user.id);

      const { data: org, error } = await sb
        .from("organizations")
        .select("id, name")
        .eq("id", profile.organization_id)
        .single();
      if (error) throw error;
      organization = org;

      accessRoles = [];
      if (!profile.is_super_admin) {
        const { data: roleLinks } = await sb.from("profile_access_roles").select("access_roles(*)").eq("user_id", profile.user_id);
        accessRoles = (roleLinks || []).map(l => l.access_roles).filter(Boolean);
      }

      document.querySelector("#organization-name").textContent = organization.name;
      document.querySelector("#user-name").textContent = profile.full_name || session.user.email;
      document.querySelector("#user-role").textContent = isSuperAdmin() ? "Super admin" : (accessRoles.length ? accessRoles.map(r => r.name).join(" + ") : "Aucun rôle");
      document.querySelector("#user-initials").textContent = initials(profile.full_name || session.user.email);
      applyNavVisibility();
      if (!canSeeView(currentView)) currentView = firstAllowedView() || "profile";
      await navigate(currentView);
    } catch (error) {
      if (/profil n.a pas encore/i.test(error.message || "")) {
        showToast("Votre accès a été révoqué ou votre session a expiré.", "error");
        await sb.auth.signOut();
        return;
      }
      showError(error);
      content.innerHTML = emptyState("Impossible d’ouvrir l’espace", error.message || "Vérifiez la configuration Supabase.");
    }
  }

  let unsavedDeliveryDraft = false;

  async function navigate(viewName) {
    if (unsavedDeliveryDraft && !confirm("Vous avez une livraison en cours de création. Quitter sans enregistrer ?")) {
      return;
    }
    unsavedDeliveryDraft = false;
    currentView = views[viewName] ? viewName : "dashboard";
    if (!canSeeView(currentView)) {
      showToast("Vous n’avez pas accès à cet onglet.", "error");
      // Aucune page accessible : la page Profil, qui explique la situation
      currentView = firstAllowedView() || "profile";
    }
    document.querySelectorAll(".nav-item").forEach(btn => btn.classList.toggle("active", btn.dataset.view === currentView));
    const activeGroup = document.querySelector(`.nav-item[data-view="${currentView}"]`)?.closest(".nav-group");
    if (activeGroup) activeGroup.open = true;
    document.querySelector(".sidebar").classList.remove("open");
    setHeader(currentView);
    setLoading();
    try {
      await views[currentView].render();
    } catch (error) {
      showError(error);
      content.innerHTML = emptyState("Chargement impossible", error.message || "Réessayez dans un instant.");
    }
    updateTasksBadge();
  }

  // Authentification
  const inviteToken = new URLSearchParams(window.location.search).get("invite");

  // Bascule entre les quatre écrans d'authentification
  function showAuthForm(which) {
    ["login", "signup", "reset", "new-password"].forEach(key => {
      const id = key === "new-password" ? "#new-password-form" : `#${key}-form`;
      document.querySelector(id)?.classList.toggle("hidden", key !== which);
    });
    // Les onglets ne concernent que connexion et création de compte
    document.querySelector(".auth-tabs")?.classList.toggle("hidden", which === "new-password");
    document.querySelectorAll("[data-auth-tab]").forEach(b =>
      b.classList.toggle("active", b.dataset.authTab === which));
  }

  document.querySelectorAll("[data-auth-tab]").forEach(button => {
    button.addEventListener("click", () => showAuthForm(button.dataset.authTab));
  });

  document.querySelector("#show-reset")?.addEventListener("click", () => {
    const typed = document.querySelector("#login-email").value.trim();
    if (typed) document.querySelector("#reset-email").value = typed;
    showAuthForm("reset");
  });
  document.querySelector("#cancel-reset")?.addEventListener("click", () => showAuthForm("login"));

  document.querySelector("#reset-form")?.addEventListener("submit", async event => {
    event.preventDefault();
    const button = event.submitter; submitButtonLoading(button, true);
    const email = document.querySelector("#reset-email").value.trim();
    // Supabase n'envoie l'e-mail que si le compte existe réellement, et ne
    // révèle jamais lequel : c'est volontaire, cela évite qu'on puisse
    // découvrir quelles adresses sont inscrites en les testant une à une.
    const { error } = await sb.auth.resetPasswordForEmail(email, {
      redirectTo: window.location.origin + window.location.pathname
    });
    submitButtonLoading(button, false);
    if (error) return showError(error);
    showToast("Si un compte existe pour cette adresse, le lien vient d’être envoyé.");
    showAuthForm("login");
  });

  document.querySelector("#new-password-form")?.addEventListener("submit", async event => {
    event.preventDefault();
    const button = event.submitter;
    const pwd = document.querySelector("#new-password").value;
    const confirm = document.querySelector("#new-password-confirm").value;
    if (pwd !== confirm) return showToast("Les deux mots de passe ne correspondent pas.", "error");
    submitButtonLoading(button, true);
    const { error } = await sb.auth.updateUser({ password: pwd });
    submitButtonLoading(button, false);
    if (error) return showError(error);
    showToast("Mot de passe modifié. Vous êtes connecté.");
    showAuthForm("login");
  });

  if (inviteToken) {
    localStorage.setItem("fiflow_pending_invite", inviteToken);
    sb.rpc("get_invitation_preview", { p_token: inviteToken }).then(({ data, error }) => {
      const preview = Array.isArray(data) ? data[0] : data;
      if (error || !preview) {
        showToast("Ce lien d’invitation est introuvable ou a expiré.", "error");
        return;
      }
      document.querySelector('[data-auth-tab="signup"]')?.click();
      const orgField = document.querySelector("#signup-org");
      if (orgField) { orgField.closest("div").classList.add("hidden"); orgField.required = false; }
      const emailField = document.querySelector("#signup-email");
      if (emailField) { emailField.value = preview.email; emailField.readOnly = true; }
      const banner = document.createElement("div");
      banner.className = "help-box";
      banner.style.marginBottom = "14px";
      banner.textContent = `Tu es invité(e) à rejoindre « ${preview.organization_name} » avec l’accès « ${preview.role_name} ». Crée ton mot de passe pour activer ton compte.`;
      document.querySelector("#signup-form")?.prepend(banner);
    });
  }

  document.querySelector("#login-form").addEventListener("submit", async event => {
    event.preventDefault();
    const button = event.submitter;
    submitButtonLoading(button, true);
    const values = formObject(event.currentTarget);
    const { error } = await sb.auth.signInWithPassword({ email: values.email, password: values.password });
    submitButtonLoading(button, false);
    if (error) showError(error, "Connexion impossible.");
  });

  document.querySelector("#signup-form").addEventListener("submit", async event => {
    event.preventDefault();
    const button = event.submitter;
    submitButtonLoading(button, true);
    const values = formObject(event.currentTarget);
    const { data, error } = await sb.auth.signUp({
      email: values.email,
      password: values.password,
      options: { data: { full_name: values.full_name, organization_name: values.organization_name || "Nouvel espace" } }
    });
    if (error) { submitButtonLoading(button, false); return showError(error, "Création du compte impossible."); }
    // Adresse déjà inscrite : Supabase ne crée rien et n'envoie AUCUN e-mail,
    // sans le signaler (pour ne pas révéler qu'une adresse existe). Il renvoie
    // simplement un utilisateur sans identité. On oriente vers la connexion,
    // qui finalisera l'invitation, au lieu d'annoncer un e-mail qui ne viendra pas.
    if (data?.user && Array.isArray(data.user.identities) && data.user.identities.length === 0) {
      submitButtonLoading(button, false);
      showAuthForm("login");
      const loginEmail = document.querySelector("#login-email");
      if (loginEmail) loginEmail.value = values.email;
      showToast(inviteToken
        ? "Cette adresse a déjà un compte. Connectez-vous avec votre mot de passe : votre invitation sera finalisée automatiquement."
        : "Cette adresse a déjà un compte. Connectez-vous avec votre mot de passe.");
      return;
    }
    if (inviteToken && data.session) {
      const { error: acceptError } = await sb.rpc("accept_invitation", { p_token: inviteToken });
      submitButtonLoading(button, false);
      if (acceptError) return showError(acceptError, "Impossible de finaliser l’invitation.");
      localStorage.removeItem("fiflow_pending_invite");
      window.history.replaceState({}, "", window.location.pathname);
      showToast("Compte activé, bienvenue !");
      window.location.reload();
      return;
    }
    submitButtonLoading(button, false);
    if (!data.session) {
      showToast("Compte créé. Un e-mail de confirmation a peut-être été envoyé : confirmez-le puis reconnectez-vous, votre invitation se finalisera automatiquement.");
      event.currentTarget.reset();
    }
  });

  document.querySelector("#logout-button").addEventListener("click", () => sb.auth.signOut());

  // La page Profil s'ouvre en cliquant sur son nom ou son avatar. La
  // déconnexion y a sa place : le bouton de la barre latérale est masqué.
  document.querySelector("#logout-button")?.classList.add("hidden");
  [document.querySelector("#user-initials"), document.querySelector(".user-chip-identity")].forEach(el => {
    if (!el) return;
    el.classList.add("user-chip-link");
    el.setAttribute("role", "button");
    el.setAttribute("tabindex", "0");
    el.setAttribute("title", "Mon profil");
    el.addEventListener("click", () => navigate("profile"));
    el.addEventListener("keydown", e => { if (e.key === "Enter" || e.key === " ") { e.preventDefault(); navigate("profile"); } });
  });

  // Messages de Supabase (en anglais) traduits pour les cas courants
  function passwordErrorMessage(error) {
    const msg = String(error?.message || "");
    if (/invalid login credentials/i.test(msg)) return "Mot de passe actuel incorrect.";
    if (/should be different/i.test(msg)) return "Le nouveau mot de passe doit être différent de l’actuel.";
    if (/at least|too short/i.test(msg)) return "Mot de passe trop court.";
    if (/weak|pwned|known/i.test(msg)) return "Ce mot de passe est trop courant : choisis-en un autre.";
    if (/rate limit|too many/i.test(msg)) return "Trop de tentatives : réessaie dans quelques minutes.";
    return msg || "Modification impossible.";
  }

  function roleLabel() {
    return isSuperAdmin() ? "Super admin" : (accessRoles.length ? accessRoles.map(r => r.name).join(" + ") : "Aucun rôle");
  }

  async function renderProfile() {
    const { data: userData } = await sb.auth.getUser();
    const email = userData?.user?.email || session?.user?.email || "";
    const name = profile.full_name || "";
    const noAccess = !isSuperAdmin() && !accessRoles.length;
    content.innerHTML = `
      <div class="profile-page">
        ${noAccess ? `<div class="warning-box">Aucun rôle ne t’a encore été attribué : tu n’as accès à aucune partie de l’outil. Demande au super admin de t’en donner un.</div>` : ""}
        <section class="card profile-card">
          <div class="profile-head">
            <div class="avatar profile-avatar" id="profile-avatar">${escapeHtml(initials(name || email))}</div>
            <div>
              <div class="profile-name" id="profile-name-display">${escapeHtml(name || email)}</div>
              <div class="muted">${escapeHtml(roleLabel())}</div>
            </div>
          </div>
          <form id="profile-name-form" class="form-grid" style="margin-top:20px">
            <div class="span-2"><label>Nom affiché *</label><input name="full_name" required maxlength="80" value="${escapeHtml(name)}"></div>
            <div class="span-2"><label>Adresse e-mail</label><input value="${escapeHtml(email)}" disabled>
              <p class="form-note">C’est l’identifiant de connexion : il ne se modifie pas ici.</p></div>
            <div class="form-actions span-2"><button class="button button-primary" type="submit">Enregistrer le nom</button></div>
          </form>
        </section>

        <section class="card profile-card">
          <div class="detail-block-title">Mot de passe ${helpTip("Le mot de passe actuel est demandé pour qu’une session restée ouverte, sur un ordinateur partagé par exemple, ne permette pas à quelqu’un d’autre de le changer.")}</div>
          <form id="change-password-form" class="form-grid">
            <div class="span-2"><label>Mot de passe actuel *</label><input type="password" name="current" required autocomplete="current-password"></div>
            <div><label>Nouveau mot de passe *</label><input type="password" name="next" required minlength="8" autocomplete="new-password">
              <p class="form-note">Au moins 8 caractères.</p></div>
            <div><label>Confirmer le nouveau *</label><input type="password" name="confirm" required minlength="8" autocomplete="new-password"></div>
            <div class="form-actions span-2"><button class="button button-primary" type="submit">Changer le mot de passe</button></div>
          </form>
        </section>

        <section class="card profile-card profile-logout">
          <div>
            <div class="detail-block-title" style="margin:0">Déconnexion</div>
            <p class="form-note" style="margin:4px 0 0">Pense à te déconnecter sur un ordinateur partagé.</p>
          </div>
          <button type="button" id="profile-logout" class="button button-secondary">Se déconnecter</button>
        </section>
      </div>`;

    content.querySelector("#profile-name-form").addEventListener("submit", async event => {
      event.preventDefault();
      const button = event.submitter;
      const next = formObject(event.currentTarget).full_name.trim();
      if (!next) return showToast("Le nom ne peut pas être vide.", "error");
      submitButtonLoading(button, true);
      const { data: saved, error } = await sb.rpc("update_my_name", { p_full_name: next });
      submitButtonLoading(button, false);
      if (error) return showError(error);
      profile.full_name = saved || next;
      // Le nom change partout à la fois : barre latérale et page
      document.querySelector("#user-name").textContent = profile.full_name;
      document.querySelector("#user-initials").textContent = initials(profile.full_name);
      content.querySelector("#profile-name-display").textContent = profile.full_name;
      content.querySelector("#profile-avatar").textContent = initials(profile.full_name);
      showToast("Nom enregistré.");
    });

    content.querySelector("#change-password-form").addEventListener("submit", async event => {
      event.preventDefault();
      const form = event.currentTarget;
      const button = event.submitter;
      const { current, next, confirm } = formObject(form);
      if (next.length < 8) return showToast("Le nouveau mot de passe doit faire au moins 8 caractères.", "error");
      if (next !== confirm) return showToast("Les deux nouveaux mots de passe ne correspondent pas.", "error");
      if (next === current) return showToast("Le nouveau mot de passe doit être différent de l’actuel.", "error");
      submitButtonLoading(button, true);
      try {
        // 1. Vérifier le mot de passe actuel. Même personne : l'application met
        //    simplement sa session à jour, sans redémarrer.
        if (!email) throw new Error("Session expirée : reconnecte-toi.");
        const { error: checkError } = await sb.auth.signInWithPassword({ email, password: current });
        if (checkError) throw checkError;
        // 2. Enregistrer le nouveau
        const { error: updateError } = await sb.auth.updateUser({ password: next });
        if (updateError) throw updateError;
        form.reset();
        showToast("Mot de passe modifié.");
      } catch (err) {
        showToast(passwordErrorMessage(err), "error");
      } finally {
        submitButtonLoading(button, false);
      }
    });

    content.querySelector("#profile-logout").addEventListener("click", () => sb.auth.signOut());
  }


  // Menu Paramètres (roue crantée) : ouverture, fermeture au clic extérieur ou Échap
  const settingsGear = document.querySelector("#settings-gear");
  const settingsMenu = document.querySelector("#settings-menu");
  if (settingsGear && settingsMenu) {
    settingsGear.addEventListener("click", e => {
      e.stopPropagation();
      const open = settingsMenu.classList.toggle("hidden") === false;
      settingsGear.setAttribute("aria-expanded", String(open));
    });
    document.addEventListener("click", e => {
      if (!settingsMenu.classList.contains("hidden") && !settingsMenu.contains(e.target) && e.target !== settingsGear) {
        settingsMenu.classList.add("hidden");
        settingsGear.setAttribute("aria-expanded", "false");
      }
    });
    document.addEventListener("keydown", e => {
      if (e.key === "Escape") { settingsMenu.classList.add("hidden"); settingsGear.setAttribute("aria-expanded", "false"); }
    });
    settingsMenu.querySelectorAll(".nav-item").forEach(btn => btn.addEventListener("click", () => {
      settingsMenu.classList.add("hidden");
      settingsGear.setAttribute("aria-expanded", "false");
    }));
  }
  document.querySelector("#mobile-menu-button").addEventListener("click", () => document.querySelector(".sidebar").classList.toggle("open"));
  document.querySelectorAll(".nav-item").forEach(button => button.addEventListener("click", () => navigate(button.dataset.view)));
  document.querySelector("#modal-close").addEventListener("click", closeModal);
  document.querySelector("#drawer-close").addEventListener("click", closeDrawer);
  modalBackdrop.addEventListener("click", event => { if (event.target === modalBackdrop) closeModal(); });
  drawerBackdrop.addEventListener("click", event => { if (event.target === drawerBackdrop) closeDrawer(); });
  document.addEventListener("keydown", event => { if (event.key === "Escape" && !modalBackdrop.classList.contains("hidden")) closeModal(); });

  sb.auth.onAuthStateChange((event, nextSession) => {
    // Arrivée par le lien de réinitialisation : on affiche l'écran de choix
    // du nouveau mot de passe au lieu d'entrer directement dans l'application.
    if (event === "PASSWORD_RECOVERY") {
      session = nextSession;
      document.querySelector("#auth-screen")?.classList.remove("hidden");
      document.querySelector("#app")?.classList.add("hidden");
      showAuthForm("new-password");
      return;
    }
    const sameUser = session && nextSession && session.user?.id === nextSession.user.id;
    if (sameUser && event !== "SIGNED_OUT") {
      session = nextSession;
      return;
    }
    bootstrap(nextSession);
  });
  sb.auth.getSession().then(({ data }) => bootstrap(data.session));

  // Tableau de bord
  function monthRange(monthOffset = 0, yearOffset = 0) {
    const d = new Date();
    d.setDate(1);
    d.setMonth(d.getMonth() + monthOffset);
    d.setFullYear(d.getFullYear() + yearOffset);
    const pad = n => String(n).padStart(2, "0");
    const y = d.getFullYear(), m = d.getMonth();
    const start = `${y}-${pad(m + 1)}-01`;
    const endBase = new Date(y, m + 1, 1);
    const end = `${endBase.getFullYear()}-${pad(endBase.getMonth() + 1)}-01`;
    const label = d.toLocaleDateString("fr-FR", { month: "long", year: "numeric" });
    return { start, end, label };
  }

  // Sélecteur de période du tableau de bord — persiste tant que la page reste ouverte
  let dashboardPeriodState = { preset: "this_month", customStart: null, customEnd: null, comparison: "previous_period" };

  function dateToStr(d) {
    const pad = n => String(n).padStart(2, "0");
    return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
  }

  function resolveDashboardPeriod(state) {
    if (state.preset === "this_month") { const r = monthRange(0); return { start: r.start, end: r.end, label: r.label }; }
    if (state.preset === "last_month") { const r = monthRange(-1); return { start: r.start, end: r.end, label: r.label }; }
    if (state.preset === "this_year") {
      const y = new Date().getFullYear();
      return { start: `${y}-01-01`, end: `${y + 1}-01-01`, label: `${y}` };
    }
    if (state.preset === "custom" && state.customStart && state.customEnd) {
      const endExclusive = new Date(`${state.customEnd}T00:00:00`);
      endExclusive.setDate(endExclusive.getDate() + 1);
      return { start: state.customStart, end: dateToStr(endExclusive), label: `${formatDate(state.customStart)} → ${formatDate(state.customEnd)}` };
    }
    const r = monthRange(0);
    return { start: r.start, end: r.end, label: r.label };
  }

  // Objectif d'une période [start, end) : somme des objectifs mensuels qu'elle
  // couvre, chaque mois au prorata de ses jours inclus. Un mois entier compte
  // pour son objectif complet, une année pour la somme de ses 12 mois.
  // Calcul en UTC pour ne jamais être faussé par un changement d'heure.
  function periodTarget(targets, startIso, endIso, field) {
    const toUtc = iso => { const [y, m, d] = iso.split("-").map(Number); return Date.UTC(y, m - 1, d); };
    const start = toUtc(startIso), end = toUtc(endIso);
    const byMonth = new Map((targets || []).map(t => [`${t.year}-${t.month}`, Number(t[field] || 0)]));
    let value = 0, monthsCovered = 0, monthsWithTarget = 0;
    const s = new Date(start);
    let y = s.getUTCFullYear(), m = s.getUTCMonth();
    while (Date.UTC(y, m, 1) < end) {
      const mStart = Date.UTC(y, m, 1), mEnd = Date.UTC(y, m + 1, 1);
      const days = (Math.min(mEnd, end) - Math.max(mStart, start)) / 86400000;
      if (days > 0) {
        monthsCovered++;
        const t = byMonth.get(`${y}-${m + 1}`) || 0;
        if (t > 0) { value += t * days / ((mEnd - mStart) / 86400000); monthsWithTarget++; }
      }
      m++; if (m > 11) { m = 0; y++; }
    }
    return { value, monthsCovered, monthsWithTarget };
  }

  function resolveComparisonPeriod(mainPeriod, comparisonPreset) {
    if (comparisonPreset === "none") return null;
    const startDate = new Date(`${mainPeriod.start}T00:00:00`);
    const endDate = new Date(`${mainPeriod.end}T00:00:00`);
    const durationDays = Math.round((endDate - startDate) / 86400000);

    if (comparisonPreset === "previous_period") {
      const newStart = new Date(startDate); newStart.setDate(newStart.getDate() - durationDays);
      return { start: dateToStr(newStart), end: mainPeriod.start, label: "période précédente" };
    }
    if (comparisonPreset === "last_year") {
      const newStart = new Date(startDate); newStart.setFullYear(newStart.getFullYear() - 1);
      const newEnd = new Date(endDate); newEnd.setFullYear(newEnd.getFullYear() - 1);
      return { start: dateToStr(newStart), end: dateToStr(newEnd), label: "même période l’an dernier" };
    }
    return null;
  }

  function pctChange(curr, prev) {
    if (!prev) return null;
    return ((curr - prev) / prev) * 100;
  }

  function trendBadge(pct) {
    if (pct == null) return `<span class="muted" style="font-size:12px">—</span>`;
    const sign = pct >= 0 ? "+" : "";
    return `<span class="${pct >= 0 ? "trend-up" : "trend-down"}">${sign}${formatNumber(pct)}%</span>`;
  }

  async function renderDashboard() {
    setHeader("dashboard");
    const orgId = profile.organization_id;
    const cutoff = plusDaysISO(60);
    const weekEnd = plusDaysISO(6);
    const [ingredientsRes, ingredientLotsRes, productionsRes, upcomingProductionsRes, finishedLotsRes, deliveriesRes, newClientsRes, lostClientsRes, pendingInvoicesRes, deliveryRules, deliveryStatusesForDash, taskDeliveriesRes] = await Promise.all([
      sb.from("ingredients").select("id, name, unit, low_stock_threshold, purchase_price").eq("organization_id", orgId).eq("archived", false),
      scopeToLocations(sb.from("ingredient_lots").select("id, ingredient_id, quantity_remaining, expiry_date, unit_price")).eq("organization_id", orgId),
      scopeToLocations(sb.from("productions").select("id, production_date")).eq("organization_id", orgId).gte("production_date", todayISO().slice(0, 8) + "01"),
      scopeToLocations(sb.from("productions").select("id")).eq("organization_id", orgId).not("status", "in", "(in_progress,completed)").gte("production_date", todayISO()).lte("production_date", weekEnd),
      scopeToLocations(sb.from("finished_lots").select("id, quantity_remaining, expiry_date, unit_cost_mp, unit_cost_production, unit_cost_packaging, unit_cost_transport, unit_cost_storage")).eq("organization_id", orgId),
      scopeToLocations(sb.from("deliveries").select("id, delivery_date")).eq("organization_id", orgId).gte("delivery_date", todayISO().slice(0, 8) + "01"),
      sb.from("clients").select("id", { count: "exact", head: true }).eq("organization_id", orgId).gte("collaboration_start", todayISO().slice(0, 8) + "01"),
      sb.from("clients").select("id", { count: "exact", head: true }).eq("organization_id", orgId).gte("collaboration_end", todayISO().slice(0, 8) + "01"),
      scopeToLocations(sb.from("deliveries").select("revenue_total, invoice_pending_since")).eq("organization_id", orgId).eq("status", "delivered").eq("invoice_status", "pending"),
      fetchDeliveryReminderRules(),
      fetchDeliveryStatuses(),
      scopeToLocations(sb.from("deliveries").select("id, estimated_delivery_date, shipping_mode, status, task_done")).eq("organization_id", orgId).not("estimated_delivery_date", "is", null)
    ]);
    for (const res of [ingredientsRes, ingredientLotsRes, productionsRes, upcomingProductionsRes, finishedLotsRes, deliveriesRes, pendingInvoicesRes, taskDeliveriesRes]) if (res.error) throw res.error;

    const ingredients = ingredientsRes.data || [];
    const ingredientById = new Map(ingredients.map(i => [i.id, i]));
    const ingredientLots = ingredientLotsRes.data || [];
    const stockByIngredient = new Map();
    ingredientLots.forEach(lot => stockByIngredient.set(lot.ingredient_id, (stockByIngredient.get(lot.ingredient_id) || 0) + Number(lot.quantity_remaining || 0)));
    // Compte limité : seulement les ingrédients présents sur ses emplacements
    // (sinon tout le catalogue apparaîtrait à zéro, donc « en stock bas »)
    const lowIngredients = ingredients.filter(item => (!isLocationRestricted() || stockByIngredient.has(item.id))
      && (stockByIngredient.get(item.id) || 0) <= Number(item.low_stock_threshold || 0));
    const expiringRaw = ingredientLots.filter(lot => lot.expiry_date && lot.expiry_date <= cutoff && Number(lot.quantity_remaining) > 0);
    const expiringFinished = (finishedLotsRes.data || []).filter(lot => lot.expiry_date && lot.expiry_date <= cutoff && Number(lot.quantity_remaining) > 0);
    const finishedQty = (finishedLotsRes.data || []).reduce((sum, lot) => sum + Number(lot.quantity_remaining || 0), 0);

    // Fournitures : elles comptent aussi dans le stock immobilisé
    const { data: supplyLotsForValue } = await scopeToLocations(sb.from("supply_lots")
      .select("quantity_remaining, unit_price, supplies(purchase_price)"))
      .eq("organization_id", orgId).gt("quantity_remaining", 0);
    const supplyStockValue = (supplyLotsForValue || []).reduce((sum, lot) =>
      sum + Number(lot.quantity_remaining || 0) * Number(lot.unit_price ?? lot.supplies?.purchase_price ?? 0), 0);

    // Valeur de stock immobilisé (matières premières + fournitures + produits finis)
    const rawStockValue = ingredientLots.reduce((sum, lot) => {
      const ingredient = ingredientById.get(lot.ingredient_id);
      return sum + Number(lot.quantity_remaining || 0) * Number(lot.unit_price ?? ingredient?.purchase_price ?? 0);
    }, 0);
    const finishedStockValue = (finishedLotsRes.data || []).reduce((sum, lot) => sum + Number(lot.quantity_remaining || 0) * finishedLotUnitCost(lot), 0);
    const totalStockValue = rawStockValue + supplyStockValue + finishedStockValue;
    const expiringRawValue = expiringRaw.reduce((sum, lot) => {
      const ingredient = ingredientById.get(lot.ingredient_id);
      return sum + Number(lot.quantity_remaining || 0) * Number(lot.unit_price ?? ingredient?.purchase_price ?? 0);
    }, 0);
    const expiringFinishedValue = expiringFinished.reduce((sum, lot) => sum + Number(lot.quantity_remaining || 0) * finishedLotUnitCost(lot), 0);

    // Tâches en retard (rappels de livraison)
    let lateTasksCount = 0;
    (taskDeliveriesRes.data || []).forEach(d => {
      computeDeliveryTasks(d, deliveryRules, deliveryStatusesForDash).forEach(task => { if (task.status === "late") lateTasksCount += 1; });
    });

    // Factures en attente / en retard
    let unpaidLateAmount = 0;
    (pendingInvoicesRes.data || []).forEach(d => {
      if (invoiceDisplayStatus("pending", d.invoice_pending_since) === "late") unpaidLateAmount += Number(d.revenue_total || 0);
    });

    // Section Commercial : CA de la période sélectionnée, marge, comparatif, top produits/clients
    const periods = { current: resolveDashboardPeriod(dashboardPeriodState) };
    periods.comparison = resolveComparisonPeriod(periods.current, dashboardPeriodState.comparison);
    const earliestStart = [periods.current.start, periods.comparison?.start].filter(Boolean).sort()[0];
    const { data: periodDeliveries, error: periodError } = await scopeToLocations(sb.from("deliveries")
      .select("id, delivered_at, revenue_total, cost_total, client_id, clients(name,company)"))
      .eq("organization_id", orgId).eq("status", "delivered")
      .gte("delivered_at", earliestStart).lt("delivered_at", periods.current.end);
    if (periodError) throw periodError;
    const allPeriodDeliveries = periodDeliveries || [];
    const deliveryIds = allPeriodDeliveries.map(d => d.id);
    const { data: periodItems, error: itemsError } = deliveryIds.length
      ? await sb.from("delivery_items").select("delivery_id, quantity, unit_price, unit_cost, finished_lots(recipes(name))").in("delivery_id", deliveryIds)
      : { data: [] };
    if (itemsError) throw itemsError;

    const inRange = (dateStr, range) => range && dateStr && dateStr >= range.start && dateStr < range.end;
    const currentDeliveries = allPeriodDeliveries.filter(d => inRange(d.delivered_at, periods.current));
    const comparisonDeliveries = allPeriodDeliveries.filter(d => inRange(d.delivered_at, periods.comparison));

    const caCurrent = currentDeliveries.reduce((s, d) => s + Number(d.revenue_total || 0), 0);
    const caComparison = comparisonDeliveries.reduce((s, d) => s + Number(d.revenue_total || 0), 0);
    const costCurrent = currentDeliveries.reduce((s, d) => s + Number(d.cost_total || 0), 0);
    const marginCurrent = caCurrent - costCurrent;
    const marginPct = caCurrent ? (marginCurrent / caCurrent) * 100 : 0;

    const currentIds = new Set(currentDeliveries.map(d => d.id));
    const productStats = new Map();
    (periodItems || []).filter(i => currentIds.has(i.delivery_id)).forEach(i => {
      const name = i.finished_lots?.recipes?.name || "—";
      const entry = productStats.get(name) || { revenue: 0, cost: 0 };
      const qty = Number(i.quantity || 0);
      entry.revenue += qty * Number(i.unit_price || 0);
      entry.cost += qty * Number(i.unit_cost || 0);
      productStats.set(name, entry);
    });
    const topProducts = [...productStats.entries()].sort((a, b) => b[1].revenue - a[1].revenue).slice(0, 5);

    const clientStats = new Map();
    currentDeliveries.forEach(d => {
      const name = d.clients?.company || d.clients?.name || "—";
      const entry = clientStats.get(name) || { revenue: 0, cost: 0 };
      entry.revenue += Number(d.revenue_total || 0);
      entry.cost += Number(d.cost_total || 0);
      clientStats.set(name, entry);
    });
    const topClients = [...clientStats.entries()].sort((a, b) => b[1].revenue - a[1].revenue).slice(0, 5);

    // Section Année : CA total + marge + Top 5 produits/clients sur l'année en cours
    // (toujours l'année civile complète a ce jour, independamment du selecteur de periode ci-dessus)
    // Repartition du CA par mode de livraison, sur la periode selectionnee
    const { data: modeDeliveries } = await scopeToLocations(sb.from("deliveries")
      .select("revenue_total, shipping_mode")).eq("organization_id", orgId).eq("status", "delivered")
      .gte("delivered_at", periods.current.start).lt("delivered_at", periods.current.end);
    const dashShippingModes = await fetchShippingModes();
    const dashModeLabel = key => key ? (dashShippingModes.find(m => m.key === key)?.label || key) : "Non défini";
    const caByMode = new Map();
    (modeDeliveries || []).forEach(d => {
      const m = d.shipping_mode || "";
      caByMode.set(m, (caByMode.get(m) || 0) + Number(d.revenue_total || 0));
    });
    const caModeTotal = [...caByMode.values()].reduce((s, v) => s + v, 0);

    // Pertes et echantillons sur la periode : quantites issues des mouvements de stock,
    // valorisees au prix de vente moyen du produit concerne.
    const { data: lossMovements } = await scopeMovementsToLocations(sb.from("stock_movements")
      .select("movement_type, quantity, item_name, created_at")).eq("organization_id", orgId)
      .in("movement_type", ["perte", "echantillon"])
      .gte("created_at", periods.current.start).lt("created_at", periods.current.end);
    let qtyPerte = 0, qtyEchantillon = 0;
    (lossMovements || []).forEach(m => {
      const q = Number(m.quantity || 0);
      if (m.movement_type === "perte") qtyPerte += q; else qtyEchantillon += q;
    });
    // Base de comparaison : quantites reellement vendues sur la meme periode
    // (currentIds est un Set deja construit plus haut : on utilise .has)
    const soldQty = (periodItems || []).filter(i => currentIds.has(i.delivery_id))
      .reduce((s, i) => s + Number(i.quantity || 0), 0);
    const lossBase = soldQty + qtyPerte + qtyEchantillon;
    const lossPct = lossBase > 0 ? (qtyPerte / lossBase) * 100 : 0;
    const samplePct = lossBase > 0 ? (qtyEchantillon / lossBase) * 100 : 0;
    // Valorisation au cout de revient moyen constate sur la periode
    const avgUnitCost = soldQty > 0
      ? (periodItems || []).filter(i => currentIds.has(i.delivery_id))
          .reduce((s, i) => s + Number(i.quantity || 0) * Number(i.unit_cost || 0), 0) / soldQty
      : 0;

    // Entreposage externe : cout cumule, occupation du forfait et rotation
    const [{ data: palletsStorage }, { data: exitedPallets }, { data: logisticsProviders }] = await Promise.all([
      scopeToLocations(sb.from("pallets").select("id, entered_at, logistics_provider_id, pallet_items(quantity, finished_lots(unit_cost_storage))"))
        .eq("organization_id", orgId).eq("status", "in_storage"),
      scopeToLocations(sb.from("pallets").select("entered_at, exited_at")).eq("organization_id", orgId).eq("status", "exited").not("exited_at", "is", null),
      sb.from("logistics_providers").select("id, name, monthly_storage_pallets_included, daily_storage_rate_per_pallet").eq("organization_id", orgId).eq("active", true)
    ]);
    let storageCostTotal = 0, activePallets = 0;
    (palletsStorage || []).forEach(p => {
      activePallets += 1;
      (p.pallet_items || []).forEach(pi => {
        storageCostTotal += Number(pi.quantity || 0) * Number(pi.finished_lots?.unit_cost_storage || 0);
      });
    });

    // Occupation du forfait, prestataire par prestataire
    const palletsByProvider = new Map();
    (palletsStorage || []).forEach(p => {
      palletsByProvider.set(p.logistics_provider_id, (palletsByProvider.get(p.logistics_provider_id) || 0) + 1);
    });
    const providerUsage = (logisticsProviders || []).map(lp => {
      const used = palletsByProvider.get(lp.id) || 0;
      const included = Number(lp.monthly_storage_pallets_included || 0);
      const dailyRate = Number(lp.daily_storage_rate_per_pallet || 0);
      return {
        name: lp.name, used, included,
        pct: included > 0 ? (used / included) * 100 : null,
        // Ce que le dépassement coûte chaque jour, tant qu'il dure
        overagePerDay: Math.max(0, used - included) * dailyRate
      };
    }).filter(p => p.included > 0);

    // Rotation : duree moyenne de sejour, mesuree sur les palettes DEJA SORTIES
    // (les palettes encore en stock fausseraient la moyenne, les rapides etant deja parties)
    const stays = (exitedPallets || [])
      .map(p => Math.round((new Date(`${p.exited_at}T00:00:00`) - new Date(`${p.entered_at}T00:00:00`)) / 86400000))
      .filter(d => d >= 0);
    const avgStay = stays.length ? stays.reduce((s, d) => s + d, 0) / stays.length : null;
    // Duree actuelle des palettes encore en stock, pour reperer celles qui stagnent
    const currentStays = (palletsStorage || [])
      .map(p => Math.round((new Date(todayISO() + "T00:00:00") - new Date(`${p.entered_at}T00:00:00`)) / 86400000))
      .filter(d => d >= 0);
    const maxCurrentStay = currentStays.length ? Math.max(...currentStays) : null;

    const yearStart = `${new Date().getFullYear()}-01-01`;
    const { data: yearDeliveriesRaw, error: yearError } = await scopeToLocations(sb.from("deliveries")
      .select("id, delivered_at, revenue_total, cost_total, client_id, clients(name,company)"))
      .eq("organization_id", orgId).eq("status", "delivered").gte("delivered_at", yearStart);
    if (yearError) throw yearError;
    const yearDeliveries = yearDeliveriesRaw || [];
    const caYear = yearDeliveries.reduce((s, d) => s + Number(d.revenue_total || 0), 0);
    const costYear = yearDeliveries.reduce((s, d) => s + Number(d.cost_total || 0), 0);
    const marginYear = caYear - costYear;
    const marginPctYear = caYear ? (marginYear / caYear) * 100 : 0;
    const yearIds = yearDeliveries.map(d => d.id);
    const { data: yearItems } = yearIds.length
      ? await sb.from("delivery_items").select("delivery_id, quantity, unit_price, finished_lots(recipes(name))").in("delivery_id", yearIds)
      : { data: [] };
    const productRevenueYear = new Map();
    (yearItems || []).forEach(i => {
      const name = i.finished_lots?.recipes?.name || "—";
      productRevenueYear.set(name, (productRevenueYear.get(name) || 0) + Number(i.quantity || 0) * Number(i.unit_price || 0));
    });
    const topProductsYear = [...productRevenueYear.entries()].sort((a, b) => b[1] - a[1]).slice(0, 5);
    const clientRevenueYear = new Map();
    yearDeliveries.forEach(d => {
      const name = d.clients?.company || d.clients?.name || "—";
      clientRevenueYear.set(name, (clientRevenueYear.get(name) || 0) + Number(d.revenue_total || 0));
    });
    const topClientsYear = [...clientRevenueYear.entries()].sort((a, b) => b[1] - a[1]).slice(0, 5);

    const now = new Date();
    const { data: currentTarget } = await sb.from("sales_targets").select("target_revenue, target_margin, target_new_clients").eq("organization_id", orgId).eq("year", now.getFullYear()).eq("month", now.getMonth() + 1).maybeSingle();
    // CA et marge suivent la période filtrée : leur objectif aussi. (La carte
    // « Clients ce mois-ci » compte le mois en cours : son objectif reste mensuel.)
    // Objectifs de l'entreprise : sans rapport avec un seul site, masqués pour un compte limité
    const { data: periodTargetsRaw } = await sb.from("sales_targets").select("year, month, target_revenue, target_margin")
      .eq("organization_id", orgId)
      .gte("year", Number(periods.current.start.slice(0, 4)))
      .lte("year", Number(periods.current.end.slice(0, 4)));
    const periodTargets = isLocationRestricted() ? [] : periodTargetsRaw;
    const revenueGoal = periodTarget(periodTargets, periods.current.start, periods.current.end, "target_revenue");
    const marginGoal = periodTarget(periodTargets, periods.current.start, periods.current.end, "target_margin");
    // Objectif incomplet : on le dit, plutôt que d'afficher un pourcentage trompeur
    const goalNote = g => g.monthsWithTarget && g.monthsWithTarget < g.monthsCovered
      ? `<small class="muted goal-partial">Objectif défini pour ${g.monthsWithTarget} mois sur ${g.monthsCovered}.</small>` : "";
    function progressBarHtml(current, target, formatFn = formatMoney) {
      if (!target || target <= 0) return "";
      const pct = Math.min(100, (current / target) * 100);
      return `<div class="goal-progress"><div class="goal-progress-bar"><div class="goal-progress-fill" style="width:${pct}%"></div></div><small class="muted">${formatNumber(pct, 0)}% de l’objectif (${formatFn(target)})</small></div>`;
    }

    // Cartes du tableau de bord, organisées par zone (même disposition qu'avant)
    const DASH_ZONES = {
      "commercial-metrics": ["ca_month", "margin_month", "clients_month", "unpaid_invoices", "ca_by_shipping_mode"],
      "commercial-top": ["top_products", "top_clients"],
      "annuel-metrics": ["ca_year", "margin_year"],
      "annuel-top": ["top_products_year", "top_clients_year"],
      "logistique-metrics": ["ingredients_ref", "productions_month", "finished_stock", "deliveries_month", "stock_value", "loss_rate", "storage_cost", "storage_occupancy", "storage_rotation"],
      "logistique-extra": ["tasks_late"],
      "alertes": ["low_stock_alert", "raw_expiry_alert", "finished_expiry_alert"]
    };
    const cardDefs = {
      ca_month: { cls: "metric-card", title: "Chiffre d’affaires (HT)", body: `<div class="metric">${formatMoney(caCurrent)}</div><div class="metric-detail">${periods.comparison ? `vs ${periods.comparison.label} ${trendBadge(pctChange(caCurrent, caComparison))}` : "Sans comparaison"}</div>${progressBarHtml(caCurrent, revenueGoal.value)}${goalNote(revenueGoal)}` },
      margin_month: { cls: "metric-card", title: "Marge moyenne", body: `<div class="metric">${formatMoney(marginCurrent)}</div><div class="metric-detail">${formatNumber(marginPct, 0)}% du CA</div>${progressBarHtml(marginCurrent, marginGoal.value)}${goalNote(marginGoal)}` },
      clients_month: { cls: "metric-card", title: "Clients ce mois-ci", body: `<div class="metric">+${newClientsRes.count || 0}</div><div class="metric-detail">${lostClientsRes.count || 0} client(s) perdu(s)</div>${progressBarHtml(newClientsRes.count || 0, currentTarget?.target_new_clients, v => `${v}`)}` },
      unpaid_invoices: { cls: "metric-card", title: "Factures en retard", body: `<div class="metric metric-critical">${formatMoney(unpaidLateAmount)}</div><div class="metric-detail">Impayées depuis plus de 30 jours</div>` },
      ca_by_shipping_mode: { cls: "metric-card", title: "CA par mode de livraison", body: caModeTotal > 0
        ? `<div class="mode-split">${[...caByMode.entries()].sort((a, b) => b[1] - a[1]).map(([mode, val]) => `
            <div class="mode-split-row">
              <div class="mode-split-head"><span>${escapeHtml(dashModeLabel(mode))}</span><strong>${formatMoney(val)}</strong></div>
              <div class="mode-split-bar"><span style="width:${(val / caModeTotal) * 100}%"></span></div>
              <div class="mode-split-pct">${formatNumber((val / caModeTotal) * 100, 0)}%</div>
            </div>`).join("")}</div>`
        : `<div class="metric">—</div><div class="metric-detail">Aucune livraison sur la période</div>` },
      loss_rate: { cls: "metric-card", title: "Taux de perte", body: `
        <div class="metric ${lossPct > 5 ? "metric-critical" : ""}">${formatNumber(lossPct, 1)}%</div>
        <div class="metric-detail">${formatNumber(qtyPerte)} u. perdues · ${formatMoney(qtyPerte * avgUnitCost)}</div>
        <div class="metric-detail">Échantillons : ${formatNumber(samplePct, 1)}% · ${formatNumber(qtyEchantillon)} u. · ${formatMoney(qtyEchantillon * avgUnitCost)}</div>` },
      storage_cost: { cls: "metric-card", title: "Entreposage cumulé", body: `
        <div class="metric">${formatMoney(storageCostTotal)}</div>
        <div class="metric-detail">${activePallets} palette(s) en entrepôt externe</div>
        <div class="metric-detail">Hors forfait fixe — seules les palettes au-delà du forfait sont facturées au jour</div>` },
      storage_occupancy: { cls: "metric-card", title: "Occupation du forfait", body: providerUsage.length
        ? `<div class="mode-split">${providerUsage.map(p => `
            <div class="mode-split-row">
              <div class="mode-split-head"><span>${escapeHtml(p.name)}</span><strong>${p.used}${p.included > 0 ? ` / ${p.included}` : ""}</strong></div>
              ${p.included > 0 ? `<div class="mode-split-bar"><span style="width:${Math.min(100, p.pct)}%;${p.used > p.included ? "background:#a74242" : ""}"></span></div>
              <div class="mode-split-pct">${formatNumber(p.pct, 0)}%</div>` : `<div class="mode-split-bar"></div><div class="mode-split-pct">—</div>`}

              ${p.used > p.included && p.included > 0 ? `<div class="mode-split-head" style="font-weight:400"><span class="muted">${p.used - p.included} palette(s) en dépassement</span><span class="muted">${formatMoney(p.overagePerDay)} / jour</span></div>` : ""}
            </div>`).join("")}</div>`
        : `<div class="metric">—</div><div class="metric-detail">Aucun forfait configuré</div>` },
      storage_rotation: { cls: "metric-card", title: "Rotation des palettes", body: `
        <div class="metric">${avgStay != null ? `${formatNumber(avgStay, 0)} j.` : "—"}</div>
        <div class="metric-detail">${avgStay != null ? `Durée moyenne de séjour (${stays.length} palette(s) sorties)` : "Aucune palette encore sortie"}</div>
        ${maxCurrentStay != null ? `<div class="metric-detail">Plus ancienne encore en stock : ${maxCurrentStay} j.</div>` : ""}` },
      top_products: { cls: "", title: "Top 5 produits", useH3: true, body: topProducts.length ? `<p class="muted" style="font-size:12px;margin:-4px 0 10px">CA en € HT</p><ol class="ranked-list">${topProducts.map(([name, e]) => `<li><span>${escapeHtml(name)}</span><span><strong>${formatMoney(e.revenue)}</strong> <small class="muted">(${e.revenue ? formatNumber((e.revenue - e.cost) / e.revenue * 100, 0) : "0"}% marge)</small></span></li>`).join("")}</ol>` : `<p class="muted">Aucune vente sur cette période.</p>` },
      top_clients: { cls: "", title: "Top 5 clients", useH3: true, body: topClients.length ? `<p class="muted" style="font-size:12px;margin:-4px 0 10px">CA en € HT</p><ol class="ranked-list">${topClients.map(([name, e]) => `<li><span>${escapeHtml(name)}</span><span><strong>${formatMoney(e.revenue)}</strong> <small class="muted">(${e.revenue ? formatNumber((e.revenue - e.cost) / e.revenue * 100, 0) : "0"}% marge)</small></span></li>`).join("")}</ol>` : `<p class="muted">Aucune vente sur cette période.</p>` },
      ca_year: { cls: "metric-card", title: `Chiffre d’affaires ${new Date().getFullYear()} (HT)`, body: `<div class="metric">${formatMoney(caYear)}</div><div class="metric-detail">Cumul depuis le 1er janvier</div>` },
      margin_year: { cls: "metric-card", title: "Marge moyenne — année", body: `<div class="metric">${formatMoney(marginYear)}</div><div class="metric-detail">${formatNumber(marginPctYear, 0)}% du CA</div>` },
      top_products_year: { cls: "", title: "Top 5 produits — année", useH3: true, body: topProductsYear.length ? `<p class="muted" style="font-size:12px;margin:-4px 0 10px">CA en € HT</p><ol class="ranked-list">${topProductsYear.map(([name, v]) => `<li><span>${escapeHtml(name)}</span><strong>${formatMoney(v)}</strong></li>`).join("")}</ol>` : `<p class="muted">Aucune vente cette année.</p>` },
      top_clients_year: { cls: "", title: "Top 5 clients — année", useH3: true, body: topClientsYear.length ? `<p class="muted" style="font-size:12px;margin:-4px 0 10px">CA en € HT</p><ol class="ranked-list">${topClientsYear.map(([name, v]) => `<li><span>${escapeHtml(name)}</span><strong>${formatMoney(v)}</strong></li>`).join("")}</ol>` : `<p class="muted">Aucune vente cette année.</p>` },
      ingredients_ref: { cls: "metric-card", title: "Ingrédients référencés", body: `<div class="metric">${ingredients.length}</div><div class="metric-detail">${lowIngredients.length} sous le seuil d’alerte</div>` },
      productions_month: { cls: "metric-card", title: "Productions ce mois-ci", body: `<div class="metric">${productionsRes.data.length}</div><div class="metric-detail">${upcomingProductionsRes.data.length} programmée(s) cette semaine</div>` },
      finished_stock: { cls: "metric-card", title: "Produits finis disponibles", body: `<div class="metric">${formatNumber(finishedQty)}</div><div class="metric-detail">Unités réparties par lot</div>` },
      deliveries_month: { cls: "metric-card", title: "Livraisons ce mois-ci", body: `<div class="metric">${deliveriesRes.data.length}</div><div class="metric-detail">Toutes créées ce mois</div>` },
      stock_value: { cls: "metric-card card-span-2", title: "Valeur de stock immobilisé", body: `<div class="metric">${formatMoney(totalStockValue)}</div>
        <div class="metric-detail">${formatMoney(rawStockValue)} matières premières · ${formatMoney(supplyStockValue)} fournitures</div>
        <div class="metric-detail">${formatMoney(finishedStockValue)} produits finis (coût complet, transport et entreposage inclus)</div>` },
      tasks_late: { cls: "metric-card", title: "Tâches en retard", body: `<div class="metric ${lateTasksCount ? "metric-critical" : ""}">${lateTasksCount}</div><div class="metric-detail">Rappels de livraison non traités</div>` },
      low_stock_alert: { cls: "", title: "Stocks faibles", useH3: true, body: lowIngredients.length ? lowIngredients.slice(0, 6).map(item => `<p><strong>${escapeHtml(item.name)}</strong><br><span class="muted">${formatNumber(stockByIngredient.get(item.id) || 0)} ${escapeHtml(item.unit)} disponibles</span></p>`).join("") : `<p class="muted">Aucune alerte de stock.</p>` },
      raw_expiry_alert: { cls: "", title: "Lots matières premières", useH3: true, body: `<div class="metric">${formatMoney(expiringRawValue)}</div><p class="muted">${expiringRaw.length} lot(s) à utiliser ou contrôler avant ${formatDate(cutoff)}.</p>` },
      finished_expiry_alert: { cls: "", title: "Lots produits finis", useH3: true, body: `<div class="metric">${formatMoney(expiringFinishedValue)}</div><p class="muted">${expiringFinished.length} lot(s) avec une DLC proche.</p>` }
    };

    // Nouveaux clients : chiffre de toute l'entreprise, masqué pour un compte limité à des emplacements
    if (isLocationRestricted()) delete cardDefs.clients_month;
    const { data: cardPrefsData } = await sb.from("dashboard_card_prefs").select("card_id, hidden, sort_order").eq("user_id", session.user.id);
    const cardPrefs = new Map((cardPrefsData || []).map(p => [p.card_id, p]));

    function renderCard(id) {
      const def = cardDefs[id];
      if (!def) return "";
      return `<article class="card dash-card ${def.cls}" data-card-id="${id}" draggable="true">
        <button type="button" class="icon-button icon-small dash-hide-btn hide-dash-card" data-id="${id}" title="Masquer cette carte"><svg class="dash-hide-icon" viewBox="0 0 24 24"><path d="M2 12s3.5-7 10-7 10 7 10 7-3.5 7-10 7-10-7-10-7z"/><circle cx="12" cy="12" r="3"/></svg></button>
        ${def.useH3 ? `<h3>${escapeHtml(def.title)}</h3>` : `<small>${escapeHtml(def.title)}</small>`}
        ${def.body}
      </article>`;
    }

    function orderedVisible(zoneKey) {
      return DASH_ZONES[zoneKey]
        .slice()
        .sort((a, b) => (cardPrefs.get(a)?.sort_order ?? DASH_ZONES[zoneKey].indexOf(a)) - (cardPrefs.get(b)?.sort_order ?? DASH_ZONES[zoneKey].indexOf(b)))
        .filter(id => !cardPrefs.get(id)?.hidden);
    }

    const allHiddenIds = Object.keys(cardDefs).filter(id => cardPrefs.get(id)?.hidden);

    content.innerHTML = `
      ${allHiddenIds.length ? `<details class="hidden-cards-menu">
        <summary>Cartes masquées (${allHiddenIds.length})</summary>
        <div class="hidden-cards-list">${allHiddenIds.map(id => `<span class="hidden-card-chip">${escapeHtml(cardDefs[id].title)} <button type="button" class="show-dash-card" data-id="${id}" title="Réafficher">↺</button></span>`).join("")}</div>
      </details>` : ""}

      <div class="section-header dash-period-header">
        <div><h2><span class="dash-section-badge dash-section-badge-commercial">Commercial</span></h2><p>${periods.current.label}</p></div>
        <div class="dash-period-controls">
          <select id="dash-period-preset">
            <option value="this_month" ${dashboardPeriodState.preset === "this_month" ? "selected" : ""}>Ce mois-ci</option>
            <option value="last_month" ${dashboardPeriodState.preset === "last_month" ? "selected" : ""}>Mois dernier</option>
            <option value="this_year" ${dashboardPeriodState.preset === "this_year" ? "selected" : ""}>Cette année</option>
            <option value="custom" ${dashboardPeriodState.preset === "custom" ? "selected" : ""}>Personnalisé…</option>
          </select>
          <span id="dash-period-custom-dates" class="${dashboardPeriodState.preset === "custom" ? "" : "hidden"}" style="display:inline-flex;gap:6px;align-items:center">
            <input type="date" id="dash-period-start" value="${dashboardPeriodState.customStart || ""}">
            <span class="muted">→</span>
            <input type="date" id="dash-period-end" value="${dashboardPeriodState.customEnd || ""}">
          </span>
          <span class="muted">vs</span>
          <select id="dash-period-comparison">
            <option value="previous_period" ${dashboardPeriodState.comparison === "previous_period" ? "selected" : ""}>Période précédente</option>
            <option value="last_year" ${dashboardPeriodState.comparison === "last_year" ? "selected" : ""}>Même période, l’an dernier</option>
            <option value="none" ${dashboardPeriodState.comparison === "none" ? "selected" : ""}>Sans comparaison</option>
          </select>
        </div>
      </div>
      <div class="grid grid-4" data-zone="commercial-metrics">${orderedVisible("commercial-metrics").map(renderCard).join("")}</div>
      <div class="grid grid-2" data-zone="commercial-top" style="margin-top:16px">${orderedVisible("commercial-top").map(renderCard).join("")}</div>

      <div class="section-header"><div><h2><span class="dash-section-badge dash-section-badge-annuel">Année</span></h2><p>${new Date().getFullYear()}, cumul depuis le 1er janvier.</p></div></div>
      <div class="grid grid-4" data-zone="annuel-metrics">${orderedVisible("annuel-metrics").map(renderCard).join("")}</div>
      <div class="grid grid-2" data-zone="annuel-top" style="margin-top:16px">${orderedVisible("annuel-top").map(renderCard).join("")}</div>

      <div class="section-header"><div><h2><span class="dash-section-badge dash-section-badge-logistique">Logistique</span></h2><p>Production et stocks.</p></div></div>
      <div class="grid grid-4" data-zone="logistique-metrics">${orderedVisible("logistique-metrics").map(renderCard).join("")}</div>
      <div class="grid grid-2" data-zone="logistique-extra" style="margin-top:16px">${orderedVisible("logistique-extra").map(renderCard).join("")}</div>

      <div class="section-header"><div><h2>Alertes à traiter</h2><p>DLC dans moins de 60 jours et stocks faibles.</p></div></div>
      <div class="grid grid-3" data-zone="alertes">${orderedVisible("alertes").map(renderCard).join("")}</div>`;

    async function saveCardPref(cardId, patch) {
      const existing = cardPrefs.get(cardId) || {};
      const merged = { ...existing, ...patch };
      cardPrefs.set(cardId, merged);
      await sb.from("dashboard_card_prefs").upsert({ user_id: session.user.id, card_id: cardId, hidden: merged.hidden ?? false, sort_order: merged.sort_order ?? null }, { onConflict: "user_id,card_id" });
    }

    document.querySelector("#dash-period-preset").addEventListener("change", e => {
      dashboardPeriodState.preset = e.target.value;
      if (e.target.value === "custom" && !dashboardPeriodState.customStart) {
        const r = monthRange(0);
        dashboardPeriodState.customStart = r.start;
        const endInclusive = new Date(`${r.end}T00:00:00`); endInclusive.setDate(endInclusive.getDate() - 1);
        dashboardPeriodState.customEnd = dateToStr(endInclusive);
      }
      renderDashboard();
    });
    document.querySelector("#dash-period-start")?.addEventListener("change", e => {
      dashboardPeriodState.customStart = e.target.value;
      if (dashboardPeriodState.customStart && dashboardPeriodState.customEnd) renderDashboard();
    });
    document.querySelector("#dash-period-end")?.addEventListener("change", e => {
      dashboardPeriodState.customEnd = e.target.value;
      if (dashboardPeriodState.customStart && dashboardPeriodState.customEnd) renderDashboard();
    });
    document.querySelector("#dash-period-comparison").addEventListener("change", e => {
      dashboardPeriodState.comparison = e.target.value;
      renderDashboard();
    });

    document.querySelectorAll(".hide-dash-card").forEach(btn => btn.addEventListener("click", async () => {
      await saveCardPref(btn.dataset.id, { hidden: true });
      renderDashboard();
    }));
    document.querySelectorAll(".show-dash-card").forEach(btn => btn.addEventListener("click", async () => {
      await saveCardPref(btn.dataset.id, { hidden: false });
      renderDashboard();
    }));
    Object.keys(DASH_ZONES).forEach(zoneKey => {
      wireDragReorder(`[data-zone="${zoneKey}"]`, ".dash-card", async orderedIds => {
        await Promise.all(orderedIds.map((id, idx) => saveCardPref(id, { sort_order: idx })));
      });
    });
  }

  async function ingredientModal(item = null) {
    const locs = item ? [] : await fetchLocations();
    openModal({
      title: item ? "Modifier l’ingrédient" : "Nouvel ingrédient",
      kicker: "Matière première",
      html: `<form id="ingredient-form" class="form-grid">
        <div><label>Nom *</label><input name="name" required value="${escapeHtml(item?.name || "")}"></div>
        <div><label>Unité de stock *</label><select name="unit" required>${["kg","g","L","mL","unité","carton","sachet"].map(unit => `<option ${item?.unit === unit ? "selected" : ""}>${unit}</option>`).join("")}</select></div>
        <div><label>TVA (%)</label><input name="vat_rate" type="number" min="0" step="0.1" value="${item?.vat_rate ?? 5.5}"></div>
        <div><label>Seuil de stock faible</label><input name="low_stock_threshold" type="number" min="0" step="0.001" value="${item?.low_stock_threshold ?? 0}"></div>
        <div class="span-2"><label>Allergènes / traces</label><textarea name="allergens">${escapeHtml(item?.allergens || "")}</textarea></div>
        ${item ? `<div class="span-2 help-inline">${helpTip("Le prix, le fournisseur et la référence produit se règlent désormais par emplacement (bouton 🏷 sur la carte de l’ingrédient, dans Stock Ingrédients).")}<span class="help-inline-label">À savoir</span></div>` : `
        <div class="span-2 form-section-title">📍 Emplacements de référencement</div>
        <div class="span-2 help-inline">${helpTip("Coche au moins un atelier où cet ingrédient sera utilisé. Le prix, le fournisseur et la référence ci-dessous serviront de point de départ pour chaque emplacement coché — modifiables ensuite indépendamment via le bouton 🏷 sur sa carte.")}<span class="help-inline-label">À savoir</span></div>
        ${locs.length ? `<div class="span-2 compat-list">${locs.map(l => `<label class="compat-list-item"><input type="checkbox" name="initial_location_ids" value="${l.id}"><span>${escapeHtml(l.name)}</span></label>`).join("")}</div>` : `<div class="span-2 muted">Aucun emplacement créé pour l’instant (Paramètres → Emplacements).</div>`}
        <div><label>Prix d’achat HT / unité (point de départ)</label><input name="purchase_price" type="number" min="0" step="0.0001"></div>
        <div><label>Fournisseur (point de départ)</label><input name="supplier"></div>
        <div class="span-2"><label>Référence produit (point de départ)</label><input name="reference"></div>
        `}
        <div class="form-actions span-2"><button type="button" class="button button-ghost" data-close-modal>Annuler</button><button class="button button-primary" type="submit">Enregistrer</button></div>
      </form>`
    });
    modalBody.querySelector("[data-close-modal]").addEventListener("click", closeModal);
    modalBody.querySelector("#ingredient-form").addEventListener("submit", async event => {
      event.preventDefault();
      const button = event.submitter;
      submitButtonLoading(button, true);
      try {
        const values = formObject(event.currentTarget);
        const checkedLocationIds = item ? [] : [...event.currentTarget.querySelectorAll('input[name="initial_location_ids"]:checked')].map(el => el.value);
        if (!item && locs.length && !checkedLocationIds.length) {
          throw new Error("Sélectionnez au moins un emplacement pour créer cet ingrédient.");
        }
        const payload = {
          organization_id: profile.organization_id,
          name: values.name.trim(), unit: values.unit,
          vat_rate: Number(values.vat_rate || 0),
          low_stock_threshold: Number(values.low_stock_threshold || 0), allergens: values.allergens.trim() || null
        };
        const query = item ? sb.from("ingredients").update(payload).eq("id", item.id) : sb.from("ingredients").insert(payload).select().single();
        const { data: saved, error } = await query;
        if (error) throw error;

        if (!item && checkedLocationIds.length) {
          const startingPrice = values.purchase_price === "" ? null : Number(values.purchase_price);
          const startingSupplier = values.supplier?.trim() || null;
          const startingReference = values.reference?.trim() || null;
          const { error: refError } = await sb.from("ingredient_locations").insert(
            checkedLocationIds.map(locationId => ({
              organization_id: profile.organization_id, ingredient_id: saved.id, location_id: locationId,
              unit_price: startingPrice, supplier: startingSupplier, reference: startingReference
            }))
          );
          if (refError) throw refError;
        }
        closeModal(); showToast("Ingrédient enregistré."); renderStock();
      } catch (err) { showError(err); }
      finally { submitButtonLoading(button, false); }
    });
  }

  async function ingredientLocationRefModal(ingredient, location, currentRef) {
    if (!ingredient) return;
    const { data: suppliers } = await sb.from("suppliers").select("id, name, supplier_locations(location_id)").eq("organization_id", profile.organization_id).order("name");
    const suppliersForLocation = (suppliers || []).filter(s => (s.supplier_locations || []).some(sl => sl.location_id === location.id));
    openModal({
      title: "Prix, fournisseur et référence",
      kicker: `${ingredient.name} — ${location.name}`,
      html: `<form id="location-ref-form" class="form-grid">
        <div class="span-2 help-inline">${helpTip("Ces informations sont propres à cet emplacement : un autre atelier peut avoir un prix, un fournisseur ou une référence différents pour le même ingrédient.")}<span class="help-inline-label">À savoir</span></div>
        <div><label>Prix d’achat HT / unité (${escapeHtml(ingredient.unit)})</label><input name="unit_price" type="number" min="0" step="0.0001" value="${currentRef?.unit_price ?? ""}"></div>
        <div><label>Fournisseur</label><select name="supplier_id">
          <option value="">Non renseigné</option>
          ${suppliersForLocation.map(s => `<option value="${s.id}" ${currentRef?.supplier_id === s.id ? "selected" : ""}>${escapeHtml(s.name)}</option>`).join("")}
        </select>
        ${!suppliersForLocation.length ? `<p class="form-note">Aucun fournisseur ne dessert encore cet emplacement — configure-le dans Paramètres → Fournisseurs.</p>` : ""}
        </div>
        <div class="span-2"><label>Référence produit</label><input name="reference" value="${escapeHtml(currentRef?.reference || "")}"></div>
        <div class="form-actions span-2"><button type="button" class="button button-ghost" data-close-modal>Annuler</button><button class="button button-primary" type="submit">Enregistrer</button></div>
      </form>`
    });
    modalBody.querySelector("[data-close-modal]").addEventListener("click", closeModal);
    modalBody.querySelector("#location-ref-form").addEventListener("submit", async event => {
      event.preventDefault();
      const button = event.submitter; submitButtonLoading(button, true);
      const values = formObject(event.currentTarget);
      const { error } = await sb.from("ingredient_locations").upsert({
        organization_id: profile.organization_id, ingredient_id: ingredient.id, location_id: location.id,
        unit_price: values.unit_price === "" ? null : Number(values.unit_price),
        supplier_id: values.supplier_id || null, reference: values.reference.trim() || null
      }, { onConflict: "ingredient_id,location_id" });
      submitButtonLoading(button, false);
      if (error) return showError(error);
      closeModal(); showToast("Informations enregistrées."); renderStock();
    });
  }


  async function archivedIngredientsModal() {
    const { data, error } = await sb.from("ingredients").select("id,name,unit,category").eq("organization_id", profile.organization_id).eq("archived", true).order("name");
    if (error) return showError(error);
    const rows = (data || []).map(item => `<tr>
      <td><strong>${escapeHtml(item.name)}</strong></td>
      <td>${escapeHtml(item.category || "—")}</td>
      <td><button type="button" class="button button-small button-secondary reactivate-ingredient" data-id="${item.id}">Réactiver</button></td>
    </tr>`).join("");
    openModal({
      title: "Ingrédients archivés",
      kicker: "Matières premières retirées",
      html: `<div class="help-inline">${helpTip("Ces ingrédients ont été retirés des listes actives. Leur historique (recettes, lots, consommations, prix) reste intact. Réactive-les pour les rendre à nouveau sélectionnables.")}<span class="help-inline-label">À savoir</span></div>
        <div class="table-wrap" style="margin-top:16px">${rows ? `<table><thead><tr><th>Nom</th><th>Catégorie</th><th></th></tr></thead><tbody>${rows}</tbody></table>` : emptyState("Aucun ingrédient archivé", "")}</div>`
    });
    modalBody.querySelectorAll(".reactivate-ingredient").forEach(btn => btn.addEventListener("click", async () => {
      const { error: reactivateError } = await sb.from("ingredients").update({ archived: false }).eq("id", btn.dataset.id);
      if (reactivateError) return showError(reactivateError);
      showToast("Ingrédient réactivé."); closeModal(); renderStock();
    }));
  }

  // Recupere toutes les lignes d'une requete au-dela de la limite par defaut
  // (1000 lignes) de Supabase, par appels successifs. A utiliser pour tout
  // total ou agregat qui doit porter sur l'historique complet.
  async function fetchAllRows(buildQuery) {
    const pageSize = 1000;
    let from = 0;
    let allRows = [];
    while (true) {
      const { data, error } = await buildQuery().range(from, from + pageSize - 1);
      if (error) throw error;
      allRows = allRows.concat(data || []);
      if (!data || data.length < pageSize) break;
      from += pageSize;
    }
    return allRows;
  }

  async function fetchLocations(includeAll = false, excludeExternalLogistics = false) {
    const { data, error } = await sb.from("locations").select("id,name,is_external_logistics,logistics_provider_id,lot_code").eq("organization_id", profile.organization_id).order("name");
    if (error) { showError(error); return []; }
    let list = data || [];
    if (excludeExternalLogistics) list = list.filter(l => !l.is_external_logistics);
    if (includeAll) return list;
    const allowed = allowedLocationIds();
    return allowed ? list.filter(l => allowed.includes(l.id)) : list;
  }

  function locationOptions(locationsList, selectedId, placeholder = "Aucun emplacement") {
    return `<option value="">${escapeHtml(placeholder)}</option>` +
      locationsList.map(loc => `<option value="${loc.id}" ${selectedId === loc.id ? "selected" : ""}>${escapeHtml(loc.name)}</option>`).join("");
  }

  // Ingrédients & lots de matières premières (onglet fusionné, par atelier)
  function computeIngredientStockMetrics(lots, ingredientById, referencedIds = new Set()) {
    let criticalCount = 0, alertCount = 0, totalValue = 0;
    const byIngredient = new Map();
    lots.forEach(lot => {
      if (!byIngredient.has(lot.ingredient_id)) byIngredient.set(lot.ingredient_id, []);
      byIngredient.get(lot.ingredient_id).push(lot);
    });
    byIngredient.forEach((ingLots, ingredientId) => {
      const ingredient = ingredientById.get(ingredientId);
      if (!ingredient) return;
      const totalRemaining = ingLots.reduce((sum, lot) => sum + Number(lot.quantity_remaining || 0), 0);
      const value = ingLots.reduce((sum, lot) => sum + Number(lot.quantity_remaining || 0) * Number(lot.unit_price ?? ingredient.purchase_price ?? 0), 0);
      const hasAlert = ingLots.some(lot => lot.expiry_date && lot.expiry_date <= plusDaysISO(60) && Number(lot.quantity_remaining) > 0);
      const isCritical = totalRemaining <= Number(ingredient.low_stock_threshold || 0);
      totalValue += value;
      if (isCritical) criticalCount += 1;
      if (hasAlert) alertCount += 1;
    });
    referencedIds.forEach(id => {
      if (!byIngredient.has(id) && ingredientById.has(id)) {
        byIngredient.set(id, []);
        criticalCount += 1; // 0 en stock est nécessairement sous le seuil
      }
    });
    return { ingredientCount: byIngredient.size, criticalCount, alertCount, totalValue };
  }

  function renderStockMetricCards(metrics) {
    return `<div class="grid grid-4 stock-summary">
      <article class="card metric-card metric-card-flip"><div class="metric">${metrics.ingredientCount}</div><small>Ingrédients</small></article>
      <article class="card metric-card metric-card-flip"><div class="metric metric-critical">${metrics.criticalCount}</div><small>Stock critique</small></article>
      <article class="card metric-card metric-card-flip"><div class="metric metric-warning">${metrics.alertCount}</div><small>Alerte DDM</small></article>
      <article class="card metric-card metric-card-flip"><div class="metric">${formatMoney(metrics.totalValue)}</div><small>Valeur</small></article>
    </div>`;
  }

  async function renderStock() {
    // Un atelier de production réceptionne ses propres matières premières :
    // le rôle "production" peut donc saisir des lots, comme "stock".
    const canEdit = pageCan("stock");
    const canCreateIngredient = canEdit && canReferenceIngredients();
    setHeader("stock", canEdit ? `${canCreateIngredient ? `<button id="view-archived-ingredients" class="button button-ghost" title="Voir les ingrédients retirés">Archivés</button><button id="add-ingredient-from-stock" class="button button-primary">＋ Ajouter un ingrédient</button>` : `<button id="view-archived-ingredients" class="button button-ghost" title="Voir les ingrédients retirés">Archivés</button>`}` : "");
    const [ingredientsRes, lotsRes, refsRes, allLocations] = await Promise.all([
      sb.from("ingredients").select("*").eq("organization_id", profile.organization_id).eq("archived", false).order("name"),
      sb.from("ingredient_lots").select("*, locations(id, name)").eq("organization_id", profile.organization_id).gt("quantity_remaining", 0).order("received_at", { ascending: true }),
      sb.from("ingredient_locations").select("ingredient_id, location_id, unit_price, supplier_id, reference, suppliers(name)").eq("organization_id", profile.organization_id),
      fetchLocations()
    ]);
    if (ingredientsRes.error) throw ingredientsRes.error;
    if (lotsRes.error) throw lotsRes.error;
    if (refsRes.error) throw refsRes.error;
    const allIngredients = ingredientsRes.data || [];
    const allLots = lotsRes.data || [];
    const allRefs = refsRes.data || [];
    const ingredientById = new Map(allIngredients.map(i => [i.id, i]));
    const refByIngredientLocation = new Map(allRefs.map(r => [`${r.ingredient_id}:${r.location_id}`, r]));

    document.querySelector("#add-ingredient-from-stock")?.addEventListener("click", () => ingredientModal());
    document.querySelector("#view-archived-ingredients")?.addEventListener("click", () => archivedIngredientsModal());

    const byLocation = new Map();
    allLocations.forEach(loc => byLocation.set(loc.id, { location: loc, lots: [], referencedIds: new Set() }));
    allRefs.forEach(ref => {
      const entry = byLocation.get(ref.location_id);
      if (entry) entry.referencedIds.add(ref.ingredient_id);
    });
    allLots.forEach(lot => {
      const key = lot.location_id || "none";
      if (!canSeeLocation(lot.location_id)) return;
      if (!byLocation.has(key)) byLocation.set(key, { location: lot.location_id ? { id: lot.location_id, name: "—" } : { id: null, name: "Sans emplacement" }, lots: [], referencedIds: new Set() });
      byLocation.get(key).lots.push(lot);
    });

    if (stockLocationKey && byLocation.has(stockLocationKey)) {
      renderStockLocationPage(byLocation.get(stockLocationKey), allLocations, ingredientById, canEdit, refByIngredientLocation);
      return;
    }

    const globalReferenced = new Set(allRefs.map(r => r.ingredient_id));
    const globalMetrics = computeIngredientStockMetrics(allLots, ingredientById, globalReferenced);
    const entries = [...byLocation.values()].filter(e => e.location.id !== null);
    const cards = entries.map(({ location, lots, referencedIds }) => {
      const metrics = computeIngredientStockMetrics(lots, ingredientById, referencedIds);
      return `<article class="card location-summary-card" data-location-key="${location.id || "none"}">
        <div class="location-summary-head">
          <h3 class="location-summary-name">${escapeHtml(location.name)}</h3>
          <div class="stock-badges">
            ${metrics.criticalCount ? `<span class="stock-dot stock-dot-critical" title="Stock critique sur au moins un ingrédient">!</span>` : ""}
            ${metrics.alertCount ? `<span class="stock-dot stock-dot-warning" title="DLC proche sur au moins un lot">!</span>` : ""}
          </div>
        </div>
        <div class="location-summary-meta">${metrics.ingredientCount} ingrédient${metrics.ingredientCount > 1 ? "s" : ""} · Valeur : ${formatMoney(metrics.totalValue)}</div>
        <button type="button" class="button button-secondary button-full view-location-ingredients" data-key="${location.id || "none"}" style="margin-top:10px">Voir les ingrédients</button>
      </article>`;
    }).join("");

    content.innerHTML = `
      ${renderStockMetricCards(globalMetrics)}
      ${!allLocations.length ? `<div class="help-box" style="margin-bottom:16px">Aucun emplacement n’est encore créé. Ajoutez-en dans <strong>Paramètres → Emplacements</strong> pour organiser tes stocks par atelier.</div>` : ""}
      <div id="stock-locations-grid" class="grid grid-3">${cards || emptyState("Aucun stock", "Ajoutez votre premier ingrédient et sa première entrée de stock.")}</div>
    `;

    document.querySelectorAll(".view-location-ingredients").forEach(btn => btn.addEventListener("click", () => {
      stockLocationKey = btn.dataset.key;
      renderStock();
    }));
  }

  function renderStockLocationPage(entry, allLocations, ingredientById, canEdit, refByIngredientLocation) {
    // Autorisations fines portées par le rôle, appliquées aux emplacements autorisés
    const canViewLots = roleAllows("can_view_lots");
    const canTransfer = roleAllows("can_transfer_stock");
    const canAddLot = roleAllows("can_add_lot");
    const canMultiAdd = roleAllows("can_multi_add_lots");
    const canEditRef = roleAllows("can_edit_location_ref", false);
    const canEditProduct = roleAllows("can_edit_ingredient", false);
    const { location, lots, referencedIds } = entry;
    const locRef = ingredientId => refByIngredientLocation.get(`${ingredientId}:${location.id}`) || {};
    const byIngredient = new Map();
    (referencedIds || new Set()).forEach(id => {
      const ingredient = ingredientById.get(id);
      if (ingredient) byIngredient.set(id, { ingredient, lots: [] });
    });
    lots.forEach(lot => {
      const ingredient = ingredientById.get(lot.ingredient_id);
      if (!ingredient) return;
      if (!byIngredient.has(ingredient.id)) byIngredient.set(ingredient.id, { ingredient, lots: [] });
      byIngredient.get(ingredient.id).lots.push(lot);
    });
    let entries = [...byIngredient.values()].sort((a, b) => a.ingredient.name.localeCompare(b.ingredient.name, "fr"));

    const locationMetrics = computeIngredientStockMetrics(lots, ingredientById, referencedIds);

    const computed = entries.map(({ ingredient, lots: ingLots }) => {
      const ref = locRef(ingredient.id);
      const totalRemaining = ingLots.reduce((sum, lot) => sum + Number(lot.quantity_remaining || 0), 0);
      const value = ingLots.reduce((sum, lot) => sum + Number(lot.quantity_remaining || 0) * Number(lot.unit_price ?? ref.unit_price ?? ingredient.purchase_price ?? 0), 0);
      const hasAlert = ingLots.some(lot => lot.expiry_date && lot.expiry_date <= plusDaysISO(60) && Number(lot.quantity_remaining) > 0);
      const isCritical = totalRemaining <= Number(ingredient.low_stock_threshold || 0);
      return { ingredient, ref, lots: ingLots, totalRemaining, value, hasAlert, isCritical };
    });

    const anyStatusFilter = stockStatusFilter.critical || stockStatusFilter.alert;
    const visibleComputed = !anyStatusFilter ? computed : computed.filter(item =>
      (stockStatusFilter.critical && item.isCritical) || (stockStatusFilter.alert && item.hasAlert)
    );

    const cards = visibleComputed.map(({ ingredient, ref, totalRemaining, value, hasAlert, isCritical }) => `<article class="card stock-card" data-searchable data-ingredient-id="${ingredient.id}">
        <div class="stock-card-head">
          <h3>${escapeHtml(ingredient.name)}</h3>
          <div class="stock-badges">
            ${isCritical ? `<span class="stock-dot stock-dot-critical" title="Stock critique">!</span>` : ""}
            ${hasAlert ? `<span class="stock-dot stock-dot-warning" title="DLC proche sur au moins un lot">!</span>` : ""}
          </div>
        </div>
        <div class="stock-card-qty">${formatNumber(totalRemaining)} ${escapeHtml(ingredient.unit)}</div>
        ${ref.suppliers?.name ? `<div class="muted stock-card-supplier">${escapeHtml(ref.suppliers.name)}</div>` : ""}
        ${ref.reference ? `<div class="muted stock-card-supplier">Réf. ${escapeHtml(ref.reference)}</div>` : ""}
        <div class="stock-card-price"><span>${formatMoney(ref.unit_price ?? ingredient.purchase_price)} / ${escapeHtml(ingredient.unit)}</span><span class="muted">Valeur : ${formatMoney(value)}</span></div>
        <div class="stock-card-actions">
          ${canViewLots ? `<button class="icon-button icon-small view-stock-detail" data-id="${ingredient.id}" title="Voir le détail par emplacement">${ICONS.eye}</button>` : ""}
          ${canEdit && canTransfer ? `<button class="icon-button icon-small transfer-stock" data-id="${ingredient.id}" title="Transférer entre emplacements">${ICONS.swap}</button>` : ""}
          ${canEdit && canAddLot ? `<button class="icon-button icon-small add-stock-for" data-id="${ingredient.id}" title="Ajouter une entrée">${ICONS.plus}</button>` : ""}
          ${canEdit && canEditRef ? `<button class="icon-button icon-small edit-location-ref" data-id="${ingredient.id}" title="Modifier prix/fournisseur/référence sur cet emplacement">${ICONS.tag}</button>` : ""}
          ${canEdit && canEditProduct ? `<button class="icon-button icon-small edit-ingredient-from-stock" data-id="${ingredient.id}" title="Modifier l’ingrédient">${ICONS.edit}</button>` : ""}
          ${canEdit && canEditProduct ? `<button class="icon-button icon-small danger delete-ingredient-from-stock" data-id="${ingredient.id}" title="Supprimer l’ingrédient">${ICONS.trash}</button>` : ""}
        </div>
      </article>`).join("");

    content.innerHTML = `
      ${renderStockMetricCards(locationMetrics)}
      <div class="finished-page-head">
        <button type="button" id="stock-back" class="icon-button" title="Retour">←</button>
        <span class="location-pill">📍 ${escapeHtml(location.name)}</span>
        <div class="toolbar-spacer"></div>
        ${canEdit && canMultiAdd ? `<button type="button" id="multi-add-stock" class="button button-primary">＋ Ajout multiple</button>` : ""}
      </div>
      <div class="toolbar" style="margin-top:14px">
        <input id="stock-search" class="search" placeholder="Rechercher un ingrédient…">
        <label class="checkbox-pill"><input type="checkbox" id="filter-critical" ${stockStatusFilter.critical ? "checked" : ""}> Stock critique</label>
        <label class="checkbox-pill"><input type="checkbox" id="filter-alert" ${stockStatusFilter.alert ? "checked" : ""}> Alerte DDM</label>
        <div class="toolbar-spacer"></div>
      </div>
      <div id="stock-grid" class="grid grid-3">${cards || emptyState("Aucun ingrédient", "Aucun ingrédient sur cet emplacement.")}</div>
    `;

    document.querySelector("#stock-back").addEventListener("click", () => {
      stockLocationKey = null;
      renderStock();
    });
    document.querySelector("#filter-critical").addEventListener("change", event => {
      stockStatusFilter.critical = event.target.checked;
      renderStock();
    });
    document.querySelector("#filter-alert").addEventListener("change", event => {
      stockStatusFilter.alert = event.target.checked;
      renderStock();
    });
    document.querySelector("#stock-search").addEventListener("input", event => {
      const q = event.target.value.trim().toLocaleLowerCase("fr");
      document.querySelectorAll("#stock-grid .stock-card").forEach(card => {
        card.hidden = Boolean(q) && !card.textContent.toLocaleLowerCase("fr").includes(q);
      });
    });
    document.querySelector("#multi-add-stock")?.addEventListener("click", () => multiAddStockModal(location, ingredientById, refByIngredientLocation));
    document.querySelectorAll(".add-stock-for").forEach(btn => btn.addEventListener("click", () => stockLotModal(byIngredient.get(btn.dataset.id)?.ingredient, allLocations, location.id || null)));
    document.querySelectorAll(".view-stock-detail").forEach(btn => btn.addEventListener("click", () => stockDetailModal(byIngredient.get(btn.dataset.id))));
    document.querySelectorAll(".transfer-stock").forEach(btn => btn.addEventListener("click", () => transferStockModal(byIngredient.get(btn.dataset.id), allLocations)));
    document.querySelectorAll(".edit-ingredient-from-stock").forEach(btn => btn.addEventListener("click", () => ingredientModal(byIngredient.get(btn.dataset.id)?.ingredient)));
    document.querySelectorAll(".edit-location-ref").forEach(btn => btn.addEventListener("click", () => ingredientLocationRefModal(byIngredient.get(btn.dataset.id)?.ingredient, location, locRef(btn.dataset.id))));
    document.querySelectorAll(".delete-ingredient-from-stock").forEach(btn => btn.addEventListener("click", async () => {
      if (!confirm("Retirer cet ingrédient ? Il disparaîtra des listes actives (recettes, entrées de stock…) mais tout son historique (lots, recettes existantes, consommations, prix) reste intact et consultable.")) return;
      const { error: archiveError } = await sb.from("ingredients").update({ archived: true }).eq("id", btn.dataset.id);
      if (archiveError) return showError(archiveError);
      const { error: refsError } = await sb.from("ingredient_locations").delete().eq("ingredient_id", btn.dataset.id);
      if (refsError) return showError(refsError);
      showToast("Ingrédient retiré."); renderStock();
    }));
  }

  function stockDetailModal(entry) {
    if (!entry) return;
    const { ingredient, lots } = entry;
    const visibleLots = lots.filter(lot => Number(lot.quantity_remaining) > 0);
    const sorted = [...visibleLots].sort((a, b) => (a.locations?.name || "").localeCompare(b.locations?.name || "", "fr") || a.received_at.localeCompare(b.received_at));
    const total = visibleLots.reduce((sum, lot) => sum + Number(lot.quantity_remaining || 0), 0);
    const rows = sorted.map(lot => `
      <div class="lot-row">
        <div class="lot-row-main">
          <div class="lot-row-title">${lot.lot_number ? escapeHtml(lot.lot_number) : `<span class="muted">Sans lot</span>`} <span class="lot-location muted">📍 ${escapeHtml(lot.locations?.name || "Emplacement non renseigné")}</span></div>
          <div class="lot-row-meta muted">📅 Réception : ${formatDate(lot.received_at)} &nbsp; 🕓 DLC : ${lot.expiry_date ? formatDate(lot.expiry_date) : "—"} &nbsp; 💶 ${lot.unit_price != null ? formatMoney(lot.unit_price) : "—"} / ${escapeHtml(lot.unit)}</div>
        </div>
        <div class="lot-row-qty">${formatNumber(lot.quantity_remaining)} ${escapeHtml(lot.unit)}</div>
        <div class="lot-row-actions">
          <button class="icon-button icon-small edit-lot" data-id="${lot.id}" title="Modifier ce lot">✎</button>
          <button class="icon-button icon-small danger delete-lot" data-id="${lot.id}" title="Supprimer ce lot">–</button>
        </div>
      </div>`).join("");

    openModal({
      title: ingredient.name,
      kicker: `Stock total : ${formatNumber(total)} ${ingredient.unit}`,
      html: `<div class="lot-list">${rows || emptyState("Aucun lot", "Ajoutez une entrée de stock pour cet ingrédient.")}</div>
        <div class="lot-total">Total disponible : <strong>${formatNumber(total)} ${escapeHtml(ingredient.unit)}</strong> (${visibleLots.length} lot${visibleLots.length > 1 ? "s" : ""})</div>`,
      width: "620px"
    });

    modalBody.querySelectorAll(".edit-lot").forEach(btn => btn.addEventListener("click", async () => {
      const lot = lots.find(l => l.id === btn.dataset.id);
      const locationsList = await fetchLocations();
      editLotModal(lot, ingredient, locationsList);
    }));
    modalBody.querySelectorAll(".delete-lot").forEach(btn => btn.addEventListener("click", () => {
      const lot = lots.find(l => l.id === btn.dataset.id);
      if (lot) deleteLotModal({ kind: "ingredient", lot, name: ingredient.name, unit: lot.unit || ingredient.unit, onDone: renderStock });
    }));
  }

  // Motif d'une correction ou d'une suppression de lot. « Autre » exige
  // une précision. Le motif part au journal des mouvements.
  const LOT_EDIT_REASONS = ["Inventaire physique", "Erreur de saisie", "Perte / casse", "Produit périmé", "Autre"];
  const LOT_DELETE_REASONS = ["Saisie en double", "Lot de test", "Erreur de saisie", "Autre"];
  function lotReasonFields(reasons, required) {
    return `<div><label>Motif${required ? " *" : ""}</label><select name="reason_choice"><option value="">— Choisir —</option>${reasons.map(r => `<option value="${escapeHtml(r)}">${escapeHtml(r)}</option>`).join("")}</select></div>
      <div><label>Précision</label><input name="reason_detail" maxlength="200" placeholder="Ex. : recomptage du 09/10"></div>`;
  }
  // Renvoie le motif complet, ou null. Signale l'erreur si nécessaire.
  function readLotReason(values, required) {
    const choice = (values.reason_choice || "").trim();
    const detail = (values.reason_detail || "").trim();
    if (!choice) {
      if (required) showToast("Indique le motif.", "error");
      return null;
    }
    if (choice === "Autre" && !detail) { showToast("Précise le motif « Autre ».", "error"); return false; }
    return choice === "Autre" ? detail : (detail ? `${choice} — ${detail}` : choice);
  }
  // Suppression d'un lot : motif demandé, puis la base contrôle et trace
  function deleteLotModal({ kind, lot, name, unit, onDone }) {
    openModal({
      title: "Supprimer le lot",
      kicker: name,
      width: "560px",
      html: `<form id="delete-lot-form" class="form-grid">
        <div class="span-2 warning-box">Lot ${escapeHtml(lot.lot_number || "sans numéro")} : ${formatNumber(lot.quantity_remaining)} ${escapeHtml(unit || "")} restant(s). La suppression est inscrite dans les mouvements de stock, avec son motif. Un lot déjà utilisé ne peut pas être supprimé : corrige sa quantité à 0.</div>
        ${lotReasonFields(LOT_DELETE_REASONS, true)}
        <div class="form-actions span-2"><button type="button" class="button button-ghost" data-close-modal>Annuler</button><button class="button button-danger" type="submit">Supprimer</button></div>
      </form>`
    });
    modalBody.querySelector("[data-close-modal]").addEventListener("click", closeModal);
    modalBody.querySelector("#delete-lot-form").addEventListener("submit", async event => {
      event.preventDefault();
      const button = event.submitter;
      const reason = readLotReason(formObject(event.currentTarget), true);
      if (!reason) return;
      submitButtonLoading(button, true);
      const { error } = await sb.rpc(kind === "supply" ? "delete_supply_lot" : "delete_ingredient_lot", { p_lot_id: lot.id, p_reason: reason });
      submitButtonLoading(button, false);
      if (error) return showError(error);
      closeModal(); showToast("Lot supprimé."); onDone();
    });
  }

  function editLotModal(lot, ingredient, locationsList) {
    const locationName = (locationsList || []).find(l => l.id === lot.location_id)?.name || "Sans emplacement";
    openModal({
      title: "Modifier le lot",
      kicker: ingredient.name,
      html: `<form id="edit-lot-form" class="form-grid">
        <div><label>Numéro de lot</label><input name="lot_number" value="${escapeHtml(lot.lot_number || "")}" placeholder="Laisser vide si sans lot"></div>
        <div><label>Emplacement</label><input value="${escapeHtml(locationName)}" disabled>
          <p class="form-note">Pour le déplacer, utilise « Transférer ».</p></div>
        <div><label>Date de réception *</label><input name="received_at" type="date" required max="${todayISO()}" value="${lot.received_at}"></div>
        <div><label>DLC / DDM</label><input name="expiry_date" type="date" value="${lot.expiry_date || ""}"></div>
        <div><label>Quantité restante *</label><input name="quantity_remaining" type="number" min="0" max="${lot.quantity_received}" step="0.001" required value="${lot.quantity_remaining}">
          <p class="form-note">Au plus ${formatNumber(lot.quantity_received)} ${escapeHtml(lot.unit || ingredient.unit || "")}, la quantité reçue. Pour ajouter du stock, saisis une réception.</p></div>
        <div><label>Prix payé / unité (€)</label><input name="unit_price" type="number" min="0" step="0.0001" value="${lot.unit_price ?? 0}"></div>
        ${lotReasonFields(LOT_EDIT_REASONS, false)}
        <p class="form-note span-2">Le motif est obligatoire si la quantité ou le prix change. Toute correction est inscrite dans les mouvements de stock.</p>
        <div class="form-actions span-2"><button type="button" class="button button-ghost" data-close-modal>Annuler</button><button class="button button-primary" type="submit">Enregistrer</button></div>
      </form>`
    });
    modalBody.querySelector("[data-close-modal]").addEventListener("click", closeModal);
    modalBody.querySelector("#edit-lot-form").addEventListener("submit", async event => {
      event.preventDefault();
      const button = event.submitter;
      const values = formObject(event.currentTarget);
      const qty = Number(values.quantity_remaining);
      const price = Number(values.unit_price || 0);
      const mustExplain = qty !== Number(lot.quantity_remaining) || price !== Number(lot.unit_price || 0);
      const reason = readLotReason(values, mustExplain);
      if (reason === false || (mustExplain && !reason)) return;
      submitButtonLoading(button, true);
      const { error } = await sb.rpc("update_ingredient_lot", {
        p_lot_id: lot.id,
        p_lot_number: values.lot_number.trim() || null,
        p_received_at: values.received_at,
        p_expiry_date: values.expiry_date || null,
        p_quantity_remaining: qty,
        p_unit_price: price,
        p_reason: reason || null
      });
      submitButtonLoading(button, false);
      if (error) return showError(error);
      showToast("Lot mis à jour."); closeModal(); renderStock();
    });
  }

  async function transferStockModal(entry, locationsList) {
    if (!entry) return;
    const { ingredient, lots } = entry;
    const available = lots.filter(lot => Number(lot.quantity_remaining) > 0);
    if (!available.length) return showToast("Aucun stock disponible à transférer.", "error");
    if (!locationsList?.length) return showToast("Créez d’abord un emplacement dans Paramètres.", "error");
    openModal({
      title: "Transférer du stock",
      kicker: ingredient.name,
      html: `<form id="transfer-form" class="form-grid">
        <div class="span-2"><label>Lot source *</label><select name="lot_id" required>${available.map(lot => `<option value="${lot.id}">${lot.lot_number ? escapeHtml(lot.lot_number) : "Sans lot"} — ${escapeHtml(lot.locations?.name || "Emplacement non renseigné")} — ${formatNumber(lot.quantity_remaining)} ${escapeHtml(lot.unit)} disponible(s)</option>`).join("")}</select></div>
        <div><label>Quantité à transférer *</label><input name="quantity" type="number" min="0.001" step="0.001" required></div>
        <div><label>Emplacement de destination *</label><select name="destination_location_id" required><option value="">Choisir…</option>${locationsList.map(loc => `<option value="${loc.id}">${escapeHtml(loc.name)}</option>`).join("")}</select></div>
        <div class="form-actions span-2"><button type="button" class="button button-ghost" data-close-modal>Annuler</button><button class="button button-primary" type="submit">Transférer</button></div>
      </form>`
    });
    modalBody.querySelector("[data-close-modal]").addEventListener("click", closeModal);
    modalBody.querySelector("#transfer-form").addEventListener("submit", async event => {
      event.preventDefault();
      const button = event.submitter;
      submitButtonLoading(button, true);
      try {
        const values = formObject(event.currentTarget);
        // Le transfert s'inscrit lui-même au journal, dans la même opération
        const { error } = await sb.rpc("transfer_ingredient_lot", {
          p_lot_id: values.lot_id,
          p_quantity: Number(values.quantity),
          p_destination_location_id: values.destination_location_id
        });
        if (error) throw error;
        closeModal(); showToast("Stock transféré."); renderStock();
      } catch (err) { showError(err); }
      finally { submitButtonLoading(button, false); }
    });
  }

  // Réception groupée : on coche d'abord tout ce qui est arrivé, puis on saisit
  // lot / DDM / quantité pour chaque ligne, et tout part en une fois.
  async function multiAddStockModal(location, ingredientById, refByIngredientLocation) {
    const { data: allIngredients, error } = await sb.from("ingredients")
      .select("id, name, unit, purchase_price").eq("organization_id", profile.organization_id)
      .eq("archived", false).order("name");
    if (error) return showError(error);
    if (!allIngredients?.length) return showToast("Aucun ingrédient référencé.", "error");

    const selected = new Map(); // id -> { lot_number, expiry_date, quantity, unit_price }

    function renderStep1() {
      openModal({
        title: "Réception groupée",
        kicker: location.name,
        width: "min(720px, 95vw)",
        html: `
          <p class="form-note">Coche tout ce que tu viens de recevoir, puis passe à la saisie des lots.</p>
          <input id="multi-add-search" class="search" placeholder="Rechercher un ingrédient…" style="margin:12px 0">
          <div class="compat-list multi-add-list">
            ${allIngredients.map(ing => `<label class="compat-list-item" data-searchable-multi>
              <input type="checkbox" class="multi-ing" value="${ing.id}" ${selected.has(ing.id) ? "checked" : ""}>
              <span>${escapeHtml(ing.name)}</span>
              <span class="muted" style="font-size:12px">${escapeHtml(ing.unit || "")}</span>
            </label>`).join("")}
          </div>
          <div class="form-actions" style="margin-top:16px">
            <button type="button" class="button button-ghost" data-close-modal>Annuler</button>
            <button type="button" class="button button-primary" id="multi-add-next">Suivant — saisir les lots</button>
          </div>`
      });
      modalBody.querySelector("[data-close-modal]").addEventListener("click", closeModal);
      modalBody.querySelector("#multi-add-search").addEventListener("input", e => {
        const q = e.target.value.trim().toLocaleLowerCase("fr");
        modalBody.querySelectorAll("[data-searchable-multi]").forEach(el => {
          el.hidden = Boolean(q) && !el.textContent.toLocaleLowerCase("fr").includes(q);
        });
      });
      modalBody.querySelector("#multi-add-next").addEventListener("click", () => {
        modalBody.querySelectorAll(".multi-ing").forEach(cb => {
          if (cb.checked && !selected.has(cb.value)) selected.set(cb.value, {});
          if (!cb.checked) selected.delete(cb.value);
        });
        if (!selected.size) return showToast("Coche au moins un ingrédient.", "error");
        renderStep2();
      });
    }

    function renderStep2() {
      const rows = [...selected.keys()].map(id => {
        const ing = allIngredients.find(i => i.id === id);
        const ref = refByIngredientLocation?.get(`${id}:${location.id}`);
        const defaultPrice = ref?.unit_price ?? ing.purchase_price ?? "";
        return `<tr data-ing="${id}">
          <td><strong>${escapeHtml(ing.name)}</strong><div class="muted" style="font-size:11.5px">${escapeHtml(ing.unit || "")}</div></td>
          <td><input class="ma-lot" placeholder="N° de lot"></td>
          <td><input type="date" class="ma-ddm"></td>
          <td><input type="number" min="0" step="0.001" class="ma-qty" placeholder="0"></td>
          <td><input type="number" min="0" step="0.0001" class="ma-price" value="${defaultPrice}" placeholder="optionnel"></td>
          <td><button type="button" class="icon-button icon-small danger ma-remove" title="Retirer">${ICONS.trash}</button></td>
        </tr>`;
      }).join("");

      openModal({
        title: "Réception groupée — saisie des lots",
        kicker: `${location.name} · ${selected.size} ingrédient(s)`,
        width: "min(1000px, 96vw)",
        html: `
          <p class="form-note">Le prix est pré-rempli avec celui de cet emplacement — modifie-le si le tarif a changé. La quantité est obligatoire, le reste facultatif.</p>
          <div class="table-wrap" style="margin-top:12px">
            <table><thead><tr><th>Ingrédient</th><th>N° de lot</th><th>DDM</th><th>Quantité *</th><th>Prix / unité</th><th></th></tr></thead>
            <tbody id="multi-add-body">${rows}</tbody></table>
          </div>
          <div class="form-actions" style="margin-top:16px">
            <button type="button" class="button button-ghost" id="multi-add-back">← Retour à la sélection</button>
            <button type="button" class="button button-primary" id="multi-add-save">Enregistrer toutes les entrées</button>
          </div>`
      });
      modalBody.querySelector("#multi-add-back").addEventListener("click", renderStep1);
      modalBody.querySelectorAll(".ma-remove").forEach(btn => btn.addEventListener("click", () => {
        const tr = btn.closest("tr");
        selected.delete(tr.dataset.ing);
        tr.remove();
        if (!selected.size) { closeModal(); showToast("Aucune ligne restante."); }
      }));
      modalBody.querySelector("#multi-add-save").addEventListener("click", async () => {
        const btn = modalBody.querySelector("#multi-add-save");
        const payload = [];
        let invalid = false;
        modalBody.querySelectorAll("#multi-add-body tr").forEach(tr => {
          const qty = Number(tr.querySelector(".ma-qty").value || 0);
          if (qty <= 0) { invalid = true; tr.querySelector(".ma-qty").style.borderColor = "var(--red)"; return; }
          const priceRaw = tr.querySelector(".ma-price").value;
          const ingRef = allIngredients.find(i => i.id === tr.dataset.ing);
          payload.push({
            organization_id: profile.organization_id,
            ingredient_id: tr.dataset.ing,
            location_id: location.id,
            lot_number: tr.querySelector(".ma-lot").value.trim() || null,
            expiry_date: tr.querySelector(".ma-ddm").value || null,
            // La colonne s'appelle quantity_received, pas quantity_initial
            quantity_received: qty,
            quantity_remaining: qty,
            unit: ingRef?.unit || null,
            unit_price: priceRaw === "" ? null : Number(priceRaw),
            received_at: todayISO()
          });
        });
        if (invalid) return showToast("Renseigne une quantité sur chaque ligne (ou retire-la).", "error");
        submitButtonLoading(btn, true);
        const { error: insError } = await sb.from("ingredient_lots").insert(payload);
        submitButtonLoading(btn, false);
        if (insError) return showError(insError);
        closeModal();
        showToast(`${payload.length} entrée(s) enregistrée(s).`);
        renderStock();
      });
    }

    renderStep1();
  }

  async function stockLotModal(preselectedIngredient = null, locationsList = null, lockedLocationId = undefined) {
    const [{ data: ingredients, error }, rawLocs] = await Promise.all([
      sb.from("ingredients").select("id,name,unit,purchase_price").eq("organization_id", profile.organization_id).eq("archived", false).order("name"),
      locationsList ? Promise.resolve(locationsList) : fetchLocations()
    ]);
    const locs = rawLocs.filter(l => !l.is_external_logistics);
    if (error) return showError(error);
    if (!ingredients.length) return showToast("Créez d’abord un ingrédient.", "error");
    const initialIngredient = preselectedIngredient ? ingredients.find(i => i.id === preselectedIngredient.id) : ingredients[0];
    const lockedLocation = lockedLocationId !== undefined ? locs.find(l => l.id === lockedLocationId) : null;
    const showLocationPicker = lockedLocationId === undefined;

    let priceByIngredient = new Map();
    if (lockedLocationId) {
      const { data: locRefs } = await sb.from("ingredient_locations").select("ingredient_id, unit_price").eq("organization_id", profile.organization_id).eq("location_id", lockedLocationId);
      priceByIngredient = new Map((locRefs || []).filter(r => r.unit_price != null).map(r => [r.ingredient_id, r.unit_price]));
    }
    const priceFor = ingredientId => priceByIngredient.get(ingredientId) ?? ingredients.find(i => i.id === ingredientId)?.purchase_price ?? 0;

    openModal({
      title: "Nouvelle entrée de stock",
      kicker: lockedLocation ? lockedLocation.name : "Lot matière première",
      html: `<form id="stock-lot-form" class="form-grid">
        <div class="span-2"><label>Ingrédient *</label><select name="ingredient_id" required>${ingredients.map(i => `<option value="${i.id}" data-unit="${escapeHtml(i.unit)}" data-price="${priceFor(i.id)}" ${preselectedIngredient?.id === i.id ? "selected" : ""}>${escapeHtml(i.name)} — ${escapeHtml(i.unit)}</option>`).join("")}</select></div>
        <div><label>Numéro de lot</label><input name="lot_number" placeholder="Laisser vide si sans lot"></div>
        <div><label>Date de réception *</label><input name="received_at" type="date" required value="${todayISO()}"></div>
        <div><label>DLC / DDM</label><input name="expiry_date" type="date"></div>
        <div><label>Quantité${showLocationPicker ? " par emplacement coché" : ""} *</label><input name="quantity_received" type="number" min="0.001" step="0.001" required></div>
        <div><label>Prix payé / unité (€)</label><input id="stock-lot-price" name="unit_price" type="number" min="0" step="0.0001" value="${priceFor(initialIngredient?.id)}"></div>
        ${!showLocationPicker ? (lockedLocation ? `<div class="span-2 help-box">📍 Cette entrée sera ajoutée uniquement sur <strong>${escapeHtml(lockedLocation.name)}</strong>. Le prix pré-rempli est celui déjà configuré sur cet emplacement pour cet ingrédient.</div>` : "") : (locs.length ? `<div class="span-2"><label>Emplacements *</label>
          <div class="compat-list">${locs.map(l => `<label class="compat-list-item"><input type="checkbox" name="location_ids" value="${l.id}"><span>${escapeHtml(l.name)}</span></label>`).join("")}</div>
          <p class="form-note">La même quantité et le même prix sont appliqués à chaque emplacement coché ; chaque lot reste ensuite modifiable indépendamment (prix, quantité…) sans affecter les autres.</p>
        </div>` : `<div class="span-2 help-box">Aucun emplacement n’est encore créé. L’entrée sera enregistrée sans emplacement ; vous pouvez en créer dans <strong>Paramètres → Emplacements</strong>.</div>`)}
        <div class="span-2"><label>Bon de livraison / facture fournisseur (PDF, image)</label><input name="attachment" type="file" accept=".pdf,image/*"></div>
        <div class="form-actions span-2"><button type="button" class="button button-ghost" data-close-modal>Annuler</button><button class="button button-primary" type="submit">Enregistrer l’entrée</button></div>
      </form>`
    });
    modalBody.querySelector("[data-close-modal]").addEventListener("click", closeModal);
    modalBody.querySelector('select[name="ingredient_id"]').addEventListener("change", event => {
      modalBody.querySelector("#stock-lot-price").value = event.target.selectedOptions[0].dataset.price || 0;
    });
    modalBody.querySelector("#stock-lot-form").addEventListener("submit", async event => {
      event.preventDefault();
      const button = event.submitter;
      submitButtonLoading(button, true);
      try {
        const values = formObject(event.currentTarget);
        const selected = ingredients.find(i => i.id === values.ingredient_id);
        const checkedLocationIds = showLocationPicker
          ? [...event.currentTarget.querySelectorAll('input[name="location_ids"]:checked')].map(el => el.value)
          : (lockedLocationId ? [lockedLocationId] : []);
        if (showLocationPicker && locs.length && !checkedLocationIds.length) throw new Error("Cochez au moins un emplacement.");
        const file = event.currentTarget.elements.attachment.files[0];
        const attachmentPath = await uploadPrivateFile("stock-files", file);
        const basePayload = {
          organization_id: profile.organization_id,
          ingredient_id: values.ingredient_id,
          lot_number: values.lot_number.trim() || null,
          received_at: values.received_at,
          expiry_date: values.expiry_date || null,
          quantity_received: Number(values.quantity_received),
          quantity_remaining: Number(values.quantity_received),
          unit: selected.unit,
          unit_price: Number(values.unit_price || 0),
          attachment_path: attachmentPath
        };
        const rows = checkedLocationIds.length
          ? checkedLocationIds.map(locationId => ({ ...basePayload, location_id: locationId }))
          : [{ ...basePayload, location_id: null }];
        const { error: insertError } = await sb.from("ingredient_lots").insert(rows);
        if (insertError) throw insertError;
        if (checkedLocationIds.length) {
          const { error: refsError } = await sb.from("ingredient_locations").upsert(
            checkedLocationIds.map(locationId => ({ organization_id: profile.organization_id, ingredient_id: values.ingredient_id, location_id: locationId })),
            { onConflict: "ingredient_id,location_id" }
          );
          if (refsError) throw refsError;
        }
        closeModal(); showToast(rows.length > 1 ? `Entrée enregistrée sur ${rows.length} emplacements.` : "Entrée de stock enregistrée."); renderStock();
      } catch (err) { showError(err); }
      finally { submitButtonLoading(button, false); }
    });
  }

  // Paramètres — Emplacements
  // Paramètres production : étapes amont libres, étapes système figées,
  // et l'étape à partir de laquelle le rétroplanning cesse de relancer.
  async function renderProductionSettings() {
    const canEdit = pageCan("production-settings");
    setHeader("production-settings", canEdit ? `<button id="add-production-stage" class="button button-primary">＋ Ajouter une étape</button>` : "");
    await loadProductionStages();
    const { data: org } = await sb.from("organizations").select("retro_silence_from_status").eq("id", profile.organization_id).single();
    const { checkpoints, enabled: checkpointsEnabled } = await loadProductionCheckpoints();
    const checkpointRows = checkpoints.map((cp, idx) => `<div class="draggable-row" draggable="${canEdit}" data-id="${cp.id}" data-idx="${idx}">
        <span class="drag-handle">⠿</span>
        <strong>${cp.section ? `<span class="muted" style="font-weight:500">${escapeHtml(cp.section)} · </span>` : ""}${escapeHtml(cp.label)}</strong>
        ${badge(CHECKPOINT_TYPES[cp.field_type] || cp.field_type, "info")}${cp.unit ? ` ${badge(cp.unit)}` : ""}${cp.required ? ` ${badge("Obligatoire", "warning")}` : ""}
        <div class="table-actions">${canEdit ? `<button class="button button-small button-ghost edit-checkpoint" data-id="${cp.id}">Modifier</button><button class="button button-small button-danger delete-checkpoint" data-id="${cp.id}">Supprimer</button>` : ""}</div>
      </div>`).join("");
    const silence = org?.retro_silence_from_status || PRODUCTION_CUSTOM_STAGES[0]?.key;

    const customRows = PRODUCTION_CUSTOM_STAGES.map((s, idx) => `<div class="draggable-row" draggable="${canEdit}" data-id="${s.id || ""}" data-idx="${idx}">
        <span class="drag-handle">⠿</span>
        <strong>${escapeHtml(s.label)}</strong> ${badge("Étape libre", s.tone)}
        <div class="table-actions">${canEdit && s.id ? `<button class="button button-small button-ghost edit-production-stage" data-id="${s.id}">Modifier</button><button class="button button-small button-danger delete-production-stage" data-id="${s.id}">Supprimer</button>` : ""}</div>
      </div>`).join("");

    const systemRows = [
      ["En cours", "Sort la matière première du stock"],
      ["Terminé", "Crée le lot de produit fini"],
      ["Archivé", "Retire la production de la vue"]
    ].map(([label, role]) => `<div class="draggable-row system-stage-row">
        <span class="drag-handle system-stage-lock" title="Étape système">🔒</span>
        <strong>${label}</strong> <span class="muted" style="font-size:12.5px">— ${role}</span>
      </div>`).join("");

    content.innerHTML = `
      <div class="form-section-title">Étapes de production${helpTip("Les étapes libres se placent avant « En cours ». Glisse-les pour changer leur ordre. Les trois dernières sont figées : elles déclenchent la sortie de matière, la création du lot et l'archivage.")}</div>
      <div id="production-stages-list">${customRows || emptyState("Aucune étape libre", "")}</div>
      <div style="margin-top:6px">${systemRows}</div>

      <div class="form-section-title" style="margin-top:32px">Relances du rétroplanning${helpTip("Quand une production atteint cette étape, le rétroplanning cesse de réclamer ce produit : le travail est engagé.")}</div>
      <div class="form-grid" style="max-width:520px">
        <div class="span-2"><label>Arrêter de relancer dès l’étape</label>
          <select id="retro-silence-select" ${!canEdit ? "disabled" : ""}>
            ${[...PRODUCTION_CUSTOM_STAGES.map(s => [s.key, s.label]), ["in_progress", "En cours"]]
              .map(([k, l]) => `<option value="${k}" ${silence === k ? "selected" : ""}>${escapeHtml(l)}</option>`).join("")}
          </select>
        </div>
      </div>
      ${canEdit ? `<button type="button" id="save-retro-silence" class="button button-primary" style="margin-top:12px">Enregistrer</button>` : ""}

      <div class="form-section-title" style="margin-top:32px">Points de contrôle à la clôture${helpTip("Les relevés demandés quand une production passe à « Terminé » : températures, heures de passage, contrôles visuels… Chaque relevé garde une copie de son libellé : renommer ou supprimer un point de contrôle ne modifie jamais l'historique des productions déjà closes.")}</div>
      <div class="checkbox-row"><label class="switch"><input type="checkbox" id="checkpoints-enabled" ${checkpointsEnabled ? "checked" : ""} ${!canEdit ? "disabled" : ""}><span class="switch-slider"></span></label><span>Demander des points de contrôle à la clôture</span></div>
      <p class="form-note">Désactivé, une production se termine par une simple confirmation.</p>
      <div id="checkpoints-list" class="${checkpointsEnabled ? "" : "is-disabled"}" style="margin-top:10px">${checkpointRows || emptyState("Aucun point de contrôle", "")}</div>
      ${canEdit ? `<button type="button" id="add-checkpoint" class="button button-secondary" style="margin-top:10px">${ICONS.plus} Ajouter un point de contrôle</button>` : ""}

      <div class="form-section-title" style="margin-top:32px">Numéro de lot${helpTip("Choisis les éléments du numéro de lot et leur ordre, en les faisant glisser. Les codes se renseignent sur chaque emplacement et chaque produit. Un code absent est simplement omis. En cas de doublon le même jour, un suffixe -2, -3… est ajouté.")}</div>
      <div id="lot-format-section"></div>
    `;

    document.querySelector("#add-production-stage")?.addEventListener("click", () => productionStageModal());
    document.querySelectorAll(".edit-production-stage").forEach(btn => btn.addEventListener("click", () =>
      productionStageModal(PRODUCTION_CUSTOM_STAGES.find(s => s.id === btn.dataset.id))));
    document.querySelectorAll(".delete-production-stage").forEach(btn => btn.addEventListener("click", async () => {
      const s = PRODUCTION_CUSTOM_STAGES.find(x => x.id === btn.dataset.id);
      if (!confirm(`Supprimer l’étape « ${s?.label} » ?`)) return;
      const { error } = await sb.rpc("delete_production_stage", { p_stage_id: btn.dataset.id });
      if (error) return showError(error);
      showToast("Étape supprimée."); renderProductionSettings();
    }));
    document.querySelector("#save-retro-silence")?.addEventListener("click", async () => {
      const value = document.querySelector("#retro-silence-select").value;
      const { error } = await sb.from("organizations").update({ retro_silence_from_status: value }).eq("id", profile.organization_id);
      if (error) return showError(error);
      showToast("Enregistré.");
    });
    await renderLotFormatSection(canEdit);

    document.querySelector("#checkpoints-enabled")?.addEventListener("change", async e => {
      const { error } = await sb.from("organizations")
        .update({ production_checkpoints_enabled: e.target.checked }).eq("id", profile.organization_id);
      if (error) { e.target.checked = !e.target.checked; return showError(error); }
      document.querySelector("#checkpoints-list")?.classList.toggle("is-disabled", !e.target.checked);
      showToast(e.target.checked ? "Points de contrôle activés." : "Points de contrôle désactivés.");
    });
    document.querySelector("#add-checkpoint")?.addEventListener("click", () => checkpointModal(null, checkpoints));
    document.querySelectorAll(".edit-checkpoint").forEach(btn => btn.addEventListener("click", () =>
      checkpointModal(checkpoints.find(x => x.id === btn.dataset.id), checkpoints)));
    document.querySelectorAll(".delete-checkpoint").forEach(btn => btn.addEventListener("click", async () => {
      const cp = checkpoints.find(x => x.id === btn.dataset.id);
      if (!confirm(`Supprimer le point de contrôle « ${cp?.label} » ?\n\nLes relevés déjà saisis sur les productions passées sont conservés.`)) return;
      const { error } = await sb.from("production_checkpoints").delete().eq("id", btn.dataset.id);
      if (error) return showError(error);
      showToast("Point de contrôle supprimé."); renderProductionSettings();
    }));
    if (canEdit) {
      wireDragReorder("#checkpoints-list", ".draggable-row", async orderedIds => {
        for (let i = 0; i < orderedIds.length; i++) {
          const { error } = await sb.from("production_checkpoints").update({ sort_order: (i + 1) * 10 }).eq("id", orderedIds[i]);
          if (error) return showError(error);
        }
        renderProductionSettings();
      });
      wireDragReorder("#production-stages-list", ".draggable-row", async orderedIds => {
        for (let i = 0; i < orderedIds.length; i++) {
          const { error } = await sb.from("production_stages").update({ sort_order: (i + 1) * 10 }).eq("id", orderedIds[i]);
          if (error) return showError(error);
        }
        renderProductionSettings();
      });
    }
  }


  const LOT_PART_LABELS = {
    location: "Code de l’emplacement",
    date: "Date de production",
    product: "Code du produit",
    text: "Texte fixe"
  };
  const LOT_DATE_FORMATS = {
    YYYYMMDD: "AAAAMMJJ — 20260925",
    YYMMDD: "AAMMJJ — 260925",
    DDMMYY: "JJMMAA — 250926",
    YYDDD: "Quantième AAJJJ — 26268"
  };
  const DEFAULT_LOT_FORMAT = {
    separator: "",
    parts: [
      { type: "location", enabled: true },
      { type: "date", enabled: true, format: "YYYYMMDD" },
      { type: "product", enabled: true },
      { type: "text", enabled: false, value: "" }
    ]
  };

  // Réglage du format du numéro de lot. L'aperçu est calculé par la base
  // (preview_lot_number) : il montre exactement ce que produira la création.
  async function renderLotFormatSection(canEdit) {
    const box = document.querySelector("#lot-format-section");
    if (!box) return;
    const [{ data: org }, { data: sampleLoc }, { data: sampleRec }] = await Promise.all([
      sb.from("organizations").select("lot_number_format").eq("id", profile.organization_id).single(),
      sb.from("locations").select("id, name, lot_code").eq("organization_id", profile.organization_id).not("lot_code", "is", null).limit(1),
      sb.from("recipes").select("id, name, lot_code").eq("organization_id", profile.organization_id).not("lot_code", "is", null).limit(1)
    ]);
    // Copie de travail : rien n'est enregistré avant le clic sur Enregistrer
    const format = JSON.parse(JSON.stringify(org?.lot_number_format || DEFAULT_LOT_FORMAT));
    // Garantit la présence des quatre composants, même dans un ancien format
    Object.keys(LOT_PART_LABELS).forEach(type => {
      if (!format.parts.some(p => p.type === type)) format.parts.push({ type, enabled: false, value: "" });
    });
    const loc = sampleLoc?.[0], rec = sampleRec?.[0];

    const draw = () => {
      const dateOn = format.parts.some(p => p.type === "date" && p.enabled);
      // Ce que chaque élément apporte au numéro, pour qu'on le voie en réglant
      const valueOf = p => {
        if (p.type === "location") return loc?.lot_code ? `<span class="lot-chip">${escapeHtml(loc.lot_code)}</span>` : `<span class="lot-chip lot-chip-empty">aucun code</span>`;
        if (p.type === "product") return rec?.lot_code ? `<span class="lot-chip">${escapeHtml(rec.lot_code)}</span>` : `<span class="lot-chip lot-chip-empty">aucun code</span>`;
        if (p.type === "date") return `<select class="lot-date-format" ${!canEdit || !p.enabled ? "disabled" : ""}>${Object.entries(LOT_DATE_FORMATS).map(([k, l]) => `<option value="${k}" ${(p.format || "YYYYMMDD") === k ? "selected" : ""}>${l}</option>`).join("")}</select>`;
        return `<input class="lot-fixed-text" value="${escapeHtml(p.value || "")}" placeholder="Ex. : INT" maxlength="12" ${!canEdit || !p.enabled ? "disabled" : ""}>`;
      };
      box.innerHTML = `
        <div class="lot-preview-card">
          <small>Aperçu${loc || rec ? ` · ${escapeHtml([rec?.name, loc?.name].filter(Boolean).join(" à "))}, production du jour` : ""}</small>
          <div class="lot-preview-number" id="lot-preview-value">…</div>
        </div>

        <div class="lot-parts" id="lot-parts-list">${format.parts.map(p => `
          <div class="lot-part-row ${p.enabled ? "" : "is-off"}" draggable="${canEdit}" data-id="${p.type}">
            ${canEdit ? `<span class="drag-handle" title="Glisser pour changer l’ordre">⠿</span>` : ""}
            <label class="switch" title="${p.enabled ? "Retirer du numéro" : "Ajouter au numéro"}"><input type="checkbox" data-part="${p.type}" ${p.enabled ? "checked" : ""} ${!canEdit ? "disabled" : ""}><span class="switch-slider"></span></label>
            <span class="lot-part-label">${LOT_PART_LABELS[p.type]}</span>
            <span class="lot-part-value ${p.type === "date" || p.type === "text" ? "has-control" : ""}">${valueOf(p)}</span>
          </div>`).join("")}</div>

        ${!loc || !rec ? `<p class="form-note">${!loc ? "Aucun emplacement n’a encore de code lot. " : ""}${!rec ? "Aucun produit n’a encore de code lot. " : ""}Renseigne-les dans leur fiche pour les voir apparaître dans le numéro.</p>` : ""}
        ${!dateOn ? `<div class="warning-box" style="margin-top:12px">Sans la date, deux productions différentes recevraient le même numéro de base : elles ne se distingueraient plus que par un suffixe -2, -3… Un numéro de lot doit permettre de retrouver une fabrication précise.</div>` : ""}

        <div class="lot-format-footer">
          <label class="lot-separator-field">Séparateur
            <select id="lot-separator" ${!canEdit ? "disabled" : ""}>
              ${[["", "Aucun — que des chiffres"], ["-", "Tiret ( - )"], [".", "Point ( . )"], ["_", "Tiret bas ( _ )"]].map(([v, l]) => `<option value="${v}" ${(format.separator || "") === v ? "selected" : ""}>${l}</option>`).join("")}
            </select>
          </label>
          ${canEdit ? `<button type="button" id="save-lot-format" class="button button-primary">Enregistrer le format</button>` : ""}
        </div>
      `;
      refreshPreview();
      if (!canEdit) return;
      box.querySelectorAll("[data-part]").forEach(cb => cb.addEventListener("change", () => {
        format.parts.find(p => p.type === cb.dataset.part).enabled = cb.checked; draw();
      }));
      box.querySelector(".lot-date-format")?.addEventListener("change", e => {
        format.parts.find(p => p.type === "date").format = e.target.value; refreshPreview();
      });
      box.querySelector(".lot-fixed-text")?.addEventListener("input", e => {
        format.parts.find(p => p.type === "text").value = e.target.value; refreshPreview();
      });
      box.querySelector("#lot-separator").addEventListener("change", e => { format.separator = e.target.value; refreshPreview(); });
      wireDragReorder("#lot-parts-list", ".lot-part-row", async orderedIds => {
        format.parts = orderedIds.map(id => format.parts.find(p => p.type === id));
        draw();
      });
      box.querySelector("#save-lot-format").addEventListener("click", async () => {
        if (!format.parts.some(p => p.enabled)) return showToast("Active au moins un élément du numéro de lot.", "error");
        const { error } = await sb.from("organizations").update({ lot_number_format: format }).eq("id", profile.organization_id);
        if (error) return showError(error);
        showToast("Format du numéro de lot enregistré. Il s’applique aux prochaines productions.");
      });
    };

    async function refreshPreview() {
      const el = document.querySelector("#lot-preview-value");
      if (!el) return;
      const { data, error } = await sb.rpc("preview_lot_number", {
        p_recipe_id: rec?.id || null, p_location_id: loc?.id || null, p_date: todayISO(), p_format: format
      });
      el.textContent = error ? "aperçu indisponible" : (data || "(vide : active au moins un élément)");
    }

    draw();
  }

  function checkpointModal(cp, all) {
    const sections = [...new Set((all || []).map(x => x.section).filter(Boolean))];
    openModal({
      title: cp ? "Modifier le point de contrôle" : "Nouveau point de contrôle",
      kicker: "Paramètres production",
      html: `<form id="checkpoint-form" class="form-grid">
        <div class="span-2"><label>Libellé *</label><input name="label" required value="${escapeHtml(cp?.label || "")}" placeholder="Température à cœur, Contrôle visuel…"></div>
        <div class="span-2"><label>Section</label><input name="section" list="checkpoint-sections" value="${escapeHtml(cp?.section || "")}" placeholder="Four, Refroidissement… (facultatif)">
          <datalist id="checkpoint-sections">${sections.map(s => `<option value="${escapeHtml(s)}">`).join("")}</datalist>
          <p class="form-note">Les points d’une même section sont regroupés dans le formulaire de clôture.</p></div>
        <div><label>Type de relevé</label><select name="field_type" id="checkpoint-type">${Object.entries(CHECKPOINT_TYPES).map(([k, l]) => `<option value="${k}" ${(cp?.field_type || "datetime") === k ? "selected" : ""}>${l}</option>`).join("")}</select></div>
        <div id="checkpoint-unit-field"><label>Unité</label><input name="unit" value="${escapeHtml(cp?.unit || "")}" placeholder="°C, min, kg…"></div>
        <div class="checkbox-row span-2"><label class="switch"><input type="checkbox" name="required" ${cp?.required ? "checked" : ""}><span class="switch-slider"></span></label><span>Obligatoire pour terminer la production</span></div>
        <div class="form-actions span-2"><button type="button" class="button button-ghost" data-close-modal>Annuler</button><button class="button button-primary" type="submit">Enregistrer</button></div>
      </form>`
    });
    const typeSelect = modalBody.querySelector("#checkpoint-type");
    const syncUnit = () => { modalBody.querySelector("#checkpoint-unit-field").style.display = typeSelect.value === "number" ? "" : "none"; };
    typeSelect.addEventListener("change", syncUnit); syncUnit();
    modalBody.querySelector("[data-close-modal]").addEventListener("click", closeModal);
    modalBody.querySelector("#checkpoint-form").addEventListener("submit", async event => {
      event.preventDefault();
      const button = event.submitter; submitButtonLoading(button, true);
      const values = formObject(event.currentTarget);
      const payload = {
        label: values.label.trim(),
        section: values.section.trim() || null,
        field_type: values.field_type,
        unit: values.field_type === "number" ? (values.unit.trim() || null) : null,
        required: modalBody.querySelector('[name="required"]').checked
      };
      let error;
      if (cp) {
        ({ error } = await sb.from("production_checkpoints").update(payload).eq("id", cp.id));
      } else {
        const maxOrder = Math.max(0, ...(all || []).map(x => x.sort_order || 0));
        ({ error } = await sb.from("production_checkpoints").insert({ ...payload, organization_id: profile.organization_id, sort_order: maxOrder + 10 }));
      }
      submitButtonLoading(button, false);
      if (error) return showError(error);
      closeModal(); showToast("Point de contrôle enregistré."); renderProductionSettings();
    });
  }

  function productionStageModal(stage = null) {
    const tones = [["info", "Bleu"], ["warning", "Ambre"], ["success", "Vert"], ["danger", "Rouge"], ["purple", "Violet"]];
    openModal({
      title: stage ? "Modifier l’étape" : "Nouvelle étape",
      kicker: "Paramètres production",
      html: `<form id="production-stage-form" class="form-grid">
        <div class="span-2"><label>Nom *</label><input name="label" required value="${escapeHtml(stage?.label || "")}" placeholder="Devis fournisseur, MP commandée…"></div>
        <div class="span-2"><label>Couleur</label><select name="tone">${tones.map(([k, l]) => `<option value="${k}" ${(stage?.tone || "info") === k ? "selected" : ""}>${l}</option>`).join("")}</select></div>
        <p class="form-note span-2">${stage ? "" : "La nouvelle étape se place juste avant « En cours ». Tu peux ensuite la déplacer."}</p>
        <div class="form-actions span-2"><button type="button" class="button button-ghost" data-close-modal>Annuler</button><button class="button button-primary" type="submit">Enregistrer</button></div>
      </form>`
    });
    modalBody.querySelector("[data-close-modal]").addEventListener("click", closeModal);
    modalBody.querySelector("#production-stage-form").addEventListener("submit", async event => {
      event.preventDefault();
      const button = event.submitter; submitButtonLoading(button, true);
      const values = formObject(event.currentTarget);
      let error;
      if (stage) {
        ({ error } = await sb.from("production_stages").update({ label: values.label.trim(), tone: values.tone }).eq("id", stage.id));
      } else {
        // Clé stable, dérivée du nom, rendue unique
        const base = values.label.trim().toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "")
          .replace(/[^a-z0-9]+/g, "_").replace(/^_|_$/g, "").slice(0, 30) || "etape";
        const taken = new Set(PRODUCTION_CUSTOM_STAGES.map(s => s.key));
        let key = base, n = 2;
        while (taken.has(key) || ["in_progress", "completed", "archived"].includes(key)) key = `${base}_${n++}`;
        const maxOrder = Math.max(0, ...PRODUCTION_CUSTOM_STAGES.map(s => s.sort_order || 0));
        ({ error } = await sb.from("production_stages").insert({
          organization_id: profile.organization_id, key, label: values.label.trim(), tone: values.tone, sort_order: maxOrder + 10
        }));
      }
      submitButtonLoading(button, false);
      if (error) return showError(error);
      closeModal(); showToast("Étape enregistrée."); renderProductionSettings();
    });
  }

  async function renderLocations() {
    const canEdit = pageCan("locations");
    setHeader("locations", canEdit ? `<button id="add-location" class="button button-primary">＋ Ajouter un emplacement</button>` : "");
    const { data, error } = await sb.from("locations").select("id,name,is_external_logistics,logistics_provider_id,is_production_site").eq("organization_id", profile.organization_id).order("name");
    if (error) throw error;
    const rows = (data || []).map(loc => `<tr>
      <td><strong>${escapeHtml(loc.name)}</strong> ${loc.is_production_site ? badge("Point de production", "success") : ""} ${loc.is_external_logistics ? badge("Logistique externe", "info") : ""}</td>
      <td><div class="table-actions">${loc.is_production_site ? `<button class="button button-small button-secondary edit-production-constraints" data-id="${loc.id}">Contraintes de production</button>` : ""}${loc.is_external_logistics ? `<button class="button button-small button-secondary edit-logistics-provider" data-id="${loc.id}" data-provider="${loc.logistics_provider_id || ""}">Tarifs logistique</button>` : ""}${canEdit ? `<button class="button button-small button-ghost edit-location" data-id="${loc.id}">Modifier</button><button class="button button-small button-danger delete-location" data-id="${loc.id}">Supprimer</button>` : ""}</div></td>
    </tr>`).join("");
    content.innerHTML = `
      <div class="help-inline">${helpTip("Les emplacements créés ici sont ensuite proposés partout dans OPLA : réception de matières premières, transferts de stock, productions et localisation des lots finis. Impossible de saisir un emplacement qui n’existe pas ici.")}<span class="help-inline-label">À savoir</span></div>
      <div class="table-wrap" style="margin-top:16px">${rows ? `<table><thead><tr><th>Nom</th><th></th></tr></thead><tbody>${rows}</tbody></table>` : emptyState("Aucun emplacement", "Ajoutez votre premier atelier ou lieu de stockage.")}</div>`;
    document.querySelector("#add-location")?.addEventListener("click", () => locationModal());
    document.querySelectorAll(".edit-logistics-provider").forEach(btn => btn.addEventListener("click", async () => {
      const providerId = btn.dataset.provider;
      if (!providerId) {
        return showToast("Aucun prestataire rattaché à cet emplacement. Modifie l’emplacement pour en choisir un.", "error");
      }
      const { data: provider, error: provError } = await sb.from("logistics_providers").select("*").eq("id", providerId).single();
      if (provError) return showError(provError);
      logisticsProviderModal(provider);
    }));
    document.querySelectorAll(".edit-production-constraints").forEach(btn => btn.addEventListener("click", () => {
      productionConstraintsLocationId = btn.dataset.id;
      navigate("production-constraints");
    }));
    document.querySelectorAll(".edit-location").forEach(btn => btn.addEventListener("click", () => locationModal(data.find(l => l.id === btn.dataset.id))));
    document.querySelectorAll(".delete-location").forEach(btn => btn.addEventListener("click", async () => {
      if (!confirm("Supprimer cet emplacement ? Impossible s’il est encore référencé par des ingrédients, des lots ou des productions.")) return;
      const { error: deleteError } = await sb.from("locations").delete().eq("id", btn.dataset.id);
      if (deleteError) {
        if (deleteError.code === "23503" || /foreign key/i.test(deleteError.message || "")) {
          return showError(new Error("Impossible de supprimer : cet emplacement est encore utilisé (ingrédients référencés, lots de stock, productions, produits finis…). Retirez d’abord les références qui pointent vers lui."));
        }
        return showError(deleteError);
      }
      showToast("Emplacement supprimé."); renderLocations();
    }));
  }

  async function locationModal(location = null) {
    const { data: providers } = await sb.from("logistics_providers").select("id,name").eq("organization_id", profile.organization_id).eq("active", true);
    openModal({
      title: location ? "Modifier l’emplacement" : "Nouvel emplacement",
      kicker: "Paramètres",
      html: `<form id="location-form" class="form-grid">
        <div class="span-2"><label>Nom *</label><input name="name" required value="${escapeHtml(location?.name || "")}" placeholder="Atelier 1, Entrepôt Nîmes…"></div>
        <div class="span-2"><label>Code lot${helpTip("Placé en tête des numéros de lot des productions de cet emplacement. Format libre ; des chiffres seuls donnent des numéros de lot entièrement numériques.")}</label><input name="lot_code" value="${escapeHtml(location?.lot_code || "")}" placeholder="01" maxlength="10"></div>
        <div class="checkbox-row span-2"><label class="switch"><input type="checkbox" id="location-is-external" name="is_external_logistics" ${location?.is_external_logistics ? "checked" : ""}><span class="switch-slider"></span></label><span>Espace logistique externe (chez un prestataire)</span></div>
        <div class="span-2 help-inline">${helpTip("Un espace logistique externe accueille uniquement des produits finis (palettes) : il n’apparaîtra jamais dans les listes de réception de matières premières, de fournitures, ou de lancement de production. Réversible à tout moment.")}<span class="help-inline-label">À savoir</span></div>
        <div id="location-provider-field" class="span-2 ${location?.is_external_logistics ? "" : "hidden"}">
          <label>Prestataire logistique</label>
          <select name="logistics_provider_id"><option value="">Non défini</option>${(providers || []).map(p => `<option value="${p.id}" ${location?.logistics_provider_id === p.id ? "selected" : ""}>${escapeHtml(p.name)}</option>`).join("")}</select>
          <p class="form-note">Enregistre l’emplacement, puis utilise le bouton « Tarifs logistique » de la liste pour saisir la grille tarifaire.</p>
          <button type="button" id="new-provider-inline" class="button button-small button-secondary" style="margin-top:8px">＋ Nouveau prestataire</button>
        </div>
        <div class="checkbox-row span-2"><label class="switch"><input type="checkbox" id="location-is-production" name="is_production_site" ${location?.is_production_site ? "checked" : ""}><span class="switch-slider"></span></label><span>Point de production</span></div>
        <div class="span-2 help-inline">${helpTip("Un point de production fabrique des produits : tu pourras ensuite lui définir ses jours travaillés, sa capacité mensuelle, ses règles de départ et les recettes qu’il sait produire, via le bouton « Contraintes de production » de la liste.")}<span class="help-inline-label">À savoir</span></div>
        <div class="form-actions span-2"><button type="button" class="button button-ghost" data-close-modal>Annuler</button><button class="button button-primary" type="submit">Enregistrer</button></div>
      </form>`
    });
    modalBody.querySelector("[data-close-modal]").addEventListener("click", closeModal);
    modalBody.querySelector("#new-provider-inline")?.addEventListener("click", async () => {
      const name = prompt("Nom du nouveau prestataire logistique :");
      if (!name?.trim()) return;
      const { data: created, error: provError } = await sb.from("logistics_providers")
        .insert({ organization_id: profile.organization_id, name: name.trim(), active: true }).select().single();
      if (provError) return showError(provError);
      const select = modalBody.querySelector('select[name="logistics_provider_id"]');
      const opt = document.createElement("option");
      opt.value = created.id; opt.textContent = created.name; opt.selected = true;
      select.appendChild(opt);
      showToast("Prestataire créé. Sa grille tarifaire se saisit via « Tarifs logistique ».");
    });
    modalBody.querySelector("#location-is-external").addEventListener("change", e => {
      modalBody.querySelector("#location-provider-field").classList.toggle("hidden", !e.target.checked);
    });
    modalBody.querySelector("#location-form").addEventListener("submit", async event => {
      event.preventDefault();
      const button = event.submitter;
      submitButtonLoading(button, true);
      const values = formObject(event.currentTarget);
      const payload = {
        name: values.name.trim(),
        lot_code: (values.lot_code || "").trim() || null,
        is_external_logistics: modalBody.querySelector("#location-is-external").checked,
        is_production_site: modalBody.querySelector("#location-is-production").checked,
        logistics_provider_id: values.logistics_provider_id || null
      };
      const query = location
        ? sb.from("locations").update(payload).eq("id", location.id)
        : sb.from("locations").insert({ organization_id: profile.organization_id, ...payload });
      const { error } = await query;
      submitButtonLoading(button, false);
      if (error) return showError(error);
      closeModal(); showToast("Emplacement enregistré."); renderLocations();
    });
  }

  async function fetchCategories() {
    const { data, error } = await sb.from("recipe_categories").select("id,name,sort_order").eq("organization_id", profile.organization_id).order("sort_order", { ascending: true, nullsFirst: false }).order("name");
    if (error) { showError(error); return []; }
    return data || [];
  }

  async function renderCategories() {
    const canEdit = pageCan("categories");
    setHeader("categories", canEdit ? `<button id="add-category" class="button button-primary">＋ Ajouter une catégorie</button>` : "");
    const data = await fetchCategories();
    const rows = data.map((cat, idx) => `<div class="draggable-row" draggable="${canEdit}" data-id="${cat.id}" data-idx="${idx}">
      <span class="drag-handle">⠿</span>
      <strong>${escapeHtml(cat.name)}</strong>
      <div class="table-actions">${canEdit ? `<button class="button button-small button-ghost edit-category" data-id="${cat.id}">Modifier</button><button class="button button-small button-danger delete-category" data-id="${cat.id}">Supprimer</button>` : ""}</div>
    </div>`).join("");
    content.innerHTML = `
      <div class="help-inline">${helpTip("Les catégories créées ici sont ensuite proposées lors de la création d’une recette (Cake, Cookie, Mini…)." + (canEdit ? " Glisse-dépose une ligne pour changer l’ordre : il se répercute dans tous les menus déroulants de l’outil." : ""))}<span class="help-inline-label">À savoir</span></div>
      <div id="categories-list" class="draggable-list" style="margin-top:16px">${rows || emptyState("Aucune catégorie", "Ajoutez votre première catégorie de produit.")}</div>`;
    document.querySelector("#add-category")?.addEventListener("click", () => categoryModal());
    document.querySelectorAll(".edit-category").forEach(btn => btn.addEventListener("click", () => categoryModal(data.find(c => c.id === btn.dataset.id))));
    document.querySelectorAll(".delete-category").forEach(btn => btn.addEventListener("click", async () => {
      if (!confirm("Supprimer cette catégorie ? Les recettes qui l’utilisent perdront leur catégorie.")) return;
      const { error: deleteError } = await sb.from("recipe_categories").delete().eq("id", btn.dataset.id);
      if (deleteError) return showError(deleteError);
      showToast("Catégorie supprimée."); renderCategories();
    }));
    if (canEdit) wireDragReorder("#categories-list", ".draggable-row", async orderedIds => {
      await Promise.all(orderedIds.map((id, idx) => sb.from("recipe_categories").update({ sort_order: idx + 1 }).eq("id", id)));
    });
  }

  function wireDragReorder(listSelector, itemSelector, onReorder) {
    const list = document.querySelector(listSelector);
    if (!list) return;
    let dragEl = null;
    list.querySelectorAll(itemSelector).forEach(el => {
      el.addEventListener("dragstart", () => { dragEl = el; el.classList.add("dragging"); });
      el.addEventListener("dragend", async () => {
        el.classList.remove("dragging");
        const orderedIds = [...list.querySelectorAll(itemSelector)].map(item => item.dataset.id);
        await onReorder(orderedIds);
      });
      el.addEventListener("dragover", event => {
        event.preventDefault();
        if (!dragEl || dragEl === el) return;
        const rect = el.getBoundingClientRect();
        const sameRow = event.clientY >= rect.top && event.clientY <= rect.bottom;
        const before = sameRow ? (event.clientX - rect.left) < rect.width / 2 : (event.clientY - rect.top) < rect.height / 2;
        list.insertBefore(dragEl, before ? el : el.nextSibling);
      });
    });
  }

  function categoryModal(category = null) {
    openModal({
      title: category ? "Modifier la catégorie" : "Nouvelle catégorie",
      kicker: "Paramètres",
      html: `<form id="category-form" class="form-grid">
        <div class="span-2"><label>Nom *</label><input name="name" required value="${escapeHtml(category?.name || "")}" placeholder="Cake, Cookie, Mini, Autres…"></div>
        <div class="form-actions span-2"><button type="button" class="button button-ghost" data-close-modal>Annuler</button><button class="button button-primary" type="submit">Enregistrer</button></div>
      </form>`
    });
    modalBody.querySelector("[data-close-modal]").addEventListener("click", closeModal);
    modalBody.querySelector("#category-form").addEventListener("submit", async event => {
      event.preventDefault();
      const button = event.submitter;
      submitButtonLoading(button, true);
      const values = formObject(event.currentTarget);
      let query;
      if (category) {
        query = sb.from("recipe_categories").update({ name: values.name.trim() }).eq("id", category.id);
      } else {
        const { count } = await sb.from("recipe_categories").select("id", { count: "exact", head: true }).eq("organization_id", profile.organization_id);
        query = sb.from("recipe_categories").insert({ organization_id: profile.organization_id, name: values.name.trim(), sort_order: (count || 0) + 1 });
      }
      const { error } = await query;
      submitButtonLoading(button, false);
      if (error) return showError(error);
      closeModal(); showToast("Catégorie enregistrée."); renderCategories();
    });
  }

  async function fetchClientCategories() {
    const { data, error } = await sb.from("client_categories").select("*").eq("organization_id", profile.organization_id).order("sort_order", { ascending: true, nullsFirst: false }).order("name");
    if (error) { showError(error); return []; }
    return data || [];
  }

  async function renderClientCategories() {
    const canEdit = pageCan("client-categories");
    setHeader("client-categories", canEdit ? `<button id="add-client-category" class="button button-primary">＋ Ajouter une catégorie</button>` : "");
    const data = await fetchClientCategories();
    const rows = data.map((cat, idx) => `<div class="draggable-row" draggable="${canEdit}" data-id="${cat.id}" data-idx="${idx}">
      <span class="drag-handle">⠿</span>
      <strong>${escapeHtml(cat.name)}</strong>
      <div class="table-actions">${canEdit ? `<button class="button button-small button-ghost edit-client-category" data-id="${cat.id}">Modifier</button><button class="button button-small button-danger delete-client-category" data-id="${cat.id}">Supprimer</button>` : ""}</div>
    </div>`).join("");
    content.innerHTML = `
      <div class="help-inline">${helpTip("Ces catégories (Coffee Shop, Épicerie…) permettent de classer tes clients et de filtrer les statistiques." + (canEdit ? " Glisse-dépose pour changer l’ordre." : ""))}<span class="help-inline-label">À savoir</span></div>
      <div id="client-categories-list" class="draggable-list" style="margin-top:16px">${rows || emptyState("Aucune catégorie", "Ajoutez votre première catégorie de client.")}</div>`;
    document.querySelector("#add-client-category")?.addEventListener("click", () => clientCategoryModal());
    document.querySelectorAll(".edit-client-category").forEach(btn => btn.addEventListener("click", () => clientCategoryModal(data.find(c => c.id === btn.dataset.id))));
    document.querySelectorAll(".delete-client-category").forEach(btn => btn.addEventListener("click", async () => {
      if (!confirm("Supprimer cette catégorie ? Les clients qui l’utilisent perdront leur catégorie.")) return;
      const { error: deleteError } = await sb.from("client_categories").delete().eq("id", btn.dataset.id);
      if (deleteError) return showError(deleteError);
      showToast("Catégorie supprimée."); renderClientCategories();
    }));
    if (canEdit) wireDragReorder("#client-categories-list", ".draggable-row", async orderedIds => {
      await Promise.all(orderedIds.map((id, idx) => sb.from("client_categories").update({ sort_order: idx + 1 }).eq("id", id)));
    });
  }

  function clientCategoryModal(category = null) {
    openModal({
      title: category ? "Modifier la catégorie" : "Nouvelle catégorie de client",
      kicker: "Paramètres",
      html: `<form id="client-category-form" class="form-grid">
        <div class="span-2"><label>Nom *</label><input name="name" required value="${escapeHtml(category?.name || "")}" placeholder="Coffee Shop, Épicerie, Restaurant…"></div>

        <div class="form-section-title span-2" style="margin-top:12px">Signaux faibles${helpTip("Alertes commerciales générées automatiquement dans l’onglet Tâches quand un client de cette catégorie montre des signes de désengagement.")}</div>

        <div class="span-2 signal-block">
          <label class="checkbox-row"><input type="checkbox" name="signal_silence_enabled" ${category?.signal_silence_enabled !== false ? "checked" : ""}><span>Silence anormal</span></label>
          <p class="form-note">Alerte quand le délai depuis la dernière commande dépasse <strong>ce multiple</strong> de la fréquence habituelle du client. S’adapte tout seul : un client hebdomadaire alerte en quelques jours, un client mensuel en quelques semaines.</p>
          <input type="number" min="1" step="0.1" name="signal_silence_factor" value="${category?.signal_silence_factor ?? 1.5}" style="max-width:120px">
        </div>

        <div class="span-2 signal-block">
          <label class="checkbox-row"><input type="checkbox" name="signal_revenue_drop_enabled" ${category?.signal_revenue_drop_enabled ? "checked" : ""}><span>Baisse de volume</span></label>
          <p class="form-note">Alerte quand le CA des 3 derniers mois a chuté d’au moins ce pourcentage par rapport aux 3 mois précédents.</p>
          <input type="number" min="1" max="100" step="1" name="signal_revenue_drop_pct" value="${category?.signal_revenue_drop_pct ?? 30}" style="max-width:120px"> %
        </div>

        <div class="span-2 signal-block">
          <label class="checkbox-row"><input type="checkbox" name="signal_range_drop_enabled" ${category?.signal_range_drop_enabled ? "checked" : ""}><span>Rétrécissement de gamme</span></label>
          <p class="form-note">Alerte quand le nombre de références commandées a baissé d’au moins ce pourcentage, sur la même comparaison. Souvent le signe qu’un concurrent a pris une partie du volume.</p>
          <input type="number" min="1" max="100" step="1" name="signal_range_drop_pct" value="${category?.signal_range_drop_pct ?? 40}" style="max-width:120px"> %
        </div>

        <div class="form-actions span-2"><button type="button" class="button button-ghost" data-close-modal>Annuler</button><button class="button button-primary" type="submit">Enregistrer</button></div>
      </form>`
    });
    modalBody.querySelector("[data-close-modal]").addEventListener("click", closeModal);
    modalBody.querySelector("#client-category-form").addEventListener("submit", async event => {
      event.preventDefault();
      const button = event.submitter;
      submitButtonLoading(button, true);
      const values = formObject(event.currentTarget);
      const form = event.currentTarget;
      const signals = {
        signal_silence_enabled: form.querySelector('[name="signal_silence_enabled"]').checked,
        signal_silence_factor: Number(values.signal_silence_factor || 1.5),
        signal_revenue_drop_enabled: form.querySelector('[name="signal_revenue_drop_enabled"]').checked,
        signal_revenue_drop_pct: Number(values.signal_revenue_drop_pct || 30),
        signal_range_drop_enabled: form.querySelector('[name="signal_range_drop_enabled"]').checked,
        signal_range_drop_pct: Number(values.signal_range_drop_pct || 40)
      };
      let query;
      if (category) {
        query = sb.from("client_categories").update({ name: values.name.trim(), ...signals }).eq("id", category.id);
      } else {
        const { count } = await sb.from("client_categories").select("id", { count: "exact", head: true }).eq("organization_id", profile.organization_id);
        query = sb.from("client_categories").insert({ organization_id: profile.organization_id, name: values.name.trim(), sort_order: (count || 0) + 1, ...signals });
      }
      const { error } = await query;
      submitButtonLoading(button, false);
      if (error) return showError(error);
      closeModal(); showToast("Catégorie enregistrée."); renderClientCategories();
    });
  }

  // ============================================================
  // Fournitures — stock d'emballage (miroir de Stocks & lots MP)
  // ============================================================
  let supplyLocationKey = null;

  async function renderSupplies() {
    const canEdit = pageCan("supplies");
    setHeader("supplies", canEdit ? `<button id="add-supply" class="button button-primary">＋ Ajouter une fourniture</button>` : "");
    const [{ data: allSupplies, error: suppliesError }, { data: lots, error: lotsError }, allLocations, { data: supplyRefs }] = await Promise.all([
      sb.from("supplies").select("*").eq("organization_id", profile.organization_id).order("name"),
      sb.from("supply_lots").select("*, locations(id,name)").eq("organization_id", profile.organization_id),
      fetchLocations(),
      sb.from("supply_locations").select("supply_id, location_id, unit_price, supplier_id, reference, suppliers(name)").eq("organization_id", profile.organization_id)
    ]);
    if (suppliesError) throw suppliesError;
    if (lotsError) throw lotsError;

    // Meme logique que la page Stock ingredients : on choisit d'abord un emplacement,
    // puis on voit les fournitures qui s'y trouvent.
    if (!supplyLocationKey || !allLocations.some(l => l.id === supplyLocationKey)) {
      const cards = allLocations.map(loc => {
        const locLots = (lots || []).filter(l => l.location_id === loc.id);
        const supplyIds = new Set(locLots.map(l => l.supply_id));
        const value = locLots.reduce((s, l) => {
          const sup = allSupplies.find(x => x.id === l.supply_id);
          return s + Number(l.quantity_remaining || 0) * Number(sup?.purchase_price || 0);
        }, 0);
        const locCritical = allSupplies.filter(sup => {
          const t = locLots.filter(l => l.supply_id === sup.id).reduce((s, l) => s + Number(l.quantity_remaining || 0), 0);
          return supplyIds.has(sup.id) && t <= Number(sup.low_stock_threshold || 0);
        }).length;
        return `<article class="card location-summary-card">
          <div class="location-summary-head">
            <h3 class="location-summary-name">${escapeHtml(loc.name)}</h3>
            <div class="stock-badges">${locCritical ? `<span class="stock-dot stock-dot-critical" title="Stock critique sur au moins une fourniture">!</span>` : ""}</div>
          </div>
          <div class="location-summary-meta">${supplyIds.size} fourniture${supplyIds.size > 1 ? "s" : ""} · Valeur : ${formatMoney(value)}</div>
          <button type="button" class="button button-secondary button-full view-location-supplies" data-key="${loc.id}" style="margin-top:10px">Voir les fournitures</button>
        </article>`;
      }).join("");
      // Recap global, tous emplacements confondus
      const globalSupplyIds = new Set((lots || []).map(l => l.supply_id));
      let globalValue = 0, globalCritical = 0;
      allSupplies.forEach(sup => {
        const total = (lots || []).filter(l => l.supply_id === sup.id).reduce((s, l) => s + Number(l.quantity_remaining || 0), 0);
        globalValue += total * Number(sup.purchase_price || 0);
        if (total <= Number(sup.low_stock_threshold || 0)) globalCritical++;
      });
      content.innerHTML = `
        <div class="grid grid-3 stock-summary">
          <article class="card metric-card metric-card-flip"><div class="metric">${globalSupplyIds.size}</div><small>Fournitures en stock</small></article>
          <article class="card metric-card metric-card-flip"><div class="metric metric-critical">${globalCritical}</div><small>Stock critique</small></article>
          <article class="card metric-card metric-card-flip"><div class="metric">${formatMoney(globalValue)}</div><small>Valeur totale</small></article>
        </div>
        ${!allLocations.length ? `<div class="help-box" style="margin-bottom:16px">Aucun emplacement n’est encore créé. Ajoutez-en dans <strong>Paramètres → Emplacements</strong>.</div>` : ""}
        <div class="grid grid-3">${cards || emptyState("Aucun emplacement", "")}</div>
      `;
      document.querySelectorAll(".view-location-supplies").forEach(btn => btn.addEventListener("click", () => {
        supplyLocationKey = btn.dataset.key; renderSupplies();
      }));
      document.querySelector("#add-supply")?.addEventListener("click", () => supplyModal());
      return;
    }
    const activeLocation = supplyLocationKey;
    const currentLocation = allLocations.find(l => l.id === activeLocation);
    const visibleLots = (lots || []).filter(l => l.location_id === activeLocation);

    const bySupply = new Map();
    allSupplies.forEach(s => bySupply.set(s.id, { supply: s, lots: [] }));
    visibleLots.forEach(lot => { const entry = bySupply.get(lot.supply_id); if (entry) entry.lots.push(lot); });

    // On garde les fournitures sans stock sur cet emplacement : sinon une
    // fourniture qui vient d'être créée n'apparaîtrait nulle part, et on ne
    // pourrait jamais lui saisir une première entrée.
    let entries = [...bySupply.values()];
    entries.sort((a, b) => {
      // Celles qui ont du stock ici d'abord, puis les autres
      const aHas = a.lots.length > 0, bHas = b.lots.length > 0;
      if (aHas !== bHas) return aHas ? -1 : 1;
      return a.supply.name.localeCompare(b.supply.name, "fr");
    });

    let criticalCount = 0, totalValue = 0;
    const computed = entries.map(({ supply, lots: supplyLots }) => {
      const totalRemaining = supplyLots.reduce((s, l) => s + Number(l.quantity_remaining || 0), 0);
      const value = supplyLots.reduce((s, l) => s + Number(l.quantity_remaining || 0) * Number(l.unit_price ?? supply.purchase_price ?? 0), 0);
      const isCritical = totalRemaining <= Number(supply.low_stock_threshold || 0);
      totalValue += value; if (isCritical) criticalCount++;
      return { supply, lots: supplyLots, totalRemaining, value, isCritical };
    });

    const cards = computed.map(({ supply, lots: cardLots, totalRemaining, value, isCritical }) => `<article class="card stock-card" data-supply-id="${supply.id}">
        <div class="stock-card-head">
          <h3>${escapeHtml(supply.name)}</h3>
          <div class="stock-badges">
            ${isCritical ? `<span class="stock-dot stock-dot-critical" title="Stock critique">!</span>` : ""}
          </div>
        </div>
        <div class="stock-card-qty">${cardLots.length ? `${formatNumber(totalRemaining)} ${escapeHtml(supply.unit)}` : `<span class="muted" style="font-size:14px;font-weight:500">Jamais reçue ici</span>`}</div>
        ${(() => { const r = activeLocation ? (supplyRefs || []).find(x => x.supply_id === supply.id && x.location_id === activeLocation) : null; const n = r?.suppliers?.name || supply.supplier; return n ? `<div class="muted stock-card-supplier">${escapeHtml(n)}</div>` : ""; })()}
        <div class="stock-card-price"><span>${formatMoney(supply.purchase_price)} / ${escapeHtml(supply.unit)}</span><span class="muted">Valeur : ${formatMoney(value)}</span></div>
        <div class="stock-card-actions">
          <button class="icon-button icon-small view-supply-detail" data-id="${supply.id}" title="Voir le détail par emplacement">${ICONS.eye}</button>
          ${canEdit ? `<button class="icon-button icon-small transfer-supply" data-id="${supply.id}" title="Transférer entre emplacements">${ICONS.swap}</button>` : ""}
          ${canEdit ? `<button class="icon-button icon-small add-supply-lot-for" data-id="${supply.id}" title="Ajouter une entrée">${ICONS.plus}</button>` : ""}
          ${canEdit ? `<button class="icon-button icon-small edit-supply-location-ref" data-id="${supply.id}" title="Prix, fournisseur et référence pour cet emplacement">${ICONS.tag}</button>` : ""}
          ${canEdit ? `<button class="icon-button icon-small edit-supply" data-id="${supply.id}" title="Modifier">${ICONS.edit}</button>` : ""}
          ${canEdit ? `<button class="icon-button icon-small danger delete-supply" data-id="${supply.id}" title="Supprimer">${ICONS.trash}</button>` : ""}
        </div>
      </article>`).join("");

    content.innerHTML = `
      <div class="grid grid-3 stock-summary">
        <article class="card metric-card metric-card-flip"><div class="metric">${computed.length}</div><small>Fournitures</small></article>
        <article class="card metric-card metric-card-flip"><div class="metric metric-critical">${criticalCount}</div><small>Stock critique</small></article>
        <article class="card metric-card metric-card-flip"><div class="metric">${formatMoney(totalValue)}</div><small>Valeur</small></article>
      </div>
      <div class="finished-page-head">
        <button type="button" id="supplies-back" class="icon-button" title="Retour">←</button>
        <span class="location-pill">📍 ${escapeHtml(currentLocation?.name || "")}</span>
        <div class="toolbar-spacer"></div>
      </div>
      <div class="toolbar" style="margin-top:14px">
        <input id="supplies-search" class="search" placeholder="Rechercher une fourniture…">
        <div class="toolbar-spacer"></div>
      </div>
      <div id="supplies-grid" class="grid grid-3">${cards || emptyState("Aucune fourniture", "Ajoutez votre premier article d’emballage.")}</div>
    `;

    document.querySelector("#supplies-back").addEventListener("click", () => { supplyLocationKey = null; renderSupplies(); });
    document.querySelector("#supplies-search").addEventListener("input", e => {
      const q = e.target.value.trim().toLocaleLowerCase("fr");
      document.querySelectorAll("#supplies-grid .stock-card").forEach(card => { card.hidden = Boolean(q) && !card.textContent.toLocaleLowerCase("fr").includes(q); });
    });
    document.querySelector("#add-supply")?.addEventListener("click", () => supplyModal());
    document.querySelectorAll(".add-supply-lot-for").forEach(btn => btn.addEventListener("click", () => supplyLotModal(bySupply.get(btn.dataset.id)?.supply, allLocations)));
    document.querySelectorAll(".view-supply-detail").forEach(btn => btn.addEventListener("click", () => supplyDetailModal(bySupply.get(btn.dataset.id))));
    document.querySelectorAll(".transfer-supply").forEach(btn => btn.addEventListener("click", () => transferSupplyModal(bySupply.get(btn.dataset.id), allLocations)));
    document.querySelectorAll(".edit-supply-location-ref").forEach(btn => btn.addEventListener("click", () => {
      const supply = bySupply.get(btn.dataset.id)?.supply;
      const loc = allLocations.find(l => l.id === activeLocation);
      const ref = (supplyRefs || []).find(r => r.supply_id === btn.dataset.id && r.location_id === activeLocation);
      supplyLocationRefModal(supply, loc, ref);
    }));
    document.querySelectorAll(".edit-supply").forEach(btn => btn.addEventListener("click", () => supplyModal(bySupply.get(btn.dataset.id)?.supply)));
    document.querySelectorAll(".delete-supply").forEach(btn => btn.addEventListener("click", async () => {
      if (!confirm("Supprimer cette fourniture ? Impossible si des lots ou conditionnements y font encore référence.")) return;
      const { error } = await sb.from("supplies").delete().eq("id", btn.dataset.id);
      if (error) return showError(error);
      showToast("Fourniture supprimée."); renderSupplies();
    }));
  }

  async function supplyLocationRefModal(supply, location, currentRef) {
    if (!supply || !location) return;
    const { data: suppliers } = await sb.from("suppliers").select("id, name, supplier_locations(location_id)").eq("organization_id", profile.organization_id).order("name");
    const suppliersForLocation = (suppliers || []).filter(s => (s.supplier_locations || []).some(sl => sl.location_id === location.id));
    openModal({
      title: "Prix, fournisseur et référence",
      kicker: `${supply.name} — ${location.name}`,
      html: `<form id="supply-ref-form" class="form-grid">
        <div class="span-2 help-inline">${helpTip("Ces informations sont propres à cet emplacement. Le fournisseur choisi ici détermine les délais utilisés par le rétroplanning pour cette fourniture.")}<span class="help-inline-label">À savoir</span></div>
        <div><label>Prix d’achat HT / unité (${escapeHtml(supply.unit || "")})</label><input name="unit_price" type="number" min="0" step="0.0001" value="${currentRef?.unit_price ?? ""}"></div>
        <div><label>Fournisseur</label><select name="supplier_id">
          <option value="">Non renseigné</option>
          ${suppliersForLocation.map(s => `<option value="${s.id}" ${currentRef?.supplier_id === s.id ? "selected" : ""}>${escapeHtml(s.name)}</option>`).join("")}
        </select>
        ${!suppliersForLocation.length ? `<p class="form-note">Aucun fournisseur ne dessert cet emplacement — configure-le dans Paramètres → Fournisseurs.</p>` : ""}
        </div>
        <div class="span-2"><label>Référence produit</label><input name="reference" value="${escapeHtml(currentRef?.reference || "")}"></div>
        <div class="form-actions span-2"><button type="button" class="button button-ghost" data-close-modal>Annuler</button><button class="button button-primary" type="submit">Enregistrer</button></div>
      </form>`
    });
    modalBody.querySelector("[data-close-modal]").addEventListener("click", closeModal);
    modalBody.querySelector("#supply-ref-form").addEventListener("submit", async event => {
      event.preventDefault();
      const button = event.submitter; submitButtonLoading(button, true);
      const values = formObject(event.currentTarget);
      const { error } = await sb.from("supply_locations").upsert({
        organization_id: profile.organization_id, supply_id: supply.id, location_id: location.id,
        unit_price: values.unit_price === "" ? null : Number(values.unit_price),
        supplier_id: values.supplier_id || null, reference: values.reference.trim() || null
      }, { onConflict: "supply_id,location_id" });
      submitButtonLoading(button, false);
      if (error) return showError(error);
      closeModal(); showToast("Informations enregistrées."); renderSupplies();
    });
  }

  function supplyModal(item = null) {
    openModal({
      title: item ? "Modifier la fourniture" : "Nouvelle fourniture",
      kicker: "Conditionnement",
      html: `<form id="supply-form" class="form-grid">
        <div><label>Nom *</label><input name="name" required value="${escapeHtml(item?.name || "")}" placeholder="Moule Aluminium MO1600"></div>
        <div><label>Catégorie</label><input name="category" value="${escapeHtml(item?.category || "")}" placeholder="Carton, sachet, moule…"></div>
        <div><label>Unité de stock *</label><input name="unit" required value="${escapeHtml(item?.unit || "pièce")}"></div>
        <div><label>Référence</label><input name="reference" value="${escapeHtml(item?.reference || "")}"></div>
        <div><label>Prix d’achat / unité (€)</label><input name="purchase_price" type="number" min="0" step="0.0001" value="${item?.purchase_price ?? 0}"></div>
        <div><label>Fournisseur</label><input name="supplier" value="${escapeHtml(item?.supplier || "")}"></div>
        <div class="span-2"><label>Seuil de stock faible</label><input name="low_stock_threshold" type="number" min="0" step="1" value="${item?.low_stock_threshold ?? 0}"></div>
        <div class="form-actions span-2"><button type="button" class="button button-ghost" data-close-modal>Annuler</button><button class="button button-primary" type="submit">Enregistrer</button></div>
      </form>`
    });
    modalBody.querySelector("[data-close-modal]").addEventListener("click", closeModal);
    modalBody.querySelector("#supply-form").addEventListener("submit", async event => {
      event.preventDefault();
      const button = event.submitter; submitButtonLoading(button, true);
      const values = formObject(event.currentTarget);
      const payload = {
        organization_id: profile.organization_id,
        name: values.name.trim(), category: values.category.trim() || null, unit: values.unit.trim() || "pièce",
        reference: values.reference.trim() || null, purchase_price: Number(values.purchase_price || 0),
        supplier: values.supplier.trim() || null, low_stock_threshold: Number(values.low_stock_threshold || 0)
      };
      const query = item ? sb.from("supplies").update(payload).eq("id", item.id) : sb.from("supplies").insert(payload);
      const { error } = await query;
      submitButtonLoading(button, false);
      if (error) return showError(error);
      closeModal(); showToast("Fourniture enregistrée."); renderSupplies();
    });
  }

  function supplyDetailModal(entry) {
    if (!entry) return;
    const { supply, lots } = entry;
    const visibleLots = lots.filter(lot => Number(lot.quantity_remaining) > 0);
    const sorted = [...visibleLots].sort((a, b) => (a.locations?.name || "").localeCompare(b.locations?.name || "", "fr"));
    const total = visibleLots.reduce((s, l) => s + Number(l.quantity_remaining || 0), 0);
    const rows = sorted.map(lot => `<div class="lot-row">
      <div class="lot-row-main">
        <div class="lot-row-title">${lot.lot_number ? escapeHtml(lot.lot_number) : `<span class="muted">Sans lot</span>`} <span class="lot-location muted">📍 ${escapeHtml(lot.locations?.name || "Emplacement non renseigné")}</span></div>
        <div class="lot-row-meta muted">💶 ${lot.unit_price != null ? formatMoney(lot.unit_price) : "—"} / ${escapeHtml(lot.unit)}</div>
      </div>
      <div class="lot-row-qty">${formatNumber(lot.quantity_remaining)} ${escapeHtml(lot.unit)}</div>
      <div class="lot-row-actions">
        <button class="icon-button icon-small edit-supply-lot" data-id="${lot.id}" title="Modifier ce lot">✎</button>
        <button class="icon-button icon-small danger delete-supply-lot" data-id="${lot.id}" title="Supprimer ce lot">–</button>
      </div>
    </div>`).join("");
    openModal({
      title: supply.name,
      kicker: `Stock total : ${formatNumber(total)} ${supply.unit}`,
      width: "620px",
      html: `<div class="lot-list">${rows || emptyState("Aucun lot", "Ajoutez une entrée de stock.")}</div>
        <div class="lot-total">Total disponible : <strong>${formatNumber(total)} ${escapeHtml(supply.unit)}</strong> (${lots.length} lot${lots.length > 1 ? "s" : ""})</div>`
    });
    modalBody.querySelectorAll(".edit-supply-lot").forEach(btn => btn.addEventListener("click", async () => {
      const lot = lots.find(l => l.id === btn.dataset.id);
      editSupplyLotModal(lot, supply, await fetchLocations());
    }));
    modalBody.querySelectorAll(".delete-supply-lot").forEach(btn => btn.addEventListener("click", () => {
      const lot = lots.find(l => l.id === btn.dataset.id);
      if (lot) deleteLotModal({ kind: "supply", lot, name: supply.name, unit: lot.unit || supply.unit, onDone: renderSupplies });
    }));
  }

  function editSupplyLotModal(lot, supply, locationsList) {
    const locationName = (locationsList || []).find(l => l.id === lot.location_id)?.name || "Sans emplacement";
    openModal({
      title: "Modifier le lot",
      kicker: supply.name,
      html: `<form id="edit-supply-lot-form" class="form-grid">
        <div><label>Numéro de lot</label><input name="lot_number" value="${escapeHtml(lot.lot_number || "")}"></div>
        <div><label>Emplacement</label><input value="${escapeHtml(locationName)}" disabled>
          <p class="form-note">Pour le déplacer, utilise « Transférer ».</p></div>
        <div><label>Quantité restante *</label><input name="quantity_remaining" type="number" min="0" max="${lot.quantity_received}" step="0.001" required value="${lot.quantity_remaining}">
          <p class="form-note">Au plus ${formatNumber(lot.quantity_received)} ${escapeHtml(lot.unit || supply.unit || "")}, la quantité reçue.</p></div>
        <div><label>Prix payé / unité (€)</label><input name="unit_price" type="number" min="0" step="0.0001" value="${lot.unit_price ?? 0}"></div>
        ${lotReasonFields(LOT_EDIT_REASONS, false)}
        <p class="form-note span-2">Le motif est obligatoire si la quantité ou le prix change. Toute correction est inscrite dans les mouvements de stock.</p>
        <div class="form-actions span-2"><button type="button" class="button button-ghost" data-close-modal>Annuler</button><button class="button button-primary" type="submit">Enregistrer</button></div>
      </form>`
    });
    modalBody.querySelector("[data-close-modal]").addEventListener("click", closeModal);
    modalBody.querySelector("#edit-supply-lot-form").addEventListener("submit", async event => {
      event.preventDefault();
      const button = event.submitter;
      const values = formObject(event.currentTarget);
      const qty = Number(values.quantity_remaining);
      const price = Number(values.unit_price || 0);
      const mustExplain = qty !== Number(lot.quantity_remaining) || price !== Number(lot.unit_price || 0);
      const reason = readLotReason(values, mustExplain);
      if (reason === false || (mustExplain && !reason)) return;
      submitButtonLoading(button, true);
      const { error } = await sb.rpc("update_supply_lot", {
        p_lot_id: lot.id,
        p_lot_number: values.lot_number.trim() || null,
        p_quantity_remaining: qty,
        p_unit_price: price,
        p_reason: reason || null
      });
      submitButtonLoading(button, false);
      if (error) return showError(error);
      showToast("Lot mis à jour."); closeModal(); renderSupplies();
    });
  }

  function transferSupplyModal(entry, allLocations) {
    if (!entry) return;
    const { supply, lots } = entry;
    const available = lots.filter(l => Number(l.quantity_remaining) > 0);
    if (!available.length) return showToast("Aucun stock disponible à transférer.", "error");
    openModal({
      title: "Transférer du stock",
      kicker: supply.name,
      html: `<form id="transfer-supply-form" class="form-grid">
        <div class="span-2"><label>Lot source *</label><select name="lot_id" required>${available.map(l => `<option value="${l.id}">${l.lot_number ? escapeHtml(l.lot_number) : "Sans lot"} — ${escapeHtml(l.locations?.name || "Emplacement non renseigné")} — ${formatNumber(l.quantity_remaining)} ${escapeHtml(l.unit)}</option>`).join("")}</select></div>
        <div><label>Quantité à transférer *</label><input name="quantity" type="number" min="0.001" step="0.001" required></div>
        <div><label>Destination *</label><select name="destination_location_id" required><option value="">Choisir…</option>${allLocations.map(loc => `<option value="${loc.id}">${escapeHtml(loc.name)}</option>`).join("")}</select></div>
        <div class="form-actions span-2"><button type="button" class="button button-ghost" data-close-modal>Annuler</button><button class="button button-primary" type="submit">Transférer</button></div>
      </form>`
    });
    modalBody.querySelector("[data-close-modal]").addEventListener("click", closeModal);
    modalBody.querySelector("#transfer-supply-form").addEventListener("submit", async event => {
      event.preventDefault();
      const button = event.submitter; submitButtonLoading(button, true);
      try {
        const values = formObject(event.currentTarget);
        // Le transfert s'inscrit lui-même au journal, dans la même opération
        const { error } = await sb.rpc("transfer_supply_lot", {
          p_lot_id: values.lot_id, p_quantity: Number(values.quantity), p_destination_location_id: values.destination_location_id
        });
        if (error) throw error;
        closeModal(); showToast("Stock transféré."); renderSupplies();
      } catch (err) { showError(err); }
      finally { submitButtonLoading(button, false); }
    });
  }

  async function supplyLotModal(preselectedSupply = null, locationsList = null) {
    const [{ data: supplies, error }, rawLocs] = await Promise.all([
      sb.from("supplies").select("id,name,unit,purchase_price").eq("organization_id", profile.organization_id).order("name"),
      locationsList ? Promise.resolve(locationsList) : fetchLocations()
    ]);
    const locs = rawLocs.filter(l => !l.is_external_logistics);
    if (error) return showError(error);
    if (!supplies.length) return showToast("Créez d’abord une fourniture.", "error");
    openModal({
      title: "Nouvelle entrée de stock",
      kicker: "Fourniture",
      html: `<form id="supply-lot-form" class="form-grid">
        <div class="span-2"><label>Fourniture *</label><select name="supply_id" required>${supplies.map(s => `<option value="${s.id}" data-unit="${escapeHtml(s.unit)}" data-price="${s.purchase_price ?? 0}" ${preselectedSupply?.id === s.id ? "selected" : ""}>${escapeHtml(s.name)} — ${escapeHtml(s.unit)}</option>`).join("")}</select></div>
        <div><label>Numéro de lot</label><input name="lot_number"></div>
        <div><label>Emplacement</label><select name="location_id">${locationOptions(locs, null)}</select></div>
        <div><label>Quantité reçue *</label><input name="quantity_received" type="number" min="0.001" step="0.001" required></div>
        <div><label>Prix payé / unité (€)</label><input id="supply-lot-price" name="unit_price" type="number" min="0" step="0.0001" value="${(preselectedSupply ? supplies.find(s => s.id === preselectedSupply.id)?.purchase_price : supplies[0]?.purchase_price) ?? 0}"></div>
        <div class="form-actions span-2"><button type="button" class="button button-ghost" data-close-modal>Annuler</button><button class="button button-primary" type="submit">Enregistrer l’entrée</button></div>
      </form>`
    });
    modalBody.querySelector("[data-close-modal]").addEventListener("click", closeModal);
    modalBody.querySelector('select[name="supply_id"]').addEventListener("change", e => {
      modalBody.querySelector("#supply-lot-price").value = e.target.selectedOptions[0].dataset.price || 0;
    });
    modalBody.querySelector("#supply-lot-form").addEventListener("submit", async event => {
      event.preventDefault();
      const button = event.submitter; submitButtonLoading(button, true);
      const values = formObject(event.currentTarget);
      const selected = supplies.find(s => s.id === values.supply_id);
      const payload = {
        organization_id: profile.organization_id, supply_id: values.supply_id,
        lot_number: values.lot_number.trim() || null, location_id: values.location_id || null,
        quantity_received: Number(values.quantity_received), quantity_remaining: Number(values.quantity_received),
        unit: selected.unit, unit_price: Number(values.unit_price || 0)
      };
      const { error } = await sb.from("supply_lots").insert(payload);
      submitButtonLoading(button, false);
      if (error) return showError(error);
      closeModal(); showToast("Entrée enregistrée."); renderSupplies();
    });
  }

  // ============================================================
  // Conditionnements — composés de fournitures, reliés aux recettes
  // ============================================================
  async function renderPackagings() {
    const canEdit = pageCan("packagings");
    setHeader("packagings", canEdit ? `<button id="add-packaging" class="button button-primary">＋ Ajouter</button>` : "");
    const { data, error } = await sb.from("packagings")
      .select("*, packaging_components(quantity, supplies(name, unit, purchase_price)), recipe_packagings(count)")
      .eq("organization_id", profile.organization_id)
      .order("name");
    if (error) throw error;
    const packagings = data || [];

    const rows = packagings.map(pack => {
      const cost = (pack.packaging_components || []).reduce((sum, c) => sum + Number(c.quantity || 0) * Number(c.supplies?.purchase_price || 0), 0);
      return `<tr data-searchable>
        <td><strong>${escapeHtml(pack.name)}</strong><br><span class="muted">${formatNumber(pack.units_per_pack)} unité(s)/pack</span></td>
        <td>${(pack.packaging_components || []).length} fourniture(s)</td>
        <td>${formatMoney(cost)}</td>
        <td><div class="table-actions">
          <button class="icon-button icon-small view-packaging" data-id="${pack.id}" title="Voir le détail">👁</button>
          ${canEdit ? `<button class="icon-button icon-small edit-packaging" data-id="${pack.id}" title="Modifier">✎</button>` : ""}
          ${canEdit ? `<button class="icon-button icon-small danger delete-packaging" data-id="${pack.id}" title="Supprimer">🗑</button>` : ""}
        </div></td>
      </tr>`;
    }).join("");

    content.innerHTML = `
      <div class="toolbar"><input id="packagings-search" class="search" placeholder="Rechercher un conditionnement…"><div class="toolbar-spacer"></div></div>
      <div class="table-wrap">${rows ? `<table><thead><tr><th>Conditionnement</th><th>Fournitures</th><th>Coût</th><th></th></tr></thead><tbody>${rows}</tbody></table>` : emptyState("Aucun conditionnement", "Créez votre premier conditionnement (ex : emballage cake).")}</div>`;

    document.querySelector("#packagings-search").addEventListener("input", e => {
      const q = e.target.value.trim().toLocaleLowerCase("fr");
      document.querySelectorAll("[data-searchable]").forEach(el => { el.hidden = Boolean(q) && !el.textContent.toLocaleLowerCase("fr").includes(q); });
    });
    document.querySelector("#add-packaging")?.addEventListener("click", () => packagingModal());
    document.querySelectorAll(".view-packaging").forEach(btn => btn.addEventListener("click", () => packagingDetailModal(packagings.find(p => p.id === btn.dataset.id))));
    document.querySelectorAll(".edit-packaging").forEach(btn => btn.addEventListener("click", () => packagingModal(packagings.find(p => p.id === btn.dataset.id))));
    document.querySelectorAll(".delete-packaging").forEach(btn => btn.addEventListener("click", async () => {
      if (!confirm("Supprimer ce conditionnement ?")) return;
      const { error } = await sb.from("packagings").delete().eq("id", btn.dataset.id);
      if (error) return showError(error);
      showToast("Conditionnement supprimé."); renderPackagings();
    }));
  }

  async function packagingDetailModal(packaging) {
    const [componentsRes, recipesRes] = await Promise.all([
      sb.from("packaging_components").select("quantity, supplies(name, unit, purchase_price)").eq("packaging_id", packaging.id),
      sb.from("recipe_packagings").select("recipes(name, code)").eq("packaging_id", packaging.id)
    ]);
    const components = componentsRes.data || [];
    const recipes = recipesRes.data || [];
    const cost = components.reduce((sum, c) => sum + Number(c.quantity || 0) * Number(c.supplies?.purchase_price || 0), 0);
    openModal({
      title: packaging.name,
      kicker: "Conditionnement",
      width: "700px",
      html: `
        <div class="detail-block">
          <div class="detail-block-title">ℹ️ Informations</div>
          <div class="detail-grid">
            <div><small>Produits finis contenus</small><div class="detail-value">${formatNumber(packaging.units_per_pack)}</div></div>
            <div><small>Coût par pack</small><div class="detail-value">${formatMoney(cost)}</div></div>
          </div>
        </div>
        <div class="detail-block">
          <div class="detail-block-title">☰ Fournitures (${components.length})</div>
          ${components.map(c => `<div class="lot-row"><div class="lot-row-main"><div class="lot-row-title">${escapeHtml(c.supplies?.name || "—")}</div></div><div class="lot-row-qty">${formatNumber(c.quantity)} ${escapeHtml(c.supplies?.unit || "")}</div></div>`).join("") || emptyState("Aucune fourniture", "")}
        </div>
        <div class="detail-block">
          <div class="detail-block-title">📋 Produits compatibles (${recipes.length})</div>
          ${recipes.map(r => `<div class="lot-row"><div class="lot-row-main"><div class="lot-row-title">${escapeHtml(r.recipes?.name || "—")}</div></div>${r.recipes?.code ? `<span class="ref-badge">${escapeHtml(r.recipes.code)}</span>` : ""}</div>`).join("") || emptyState("Aucun produit relié", "Reliez ce conditionnement depuis la fiche d’une recette.")}
        </div>`
    });
  }

  async function packagingModal(packaging = null) {
    const { data: supplies, error } = await sb.from("supplies").select("id,name,unit,purchase_price").eq("organization_id", profile.organization_id).order("name");
    if (error) return showError(error);
    openModal({
      title: packaging ? "Modifier le conditionnement" : "Nouveau conditionnement",
      kicker: "Conditionnement",
      width: "760px",
      html: `<form id="packaging-form" class="form-grid">
        <div><label>Nom *</label><input name="name" required value="${escapeHtml(packaging?.name || "")}" placeholder="Emballage cake"></div>
        <div><label>Quantité de produits finis contenus * ${helpTip("Exemple : un carton qui contient 120 cookies → indique 120 ici. Un emballage individuel pour 1 gâteau → indique 1.")}</label><input id="packaging-units" name="units_per_pack" type="number" min="0.001" step="0.001" required value="${packaging?.units_per_pack ?? 1}"></div>
      </form>
      ${packaging ? `<div id="packaging-components-section"></div><div id="packaging-recipes-section" style="margin-top:22px"></div>` : `<div class="help-box" style="margin-top:16px">Enregistrez d’abord le conditionnement pour ajouter ses fournitures et ses produits compatibles.</div>`}
      <div class="form-actions" style="margin-top:22px"><button type="button" class="button button-ghost" data-close-modal>Annuler</button><button class="button button-primary" type="submit" form="packaging-form">Enregistrer</button></div>`
    });
    modalBody.querySelector("[data-close-modal]").addEventListener("click", closeModal);
    modalBody.querySelector("#packaging-form").addEventListener("submit", async event => {
      event.preventDefault();
      const values = formObject(event.currentTarget);
      const payload = { organization_id: profile.organization_id, name: values.name.trim(), units_per_pack: Number(values.units_per_pack) };
      const button = event.submitter; submitButtonLoading(button, true);
      const query = packaging ? sb.from("packagings").update(payload).eq("id", packaging.id).select().single() : sb.from("packagings").insert(payload).select().single();
      const { data: saved, error: saveError } = await query;
      submitButtonLoading(button, false);
      if (saveError) return showError(saveError);
      showToast("Conditionnement enregistré.");
      renderPackagings();
      if (!packaging) { packagingModal(saved); } else { Object.assign(packaging, saved); }
    });
    if (packaging) {
      renderPackagingComponentsSection(packaging, supplies);
      renderPackagingRecipesSection(packaging);
    }
  }

  async function renderPackagingComponentsSection(packaging, supplies) {
    const container = modalBody.querySelector("#packaging-components-section");
    if (!container) return;
    const { data: components, error } = await sb.from("packaging_components").select("id, quantity, supplies(id, name, unit, purchase_price)").eq("packaging_id", packaging.id).order("created_at");
    if (error) return showError(error);
    const unitsPerPack = Number(modalBody.querySelector("#packaging-units")?.value || packaging.units_per_pack || 1);
    const totalCost = (components || []).reduce((sum, c) => sum + Number(c.quantity || 0) * Number(c.supplies?.purchase_price || 0), 0);
    const rows = (components || []).map(c => `<tr data-id="${c.id}">
      <td>${escapeHtml(c.supplies?.name || "—")}</td>
      <td>${formatNumber(c.quantity)} ${escapeHtml(c.supplies?.unit || "")}</td>
      <td><button type="button" class="icon-button icon-small danger delete-packaging-component">🗑</button></td>
    </tr>`).join("");
    container.innerHTML = `
      <div class="form-section-title">☰ Fournitures de ce conditionnement</div>
      ${!supplies.length ? `<div class="help-box">Créez d’abord des fournitures dans l’onglet Fournitures.</div>` : `
      <div class="form-grid">
        <div class="span-2"><label>Fourniture</label><select id="packaging-component-supply">${supplies.map(s => `<option value="${s.id}">${escapeHtml(s.name)}</option>`).join("")}</select></div>
        <div><label>Quantité de fournitures utilisées</label><input id="packaging-component-qty" type="number" min="0.001" step="0.001" value="1"></div>
        <div style="align-self:end"><button type="button" id="packaging-component-add" class="button button-primary button-full">＋ Ajouter</button></div>
      </div>`}
      <div class="table-wrap" style="margin-top:12px">${rows ? `<table><thead><tr><th>Fourniture</th><th>Quantité</th><th></th></tr></thead><tbody>${rows}</tbody></table>` : emptyState("Aucune fourniture", "")}</div>
      <div class="help-box" style="margin-top:12px">Ce conditionnement coûte <strong>${formatMoney(totalCost)}</strong> et couvre <strong>${formatNumber(unitsPerPack)} produit${unitsPerPack > 1 ? "s" : ""} fini${unitsPerPack > 1 ? "s" : ""}</strong>, soit ${formatMoney(unitsPerPack ? totalCost / unitsPerPack : totalCost)} par produit.</div>
    `;
    if (!supplies.length) return;
    container.querySelector("#packaging-component-add").addEventListener("click", async () => {
      const supplyId = container.querySelector("#packaging-component-supply").value;
      const qty = Number(container.querySelector("#packaging-component-qty").value || 0);
      if (!supplyId || qty <= 0) return showToast("Choisissez une fourniture et une quantité.", "error");
      const { error: insertError } = await sb.from("packaging_components").insert({ packaging_id: packaging.id, supply_id: supplyId, quantity: qty });
      if (insertError) return showError(insertError);
      renderPackagingComponentsSection(packaging, supplies);
      renderPackagings();
    });
    container.querySelectorAll(".delete-packaging-component").forEach(btn => btn.addEventListener("click", async () => {
      const row = btn.closest("tr");
      const { error: deleteError } = await sb.from("packaging_components").delete().eq("id", row.dataset.id);
      if (deleteError) return showError(deleteError);
      renderPackagingComponentsSection(packaging, supplies);
      renderPackagings();
    }));
    modalBody.querySelector("#packaging-units")?.addEventListener("input", () => renderPackagingComponentsSection(packaging, supplies));
  }

  async function renderPackagingRecipesSection(packaging) {
    const container = modalBody.querySelector("#packaging-recipes-section");
    if (!container) return;
    const [{ data: recipes }, { data: links }] = await Promise.all([
      sb.from("recipes").select("id,name,code").eq("organization_id", profile.organization_id).order("name"),
      sb.from("recipe_packagings").select("id, recipe_id").eq("packaging_id", packaging.id)
    ]);
    const linkedIds = new Set((links || []).map(l => l.recipe_id));
    container.innerHTML = `
      <div class="form-section-title">📋 Produits compatibles</div>
      <div class="compat-list">${(recipes || []).map(r => `<label class="compat-list-item"><input type="checkbox" data-recipe-id="${r.id}" ${linkedIds.has(r.id) ? "checked" : ""}> <span>${escapeHtml(r.name)}</span>${r.code ? `<span class="ref-badge">${escapeHtml(r.code)}</span>` : ""}</label>`).join("") || `<span class="muted">Aucune recette créée</span>`}</div>
    `;
    container.querySelectorAll('input[type="checkbox"]').forEach(cb => cb.addEventListener("change", async () => {
      if (cb.checked) {
        const { error } = await sb.from("recipe_packagings").insert({ recipe_id: cb.dataset.recipeId, packaging_id: packaging.id });
        if (error) { showError(error); cb.checked = false; }
      } else {
        const { error } = await sb.from("recipe_packagings").delete().eq("packaging_id", packaging.id).eq("recipe_id", cb.dataset.recipeId);
        if (error) { showError(error); cb.checked = true; }
      }
    }));
  }

  // Recettes

  // ============================================================
  // COÛT DE REVIENT DES RECETTES — calcul unique.
  // Utilisé par la carte, la fiche et l'évolution : écrit une fois,
  // pour que les chiffres ne puissent jamais diverger d'un écran à
  // l'autre. Les fonctions de calcul sont pures (aucune lecture ni
  // écriture), ce qui permet de les tester isolément.
  // ============================================================

  // Fenêtre des 12 derniers mois civils, mois en cours compris
  function costWindowStart(todayIso) {
    const [y, m] = todayIso.split("-").map(Number);
    const d = new Date(Date.UTC(y, m - 1 - 11, 1));
    return d.toISOString().slice(0, 10);
  }

  // Données communes, chargées une seule fois pour tout l'écran
  // Catégories dans l'ordre réglé dans les paramètres ; « Sans catégorie » en dernier
  function compareCategories(a, b) {
    if (!a && !b) return 0;
    if (!a) return 1;
    if (!b) return -1;
    return (Number(a.sort_order) || 0) - (Number(b.sort_order) || 0) || String(a.name).localeCompare(String(b.name), "fr");
  }
  // Options d'une liste déroulante, regroupées sous le nom de leur catégorie.
  // getName trie dans chaque catégorie ; à égalité, l'ordre d'origine est
  // conservé (utile pour les lots, déjà classés du plus ancien au plus récent).
  // opts.groupLabel : intitulé d'un groupe à partir du nom de la catégorie ;
  // opts.forceGroups : garder les intitulés même sans aucune catégorie
  function optionsByCategory(items, getCategory, renderOption, getName = null, opts = {}) {
    const groups = new Map();
    items.forEach((it, idx) => {
      const cat = getCategory(it) || null;
      const key = cat ? cat.name : "";
      if (!groups.has(key)) groups.set(key, { cat, list: [] });
      groups.get(key).list.push({ it, idx });
    });
    const sortList = list => getName
      ? [...list].sort((x, y) => String(getName(x.it)).localeCompare(String(getName(y.it)), "fr") || x.idx - y.idx)
      : list;
    const ordered = [...groups.values()].sort((a, b) => compareCategories(a.cat, b.cat));
    // Aucune catégorie utilisée : liste simple, sans intitulé inutile
    if (!opts.forceGroups && ordered.length === 1 && !ordered[0].cat) return sortList(ordered[0].list).map(x => renderOption(x.it)).join("");
    const labelOf = name => (opts.groupLabel ? opts.groupLabel(name) : name);
    return ordered.map(g => `<optgroup label="${escapeHtml(labelOf(g.cat ? g.cat.name : "Sans catégorie"))}">${sortList(g.list).map(x => renderOption(x.it)).join("")}</optgroup>`).join("");
  }

  // Coût saisi à l'ajout manuel, réparti entre matières et production selon les
  // proportions de la fiche produit (pour que les analyses de marge restent
  // cohérentes). Sans proportions connues, tout va en production. Vide : aucun coût.
  function manualCostSplit(raw, suggestion) {
    if (raw === "" || raw === null || raw === undefined) return { p_unit_cost_mp: null, p_unit_cost_production: null };
    const total = Number(raw);
    if (!Number.isFinite(total) || total < 0) return { p_unit_cost_mp: null, p_unit_cost_production: null };
    if (suggestion && suggestion.total > 0) {
      const mp = total * suggestion.mp / suggestion.total;
      return { p_unit_cost_mp: mp, p_unit_cost_production: total - mp };
    }
    return { p_unit_cost_mp: 0, p_unit_cost_production: total };
  }

  async function loadRecipeCostContext() {
    const orgId = profile.organization_id;
    const since = costWindowStart(todayISO());
    const [locPrices, pricedLots, locCostsRes, prods, locsRes] = await Promise.all([
      fetchAllRows(() => sb.from("ingredient_locations").select("ingredient_id, location_id, unit_price").eq("organization_id", orgId)),
      fetchAllRows(() => sb.from("ingredient_lots").select("ingredient_id, unit_price, received_at").eq("organization_id", orgId).gt("unit_price", 0).order("received_at", { ascending: false })),
      sb.from("recipe_location_costs").select("recipe_id, location_id, production_cost"),
      fetchAllRows(() => sb.from("productions").select("recipe_id, location_id, quantity_produced, production_date, unit_cost_mp").eq("organization_id", orgId).eq("status", "completed").gte("production_date", since)),
      sb.from("locations").select("id, name, is_production_site").eq("organization_id", orgId).order("name")
    ]);
    if (locCostsRes.error) throw locCostsRes.error;
    if (locsRes.error) throw locsRes.error;
    return buildRecipeCostContext({
      locPrices, pricedLots, locCosts: locCostsRes.data || [], productions: prods,
      locations: locsRes.data || [], since
    });
  }

  function buildRecipeCostContext({ locPrices, pricedLots, locCosts, productions, locations, since }) {
    const locPrice = new Map();
    (locPrices || []).forEach(p => {
      if (Number(p.unit_price) > 0) locPrice.set(`${p.ingredient_id}:${p.location_id}`, Number(p.unit_price));
    });
    // Dernier prix payé, tous emplacements confondus : secours pour un
    // atelier qui ne reçoit jamais l'ingrédient directement
    const latestPrice = new Map();
    [...(pricedLots || [])]
      .sort((a, b) => String(b.received_at || "").localeCompare(String(a.received_at || "")))
      .forEach(l => { if (!latestPrice.has(l.ingredient_id) && Number(l.unit_price) > 0) latestPrice.set(l.ingredient_id, Number(l.unit_price)); });
    const locCost = new Map();
    (locCosts || []).forEach(c => locCost.set(`${c.recipe_id}:${c.location_id}`, Number(c.production_cost || 0)));
    const definedLocs = new Map();
    (locCosts || []).forEach(c => {
      if (!definedLocs.has(c.recipe_id)) definedLocs.set(c.recipe_id, new Set());
      definedLocs.get(c.recipe_id).add(c.location_id);
    });
    const productionsOf = new Map();
    (productions || []).forEach(p => {
      if (!p.production_date || p.production_date < since) return;
      if (!productionsOf.has(p.recipe_id)) productionsOf.set(p.recipe_id, []);
      productionsOf.get(p.recipe_id).push(p);
    });
    return { locPrice, latestPrice, locCost, definedLocs, productionsOf, locations: locations || [], since };
  }

  // Prix d'un ingrédient pour un atelier : son prix de référence, sinon le
  // dernier prix payé ailleurs, sinon le prix général de l'ingrédient
  function ingredientPriceAt(ctx, ingredient, locationId) {
    if (locationId) {
      const p = ctx.locPrice.get(`${ingredient.id}:${locationId}`);
      if (p > 0) return p;
    }
    const latest = ctx.latestPrice.get(ingredient.id);
    if (latest > 0) return latest;
    return Number(ingredient.purchase_price || 0);
  }

  // Coût théorique aux prix d'aujourd'hui, par atelier et pondéré
  function computeRecipeCostProfile(recipe, items, ctx) {
    const yieldQty = Number(recipe.yield_quantity || 1) || 1;
    const lines = (items || []).filter(i => i.ingredients).map(item => {
      const converted = convertQty(item.quantity, item.unit, item.ingredients.unit);
      return { item, qty: converted === null ? Number(item.quantity || 0) : converted };
    });
    // Une production consomme la recette majorée de son écart matière :
    // le coût théorique doit l'inclure pour être comparable au coût réel
    const lossFactor = 1 + Number(recipe.material_loss_pct || 0) / 100;
    const mpRecipeAt = locId => lines.reduce((s, l) => s + l.qty * ingredientPriceAt(ctx, l.item.ingredients, locId), 0) / yieldQty;
    const prodAt = locId => {
      const c = locId ? ctx.locCost.get(`${recipe.id}:${locId}`) : undefined;
      return c !== undefined ? c : Number(recipe.production_cost || 0);
    };

    // Poids : quantités produites sur 12 mois, par atelier
    const volume = new Map();
    (ctx.productionsOf.get(recipe.id) || []).forEach(p => {
      const q = Number(p.quantity_produced || 0);
      if (p.location_id && q > 0) volume.set(p.location_id, (volume.get(p.location_id) || 0) + q);
    });
    let basis, weights;
    if (volume.size) {
      basis = "volumes"; weights = volume;
    } else if ((ctx.definedLocs.get(recipe.id) || new Set()).size) {
      // Produit sans historique : ateliers ayant un coût de production, à poids égal
      basis = "defined"; weights = new Map([...ctx.definedLocs.get(recipe.id)].map(id => [id, 1]));
    } else {
      basis = "general"; weights = new Map([[null, 1]]);
    }
    const totalWeight = [...weights.values()].reduce((a, b) => a + b, 0);
    const nameOf = id => ctx.locations.find(l => l.id === id)?.name || "—";
    const locations = [...weights.entries()].map(([id, w]) => {
      const mpRecipe = mpRecipeAt(id), mp = mpRecipe * lossFactor, prod = prodAt(id);
      return { id, name: id ? nameOf(id) : null, mpRecipe, loss: mp - mpRecipe, mp, prod, total: mp + prod, qty: basis === "volumes" ? w : null, share: w / totalWeight };
    }).sort((a, b) => b.share - a.share || String(a.name).localeCompare(String(b.name), "fr"));
    const mpRecipe = locations.reduce((s, l) => s + l.share * l.mpRecipe, 0);
    const loss = locations.reduce((s, l) => s + l.share * l.loss, 0);
    const mp = locations.reduce((s, l) => s + l.share * l.mp, 0);
    const prod = locations.reduce((s, l) => s + l.share * l.prod, 0);
    // Coût de chaque ingrédient (quantités de recette), avec les mêmes poids :
    // la colonne « Coût » de la fiche s'additionne exactement au coût matière
    // de la recette ; l'écart matière s'y ajoute sur une ligne à part
    const perItem = lines.map(l => ({
      item: l.item,
      cost: locations.reduce((s, loc) => s + loc.share * l.qty * ingredientPriceAt(ctx, l.item.ingredients, loc.id), 0) / yieldQty
    }));
    return { basis, locations, mpRecipe, loss, lossPct: Number(recipe.material_loss_pct || 0), mp, prod, total: mp + prod, perItem };
  }

  // Coût réel des productions terminées, mois par mois sur 12 mois
  // Avec locationId : un seul atelier. L'évolution d'un mois à l'autre ne
  // mélange ainsi jamais deux ateliers aux coûts différents — sinon un mois où
  // seul l'atelier le plus cher a produit passerait pour une hausse de prix.
  // Sans locationId : tous ateliers, pour la moyenne réelle de l'année.
  function computeRealCostSeries(recipeId, ctx, todayIso, locationId = null) {
    const start = costWindowStart(todayIso);
    const [sy, sm] = start.split("-").map(Number);
    const monthNames = ["janv.", "févr.", "mars", "avr.", "mai", "juin", "juil.", "août", "sept.", "oct.", "nov.", "déc."];
    const months = [];
    for (let k = 0; k < 12; k++) {
      const d = new Date(Date.UTC(sy, sm - 1 + k, 1));
      months.push({ key: d.toISOString().slice(0, 7), label: monthNames[d.getUTCMonth()], cost: 0, qty: 0 });
    }
    let count = 0, sumCost = 0, sumQty = 0;
    (ctx.productionsOf.get(recipeId) || []).forEach(p => {
      const q = Number(p.quantity_produced || 0);
      if (p.unit_cost_mp == null || !(q > 0)) return;
      if (locationId && p.location_id !== locationId) return;
      const m = months.find(x => x.key === String(p.production_date).slice(0, 7));
      if (!m) return;
      m.cost += Number(p.unit_cost_mp) * q; m.qty += q;
      sumCost += Number(p.unit_cost_mp) * q; sumQty += q; count++;
    });
    months.forEach(m => { m.avg = m.qty > 0 ? m.cost / m.qty : null; });
    const withData = months.filter(m => m.avg !== null);
    const change = withData.length >= 2 ? (withData[withData.length - 1].avg - withData[0].avg) / withData[0].avg : null;
    return { months, annual: sumQty > 0 ? sumCost / sumQty : null, change, count,
             firstMonth: withData[0] || null, lastMonth: withData[withData.length - 1] || null };
  }


  // Graphique du coût réel mois par mois, en COURBE : une courbe se lit sans
  // partir de zéro, alors que des barres tronquées exagèrent la variation
  // (+6 % y ressemblerait à un triplement). Deux lignes repères donnent
  // l'échelle. Un mois sans production reste vide, jamais à zéro.
  function renderRealCostChart(serie) {
    const W = 640, H = 170, left = 54, right = 16, top = 22, base = H - 26;
    const pts = serie.months.map((m, k) => ({ k, m })).filter(x => x.m.avg !== null);
    if (!pts.length) return `<p class="cost-note">Aucune production terminée pour cet atelier sur les 12 derniers mois.</p>`;
    const vals = pts.map(x => x.m.avg);
    let lo = Math.min(...vals), hi = Math.max(...vals);
    if (hi - lo < 1e-9) { lo = lo * 0.9; hi = hi * 1.1; } else { const pad = (hi - lo) * 0.25; lo -= pad; hi += pad; }
    const step = (W - left - right) / serie.months.length;
    const xOf = k => left + step * (k + 0.5);
    const yOf = v => base - (v - lo) / (hi - lo) * (base - top);
    const minV = Math.min(...vals), maxV = Math.max(...vals);
    const grid = [...new Set([minV, maxV])].map(v => `<line x1="${left}" x2="${W - right}" y1="${yOf(v).toFixed(1)}" y2="${yOf(v).toFixed(1)}" stroke="#e3e7e3" stroke-dasharray="3 4"/><text x="${left - 8}" y="${(yOf(v) + 4).toFixed(1)}" font-size="10.5" text-anchor="end" fill="#6b7a70">${formatMoney(v)}</text>`).join("");
    // Trait plein entre deux mois consécutifs, pointillé par-dessus un trou
    const segs = pts.slice(1).map((p, i) => {
      const a = pts[i];
      return `<line x1="${xOf(a.k).toFixed(1)}" y1="${yOf(a.m.avg).toFixed(1)}" x2="${xOf(p.k).toFixed(1)}" y2="${yOf(p.m.avg).toFixed(1)}" stroke="#2f5d45" stroke-width="2.5" ${p.k - a.k > 1 ? 'stroke-dasharray="5 5" opacity=".55"' : ""}/>`;
    }).join("");
    const dots = pts.map((p, i) => `<circle cx="${xOf(p.k).toFixed(1)}" cy="${yOf(p.m.avg).toFixed(1)}" r="4.5" fill="#2f5d45"><title>${p.m.label} : ${formatMoney(p.m.avg)} (${formatNumber(p.m.qty)} produits)</title></circle>${(i === 0 || i === pts.length - 1) ? `<text x="${xOf(p.k).toFixed(1)}" y="${(yOf(p.m.avg) - 10).toFixed(1)}" font-size="11" font-weight="700" text-anchor="middle" fill="#1f2a24">${formatMoney(p.m.avg)}</text>` : ""}`).join("");
    const labels = serie.months.map((m, k) => `<text x="${xOf(k).toFixed(1)}" y="${H - 8}" font-size="10.5" text-anchor="middle" fill="${m.avg === null ? "#b8c0ba" : "#6b7a70"}">${m.label}</text>`).join("");
    return `<svg viewBox="0 0 ${W} ${H}" width="100%" style="max-width:${W}px" role="img" aria-label="Coût matière réel par mois">${grid}${segs}${dots}${labels}</svg>`;
  }

  async function renderRecipes() {
    const canEdit = pageCan("recipes");
    setHeader("recipes", canEdit ? `<button id="add-recipe" class="button button-primary">＋ Ajouter une recette</button>` : "");
    const { data, error } = await sb.from("recipes")
      .select("*, recipe_items(quantity, unit, ingredients(id, unit, purchase_price)), recipe_categories(name)")
      .eq("organization_id", profile.organization_id)
      .order("name");
    if (error) throw error;
    const recipes = data || [];

    // Coût de revient : calcul unique, partagé avec la fiche produit
    const costCtx = await loadRecipeCostContext();

    const cards = recipes.map(recipe => {
      const cost = computeRecipeCostProfile(recipe, recipe.recipe_items, costCtx);
      const mpCost = cost.mp, prodCost = cost.prod, totalCost = cost.total;
      const costBasisNote = cost.basis === "volumes"
        ? (cost.locations.length > 1 ? `Moyenne pondérée · ${cost.locations.length} ateliers` : `Atelier : ${escapeHtml(cost.locations[0].name)}`)
        : cost.basis === "defined" ? "Sans production récente" : "Prix généraux";
      const weight = recipe.unit_weight_g ? `${formatNumber(recipe.unit_weight_g)}g` : null;
      return `<article class="card recipe-card" data-recipe-id="${recipe.id}">
        <div class="recipe-card-head">
          <h3>${escapeHtml(recipe.name)}</h3>
          ${recipe.code ? `<span class="ref-badge">${escapeHtml(recipe.code)}</span>` : ""}
        </div>
        ${recipe.recipe_categories?.name ? `<div class="muted recipe-card-category">${escapeHtml(recipe.recipe_categories.name)}</div>` : ""}
        <div class="recipe-card-cost">${formatMoney(totalCost)}</div>
        ${weight ? `<div class="muted">${weight} / ${escapeHtml(recipe.sale_unit)}</div>` : ""}
        <div class="recipe-card-breakdown muted">MP : ${formatMoney(mpCost)}<span class="breakdown-plus">+</span>Prod : ${formatMoney(prodCost)}</div>
        <div class="muted recipe-card-basis">${costBasisNote}</div>
        <div class="stock-card-actions">
          <button class="icon-button icon-small view-recipe" data-id="${recipe.id}" title="Voir les informations">${ICONS.eye}</button>
          ${canEdit ? `<button class="icon-button icon-small edit-recipe" data-id="${recipe.id}" title="Modifier">${ICONS.edit}</button>` : ""}
          ${canEdit ? `<button class="icon-button icon-small danger delete-recipe" data-id="${recipe.id}" title="Supprimer">${ICONS.trash}</button>` : ""}
        </div>
      </article>`;
    }).join("");

    content.innerHTML = `
      <div class="toolbar"><input id="recipes-search" class="search" placeholder="Rechercher une recette…"><div class="toolbar-spacer"></div></div>
      <div id="recipes-grid" class="grid grid-3">${cards || emptyState("Aucune recette", "Créez un produit fini, puis renseignez sa composition.")}</div>`;

    document.querySelector("#recipes-search").addEventListener("input", event => {
      const q = event.target.value.trim().toLocaleLowerCase("fr");
      document.querySelectorAll("#recipes-grid .recipe-card").forEach(card => {
        card.hidden = Boolean(q) && !card.textContent.toLocaleLowerCase("fr").includes(q);
      });
    });
    document.querySelector("#add-recipe")?.addEventListener("click", () => recipeModal());
    document.querySelectorAll(".view-recipe").forEach(btn => btn.addEventListener("click", () => recipeDetailModal(recipes.find(item => item.id === btn.dataset.id))));
    document.querySelectorAll(".edit-recipe").forEach(btn => btn.addEventListener("click", () => recipeModal(recipes.find(item => item.id === btn.dataset.id))));
    document.querySelectorAll(".delete-recipe").forEach(btn => btn.addEventListener("click", async () => {
      if (!confirm("Supprimer cette recette ? Impossible si des productions ou lots finis y font encore référence.")) return;
      const { error: deleteError } = await sb.from("recipes").delete().eq("id", btn.dataset.id);
      if (deleteError) return showError(deleteError);
      showToast("Recette supprimée."); renderRecipes();
    }));
  }

  // Modale de détail (lecture seule) — coût de revient et composition
  async function recipeDetailModal(recipe) {
    const { data: fullRecipe } = await sb.from("recipes").select("*, recipe_categories(name)").eq("id", recipe.id).single();
    if (fullRecipe) recipe = { ...recipe, ...fullRecipe };
    const { data: items, error } = await sb.from("recipe_items")
      .select("id, quantity, unit, percentage, ingredients(id, name, unit, purchase_price, allergens)")
      .eq("recipe_id", recipe.id)
      .order("created_at");
    if (error) return showError(error);

    const allergenSet = new Set();
    (items || []).forEach(item => {
      String(item.ingredients?.allergens || "").split(/[,;]/).forEach(part => {
        const value = part.trim();
        if (value) allergenSet.add(value);
      });
    });

    // Coût de revient : même calcul que la carte de la liste
    const costCtx = await loadRecipeCostContext();
    const cost = computeRecipeCostProfile(recipe, items || [], costCtx);
    const itemCost = new Map(cost.perItem.map(x => [x.item.id, x.cost]));
    const mpCost = cost.mp, prodCost = cost.prod, totalCost = cost.total;
    const rows = (items || []).map(item => {
      const ingredient = item.ingredients;
      const lineCost = itemCost.get(item.id) || 0;
      const pct = item.percentage != null ? Number(item.percentage) : (recipe.unit_weight_g ? Number(item.quantity || 0) / Number(recipe.unit_weight_g) * 100 : null);
      return `<tr>
        <td>${escapeHtml(ingredient?.name || "—")}</td>
        <td>${pct !== null ? `${formatNumber(pct)}%` : "—"}</td>
        <td>${formatNumber(item.quantity)} ${escapeHtml(item.unit)}</td>
        <td>${badge(formatMoney(lineCost), "success")}</td>
      </tr>`;
    }).join("");

    const unitLabel = recipe.sale_unit || "unité";
    const traces = recipe.trace_allergens || [];
    // Ateliers de production écartés de la moyenne, affichés pour qu'on voie
    // qu'ils ne sont pas oubliés mais exclus volontairement
    const usedIds = new Set(cost.locations.map(l => l.id));
    const excludedSites = cost.basis === "general" ? [] : costCtx.locations.filter(l => l.is_production_site && !usedIds.has(l.id));
    // Coût réel : moyenne de l'année tous ateliers, évolution atelier par atelier
    const today = todayISO();
    const realAll = computeRealCostSeries(recipe.id, costCtx, today);
    const realVolume = new Map();
    (costCtx.productionsOf.get(recipe.id) || []).forEach(p => {
      if (p.location_id && p.unit_cost_mp != null && Number(p.quantity_produced) > 0)
        realVolume.set(p.location_id, (realVolume.get(p.location_id) || 0) + Number(p.quantity_produced));
    });
    const realSites = [...realVolume.entries()].sort((a, b) => b[1] - a[1])
      .map(([id]) => ({ id, name: costCtx.locations.find(l => l.id === id)?.name || "—" }));

    openModal({
      title: recipe.name,
      kicker: "Fiche produit",
      width: "780px",
      html: `
        <div class="detail-block">
          <div class="detail-block-title">ℹ️ Informations</div>
          <div class="detail-grid">
            <div><small>Rendement</small><div class="detail-value">1 ${escapeHtml(unitLabel)}${recipe.unit_weight_g ? ` (${formatNumber(recipe.unit_weight_g)}g)` : ""}</div></div>
            <div><small>Catégorie</small><div class="detail-value">${recipe.recipe_categories?.name ? escapeHtml(recipe.recipe_categories.name) : "—"}</div></div>
            <div><small>SKU</small><div class="detail-value">${recipe.code ? `<span class="ref-badge">${escapeHtml(recipe.code)}</span>` : "—"}</div></div>
          </div>
        </div>
        <div class="detail-block">
          <div class="detail-block-title">€ Coût de revient / ${escapeHtml(unitLabel)} <span class="cost-kind kind-theo">aux prix d’aujourd’hui</span></div>
          <div class="detail-grid detail-grid-cost">
            <div><small>Matières premières</small><div class="detail-value">${formatMoney(mpCost)}</div></div>
            <div><small>Production</small><div class="detail-value">${formatMoney(prodCost)}</div></div>
            <div class="detail-total"><small>Total</small><div class="detail-value">${formatMoney(totalCost)}</div></div>
          </div>
          ${cost.loss > 0 ? `<p class="cost-note">Matières premières : ${formatMoney(cost.mpRecipe)} de recette + ${formatMoney(cost.loss)} d’écart matière (${formatNumber(cost.lossPct)} %).</p>` : ""}
          <p class="cost-note">${cost.basis === "volumes"
            ? "Moyenne des ateliers qui fabriquent ce produit, pondérée par les quantités produites sur les 12 derniers mois."
            : cost.basis === "defined"
              ? "Aucune production terminée sur les 12 derniers mois : moyenne à parts égales des ateliers qui ont un coût de production renseigné."
              : "Aucun atelier associé à ce produit : calcul avec les derniers prix connus des ingrédients."}</p>
        </div>
        ${cost.basis === "general" ? `<div class="detail-block">
          <div class="detail-block-title">Par atelier</div>
          <p class="cost-note">Aucun atelier n’est associé à ce produit : ni production terminée sur les 12 derniers mois, ni coût de production renseigné. Renseigne le coût de production de chaque atelier qui le fabrique dans « Modifier » : le coût se calculera alors avec les prix de ces ateliers.</p>
        </div>` : ""}
        ${cost.basis !== "general" ? `<div class="detail-block">
          <div class="detail-block-title">Par atelier</div>
          <div class="table-wrap"><table class="cost-by-site">
            <thead><tr><th>Atelier</th><th>Matières</th><th>Production</th><th>Total</th><th>${cost.basis === "volumes" ? "Produit sur 12 mois" : "Part"}</th></tr></thead>
            <tbody>
              ${cost.locations.map(l => `<tr>
                <td><strong>${escapeHtml(l.name)}</strong></td>
                <td>${formatMoney(l.mp)}</td>
                <td>${formatMoney(l.prod)}</td>
                <td><strong>${formatMoney(l.total)}</strong></td>
                <td>${cost.basis === "volumes"
                  ? `${formatNumber(l.qty)} ${escapeHtml(unitLabel)} · ${formatNumber(l.share * 100, 0)} %<div class="share-bar"><i style="width:${(l.share * 100).toFixed(1)}%"></i></div>`
                  : "part égale"}</td>
              </tr>`).join("")}
              ${excludedSites.map(l => `<tr class="cost-site-off"><td>${escapeHtml(l.name)}</td><td colspan="4">${cost.basis === "volumes" ? "Aucune production sur 12 mois — exclu de la moyenne" : "Pas de coût de production renseigné — exclu"}</td></tr>`).join("")}
            </tbody>
          </table></div>
        </div>` : ""}
        <div class="detail-block">
          <div class="detail-block-title">Évolution du coût matière <span class="cost-kind kind-real">coût réel des productions</span></div>
          ${realAll.count ? `
            ${realSites.length > 1 ? `<div class="cost-site-select"><label>Atelier</label><select id="real-cost-site">${realSites.map(l => `<option value="${l.id}">${escapeHtml(l.name)}</option>`).join("")}</select></div>` : ""}
            <div id="real-cost-chart"></div>
            <div class="detail-grid" style="margin-top:8px">
              <div><small>Moyenne réelle sur l’année</small><div class="detail-value">${formatMoney(realAll.annual)}</div><div class="cost-note" style="margin:2px 0 0">tous ateliers, ${realAll.count} production${realAll.count > 1 ? "s" : ""}</div></div>
              <div><small>Évolution</small><div class="detail-value" id="real-cost-change">—</div><div class="cost-note" id="real-cost-change-note" style="margin:2px 0 0"></div></div>
            </div>`
          : `<p class="cost-note">Aucune production terminée sur les 12 derniers mois : l’évolution apparaîtra avec les prochaines productions.</p>`}
        </div>
        
        <div class="detail-block">
          <div class="detail-block-title">⚠️ Allergènes &amp; traces</div>
          <div class="detail-grid">
            <div><small>Allergènes (issus des ingrédients)</small><div class="allergen-tags">${allergenSet.size ? [...allergenSet].map(a => `<span class="allergen-tag allergen-tag-direct">${escapeHtml(a)}</span>`).join("") : `<span class="muted">Aucun renseigné sur les ingrédients</span>`}</div></div>
            <div><small>Traces éventuelles</small><div class="allergen-tags">${traces.length ? traces.map(a => `<span class="allergen-tag allergen-tag-trace">${escapeHtml(a)}</span>`).join("") : `<span class="muted">Aucune</span>`}</div></div>
          </div>
        </div>
        <div class="detail-block">
          <div class="detail-block-title">☰ Ingrédients</div>
          <div class="table-wrap">${rows ? `<table><thead><tr><th>Ingrédient</th><th>%</th><th>Quantité</th><th>Coût</th></tr></thead><tbody>${rows}</tbody>
              <tfoot>
                <tr><td colspan="3">Total recette</td><td>${formatMoney(cost.mpRecipe)}</td></tr>
                ${cost.loss > 0 ? `<tr><td colspan="3">Écart matière (${formatNumber(cost.lossPct)} %)</td><td>+ ${formatMoney(cost.loss)}</td></tr>
                <tr class="cost-foot-total"><td colspan="3">Matières premières</td><td>${formatMoney(cost.mp)}</td></tr>` : ""}
              </tfoot></table>` : emptyState("Composition vide", "Ouvrez « Modifier » pour ajouter des ingrédients.")}</div>
        </div>`
    });
    const drawRealCost = locationId => {
      const box = modalBody.querySelector("#real-cost-chart");
      if (!box) return;
      const serie = computeRealCostSeries(recipe.id, costCtx, today, locationId);
      box.innerHTML = renderRealCostChart(serie);
      const ch = modalBody.querySelector("#real-cost-change"), note = modalBody.querySelector("#real-cost-change-note");
      if (serie.change === null) {
        ch.textContent = "—";
        note.textContent = "Un seul mois de production : pas encore d’évolution.";
      } else {
        ch.textContent = `${serie.change > 0 ? "+ " : serie.change < 0 ? "− " : ""}${formatNumber(Math.abs(serie.change) * 100, 1)} %`;
        ch.style.color = serie.change > 0.0005 ? "#a74242" : serie.change < -0.0005 ? "var(--green-dark)" : "";
        note.textContent = `${serie.firstMonth.label} → ${serie.lastMonth.label}, à ${realSites.find(s => s.id === locationId)?.name || "cet atelier"}`;
      }
    };
    if (realSites.length) {
      drawRealCost(realSites[0].id);
      modalBody.querySelector("#real-cost-site")?.addEventListener("change", e => drawRealCost(e.target.value));
    }
  }

  // Modale d'édition : informations générales, rendement et coûts de
  // production, avec la composition en % ou en grammes juste en dessous.
  async function recipeModal(recipe = null) {
    const selectedTraces = new Set(recipe?.trace_allergens || []);
    const categoriesList = await fetchCategories();
    const selectedTracesLabel = selectedTraces.size ? `${selectedTraces.size} sélectionnée(s)` : "Sélectionner…";
    openModal({
      title: recipe ? "Modifier la recette" : "Nouvelle recette",
      kicker: "Produit fini",
      width: "820px",
      html: `
        <form id="recipe-form" class="form-grid">
          <div class="span-2 form-section-title">ℹ️ Informations générales</div>
          <div><label>Nom *</label><input name="name" required value="${escapeHtml(recipe?.name || "")}"></div>
          <div><label>SKU (code produit)</label><input name="code" value="${escapeHtml(recipe?.code || "")}" placeholder="COOK003"></div>
          <div><label>Code lot${helpTip("Placé en fin des numéros de lot de ce produit. Distinct du SKU : des chiffres seuls donnent des numéros de lot entièrement numériques.")}</label><input name="lot_code" value="${escapeHtml(recipe?.lot_code || "")}" placeholder="12" maxlength="10"></div>
          <div><label>Écart matière par défaut (%)${helpTip("Matière perdue à chaque production (reste en cuve, sur les outils). Repris à la création d'une production, modifiable ensuite. Le calculateur de besoin et le rétroplanning en tiennent compte.")}</label><input name="material_loss_pct" type="number" min="0" max="99" step="0.1" value="${recipe?.material_loss_pct ?? 0}"></div>
          <div><label>Catégorie</label><select name="category_id"><option value="">Aucune</option>${categoriesList.map(cat => `<option value="${cat.id}" ${recipe?.category_id === cat.id ? "selected" : ""}>${escapeHtml(cat.name)}</option>`).join("")}</select></div>
          <div class="span-2"><label>Description</label><textarea name="description" placeholder="Description de la recette">${escapeHtml(recipe?.notes || "")}</textarea></div>

          <div class="span-2 form-section-title">▦ Rendement</div>
          <div><label>Nom de l’unité *</label><input name="sale_unit" required value="${escapeHtml(recipe?.sale_unit || "")}" placeholder="cookie, gâteau, part…"></div>
          <div><label>Poids par unité (g) *</label><input id="recipe-unit-weight" name="unit_weight_g" type="number" min="0.01" step="0.01" required value="${recipe?.unit_weight_g ?? ""}" placeholder="Poids d’une unité"></div>
          <div class="span-2"><label>Valeur de transport</label><input name="transport_value" type="number" min="0" step="0.01" value="${recipe?.transport_value ?? 1}"><p class="form-note">Sert à répartir équitablement un coût de transport entre plusieurs produits lors d’un transfert entre emplacements : un produit avec une valeur de 10 « pèse » 10 fois plus qu’un produit à 1 dans le calcul, indépendamment de l’unité de vente.</p></div>
          <div class="span-2"><label>Valeur de stockage</label><input name="storage_value" type="number" min="0" step="0.01" value="${recipe?.storage_value ?? 1}"><p class="form-note">Même principe que la valeur de transport, mais pour répartir le coût d’entreposage externe entre plusieurs produits partageant une même palette.</p></div>
          <div class="span-2"><label>Coût de revient maximal toléré (€)</label><input name="max_cost_threshold" type="number" min="0" step="0.01" value="${recipe?.max_cost_threshold ?? ""}" placeholder="Laisser vide pour aucun seuil"><p class="form-note">Au-delà de ce coût de revient (matière première + fabrication + conditionnement + entreposage accumulé), une tâche d’alerte sera créée pour décider de sortir le produit avant qu’il ne devienne une perte.</p></div>

          <div class="span-2 form-section-title">⚠️ Traces éventuelles de</div>
          <details class="span-2 dropdown-multi">
            <summary>${selectedTracesLabel}</summary>
            <div class="dropdown-multi-options">${ALLERGENS_LIST.map(a => `<label class="allergen-check"><input type="checkbox" name="trace_allergens" value="${escapeHtml(a)}" ${selectedTraces.has(a) ? "checked" : ""}> ${escapeHtml(a)}</label>`).join("")}</div>
          </details>
        </form>
        <div id="location-costs-section" style="margin-top:16px"></div>
        <div id="composition-section"></div>
        <div class="form-actions" style="margin-top:22px"><button type="button" class="button button-ghost" data-close-modal>Annuler</button><button class="button button-primary" type="submit" form="recipe-form">Enregistrer</button></div>`
    });

    modalBody.querySelector("[data-close-modal]").addEventListener("click", closeModal);
    const tracesDetails = modalBody.querySelector(".dropdown-multi");
    tracesDetails.querySelectorAll('input[name="trace_allergens"]').forEach(input => input.addEventListener("change", () => {
      const count = tracesDetails.querySelectorAll('input[name="trace_allergens"]:checked').length;
      tracesDetails.querySelector("summary").textContent = count ? `${count} sélectionnée(s)` : "Sélectionner…";
    }));

    const pendingItems = [];
    const pendingCosts = new Map();
    if (recipe) {
      renderCompositionSection(recipe);
      renderLocationCostsSection(recipe);
    } else {
      renderPendingCompositionSection(pendingItems);
      renderLocationCostsSection(null, pendingCosts);
    }

    modalBody.querySelector("#recipe-form").addEventListener("submit", async event => {
      event.preventDefault();
      const values = formObject(event.currentTarget);
      const unitWeight = Number(values.unit_weight_g);
      const traceAllergens = [...event.currentTarget.querySelectorAll('input[name="trace_allergens"]:checked')].map(el => el.value);
      const payload = {
        organization_id: profile.organization_id,
        name: values.name.trim(),
        code: values.code.trim() || null,
        lot_code: (values.lot_code || "").trim() || null,
        material_loss_pct: Math.min(99, Math.max(0, Number(values.material_loss_pct || 0))),
        category_id: values.category_id || null,
        sale_unit: values.sale_unit.trim(),
        unit_weight_g: unitWeight,
        final_weight: unitWeight,
        weight_unit: "g",
        yield_quantity: 1,
        production_cost: 0,
        transport_value: Number(values.transport_value || 1),
        storage_value: Number(values.storage_value || 1),
        max_cost_threshold: values.max_cost_threshold === "" ? null : Number(values.max_cost_threshold),
        trace_allergens: traceAllergens,
        notes: values.description.trim() || null
      };
      const button = event.submitter; submitButtonLoading(button, true);
      const query = recipe
        ? sb.from("recipes").update(payload).eq("id", recipe.id).select().single()
        : sb.from("recipes").insert(payload).select().single();
      const { data: saved, error } = await query;
      if (error) { submitButtonLoading(button, false); return showError(error); }
      if (!recipe && pendingItems.length) {
        const { error: itemsError } = await sb.from("recipe_items").insert(pendingItems.map(it => ({
          recipe_id: saved.id, ingredient_id: it.ingredientId, quantity: it.quantity, unit: "g", percentage: it.percentage
        })));
        if (itemsError) { submitButtonLoading(button, false); return showError(itemsError); }
      }
      if (!recipe && pendingCosts.size) {
        const { error: costsError } = await sb.from("recipe_location_costs").insert(
          [...pendingCosts.entries()].map(([locationId, cost]) => ({ recipe_id: saved.id, location_id: locationId, production_cost: cost }))
        );
        if (costsError) { submitButtonLoading(button, false); return showError(costsError); }
      }
      submitButtonLoading(button, false);
      showToast("Recette enregistrée.");
      renderRecipes();
      closeModal();
    });
  }

  function renderPendingCompositionSection(pendingItems) {
    const container = modalBody.querySelector("#composition-section");
    sb.from("ingredients").select("id,name,unit").eq("organization_id", profile.organization_id).eq("archived", false).order("name").then(({ data: ingredients, error }) => {
      if (error) return showError(error);
      const unitLabel = modalBody.querySelector('input[name="sale_unit"]')?.value || "unité";

      const rows = pendingItems.map((item, idx) => `<tr data-idx="${idx}">
        <td>${escapeHtml(item.ingredientName)}</td>
        <td>${item.percentage != null ? `${formatNumber(item.percentage)}%` : "—"}</td>
        <td>${formatNumber(item.quantity)} g</td>
        <td><button type="button" class="icon-button icon-small danger pending-delete-item">🗑</button></td>
      </tr>`).join("");

      container.innerHTML = `
        <div class="form-section-title" style="margin-top:22px">☰ Ingrédients pour 1 ${escapeHtml(unitLabel)}</div>
        <div class="mode-toggle">
          <span>Mode de saisie :</span>
          <button type="button" class="mode-btn active" data-mode="percentage">Pourcentage (%)</button>
          <button type="button" class="mode-btn" data-mode="grams">Grammes (g)</button>
        </div>
        ${!ingredients.length ? `<div class="help-box" style="margin-top:10px">Créez d’abord des ingrédients dans l’onglet Stocks &amp; lots MP.</div>` : `
        <div class="form-grid" style="margin-top:10px">
          <div class="span-2"><label>Ingrédient</label><select id="pending-ingredient"><option value="">Sélectionner…</option>${ingredients.map(i => `<option value="${i.id}">${escapeHtml(i.name)}</option>`).join("")}</select></div>
          <div><label id="pending-value-label">Pourcentage (%)</label><input id="pending-value" type="number" min="0" step="0.01" value="0"></div>
          <div style="align-self:end"><button type="button" id="pending-submit" class="button button-primary button-full">＋ Ajouter</button></div>
        </div>`}
        <div class="table-wrap" style="margin-top:14px">${rows ? `<table><thead><tr><th title="Ordre de pesée sur la feuille de production">Pesée</th><th>Ingrédient</th><th>Pourcentage</th><th>Quantité</th><th></th></tr></thead><tbody>${rows}</tbody></table>
      ${rows ? `<p class="form-note">La colonne « Pesée » fixe l’ordre de la feuille de production, pour toutes les productions de ce produit. Sans numéro, un ingrédient passe en dernier.</p>` : ""}` : emptyState("Aucun ingrédient", "Ajoutez la composition de cette recette.")}</div>
      `;
      if (!ingredients.length) return;

      let mode = "percentage";
      const modeButtons = container.querySelectorAll(".mode-btn");
      const valueInput = container.querySelector("#pending-value");
      const valueLabel = container.querySelector("#pending-value-label");
      modeButtons.forEach(btn => btn.addEventListener("click", () => {
        mode = btn.dataset.mode;
        modeButtons.forEach(b => b.classList.toggle("active", b === btn));
        valueLabel.textContent = mode === "percentage" ? "Pourcentage (%)" : "Grammes (g)";
      }));
      container.querySelector("#pending-submit").addEventListener("click", () => {
        const unitWeight = Number(modalBody.querySelector("#recipe-unit-weight")?.value || 0);
        if (!unitWeight) return showToast("Renseignez d’abord le poids par unité.", "error");
        const ingredientSelect = container.querySelector("#pending-ingredient");
        const ingredientId = ingredientSelect.value;
        if (!ingredientId) return showToast("Choisissez un ingrédient.", "error");
        const rawValue = Number(valueInput.value || 0);
        if (rawValue <= 0) return showToast("Indiquez une quantité supérieure à zéro.", "error");
        const grams = mode === "percentage" ? (rawValue / 100) * unitWeight : rawValue;
        const percentage = mode === "percentage" ? rawValue : (grams / unitWeight) * 100;
        pendingItems.push({ ingredientId, ingredientName: ingredientSelect.selectedOptions[0].textContent, quantity: grams, percentage });
        renderPendingCompositionSection(pendingItems);
      });
      container.querySelectorAll(".pending-delete-item").forEach(btn => btn.addEventListener("click", () => {
        const idx = Number(btn.closest("tr").dataset.idx);
        pendingItems.splice(idx, 1);
        renderPendingCompositionSection(pendingItems);
      }));
    });
  }

  async function renderCompositionSection(recipe) {
    const container = modalBody.querySelector("#composition-section");
    if (!container) return;
    const [ingredientsRes, itemsRes] = await Promise.all([
      sb.from("ingredients").select("id,name,unit").eq("organization_id", profile.organization_id).eq("archived", false).order("name"),
      sb.from("recipe_items").select("id,quantity,unit,percentage,weigh_order,ingredients(id,name)").eq("recipe_id", recipe.id).order("created_at")
    ]);
    if (ingredientsRes.error || itemsRes.error) return showError(ingredientsRes.error || itemsRes.error);
    const ingredients = ingredientsRes.data || [];
    // Affichée dans l'ordre de pesée : on voit la séquence réelle de travail
    const items = sortByWeighOrder(itemsRes.data || [], it => it.weigh_order, it => it.ingredients?.name);
    const unitLabel = recipe.sale_unit || "unité";

    const rows = items.map(item => `<tr data-id="${item.id}">
      <td><input type="number" min="1" step="1" class="weigh-order-input" data-id="${item.id}" value="${item.weigh_order ?? ""}" placeholder="—" title="Ordre de pesée : 1 = pesé en premier"></td>
      <td>${escapeHtml(item.ingredients?.name || "—")}</td>
      <td>${item.percentage != null ? `${formatNumber(Number(item.percentage))}%` : "—"}</td>
      <td>${formatNumber(item.quantity)} ${escapeHtml(item.unit)}</td>
      <td><div class="table-actions"><button type="button" class="icon-button icon-small edit-composition-item" title="Modifier">${ICONS.edit}</button><button type="button" class="icon-button icon-small danger delete-composition-item" title="Supprimer">${ICONS.trash}</button></div></td>
    </tr>`).join("");

    container.innerHTML = `
      <div class="form-section-title" style="margin-top:22px">☰ Ingrédients pour 1 ${escapeHtml(unitLabel)}</div>
      <div class="mode-toggle">
        <span>Mode de saisie :</span>
        <button type="button" class="mode-btn active" data-mode="percentage">Pourcentage (%)</button>
        <button type="button" class="mode-btn" data-mode="grams">Grammes (g)</button>
      </div>
      ${!ingredients.length ? `<div class="help-box" style="margin-top:10px">Créez d’abord des ingrédients dans l’onglet Ingrédients.</div>` : `
      <div class="form-grid" style="margin-top:10px">
        <div class="span-2"><label>Ingrédient</label><select id="composition-ingredient"><option value="">Sélectionner…</option>${ingredients.map(i => `<option value="${i.id}">${escapeHtml(i.name)}</option>`).join("")}</select></div>
        <div><label id="composition-value-label">Pourcentage (%)</label><input id="composition-value" type="number" min="0" step="0.01" value="0"></div>
        <div style="align-self:end"><button type="button" id="composition-submit" class="button button-primary button-full">＋ Ajouter</button></div>
      </div>`}
      <div class="table-wrap" style="margin-top:14px">${rows ? `<table><thead><tr><th title="Ordre de pesée sur la feuille de production">Pesée</th><th>Ingrédient</th><th>Pourcentage</th><th>Quantité</th><th></th></tr></thead><tbody>${rows}</tbody></table>
      ${rows ? `<p class="form-note">La colonne « Pesée » fixe l’ordre de la feuille de production, pour toutes les productions de ce produit. Sans numéro, un ingrédient passe en dernier.</p>` : ""}` : emptyState("Aucun ingrédient", "Ajoutez la composition de cette recette.")}</div>
    `;

    container.querySelectorAll(".weigh-order-input").forEach(input => input.addEventListener("change", async () => {
      const raw = input.value.trim();
      const value = raw === "" ? null : Math.round(Number(raw));
      if (value !== null && (!Number.isFinite(value) || value < 1)) {
        input.value = ""; return showToast("L’ordre de pesée doit être un nombre à partir de 1.", "error");
      }
      const { error: orderError } = await sb.from("recipe_items").update({ weigh_order: value }).eq("id", input.dataset.id);
      if (orderError) return showError(orderError);
      showToast("Ordre de pesée enregistré.");
      renderCompositionSection(recipe);
    }));

    if (!ingredients.length) return;

    let mode = "percentage";
    let editingId = null;
    const modeButtons = container.querySelectorAll(".mode-btn");
    const valueInput = container.querySelector("#composition-value");
    const valueLabel = container.querySelector("#composition-value-label");
    const submitButton = container.querySelector("#composition-submit");

    modeButtons.forEach(btn => btn.addEventListener("click", () => {
      mode = btn.dataset.mode;
      modeButtons.forEach(b => b.classList.toggle("active", b === btn));
      valueLabel.textContent = mode === "percentage" ? "Pourcentage (%)" : "Grammes (g)";
    }));

    function resetCompositionForm() {
      editingId = null;
      valueInput.value = 0;
      submitButton.textContent = "＋ Ajouter";
    }

    submitButton.addEventListener("click", async () => {
      const unitWeight = Number(modalBody.querySelector("#recipe-unit-weight")?.value || recipe.unit_weight_g || 0);
      if (!unitWeight) return showToast("Renseignez d’abord le poids par unité.", "error");
      const ingredientId = container.querySelector("#composition-ingredient").value;
      if (!ingredientId) return showToast("Choisissez un ingrédient.", "error");
      const rawValue = Number(valueInput.value || 0);
      if (rawValue <= 0) return showToast("Indiquez une quantité supérieure à zéro.", "error");
      const grams = mode === "percentage" ? (rawValue / 100) * unitWeight : rawValue;
      const percentage = mode === "percentage" ? rawValue : (grams / unitWeight) * 100;
      const payload = { recipe_id: recipe.id, ingredient_id: ingredientId, quantity: grams, unit: "g", percentage };
      submitButton.disabled = true;
      const query = editingId ? sb.from("recipe_items").update(payload).eq("id", editingId) : sb.from("recipe_items").insert(payload);
      const { error } = await query;
      submitButton.disabled = false;
      if (error) return showError(error);
      showToast(editingId ? "Ingrédient mis à jour." : "Ingrédient ajouté.");
      resetCompositionForm();
      renderCompositionSection(recipe);
      renderRecipes();
    });

    container.querySelectorAll(".edit-composition-item").forEach(btn => btn.addEventListener("click", () => {
      const row = btn.closest("tr");
      const item = items.find(i => i.id === row.dataset.id);
      if (!item) return;
      editingId = item.id;
      container.querySelector("#composition-ingredient").value = item.ingredients?.id || "";
      if (item.percentage != null) {
        mode = "percentage";
        valueInput.value = Number(item.percentage);
      } else {
        mode = "grams";
        valueInput.value = Number(item.quantity);
      }
      modeButtons.forEach(b => b.classList.toggle("active", b.dataset.mode === mode));
      valueLabel.textContent = mode === "percentage" ? "Pourcentage (%)" : "Grammes (g)";
      submitButton.textContent = "Mettre à jour";
    }));

    container.querySelectorAll(".delete-composition-item").forEach(btn => btn.addEventListener("click", async () => {
      const row = btn.closest("tr");
      if (!confirm("Retirer cet ingrédient de la recette ?")) return;
      const { error } = await sb.from("recipe_items").delete().eq("id", row.dataset.id);
      if (error) return showError(error);
      renderCompositionSection(recipe);
      renderRecipes();
    }));
  }

  async function renderLocationCostsSection(recipe, pendingCosts) {
    const container = modalBody.querySelector("#location-costs-section");
    if (!container) return;
    const isPending = !recipe;
    const [allLocations, overrides] = await Promise.all([
      fetchLocations(),
      isPending ? Promise.resolve([]) : sb.from("recipe_location_costs").select("id, location_id, production_cost").eq("recipe_id", recipe.id).then(r => r.data || [])
    ]);
    if (!allLocations.length) {
      container.innerHTML = `<div class="form-section-title">€ Coût de fabrication par emplacement</div><div class="help-box">Créez des emplacements dans Paramètres pour pouvoir renseigner un coût de fabrication.</div>`;
      return;
    }
    const byLocation = new Map(overrides.map(o => [o.location_id, o]));
    container.innerHTML = `
      <div class="form-section-title">€ Coût de fabrication par emplacement ${helpTip("Coût de fabrication (opérateur, énergie…) pour une unité produite sur cet emplacement. Laisse vide si non applicable : le coût sera alors de 0€ sur cet emplacement.")}</div>
      <div class="form-grid">
        ${allLocations.map(loc => `<div><label>${escapeHtml(loc.name)}</label><input type="number" min="0" step="0.01" class="location-cost-input" data-location-id="${loc.id}" value="${isPending ? (pendingCosts.get(loc.id) ?? "") : (byLocation.get(loc.id)?.production_cost ?? "")}"></div>`).join("")}
      </div>
    `;
    container.querySelectorAll(".location-cost-input").forEach(input => {
      input.addEventListener(isPending ? "input" : "change", async () => {
        const locationId = input.dataset.locationId;
        const raw = input.value;
        if (isPending) {
          if (raw === "") pendingCosts.delete(locationId);
          else pendingCosts.set(locationId, Number(raw));
          return;
        }
        if (raw === "") {
          const existing = byLocation.get(locationId);
          if (existing) {
            const { error: delError } = await sb.from("recipe_location_costs").delete().eq("id", existing.id);
            if (delError) return showError(delError);
          }
        } else {
          const { error: costError } = await sb.from("recipe_location_costs").upsert({ recipe_id: recipe.id, location_id: locationId, production_cost: Number(raw) }, { onConflict: "recipe_id,location_id" });
          if (costError) return showError(costError);
        }
        showToast("Coût enregistré.");
      });
    });
  }

  // Productions
  function productionDateTimeLocal(date) {
    if (!date) return "";
    const d = new Date(date);
    const pad = n => String(n).padStart(2, "0");
    return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}T${pad(d.getHours())}:${pad(d.getMinutes())}`;
  }

  async function renderProductions() {
    await loadProductionStages();
    const canCreate = pageCan("productions");
    setHeader("productions", canCreate ? `<button id="add-production" class="button button-primary">＋ Nouvelle production</button>` : "");
    const { data, error } = await sb.from("productions")
      .select("*, recipes(name,code,sale_unit,recipe_categories(name)), locations(name)")
      .eq("organization_id", profile.organization_id)
      .order("production_date", { ascending: false });
    if (error) throw error;
    const allProductions = (data || []).filter(p => canSeeLocation(p.location_id));
    const productions = productionsArchiveFilter === "all" ? allProductions
      : productionsArchiveFilter === "archived" ? allProductions.filter(p => p.archived)
      : allProductions.filter(p => !p.archived);

    content.innerHTML = `
      <div class="toolbar">
        <input id="productions-search" class="search" placeholder="Rechercher une recette, un lot, un opérateur…">
        ${productionsViewMode === "list" ? `<select id="productions-archive-filter" class="filter-select">
          <option value="active" ${productionsArchiveFilter === "active" ? "selected" : ""}>Actives</option>
          <option value="archived" ${productionsArchiveFilter === "archived" ? "selected" : ""}>Archivées</option>
          <option value="all" ${productionsArchiveFilter === "all" ? "selected" : ""}>Toutes</option>
        </select>` : ""}
        <div class="view-toggle">
          <button type="button" class="mode-btn ${productionsViewMode === "list" ? "active" : ""}" data-view-mode="list">☰ Liste</button>
          <button type="button" class="mode-btn ${productionsViewMode === "kanban" ? "active" : ""}" data-view-mode="kanban">▦ Kanban</button>
        </div>
        <div class="toolbar-spacer"></div>
      </div>
      <div id="productions-body"></div>`;

    document.querySelectorAll("[data-view-mode]").forEach(btn => btn.addEventListener("click", () => {
      productionsViewMode = btn.dataset.viewMode;
      renderProductions();
    }));
    document.querySelector("#productions-archive-filter")?.addEventListener("change", event => {
      productionsArchiveFilter = event.target.value;
      renderProductions();
    });
    document.querySelector("#add-production")?.addEventListener("click", () => productionModal());
    document.querySelector("#productions-search").addEventListener("input", event => {
      const q = event.target.value.trim().toLocaleLowerCase("fr");
      document.querySelectorAll("#productions-body [data-searchable]").forEach(el => {
        el.hidden = Boolean(q) && !el.textContent.toLocaleLowerCase("fr").includes(q);
      });
    });

    const body = document.querySelector("#productions-body");
    if (productionsViewMode === "kanban") {
      renderProductionsKanban(body, allProductions, canCreate);
    } else {
      renderProductionsList(body, productions, canCreate);
    }
  }

  function renderProductionsList(container, productions, canEdit) {
    const rows = productions.map(prod => {
      const statusInfo = PRODUCTION_STATUSES[prod.status] || { label: prod.status, tone: "success" };
      return `<tr data-searchable>
        <td><strong>${escapeHtml(prod.recipes?.name || "—")}</strong><br><span class="muted">${escapeHtml(prod.recipes?.code || "")}</span></td>
        <td>${formatDate(prod.production_date)}</td>
        <td><strong>${escapeHtml(prod.finished_lot_number)}</strong></td>
        <td>${formatNumber(prod.quantity_produced)} ${escapeHtml(prod.recipes?.sale_unit || "unités")}</td>
        <td>${escapeHtml(prod.operator || "—")}</td>
        <td>${escapeHtml(prod.locations?.name || "—")}</td>
        <td>${badge(statusInfo.label, statusInfo.tone)}${prod.archived ? ` ${badge("Archivée")}` : ""}</td>
        <td><div class="table-actions">
          <button class="icon-button icon-small view-production" data-id="${prod.id}" title="Voir le détail">${ICONS.eye}</button>
          ${prod.status !== "completed" ? `<button class="icon-button icon-small open-production-sheet" data-id="${prod.id}" title="Feuille de production : ce qu'il faut peser">${ICONS.sheet}</button>` : ""}
          ${canEdit ? `<button class="icon-button icon-small revert-production" data-id="${prod.id}" title="Revenir à l’étape précédente">${ICONS.arrowLeft}</button>` : ""}
          ${canEdit ? advanceStageButton(prod.id, prod.status) : ""}
          ${canEdit && prod.status === "in_progress" ? `<button class="icon-button icon-small complete-production" data-id="${prod.id}" title="Terminer (saisie de la traçabilité, création du lot)">${ICONS.check}</button>` : ""}
          ${canEdit && prod.status === "completed" && !prod.archived ? `<button class="icon-button icon-small archive-production" data-id="${prod.id}" title="Archiver">${ICONS.archive}</button>` : ""}
          ${prod.attachment_path ? `<button class="button button-small button-ghost view-production-file" data-path="${escapeHtml(prod.attachment_path)}">Fiche</button>` : ""}
        </div></td>
      </tr>`;
    }).join("");
    container.innerHTML = `<div class="table-wrap">${rows ? `<table><thead><tr><th>Produit</th><th>Date</th><th>Lot</th><th>Quantité</th><th>Responsable</th><th>Emplacement</th><th>Statut</th><th></th></tr></thead><tbody>${rows}</tbody></table>` : emptyState("Aucune production", "Créez une première production.")}</div>`;
    wireProductionActions(container, productions);
  }

  function renderProductionsKanban(container, productions, canEdit) {
    // Comme pour les livraisons : le Kanban ne montre que les productions
    // actives. Les archivées se consultent en vue liste, via le filtre.
    const columns = [...PRODUCTION_CUSTOM_STAGES.map(s => s.key), "in_progress", "completed"];
    const columnInfo = { ...PRODUCTION_STATUSES, archived: { label: "Archivé", tone: "" } };
    container.innerHTML = `<div class="kanban-board kanban-board-6" style="grid-template-columns: repeat(${columns.length}, minmax(210px, 1fr))">
      ${columns.map(colKey => {
        const items = productions.filter(p => p.status === colKey && !p.archived);
        const info = columnInfo[colKey];
        return `<div class="kanban-column kanban-column-tone-${info.tone || "neutral"}">
          <div class="kanban-column-head">
            <span class="kanban-status-pill kanban-status-pill-${info.tone || "neutral"}">${escapeHtml(info.label)} <strong>${items.length}</strong></span>
            ${canEdit && colKey !== "completed" && colKey !== "archived" ? `<button type="button" class="icon-button icon-small quick-add-production" data-status="${colKey}" title="Nouvelle production">＋</button>` : ""}
          </div>
          <div class="kanban-cards">${items.map(prod => `
            <article class="card kanban-card-v2" data-searchable>
              <div class="kanban-card-icon-row"><strong>${escapeHtml(prod.recipes?.name || "—")}</strong></div>
              ${prod.recipes?.recipe_categories?.name ? `<span class="ref-badge">${escapeHtml(prod.recipes.recipe_categories.name)}</span>` : ""}
              <div class="muted kanban-card-date">${formatDate(prod.production_date)}</div>
              <div class="muted">${escapeHtml(prod.finished_lot_number)} · ${formatNumber(prod.quantity_produced)} ${escapeHtml(prod.recipes?.sale_unit || "unités")}</div>
              ${prod.locations?.name ? `<div class="muted">${escapeHtml(prod.locations.name)}</div>` : ""}
              ${prod.operator ? `<div class="muted">Par ${escapeHtml(prod.operator)}</div>` : ""}
              <div class="kanban-card-actions kanban-card-actions-nowrap">
                <button class="icon-button icon-small view-production" data-id="${prod.id}" title="Voir le détail">${ICONS.eye}</button>
                ${colKey !== "completed" ? `<button class="icon-button icon-small open-production-sheet" data-id="${prod.id}" title="Feuille de production : ce qu'il faut peser">${ICONS.sheet}</button>` : ""}
                ${canEdit && colKey === "archived" ? `<button class="icon-button icon-small unarchive-production" data-id="${prod.id}" title="Revenir en Terminé">${ICONS.arrowLeft}</button>` : ""}
                ${canEdit && colKey !== "archived" ? `<button class="icon-button icon-small revert-production" data-id="${prod.id}" title="Revenir à l’étape précédente">${ICONS.arrowLeft}</button>` : ""}
          ${canEdit ? advanceStageButton(prod.id, colKey) : ""}
                ${canEdit && colKey === "in_progress" ? `<button class="icon-button icon-small complete-production" data-id="${prod.id}" title="Terminer (saisie de la traçabilité, création du lot)">${ICONS.check}</button>` : ""}
                ${canEdit && colKey === "completed" ? `<button class="icon-button icon-small archive-production" data-id="${prod.id}" title="Archiver">${ICONS.archive}</button>` : ""}
              </div>
            </article>`).join("") || `<p class="muted kanban-empty">Aucune</p>`}
          </div>
        </div>`;
      }).join("")}
    </div>`;
    wireProductionActions(container, productions);
    container.querySelectorAll(".quick-add-production").forEach(btn => btn.addEventListener("click", () => productionModal(null, btn.dataset.status)));
    container.querySelectorAll(".unarchive-production").forEach(btn => btn.addEventListener("click", async () => {
      const { error } = await sb.rpc("set_production_archived", { p_production_id: btn.dataset.id, p_archived: false });
      if (error) return showError(error);
      showToast("Production revenue dans Terminé."); renderProductions();
    }));
  }

  function wireProductionActions(container, productions) {
    container.querySelectorAll(".view-production-file").forEach(btn => btn.addEventListener("click", () => openPrivateFile("production-files", btn.dataset.path)));
    container.querySelectorAll(".view-production").forEach(btn => btn.addEventListener("click", () => {
      productionDetailModal(productions.find(p => p.id === btn.dataset.id));
    }));
    container.querySelectorAll(".open-production-sheet").forEach(btn => btn.addEventListener("click", () =>
      productionSheetModal(productions.find(p => p.id === btn.dataset.id))));
    container.querySelectorAll(".advance-stage").forEach(btn => btn.addEventListener("click", async () => {
      submitButtonLoading(btn, true);
      const { data: newStatus, error } = await sb.rpc("advance_production_stage", { p_production_id: btn.dataset.id });
      submitButtonLoading(btn, false);
      if (error) return showError(error);
      showToast(newStatus === "in_progress" ? "Production démarrée : la matière première est sortie du stock." : "Étape suivante.");
      renderProductions();
    }));
    container.querySelectorAll(".start-production").forEach(btn => btn.addEventListener("click", async () => {
      const { error } = await sb.rpc("set_production_in_progress", { p_production_id: btn.dataset.id });
      if (error) return showError(error);
      showToast("Production passée en cours."); renderProductions();
    }));
    container.querySelectorAll(".revert-production").forEach(btn => btn.addEventListener("click", async () => {
      const prod = productions.find(p => p.id === btn.dataset.id);
      const warning = prod?.status === "completed" ? " Le stock de matières premières consommé sera restitué." : "";
      if (!confirm(`Revenir à l’étape précédente ?${warning}`)) return;
      const { error } = await sb.rpc("revert_production_status", { p_production_id: btn.dataset.id });
      if (error) return showError(error);
      showToast("Production revenue à l’étape précédente."); renderProductions();
    }));
    container.querySelectorAll(".complete-production").forEach(btn => btn.addEventListener("click", () => {
      completeProductionModal(productions.find(p => p.id === btn.dataset.id));
    }));
    container.querySelectorAll(".edit-production").forEach(btn => btn.addEventListener("click", () => {
      productionModal(productions.find(p => p.id === btn.dataset.id));
    }));
    container.querySelectorAll(".delete-production").forEach(btn => btn.addEventListener("click", async () => {
      const prod = productions.find(p => p.id === btn.dataset.id);
      const warning = prod?.status === "in_progress" ? " Le stock de matières premières consommé sera restitué." : "";
      if (!confirm(`Supprimer cette production ?${warning}`)) return;
      const { error } = await sb.rpc("delete_production", { p_production_id: btn.dataset.id });
      if (error) return showError(error);
      showToast("Production supprimée."); renderProductions();
    }));
    container.querySelectorAll(".archive-production").forEach(btn => btn.addEventListener("click", async () => {
      const { error } = await sb.rpc("set_production_archived", { p_production_id: btn.dataset.id, p_archived: true });
      if (error) return showError(error);
      showToast("Production archivée."); renderProductions();
    }));
  }

  async function productionDetailModal(production) {
    if (!production) return;
    const info = PRODUCTION_STATUSES[production.status] || { label: production.status, tone: "success" };

    let consumptions = [];
    let supplyConsumptions = [];
    let checkpointValues = [];
    if (production.status === "completed") {
      const { data: cv } = await sb.from("production_checkpoint_values")
        .select("section, label, field_type, unit, value, sort_order")
        .eq("production_id", production.id).order("sort_order");
      checkpointValues = cv || [];
    }
    const materialsConsumed = production.status === "in_progress" || production.status === "completed";
    if (materialsConsumed) {
      const [consRes, supplyConsRes] = await Promise.all([
        sb.from("production_consumptions")
          .select("id, quantity, ingredient_lots(lot_number, unit, expiry_date, ingredients(id, name))")
          .eq("production_id", production.id)
          .order("created_at"),
        sb.from("production_supply_consumptions")
          .select("id, quantity, supply_lots(lot_number, unit, supplies(id, name))")
          .eq("production_id", production.id)
          .order("created_at")
      ]);
      if (consRes.error) return showError(consRes.error);
      consumptions = consRes.data || [];
      supplyConsumptions = supplyConsRes.data || [];
    }

    const consumptionRows = consumptions.map(c => `<tr>
      <td>${escapeHtml(c.ingredient_lots?.ingredients?.name || "—")}</td>
      <td>${formatNumber(c.quantity)} ${escapeHtml(c.ingredient_lots?.unit || "")}</td>
      <td><span class="lot-pill">${c.ingredient_lots?.lot_number ? escapeHtml(c.ingredient_lots.lot_number) : "Sans numéro de lot"}</span></td>
      <td>${c.ingredient_lots?.expiry_date ? formatDate(c.ingredient_lots.expiry_date) : "—"}</td>
      <td><button type="button" class="icon-button icon-small edit-consumption" data-id="${c.id}" data-qty="${c.quantity}" data-unit="${escapeHtml(c.ingredient_lots?.unit || "")}" data-name="${escapeHtml(c.ingredient_lots?.ingredients?.name || "")}" title="Corriger la quantité">✎</button></td>
    </tr>`).join("");

    const supplyConsumptionRows = supplyConsumptions.map(c => `<tr>
      <td>${escapeHtml(c.supply_lots?.supplies?.name || "—")}</td>
      <td>${formatNumber(c.quantity)} ${escapeHtml(c.supply_lots?.unit || "")}</td>
      <td><span class="lot-pill">${c.supply_lots?.lot_number ? escapeHtml(c.supply_lots.lot_number) : "Sans numéro de lot"}</span></td>
    </tr>`).join("");


    openModal({
      title: production.recipes?.name || production.finished_lot_number,
      kicker: "",
      width: "760px",
      html: `
        <div class="prod-detail-head">${badge(info.label, info.tone)}</div>
        <div class="detail-grid detail-grid-4" style="margin-bottom:22px">
          <div><small>Quantité produite</small><div class="detail-value">${formatNumber(production.quantity_produced)} ${escapeHtml(production.recipes?.sale_unit || "unités")}</div></div>
          <div><small>Date de production</small><div class="detail-value">${formatDate(production.production_date)}</div></div>
          <div><small>Opérateur</small><div class="detail-value">${escapeHtml(production.operator || "—")}</div></div>
          <div><small>N° de lot</small><div class="detail-value">${escapeHtml(production.finished_lot_number)}</div></div>
        </div>
        <div class="detail-block">
          <div class="detail-block-title">📍 Emplacement &amp; DDM</div>
          <div class="detail-grid">
            <div><small>Emplacement</small><div class="detail-value">${escapeHtml(production.locations?.name || "—")}</div></div>
            <div><small>DDM</small><div class="detail-value">${formatDate(production.expiry_date)}</div></div>
          </div>
        </div>
        ${Number(production.material_loss_pct || 0) > 0 ? (() => {
          // Part de la matière consommée qui correspond à la perte :
          // consommé = recette x (1 + p) ; perte = consommé x p / (1 + p)
          const pct = Number(production.material_loss_pct);
          const mpTotal = production.unit_cost_mp != null ? Number(production.unit_cost_mp) * Number(production.quantity_produced || 0) : null;
          const lossValue = mpTotal != null ? mpTotal * pct / (100 + pct) : null;
          return `<div class="detail-block">
            <div class="detail-block-title">Écart matière</div>
            <div class="detail-grid">
              <div><small>Pourcentage appliqué</small><div class="detail-value">${formatNumber(pct, 1)} %</div></div>
              <div><small>Valeur de la matière perdue</small><div class="detail-value">${lossValue != null ? formatMoney(lossValue) : "Calculée au démarrage"}</div></div>
            </div>
          </div>`;
        })() : ""}
        ${production.status === "completed" ? renderCheckpointBlocks(checkpointValues) : ""}
        ${materialsConsumed ? `
        <div class="detail-block">
          <div class="detail-block-title">☰ Ingrédients consommés</div>
          <div class="table-wrap">${consumptionRows ? `<table><thead><tr><th>Ingrédient</th><th>Quantité</th><th>Lots</th><th>DDM</th><th>Actions</th></tr></thead><tbody>${consumptionRows}</tbody></table>` : emptyState("Aucune consommation enregistrée", "")}</div>
        </div>
        <div class="detail-block">
          <div class="detail-block-title">📦 Conditionnements utilisés</div>
          <div class="table-wrap">${supplyConsumptionRows ? `<table><thead><tr><th>Fourniture</th><th>Quantité</th><th>Lot</th></tr></thead><tbody>${supplyConsumptionRows}</tbody></table>` : emptyState("Aucun conditionnement lié à cette recette", "")}</div>
        </div>` : `<div class="detail-block"><div class="help-inline">${helpTip("Les matières premières et conditionnements seront consommés dès le passage au statut « En cours ».")}<span class="help-inline-label">À savoir</span></div></div>`}
        ${production.notes ? `<div class="detail-block"><div class="detail-block-title">📝 Notes</div><p>${escapeHtml(production.notes)}</p></div>` : ""}
        ${pageCan("productions") ? `<div class="form-actions detail-footer-actions">
          <button type="button" class="button button-danger" id="detail-delete-production">${ICONS.trash} Supprimer</button>
          <button type="button" class="button button-secondary" id="detail-edit-production">${ICONS.edit} Modifier</button>
        </div>` : ""}
      `
    });

    // Actions de gestion, déplacées ici depuis la carte pour que celle-ci
    // ne garde que les actions du quotidien, sur une seule ligne.
    modalBody.querySelector("#detail-edit-production")?.addEventListener("click", () => {
      closeModal();
      productionModal(production);
    });
    modalBody.querySelector("#detail-delete-production")?.addEventListener("click", async () => {
      const warning = production.status === "in_progress" ? " Le stock de matières premières consommé sera restitué." : "";
      if (!confirm(`Supprimer cette production ?${warning}`)) return;
      const { error } = await sb.rpc("delete_production", { p_production_id: production.id });
      if (error) return showError(error);
      closeModal();
      showToast("Production supprimée.");
      renderProductions();
    });

    modalBody.querySelectorAll(".edit-consumption").forEach(btn => btn.addEventListener("click", () => {
      editConsumptionModal(btn.dataset.id, btn.dataset.name, Number(btn.dataset.qty), btn.dataset.unit, production);
    }));
  }

  function editConsumptionModal(consumptionId, ingredientName, currentQty, unit, production) {
    openModal({
      title: "Corriger la consommation",
      kicker: ingredientName,
      html: `<form id="edit-consumption-form" class="form-grid">
        <div class="span-2"><label>Quantité réellement consommée (${escapeHtml(unit)}) * ${helpTip("Le stock du lot de matière première est ajusté de la différence, et le coût matière de la production et de ses lots de produits finis est recalculé.")}</label><input name="quantity" type="number" min="0" step="0.001" required value="${currentQty}"></div>
        <div class="form-actions span-2"><button type="button" class="button button-ghost" data-close-modal>Annuler</button><button class="button button-primary" type="submit">Enregistrer</button></div>
      </form>`
    });
    modalBody.querySelector("[data-close-modal]").addEventListener("click", closeModal);
    modalBody.querySelector("#edit-consumption-form").addEventListener("submit", async event => {
      event.preventDefault();
      const button = event.submitter; submitButtonLoading(button, true);
      try {
        const values = formObject(event.currentTarget);
        const { error } = await sb.rpc("update_production_consumption", {
          p_consumption_id: consumptionId,
          p_new_quantity: Number(values.quantity)
        });
        if (error) throw error;
        showToast("Consommation corrigée.");
        closeModal();
        productionDetailModal(production);
      } catch (err) { showError(err); }
      finally { submitButtonLoading(button, false); }
    });
  }

  async function productionModal(production = null, presetStatus = null) {
    const [recipesRes, locationsList] = await Promise.all([
      sb.from("recipes").select("id,name,code,sale_unit,yield_quantity,lot_code,material_loss_pct,recipe_categories(name,sort_order)").eq("organization_id", profile.organization_id).order("name"),
      fetchLocations(false, true)
    ]);
    if (recipesRes.error) return showError(recipesRes.error);
    const recipes = recipesRes.data || [];
    if (!recipes.length) return showToast("Créez d’abord une recette.", "error");
    const isCompleted = production?.status === "completed";
    const defaultLotNumber = todayISO().replace(/-/g, "");

    openModal({
      title: production ? "Modifier la production" : "Nouvelle production",
      kicker: production ? PRODUCTION_STATUSES[production.status]?.label : "Statut : Programmé",
      html: `<form id="production-form" class="form-grid">
        <div class="span-2"><label>Recette utilisée *</label><select name="recipe_id" required>${optionsByCategory(recipes, r => r.recipe_categories, r => `<option value="${r.id}" ${production?.recipe_id === r.id ? "selected" : ""}>${escapeHtml(r.name)}${r.code ? ` — ${escapeHtml(r.code)}` : ""}</option>`, r => r.name)}</select></div>
        <div><label>Date de fabrication *</label><input id="production-date-field" name="production_date" type="date" required value="${production?.production_date || todayISO()}"></div>
        <div><label>Date limite / DDM</label><input id="production-expiry-field" name="expiry_date" type="date" value="${production?.expiry_date || (production ? "" : plusDaysISO(365))}"></div>
        <div><label>Quantité produite *</label><input name="quantity_produced" type="number" min="0.001" step="0.001" required value="${production?.quantity_produced ?? ""}"></div>
        <div><label>Écart matière (%)${helpTip("Matière première consommée en plus de la recette et perdue : reste en cuve, sur les outils… Elle sort du stock au démarrage et entre dans le coût du lot.")}</label><input name="material_loss_pct" type="number" min="0" max="99" step="0.1" value="${production?.material_loss_pct ?? 0}"></div>
        <div><label>Responsable de fabrication</label><input name="operator" value="${escapeHtml(production?.operator || profile.full_name || "")}"></div>
        <div><label>Numéro de lot</label><input id="production-lot-field" name="lot_number" value="${escapeHtml(production?.finished_lot_number || defaultLotNumber)}"></div>
        <div><label>Emplacement du lot fini${(() => {
          const allowed = allowedLocationIds();
          return (allowed && allowed.length === 1) ? "" : " *";
        })()}</label>
          ${(() => {
            // Un utilisateur restreint à un seul emplacement ne doit pas pouvoir
            // enregistrer « Aucun emplacement » : sa production deviendrait
            // invisible pour lui. On présélectionne le sien.
            const allowed = allowedLocationIds();
            const defaultLoc = production?.location_id
              || (allowed && allowed.length ? allowed[0] : null)
              || (locationsList.length === 1 ? locationsList[0].id : null);
            const forceChoice = Boolean(allowed && allowed.length);
            return `<select name="location_id" ${forceChoice ? "required" : ""}>${
              forceChoice
                ? locationsList.map(loc => `<option value="${loc.id}" ${defaultLoc === loc.id ? "selected" : ""}>${escapeHtml(loc.name)}</option>`).join("")
                : locationOptions(locationsList, defaultLoc)
            }</select>`;
          })()}
        </div>
        ${!production ? `<div><label>Étape initiale *</label><select name="status">${
          [...PRODUCTION_CUSTOM_STAGES.map(s => [s.key, s.label]), ["in_progress", "En cours — la matière sort du stock"]]
            .map(([k, l]) => `<option value="${k}" ${presetStatus === k ? "selected" : ""}>${escapeHtml(l)}</option>`).join("")
        }</select></div>` : ""}
        <div class="span-2"><label>Fiche de production (PDF, Word, image)</label><input name="attachment" type="file" accept=".pdf,.doc,.docx,image/*"></div>
        <div class="span-2"><label>Notes</label><textarea name="notes" placeholder="Écart, perte, remarque qualité…">${escapeHtml(production?.notes || "")}</textarea></div>
        ${!locationsList.length ? `<div class="span-2 help-box">Aucun emplacement n’est encore créé. Vous pouvez enregistrer sans en choisir, ou en créer un dans <strong>Paramètres → Emplacements</strong>.</div>` : ""}
        ${isCompleted ? `<div class="span-2 warning-box">Cette production est déjà <strong>Terminée</strong> : modifier la recette ou la quantité annule puis réapplique automatiquement la consommation de matières premières. Impossible si le lot fini a déjà été livré.</div>` : `<div class="span-2 help-inline">${helpTip("Les matières premières et conditionnements liés seront consommés automatiquement dès le passage au statut « En cours ».")}<span class="help-inline-label">À savoir</span></div>`}
        <div class="form-actions span-2"><button type="button" class="button button-ghost" data-close-modal>Annuler</button><button class="button button-primary" type="submit">${production ? "Enregistrer" : "Créer la production"}</button></div>
      </form>`
    });
    modalBody.querySelector("[data-close-modal]").addEventListener("click", closeModal);
    const dateField = modalBody.querySelector("#production-date-field");
    const lotField = modalBody.querySelector("#production-lot-field");
    const expiryField = modalBody.querySelector("#production-expiry-field");
    const recipeSelect = modalBody.querySelector('select[name="recipe_id"]');
    const locationSelect = modalBody.querySelector('select[name="location_id"]');
    const lossField = modalBody.querySelector('input[name="material_loss_pct"]');
    // Le numéro est calculé par la base, selon le format réglé dans
    // Paramètres production : une seule règle, jamais recopiée ici.
    let lastLotPreview = lotField.value;
    const refreshLotPreview = async () => {
      if (!lotNumberAuto) return;
      const { data, error } = await sb.rpc("preview_lot_number", {
        p_recipe_id: recipeSelect?.value || null,
        p_location_id: locationSelect?.value || null,
        p_date: dateField.value || null
      });
      // En cas d'échec, on garde la valeur affichée plutôt que de la vider
      if (!error && typeof data === "string" && data && lotNumberAuto) {
        lastLotPreview = data;
        lotField.value = data;
      }
    };
    const recipeLoss = () => Number(recipes.find(r => r.id === recipeSelect?.value)?.material_loss_pct || 0);
    let lotNumberAuto = !production;
    let expiryAuto = !production;
    let lossAuto = !production;
    if (!production) {
      if (lossField) lossField.value = recipeLoss();
    }
    lotField.addEventListener("input", () => { lotNumberAuto = lotField.value === lastLotPreview; });
    expiryField.addEventListener("input", () => {
      expiryAuto = expiryField.value === plusDaysISO(365, dateField.value);
    });
    lossField?.addEventListener("input", () => { lossAuto = Number(lossField.value) === recipeLoss(); });
    const refreshAuto = () => {
      refreshLotPreview();
      if (lossAuto && lossField) lossField.value = recipeLoss();
    };
    if (!production) refreshLotPreview();
    dateField.addEventListener("change", () => {
      refreshAuto();
      if (expiryAuto) expiryField.value = plusDaysISO(365, dateField.value);
    });
    recipeSelect?.addEventListener("change", refreshAuto);
    locationSelect?.addEventListener("change", refreshAuto);
    modalBody.querySelector("#production-form").addEventListener("submit", async event => {
      event.preventDefault();
      const button = event.submitter; submitButtonLoading(button, true);
      try {
        const values = formObject(event.currentTarget);
        const file = event.currentTarget.elements.attachment.files[0];
        const attachmentPath = file ? await uploadPrivateFile("production-files", file) : null;
        if (production) {
          const { error: rpcError } = await sb.rpc("update_production", {
            p_production_id: production.id,
            p_recipe_id: values.recipe_id,
            p_quantity_produced: Number(values.quantity_produced),
            p_operator: values.operator.trim() || null,
            p_production_date: values.production_date,
            p_expiry_date: values.expiry_date || null,
            p_lot_number: values.lot_number.trim() || null,
            p_location_id: values.location_id || null,
            p_attachment_path: attachmentPath,
            p_notes: values.notes.trim() || null,
            p_material_loss_pct: Number(values.material_loss_pct || 0)
          });
          if (rpcError) throw rpcError;
          showToast("Production mise à jour.");
        } else {
          const { error: rpcError } = await sb.rpc("create_production", {
            p_recipe_id: values.recipe_id,
            p_quantity_produced: Number(values.quantity_produced),
            p_operator: values.operator.trim() || null,
            p_production_date: values.production_date,
            p_expiry_date: values.expiry_date || null,
            p_lot_number: values.lot_number.trim() || null,
            p_location_id: values.location_id || null,
            p_attachment_path: attachmentPath,
            p_notes: values.notes.trim() || null,
            p_status: values.status || PRODUCTION_CUSTOM_STAGES[0]?.key || "in_progress",
            p_material_loss_pct: Number(values.material_loss_pct || 0)
          });
          if (rpcError) throw rpcError;
          showToast("Production créée.");
        }
        closeModal(); renderProductions();
      } catch (err) { showError(err); }
      finally { submitButtonLoading(button, false); }
    });
  }


  // Quantité lisible sur une balance : grammes / millilitres sous l'unité
  function formatWeighing(qty, unit) {
    const u = String(unit || "").toLowerCase();
    if (u === "kg" && qty < 1) return `${formatNumber(qty * 1000, 0)} g`;
    if ((u === "l" || u === "litre" || u === "litres") && qty < 1) return `${formatNumber(qty * 1000, 0)} mL`;
    const decimals = qty >= 100 ? 1 : qty >= 10 ? 2 : 3;
    return `${formatNumber(qty, decimals)} ${escapeHtml(unit || "")}`;
  }

  // Feuille de production : ce qu'il faut peser pour lancer ce lot.
  // Même calcul que le calculateur de besoin (recipeIngredientNeeds).
  async function productionSheetModal(production) {
    if (!production) return;
    const [{ data: recipe, error: rErr }, { data: items, error: iErr }] = await Promise.all([
      sb.from("recipes").select("id, name, yield_quantity, sale_unit").eq("id", production.recipe_id).single(),
      sb.from("recipe_items").select("quantity, unit, weigh_order, ingredients(id, name, unit)").eq("recipe_id", production.recipe_id)
    ]);
    if (rErr) return showError(rErr);
    if (iErr) return showError(iErr);

    const qty = Number(production.quantity_produced || 0);
    // Dans l'ordre de pesée défini sur la recette, puis alphabétique
    const needs = sortByWeighOrder(recipeIngredientNeeds(recipe, items, qty), n => n.weighOrder, n => n.ingredient.name);
    const hasOrder = needs.some(n => n.weighOrder != null);
    // Écart matière de CETTE production (repris de la recette, modifiable)
    const lossPct = Number(production.material_loss_pct || 0);
    const hasLoss = lossPct > 0;
    const location = production.locations?.name || "";

    const rowsHtml = needs.map((n, idx) => `<tr>
        <td class="sheet-check"><span></span></td>
        ${hasOrder ? `<td class="sheet-step">${idx + 1}</td>` : ""}
        <td class="sheet-name"><strong>${escapeHtml(n.ingredient.name)}</strong></td>
        ${hasLoss ? `<td class="sheet-qty sheet-recipe">${formatWeighing(n.needed, n.unit)}</td>` : ""}
        <td class="sheet-qty">${formatWeighing(n.needed * (1 + lossPct / 100), n.unit)}</td>
      </tr>`).join("");

    const body = `
      <div class="sheet-head">
        <div><small>Produit</small><strong>${escapeHtml(recipe?.name || "—")}</strong></div>
        <div><small>Quantité à produire</small><strong>${formatNumber(qty)} ${escapeHtml(recipe?.sale_unit || "")}</strong></div>
        <div><small>Lot</small><strong>${escapeHtml(production.finished_lot_number || "—")}</strong></div>
        ${location ? `<div><small>Atelier</small><strong>${escapeHtml(location)}</strong></div>` : ""}
      </div>
      ${needs.length
        ? `<table class="sheet-table"><thead><tr><th class="sheet-check">✓</th>${hasOrder ? `<th class="sheet-step">N°</th>` : ""}<th class="sheet-name">Matière première</th>${hasLoss ? `<th class="sheet-qty sheet-recipe">Recette</th><th class="sheet-qty">À peser (+${formatNumber(lossPct, 1)} %)</th>` : `<th class="sheet-qty">Quantité</th>`}</tr></thead><tbody>${rowsHtml}</tbody></table>`
        : emptyState("Recette sans ingrédient", "Complète la recette pour obtenir la feuille de production.")}`;

    openModal({
      title: "Feuille de production",
      kicker: production.finished_lot_number,
      html: `<div id="production-sheet">${body}</div>
        <div class="form-actions" style="margin-top:18px">
          <button type="button" class="button button-ghost" data-close-modal>Fermer</button>
          ${needs.length ? `<button type="button" class="button button-primary" id="print-sheet">Imprimer</button>` : ""}
        </div>`
    });
    modalBody.querySelector("[data-close-modal]").addEventListener("click", closeModal);
    modalBody.querySelector("#print-sheet")?.addEventListener("click", () => {
      // Impression dans une fenêtre dédiée : une page propre, sans le reste de l'app
      const w = window.open("", "_blank", "width=820,height=1000");
      if (!w) return showToast("Autorise les fenêtres pop-up pour imprimer.", "error");
      w.document.write(`<!doctype html><html lang="fr"><head><meta charset="utf-8"><title>Feuille de production ${escapeHtml(production.finished_lot_number || "")}</title>
        <style>
          body { font-family: -apple-system, "Segoe UI", Roboto, sans-serif; color: #111; margin: 28px; }
          h1 { font-size: 20px; margin: 0 0 18px; }
          .sheet-head { display: grid; grid-template-columns: repeat(2, 1fr); gap: 12px 24px; margin-bottom: 22px; }
          .sheet-head small { display: block; font-size: 11px; text-transform: uppercase; letter-spacing: .04em; color: #666; }
          .sheet-head strong { font-size: 16px; }
          table { width: 100%; border-collapse: collapse; font-size: 15px; }
          th { text-align: left; font-size: 11px; text-transform: uppercase; color: #666; border-bottom: 2px solid #111; padding: 8px 6px; }
          td { border-bottom: 1px solid #ccc; padding: 12px 6px; }
          .sheet-qty { text-align: right; white-space: nowrap; font-variant-numeric: tabular-nums; }
          table { table-layout: fixed; }
          .sheet-check { width: 34px; }
          .sheet-step { width: 38px; font-weight: 700; color: #666; }
          .sheet-qty { width: 110px; }
          .sheet-name { word-break: break-word; }
          .sheet-recipe { color: #777; font-weight: 400; }
          .sheet-check span { display: inline-block; width: 16px; height: 16px; border: 1.5px solid #111; border-radius: 3px; }
          .sheet-foot { margin-top: 34px; font-size: 13px; color: #444; display: flex; gap: 40px; }
        </style></head><body>
        <h1>Feuille de production</h1>${body}
        <div class="sheet-foot"><span>Pesé par : ____________________</span><span>Date : ____ / ____ / ________</span></div>
        </body></html>`);
      w.document.close();
      w.focus();
      w.print();
    });
  }

  async function completeProductionModal(production) {
    if (!production) return;
    const { checkpoints, enabled } = await loadProductionCheckpoints();

    // Le texte dépend du chemin parcouru : avec les étapes paramétrables, on
    // peut clôturer sans être passé par « En cours ».
    // La clôture n'est possible que depuis « En cours » : la matière est
    // donc toujours déjà sortie du stock à ce stade.
    if (production.status !== "in_progress") {
      return showToast("Une production doit être « En cours » pour être terminée.", "error");
    }
    const note = "La matière première a été sortie du stock au démarrage. Cette étape crée le lot de produit fini.";

    const finish = async values => {
      const { error } = await sb.rpc("complete_production_with_checkpoints", {
        p_production_id: production.id, p_values: values
      });
      if (error) throw error;
      showToast("Production terminée, stocks mis à jour.");
      renderProductions();
    };

    // Points de contrôle désactivés : une simple confirmation suffit
    if (!enabled || !checkpoints.length) {
      if (!confirm(`Terminer la production ${production.finished_lot_number || ""} ?\n\n${note}`)) return;
      try { await finish([]); } catch (err) { showError(err); }
      return;
    }

    const field = cp => {
      const req = cp.required ? "required" : "";
      const star = cp.required ? " *" : "";
      const unit = cp.unit ? ` (${escapeHtml(cp.unit)})` : "";
      const label = `<label>${escapeHtml(cp.label)}${unit}${star}</label>`;
      if (cp.field_type === "datetime") return `<div>${label}<input type="datetime-local" data-cp="${cp.id}" data-type="datetime" ${req}></div>`;
      if (cp.field_type === "number") return `<div>${label}<input type="number" step="any" data-cp="${cp.id}" data-type="number" ${req}></div>`;
      if (cp.field_type === "boolean") return `<div>${label}<select data-cp="${cp.id}" data-type="boolean" ${req}><option value="">—</option><option value="true">Oui</option><option value="false">Non</option></select></div>`;
      return `<div class="span-2">${label}<input type="text" data-cp="${cp.id}" data-type="text" ${req}></div>`;
    };

    const hasRequired = checkpoints.some(cp => cp.required);
    openModal({
      title: "Terminer la production",
      kicker: production.finished_lot_number,
      html: `<form id="complete-production-form" class="form-grid">
        <div class="span-2 help-box">${hasRequired ? "Les champs marqués * sont obligatoires, les autres peuvent rester vides." : "Ces relevés sont facultatifs : laisse vide ce que tu ne mesures pas."}</div>
        ${groupBySection(checkpoints).map(([section, items]) => `
          ${section ? `<div class="span-2 form-section-title">${escapeHtml(section)}</div>` : ""}
          ${items.map(field).join("")}`).join("")}
        <div class="span-2 warning-box">${note}</div>
        <div class="form-actions span-2"><button type="button" class="button button-ghost" data-close-modal>Annuler</button><button class="button button-primary" type="submit">Valider comme Terminé</button></div>
      </form>`
    });
    modalBody.querySelector("[data-close-modal]").addEventListener("click", closeModal);
    modalBody.querySelector("#complete-production-form").addEventListener("submit", async event => {
      event.preventDefault();
      const button = event.submitter; submitButtonLoading(button, true);
      try {
        const values = [...modalBody.querySelectorAll("[data-cp]")].map(el => {
          let value = el.value.trim();
          if (value && el.dataset.type === "datetime") value = new Date(value).toISOString();
          return { checkpoint_id: el.dataset.cp, value };
        }).filter(v => v.value !== "");
        await finish(values);
        closeModal();
      } catch (err) { showError(err); }
      finally { submitButtonLoading(button, false); }
    });
  }

  // Calculateur de besoin

  // Besoin en matières premières pour produire `quantity` unités d'une
  // recette. Utilisé par le calculateur de besoin ET par la feuille de
  // production : un seul calcul, pour que les deux ne divergent jamais.
  function sortByWeighOrder(list, getOrder, getName) {
    return [...list].sort((a, b) => {
      const oa = getOrder(a), ob = getOrder(b);
      if (oa != null && ob != null && oa !== ob) return oa - ob;
      if (oa != null && ob == null) return -1;
      if (oa == null && ob != null) return 1;
      return String(getName(a) || "").localeCompare(String(getName(b) || ""), "fr");
    });
  }

  function recipeIngredientNeeds(recipe, items, quantity) {
    const yieldQty = Number(recipe?.yield_quantity || 1) || 1;
    const scale = quantity / yieldQty;
    return (items || []).filter(i => i.ingredients).map(item => {
      const ingredient = item.ingredients;
      const neededRaw = Number(item.quantity || 0) * scale;
      const converted = convertQty(neededRaw, item.unit, ingredient.unit);
      return { ingredient, needed: converted === null ? neededRaw : converted, unit: ingredient.unit, weighOrder: item.weigh_order ?? null };
    });
  }

  async function renderCalculator() {
    setHeader("calculator");
    const [{ data: recipes }, allLocations] = await Promise.all([
      sb.from("recipes").select("id,name,code,sale_unit,yield_quantity,lot_code,material_loss_pct,recipe_categories(name,sort_order)").eq("organization_id", profile.organization_id).order("name"),
      fetchLocations(false, true)
    ]);
    if (!recipes?.length) {
      content.innerHTML = emptyState("Aucune recette", "Créez une recette avant d’utiliser le calculateur.");
      return;
    }
    const calcState = { lines: [] };
    content.innerHTML = `
      <div class="help-inline">${helpTip("Ajoute un ou plusieurs produits à fabriquer et choisis l’emplacement de production : le calculateur additionne les besoins en matières premières et conditionnements, les compare au stock disponible à cet endroit, et indique ce qu’il faut commander.")}<span class="help-inline-label">À savoir</span></div>
      <div class="form-grid" style="margin-top:16px">
        <div><label>Emplacement de production *</label><select id="calc-location"><option value="">Sélectionner…</option>${allLocations.map(l => `<option value="${l.id}">${escapeHtml(l.name)}</option>`).join("")}</select></div>
      </div>
      <div class="form-section-title" style="margin-top:20px">☰ Produits à fabriquer</div>
      <div class="form-grid">
        <div class="span-2"><label>Produit</label><select id="calc-recipe">${optionsByCategory(recipes, r => r.recipe_categories, r => `<option value="${r.id}">${escapeHtml(r.name)}${r.code ? ` — ${escapeHtml(r.code)}` : ""}</option>`, r => r.name)}</select></div>
        <div><label>Quantité</label><input id="calc-quantity" type="number" min="0.001" step="0.001" value="1"></div>
        <div style="align-self:end"><button type="button" id="calc-add-line" class="button button-primary button-full">＋ Ajouter</button></div>
      </div>
      <div class="table-wrap" style="margin-top:12px"><table><thead><tr><th>Produit</th><th>Quantité</th><th></th></tr></thead><tbody id="calc-lines-body"></tbody></table></div>
      <div class="form-actions" style="margin-top:18px"><button type="button" id="calc-run" class="button button-primary">Calculer les besoins</button></div>
      <div id="calc-results" style="margin-top:26px"></div>
    `;

    function renderCalcLines() {
      document.querySelector("#calc-lines-body").innerHTML = calcState.lines.map((l, idx) => `<tr>
        <td>${escapeHtml(l.recipeName)}</td>
        <td>${formatNumber(l.quantity)} ${escapeHtml(l.saleUnit)}</td>
        <td><button type="button" class="icon-button icon-small danger calc-remove-line" data-idx="${idx}">🗑</button></td>
      </tr>`).join("") || `<tr><td colspan="3" class="muted" style="text-align:center;padding:16px">Aucun produit ajouté</td></tr>`;
      document.querySelectorAll(".calc-remove-line").forEach(btn => btn.addEventListener("click", () => {
        calcState.lines.splice(Number(btn.dataset.idx), 1);
        renderCalcLines();
      }));
    }
    renderCalcLines();

    document.querySelector("#calc-add-line").addEventListener("click", () => {
      const recipeId = document.querySelector("#calc-recipe").value;
      const quantity = Number(document.querySelector("#calc-quantity").value || 0);
      const recipe = recipes.find(r => r.id === recipeId);
      if (!recipe || quantity <= 0) return showToast("Choisissez un produit et une quantité.", "error");
      calcState.lines.push({ recipeId, recipeName: recipe.name, saleUnit: recipe.sale_unit || "unités", quantity });
      renderCalcLines();
    });

    document.querySelector("#calc-run").addEventListener("click", () => runCalculator(recipes, allLocations, calcState.lines));
  }

  async function runCalculator(recipes, allLocations, lines) {
    const locationId = document.querySelector("#calc-location").value;
    const results = document.querySelector("#calc-results");
    if (!lines.length) return showToast("Ajoutez au moins un produit à fabriquer.", "error");
    if (!locationId) return showToast("Choisissez un emplacement de production.", "error");
    const locationName = allLocations.find(l => l.id === locationId)?.name || "—";

    results.innerHTML = `<div class="loading"><div class="spinner"></div>Calcul en cours…</div>`;

    const recipeIds = [...new Set(lines.map(l => l.recipeId))];
    const [{ data: allItems, error: itemsError }, { data: allPackLinks, error: packError }] = await Promise.all([
      sb.from("recipe_items").select("recipe_id, quantity, unit, weigh_order, ingredients(id, name, unit)").in("recipe_id", recipeIds),
      sb.from("recipe_packagings").select("recipe_id, packagings(id, name, units_per_pack, packaging_components(quantity, supplies(id, name, unit)))").in("recipe_id", recipeIds)
    ]);
    if (itemsError) return showError(itemsError);
    if (packError) return showError(packError);

    // Agrégation des besoins en ingrédients, tous produits confondus
    const ingredientNeeds = new Map();
    lines.forEach(line => {
      const recipe = recipes.find(r => r.id === line.recipeId);
      // Chaque produit apporte ses ingrédients dans son ordre de pesée : le
      // tableau additionné suit ainsi l'ordre du premier produit, puis les
      // ingrédients propres aux suivants. Avec un seul produit, c'est
      // exactement l'ordre de sa fiche recette.
      const items = sortByWeighOrder((allItems || []).filter(i => i.recipe_id === line.recipeId), it => it.weigh_order, it => it.ingredients?.name);
      const lossPct = Number(recipe?.material_loss_pct || 0);
      recipeIngredientNeeds(recipe, items, line.quantity).forEach(({ ingredient, needed }) => {
        const entry = ingredientNeeds.get(ingredient.id) || { name: ingredient.name, unit: ingredient.unit, needed: 0, neededWithLoss: 0 };
        entry.needed += needed;
        // Besoin majoré de l'écart matière du produit : ce qui sortira réellement du stock
        entry.neededWithLoss += needed * (1 + lossPct / 100);
        ingredientNeeds.set(ingredient.id, entry);
      });
    });

    const stockByIngredient = new Map();
    const stockByIngredientAtLocation = new Map();
    if (ingredientNeeds.size) {
      const { data: lots } = await sb.from("ingredient_lots").select("ingredient_id, location_id, quantity_remaining").in("ingredient_id", [...ingredientNeeds.keys()]);
      (lots || []).forEach(lot => {
        stockByIngredient.set(lot.ingredient_id, (stockByIngredient.get(lot.ingredient_id) || 0) + Number(lot.quantity_remaining || 0));
        if (lot.location_id === locationId) {
          stockByIngredientAtLocation.set(lot.ingredient_id, (stockByIngredientAtLocation.get(lot.ingredient_id) || 0) + Number(lot.quantity_remaining || 0));
        }
      });
    }

    let anyIngredientMissing = false;
    const hasLoss = [...ingredientNeeds.values()].some(e => e.neededWithLoss - e.needed > 0.0005);
    const ingredientRows = [...ingredientNeeds.entries()].map(([id, entry]) => {
      const atLocation = stockByIngredientAtLocation.get(id) || 0;
      const global = stockByIngredient.get(id) || 0;
      // La commande couvre le besoin majoré : c'est lui qui sortira du stock
      const missing = Math.max(0, entry.neededWithLoss - atLocation);
      const remaining = atLocation - entry.neededWithLoss + missing;
      if (missing > 0.0005) anyIngredientMissing = true;
      return `<tr>
        <td>${escapeHtml(entry.name)}</td>
        <td data-col="need">${formatNumber(entry.needed)} ${escapeHtml(entry.unit)}</td>
        ${hasLoss ? `<td data-col="needLoss"><strong>${formatNumber(entry.neededWithLoss)} ${escapeHtml(entry.unit)}</strong></td>` : ""}
        <td data-col="stock">${formatNumber(atLocation)} ${escapeHtml(entry.unit)}</td>
        <td data-col="remaining">${formatNumber(remaining)} ${escapeHtml(entry.unit)}</td>
        <td data-col="order">${missing > 0.0005 ? badge(`${formatNumber(missing)} ${entry.unit} à commander`, "danger") : badge("Suffisant", "success")}</td>
      </tr>`;
    }).join("");

    // Agrégation des besoins en conditionnements, tous produits confondus
    const supplyNeeds = new Map();
    lines.forEach(line => {
      const packLinks = (allPackLinks || []).filter(l => l.recipe_id === line.recipeId).map(l => l.packagings).filter(Boolean);
      packLinks.forEach(pack => {
        const packsNeeded = Math.ceil(line.quantity / Number(pack.units_per_pack || 1));
        (pack.packaging_components || []).forEach(comp => {
          const supply = comp.supplies;
          if (!supply) return;
          const entry = supplyNeeds.get(supply.id) || { name: supply.name, unit: supply.unit, needed: 0 };
          entry.needed += Number(comp.quantity || 0) * packsNeeded;
          supplyNeeds.set(supply.id, entry);
        });
      });
    });

    let anySupplyMissing = false;
    let supplyRows = "";
    if (supplyNeeds.size) {
      const { data: supplyLots } = await sb.from("supply_lots").select("supply_id, location_id, quantity_remaining").in("supply_id", [...supplyNeeds.keys()]);
      const stockAtLocation = new Map();
      const stockGlobal = new Map();
      (supplyLots || []).forEach(lot => {
        stockGlobal.set(lot.supply_id, (stockGlobal.get(lot.supply_id) || 0) + Number(lot.quantity_remaining || 0));
        if (lot.location_id === locationId) stockAtLocation.set(lot.supply_id, (stockAtLocation.get(lot.supply_id) || 0) + Number(lot.quantity_remaining || 0));
      });
      supplyRows = [...supplyNeeds.entries()].map(([id, entry]) => {
        const atLocation = stockAtLocation.get(id) || 0;
        const global = stockGlobal.get(id) || 0;
        const missing = Math.max(0, entry.needed - atLocation);
        const remaining = atLocation - entry.needed + missing;
        if (missing > 0.0005) anySupplyMissing = true;
        return `<tr>
          <td>${escapeHtml(entry.name)}</td>
          <td data-col="supplyNeed">${formatNumber(entry.needed)} ${escapeHtml(entry.unit)}</td>
          <td data-col="stock">${formatNumber(atLocation)} ${escapeHtml(entry.unit)}</td>
          <td data-col="remaining">${formatNumber(remaining)} ${escapeHtml(entry.unit)}</td>
          <td data-col="order">${missing > 0.0005 ? badge(`${formatNumber(missing)} ${entry.unit} à commander`, "danger") : badge("Suffisant", "success")}</td>
        </tr>`;
      }).join("");
    }

    // Colonnes affichables. Le choix est mémorisé sur ce poste : l'atelier
    // garde sa vue « quoi peser », le bureau sa vue « quoi commander ».
    const CALC_COLUMNS = [
      { key: "need", label: hasLoss ? "Besoin recette" : "Besoin" },
      ...(hasLoss ? [{ key: "needLoss", label: "Besoin majoré" }] : []),
      { key: "stock", label: `Stock à ${locationName}` },
      { key: "remaining", label: "Stock restant" },
      { key: "order", label: "À commander" }
    ];
    let hiddenCols = [];
    try { hiddenCols = JSON.parse(localStorage.getItem("fiflow_calc_hidden_cols") || "[]"); } catch (e) { hiddenCols = []; }
    const productsLine = lines.map(l => `${formatNumber(l.quantity)} ${escapeHtml(l.saleUnit)} de ${escapeHtml(l.recipeName)}`).join(" · ");

    results.innerHTML = `
      <div class="calc-toolbar">
        <div class="calc-columns">
          <span class="calc-columns-label">Colonnes :</span>
          ${CALC_COLUMNS.map(col => `<label class="checkbox-pill"><input type="checkbox" data-col-toggle="${col.key}" ${hiddenCols.includes(col.key) ? "" : "checked"}> ${escapeHtml(col.label)}</label>`).join("")}
        </div>
        <button type="button" class="button button-secondary" id="calc-print">Imprimer</button>
      </div>
      <div id="calc-printable">
        <div class="detail-block">
          <div class="detail-block-title">${productsLine} — à ${escapeHtml(locationName)}</div>
        </div>
        <div class="detail-block">
          <div class="detail-block-title">Matières premières</div>
          <div class="calc-availability">${anyIngredientMissing ? `<div class="warning-box" style="margin-bottom:12px">Il manque au moins un ingrédient sur cet emplacement pour lancer ces productions.</div>` : `<div class="help-box" style="margin-bottom:12px">Tout est disponible sur cet emplacement.</div>`}</div>
          <div class="table-wrap"><table><thead><tr><th>Ingrédient</th><th data-col="need">${hasLoss ? "Besoin recette" : "Besoin total"}</th>${hasLoss ? `<th data-col="needLoss">Besoin majoré${helpTip("Besoin de la recette augmenté de l'écart matière de chaque produit. C'est ce qui sortira réellement du stock : les quantités à commander se basent dessus.")}</th>` : ""}<th data-col="stock">Stock à ${escapeHtml(locationName)}</th><th data-col="remaining">Stock restant après production + achat</th><th data-col="order">À commander</th></tr></thead><tbody>${ingredientRows || `<tr><td colspan="${hasLoss ? 6 : 5}" class="muted" style="text-align:center;padding:16px">Composition vide</td></tr>`}</tbody></table></div>
        </div>
        ${supplyNeeds.size ? `<div class="detail-block">
          <div class="detail-block-title">Conditionnements</div>
          <div class="calc-availability">${anySupplyMissing ? `<div class="warning-box" style="margin-bottom:12px">Il manque au moins une fourniture sur cet emplacement.</div>` : `<div class="help-box" style="margin-bottom:12px">Tout est disponible sur cet emplacement.</div>`}</div>
          <div class="table-wrap"><table><thead><tr><th>Fourniture</th><th data-col="supplyNeed">Besoin total</th><th data-col="stock">Stock à ${escapeHtml(locationName)}</th><th data-col="remaining">Stock restant après production + achat</th><th data-col="order">À commander</th></tr></thead><tbody>${supplyRows}</tbody></table></div>
        </div>` : ""}
      </div>
    `;

    // Masquer une colonne = une classe sur le conteneur : rien n'est recalculé,
    // et ce qui s'imprime est exactement ce qui est affiché.
    const applyColumns = () => {
      CALC_COLUMNS.forEach(col => results.classList.toggle(`hide-col-${col.key}`, hiddenCols.includes(col.key)));
      // Les fournitures n'ont pas d'écart matière : leur quantité reste visible
      // tant que l'une des deux colonnes de besoin est affichée
      results.classList.toggle("hide-col-supplyNeed", hiddenCols.includes("need") && (!hasLoss || hiddenCols.includes("needLoss")));
      // Les messages de disponibilité n'ont de sens qu'avec le stock ou la commande
      results.classList.toggle("hide-availability", hiddenCols.includes("stock") && hiddenCols.includes("order"));
    };
    applyColumns();
    results.querySelectorAll("[data-col-toggle]").forEach(cb => cb.addEventListener("change", () => {
      const key = cb.dataset.colToggle;
      hiddenCols = cb.checked ? hiddenCols.filter(k => k !== key) : [...new Set([...hiddenCols, key])];
      try { localStorage.setItem("fiflow_calc_hidden_cols", JSON.stringify(hiddenCols)); } catch (e) { /* stockage indisponible : le choix vaut pour la session */ }
      applyColumns();
    }));

    results.querySelector("#calc-print").addEventListener("click", () => {
      // Copie de ce qui est affiché, colonnes masquées et bulles d'aide retirées
      const copy = results.querySelector("#calc-printable").cloneNode(true);
      hiddenCols.forEach(key => copy.querySelectorAll(`[data-col="${key}"]`).forEach(el => el.remove()));
      if (results.classList.contains("hide-col-supplyNeed")) copy.querySelectorAll('[data-col="supplyNeed"]').forEach(el => el.remove());
      if (results.classList.contains("hide-availability")) copy.querySelectorAll(".calc-availability").forEach(el => el.remove());
      copy.querySelectorAll(".help-tip").forEach(el => el.remove());
      const w = window.open("", "_blank", "width=900,height=1000");
      if (!w) return showToast("Autorise les fenêtres pop-up pour imprimer.", "error");
      w.document.write(`<!doctype html><html lang="fr"><head><meta charset="utf-8"><title>Besoin de production</title>
        <style>
          body { font-family: -apple-system, "Segoe UI", Roboto, sans-serif; color: #111; margin: 28px; font-size: 14px; }
          h1 { font-size: 20px; margin: 0 0 4px; }
          .print-date { color: #666; font-size: 12px; margin-bottom: 18px; }
          .detail-block { margin-bottom: 22px; }
          .detail-block-title { font-weight: 700; font-size: 15px; margin-bottom: 8px; }
          table { width: 100%; border-collapse: collapse; }
          th { text-align: left; font-size: 11px; text-transform: uppercase; color: #666; border-bottom: 2px solid #111; padding: 7px 6px; }
          td { border-bottom: 1px solid #ccc; padding: 10px 6px; font-variant-numeric: tabular-nums; }
          .warning-box, .help-box { padding: 8px 10px; border: 1px solid #ccc; border-radius: 6px; margin-bottom: 10px; font-size: 13px; }
          .badge { font-weight: 700; }
        </style></head><body>
        <h1>Besoin de production</h1>
        <div class="print-date">Imprimé le ${new Date().toLocaleDateString("fr-FR", { weekday: "long", day: "numeric", month: "long", year: "numeric" })}</div>
        ${copy.innerHTML}
        </body></html>`);
      w.document.close(); w.focus(); w.print();
    });
  }

  // Produits finis
  let finishedGoodsViewMode = "list";
  let finishedGoodsLocationKey = null;

  function finishedGoodsUnitCost(recipe) {
    if (!recipe) return 0;
    const yieldQty = Number(recipe.yield_quantity || 1) || 1;
    const mpCost = (recipe.recipe_items || []).reduce((sum, item) => {
      const converted = convertQty(item.quantity, item.unit, item.ingredients?.unit);
      const qty = converted === null ? Number(item.quantity || 0) : converted;
      return sum + qty * Number(item.ingredients?.purchase_price || 0);
    }, 0) / yieldQty;
    return mpCost + Number(recipe.production_cost || 0);
  }

  function finishedLotUnitCost(lot) {
    // Coût de revient complet : matière, production, conditionnement, transport
    // et entreposage. Les deux derniers comptent surtout pour les lots partis
    // en entrepôt externe, où ils sont loin d'être négligeables.
    if (lot.unit_cost_mp != null || lot.unit_cost_production != null || lot.unit_cost_packaging != null
        || lot.unit_cost_transport != null || lot.unit_cost_storage != null) {
      return Number(lot.unit_cost_mp || 0) + Number(lot.unit_cost_production || 0) + Number(lot.unit_cost_packaging || 0)
        + Number(lot.unit_cost_transport || 0) + Number(lot.unit_cost_storage || 0);
    }
    return finishedGoodsUnitCost(lot.recipes);
  }

  async function fetchFinishedLots() {
    const { data, error } = await sb.from("finished_lots")
      .select("*, recipes(id, name, code, sale_unit, yield_quantity, production_cost, recipe_items(quantity, unit, ingredients(unit, purchase_price))), locations(id, name)")
      .eq("organization_id", profile.organization_id)
      .gt("quantity_remaining", 0);
    if (error) throw error;
    return data || [];
  }

  async function fetchFinishedThresholds() {
    const { data, error } = await sb.from("finished_stock_thresholds").select("recipe_id, location_id, threshold").eq("organization_id", profile.organization_id);
    if (error) { showError(error); return new Map(); }
    const map = new Map();
    (data || []).forEach(t => map.set(`${t.recipe_id}:${t.location_id}`, Number(t.threshold)));
    return map;
  }

  function groupFinishedLotsByLocation(allLots, allLocations) {
    const byLocation = new Map();
    allLocations.forEach(loc => byLocation.set(loc.id, { location: loc, lots: [] }));
    allLots.forEach(lot => {
      if (!lot.location_id) return;
      if (!canSeeLocation(lot.location_id)) return;
      const key = lot.location_id;
      if (!byLocation.has(key)) byLocation.set(key, { location: { id: lot.location_id, name: "—" }, lots: [] });
      byLocation.get(key).lots.push(lot);
    });
    const noneLots = allLots.filter(lot => !lot.location_id);
    if (noneLots.length && !allowedLocationIds()) byLocation.set("none", { location: { id: null, name: "Sans emplacement" }, lots: noneLots });
    return byLocation;
  }

  function computeFinishedGoodsSummary(lots, allRecipes, thresholds, locationScopeId) {
    let totalValue = 0, alertCount = 0, criticalCount = 0;
    const distinctProducts = new Set();
    lots.forEach(lot => {
      totalValue += Number(lot.quantity_remaining || 0) * finishedLotUnitCost(lot);
      if (lot.expiry_date && lot.expiry_date <= plusDaysISO(60)) alertCount += 1;
      if (lot.recipe_id) distinctProducts.add(lot.recipe_id);
    });
    if (locationScopeId) {
      const byRecipeQty = new Map();
      lots.forEach(lot => byRecipeQty.set(lot.recipe_id, (byRecipeQty.get(lot.recipe_id) || 0) + Number(lot.quantity_remaining || 0)));
      allRecipes.forEach(recipe => {
        const threshold = thresholds.get(`${recipe.id}:${locationScopeId}`);
        if (threshold == null) return;
        if ((byRecipeQty.get(recipe.id) || 0) <= threshold) criticalCount += 1;
      });
    }
    return { totalValue, alertCount, criticalCount, productCount: distinctProducts.size };
  }

  function renderFinishedSummaryCards(summary) {
    return `<div class="grid grid-4 stock-summary">
      <article class="card metric-card metric-card-flip"><div class="metric">${summary.productCount}</div><small>Produits en stock</small></article>
      <article class="card metric-card metric-card-flip"><div class="metric metric-critical">${summary.criticalCount}</div><small>Stock critique</small></article>
      <article class="card metric-card metric-card-flip"><div class="metric metric-warning">${summary.alertCount}</div><small>Alerte DDM</small></article>
      <article class="card metric-card metric-card-flip"><div class="metric">${formatMoneyRoundUp(summary.totalValue)}</div><small>Valeur</small></article>
    </div>`;
  }

  // Logistique externe — grille tarifaire du prestataire
  // Fournisseurs — jours de livraison et deadline de commande, par emplacement desservi
  async function renderSuppliersSettings() {
    const canEdit = pageCan("suppliers-settings");
    const [{ data: suppliers, error }, allLocations] = await Promise.all([
      sb.from("suppliers").select("*, supplier_locations(id, location_id, delivery_days, order_deadline_days_before, order_deadline_time, locations(name))").eq("organization_id", profile.organization_id).order("name"),
      fetchLocations(true)
    ]);
    if (error) throw error;

    const rows = (suppliers || []).map(s => `<div class="lot-row">
      <div class="lot-row-main">
        <div class="lot-row-title">${escapeHtml(s.name)}</div>
        <div class="muted" style="font-size:12.5px">
          ${(s.supplier_locations || []).length
            ? s.supplier_locations.map(sl => `${escapeHtml(sl.locations?.name || "—")} : ${(sl.delivery_days || []).map(d => WEEKDAY_LABELS[d].slice(0, 3)).join("/")} · commande avant ${sl.order_deadline_time?.slice(0, 5)} J-${sl.order_deadline_days_before}`).join(" &nbsp;|&nbsp; ")
            : "Aucun emplacement desservi configuré"}
        </div>
        <div class="supplier-contacts">
          ${[["Commercial", s.sales_contact_name, s.sales_contact_phone, s.sales_contact_email],
             ["Assistant", s.support_contact_name, s.support_contact_phone, s.support_contact_email]]
            .filter(([, n, p, m]) => n || p || m)
            .map(([role, n, p, m]) => `<div class="supplier-contact">
              <span class="supplier-contact-role">${role}</span>
              ${n ? `<span>${escapeHtml(n)}</span>` : ""}
              ${p ? `<a href="tel:${escapeHtml(p.replace(/\s/g, ""))}">${escapeHtml(p)}</a>` : ""}
              ${m ? `<a href="mailto:${escapeHtml(m)}">${escapeHtml(m)}</a>` : ""}
            </div>`).join("")}
        </div>
      </div>
      <div class="lot-row-actions">
        <button class="icon-button icon-small edit-supplier" data-id="${s.id}" title="Modifier">${ICONS.edit}</button>
        <button class="icon-button icon-small danger delete-supplier" data-id="${s.id}" title="Supprimer">${ICONS.trash}</button>
      </div>
    </div>`).join("");

    content.innerHTML = `
      <div style="margin-top:14px">${rows || emptyState("Aucun fournisseur créé", "")}</div>
      ${canEdit ? `<button type="button" id="add-supplier" class="button button-secondary" style="margin-top:10px">${ICONS.plus} Ajouter un fournisseur</button>` : ""}
    `;
    document.querySelector("#add-supplier")?.addEventListener("click", () => supplierModal(null, allLocations));
    document.querySelectorAll(".edit-supplier").forEach(btn => btn.addEventListener("click", () => supplierModal(suppliers.find(s => s.id === btn.dataset.id), allLocations)));
    document.querySelectorAll(".delete-supplier").forEach(btn => btn.addEventListener("click", async () => {
      if (!confirm("Supprimer ce fournisseur ? Les ingrédients/fournitures qui lui sont rattachés perdront cette association.")) return;
      const { error: delError } = await sb.from("suppliers").delete().eq("id", btn.dataset.id);
      if (delError) return showError(delError);
      showToast("Fournisseur supprimé."); renderSuppliersSettings();
    }));
  }

  function supplierModal(supplier, allLocations) {
    openModal({
      title: supplier ? "Modifier le fournisseur" : "Nouveau fournisseur",
      kicker: "Fournisseurs",
      width: "760px",
      html: `
        <form id="supplier-form" class="form-grid">
          <div class="span-2"><label>Nom *</label><input name="name" required value="${escapeHtml(supplier?.name || "")}"></div>

          <div class="form-section-title span-2" style="margin-top:8px">Contact commercial${helpTip("L’interlocuteur pour la négociation, les tarifs et les conditions.")}</div>
          <div class="span-2"><label>Nom</label><input name="sales_contact_name" value="${escapeHtml(supplier?.sales_contact_name || "")}"></div>
          <div><label>Téléphone</label><input type="tel" name="sales_contact_phone" value="${escapeHtml(supplier?.sales_contact_phone || "")}"></div>
          <div><label>E-mail</label><input type="email" name="sales_contact_email" value="${escapeHtml(supplier?.sales_contact_email || "")}"></div>

          <div class="form-section-title span-2" style="margin-top:8px">Contact assistant${helpTip("L’interlocuteur pour le suivi des commandes et des livraisons.")}</div>
          <div class="span-2"><label>Nom</label><input name="support_contact_name" value="${escapeHtml(supplier?.support_contact_name || "")}"></div>
          <div><label>Téléphone</label><input type="tel" name="support_contact_phone" value="${escapeHtml(supplier?.support_contact_phone || "")}"></div>
          <div><label>E-mail</label><input type="email" name="support_contact_email" value="${escapeHtml(supplier?.support_contact_email || "")}"></div>

          <div class="span-2"><label>Notes</label><textarea name="notes" rows="2" placeholder="Conditions particulières, minimum de commande…">${escapeHtml(supplier?.notes || "")}</textarea></div>

          <div class="form-actions span-2"><button type="button" class="button button-ghost" data-close-modal>Annuler</button><button class="button button-primary" type="submit">Enregistrer</button></div>
        </form>
        ${supplier ? `
        <div class="form-section-title" style="margin-top:20px">📍 Emplacements desservis</div>
        <div id="supplier-locations-list">${renderSupplierLocationRows(supplier)}</div>
        <button type="button" id="add-supplier-location" class="button button-secondary" style="margin-top:10px">${ICONS.plus} Ajouter un emplacement</button>
        ` : `<div class="help-box" style="margin-top:16px">Enregistre d’abord le fournisseur pour pouvoir lui rattacher des emplacements.</div>`}
      `
    });
    modalBody.querySelector("[data-close-modal]").addEventListener("click", closeModal);
    modalBody.querySelector("#supplier-form").addEventListener("submit", async event => {
      event.preventDefault();
      const button = event.submitter; submitButtonLoading(button, true);
      const values = formObject(event.currentTarget);
      const clean = v => (v || "").trim() || null;
      const payload = {
        organization_id: profile.organization_id, name: values.name.trim(),
        sales_contact_name: clean(values.sales_contact_name),
        sales_contact_phone: clean(values.sales_contact_phone),
        sales_contact_email: clean(values.sales_contact_email),
        support_contact_name: clean(values.support_contact_name),
        support_contact_phone: clean(values.support_contact_phone),
        support_contact_email: clean(values.support_contact_email),
        notes: clean(values.notes)
      };
      const query = supplier ? sb.from("suppliers").update(payload).eq("id", supplier.id) : sb.from("suppliers").insert(payload);
      const { error } = await query;
      submitButtonLoading(button, false);
      if (error) return showError(error);
      closeModal(); showToast("Fournisseur enregistré."); renderSuppliersSettings();
    });
    document.querySelector("#add-supplier-location")?.addEventListener("click", () => supplierLocationModal(supplier, null, allLocations));
    modalBody.querySelectorAll(".edit-supplier-location").forEach(btn => btn.addEventListener("click", () => {
      const sl = supplier.supplier_locations.find(x => x.id === btn.dataset.id);
      supplierLocationModal(supplier, sl, allLocations);
    }));
    modalBody.querySelectorAll(".delete-supplier-location").forEach(btn => btn.addEventListener("click", async () => {
      const { error: delError } = await sb.from("supplier_locations").delete().eq("id", btn.dataset.id);
      if (delError) return showError(delError);
      showToast("Emplacement retiré."); closeModal(); renderSuppliersSettings();
    }));
  }

  function renderSupplierLocationRows(supplier) {
    const rows = supplier.supplier_locations || [];
    if (!rows.length) return `<p class="muted" style="padding:8px 0">Aucun emplacement rattaché.</p>`;
    return rows.map(sl => `<div class="lot-row">
      <div class="lot-row-main">
        <div class="lot-row-title">${escapeHtml(sl.locations?.name || "—")}</div>
        <div class="muted" style="font-size:12.5px">Livraison : ${(sl.delivery_days || []).map(d => WEEKDAY_LABELS[d]).join(", ") || "—"} · Commande avant ${sl.order_deadline_time?.slice(0, 5)}, J-${sl.order_deadline_days_before}</div>
      </div>
      <div class="lot-row-actions">
        <button type="button" class="icon-button icon-small edit-supplier-location" data-id="${sl.id}" title="Modifier">${ICONS.edit}</button>
        <button type="button" class="icon-button icon-small danger delete-supplier-location" data-id="${sl.id}" title="Retirer">${ICONS.trash}</button>
      </div>
    </div>`).join("");
  }

  function supplierLocationModal(supplier, existing, allLocations) {
    const selectedDays = new Set(existing?.delivery_days || []);
    openModal({
      title: existing ? "Modifier l’emplacement desservi" : "Ajouter un emplacement desservi",
      kicker: supplier.name,
      html: `<form id="supplier-location-form" class="form-grid">
        <div class="span-2"><label>Emplacement *</label><select name="location_id" ${existing ? "disabled" : ""}>${allLocations.map(l => `<option value="${l.id}" ${existing?.location_id === l.id ? "selected" : ""}>${escapeHtml(l.name)}</option>`).join("")}</select></div>
        <div class="span-2"><label>Jours de livraison</label>
          <div class="compat-list">${WEEKDAY_LABELS.map((label, i) => `<label class="compat-list-item"><input type="checkbox" name="delivery_days" value="${i}" ${selectedDays.has(i) ? "checked" : ""}><span>${label}</span></label>`).join("")}</div>
        </div>
        <div><label>Deadline de commande (jours avant)</label><input type="number" min="0" step="1" name="order_deadline_days_before" value="${existing?.order_deadline_days_before ?? 1}"></div>
        <div><label>Heure limite</label><input type="time" name="order_deadline_time" value="${existing?.order_deadline_time?.slice(0, 5) || "13:00"}"></div>
        <p class="form-note span-2">Ex : livraison le jeudi, deadline "1 jour avant, 13:00" = commande possible jusqu’au mercredi 13h.</p>
        <div class="form-actions span-2"><button type="button" class="button button-ghost" data-close-modal>Annuler</button><button class="button button-primary" type="submit">Enregistrer</button></div>
      </form>`
    });
    modalBody.querySelector("[data-close-modal]").addEventListener("click", closeModal);
    modalBody.querySelector("#supplier-location-form").addEventListener("submit", async event => {
      event.preventDefault();
      const button = event.submitter; submitButtonLoading(button, true);
      const values = formObject(event.currentTarget);
      const days = [...event.currentTarget.querySelectorAll('input[name="delivery_days"]:checked')].map(el => Number(el.value));
      const payload = {
        supplier_id: supplier.id, location_id: existing?.location_id || values.location_id,
        delivery_days: days, order_deadline_days_before: Number(values.order_deadline_days_before || 0),
        order_deadline_time: values.order_deadline_time
      };
      const query = existing ? sb.from("supplier_locations").update(payload).eq("id", existing.id) : sb.from("supplier_locations").insert(payload);
      const { error } = await query;
      submitButtonLoading(button, false);
      if (error) return showError(error);
      closeModal(); showToast("Enregistré."); renderSuppliersSettings();
    });
  }

  // Contraintes de production — par emplacement : jours travaillés, capacité
  // mensuelle, règles d'expédition, et quelles recettes il peut produire
  // (avec la durée d'une fournée mois par mois).
  let productionConstraintsLocationId = null;

  async function renderProductionConstraints() {
    const canEdit = pageCan("production-constraints");
    const { data: allLocations } = await sb.from("locations").select("*").eq("organization_id", profile.organization_id).eq("is_production_site", true).order("name");
    if (!allLocations?.length) {
      content.innerHTML = emptyState("Aucun point de production", "Coche « Point de production » sur un emplacement, dans Paramètres → Emplacements, pour lui définir ses contraintes ici.");
      return;
    }
    if (!productionConstraintsLocationId || !allLocations.some(l => l.id === productionConstraintsLocationId)) {
      productionConstraintsLocationId = allLocations[0].id;
    }
    const [{ data: location, error }, { data: recipes }, { data: settings }] = await Promise.all([
      sb.from("locations").select("*").eq("id", productionConstraintsLocationId).single(),
      sb.from("recipes").select("id, name, sale_unit").eq("organization_id", profile.organization_id).order("name"),
      sb.from("location_recipe_settings").select("*").eq("organization_id", profile.organization_id).eq("location_id", productionConstraintsLocationId)
    ]);
    if (error) throw error;
    const settingsByRecipe = new Map((settings || []).map(s => [s.recipe_id, s]));

    const workingDays = new Set(location.working_days || []);
    const departureDays = new Set(location.shipping_departure_days || []);
    const capacity = location.monthly_capacity || Array(12).fill(1);

    const monthHeaderRow = MONTH_LABELS.map(m => `<span>${m}</span>`).join("");
    const capacityInputsRow = capacity.map((v, i) => `<input type="number" min="0" step="1" class="prod-capacity-input" data-month="${i}" value="${v}" ${!canEdit ? "disabled" : ""}>`).join("");

    const recipeRows = (recipes || []).map((r, idx) => {
      const s = settingsByRecipe.get(r.id);
      const canProduce = s?.can_produce ?? false;
      const durations = s?.monthly_duration_days || Array(12).fill(7);
      return `<div class="lot-row" data-recipe-row>
        <div class="lot-row-main">
          <label class="checkbox-row" style="margin:0"><input type="checkbox" class="prod-can-produce" data-recipe-id="${r.id}" ${canProduce ? "checked" : ""} ${!canEdit ? "disabled" : ""}><span><strong>${escapeHtml(r.name)}</strong></span></label>
          <div class="prod-duration-grid ${canProduce ? "" : "hidden"}" data-duration-grid="${r.id}">
            <div class="prod-month-header">${monthHeaderRow}</div>
            <div class="prod-month-inputs">${durations.map((d, i) => `<input type="number" min="1" step="1" class="prod-duration-input" data-recipe-id="${r.id}" data-month="${i}" value="${d}" ${!canEdit ? "disabled" : ""}>`).join("")}</div>
            <p class="form-note">Durée d’une fournée (en jours), mois par mois.</p>
            <div style="margin-top:10px;max-width:280px">
              <label>Taille d’une fournée (${escapeHtml(r.sale_unit || "unités")})</label>
              <input type="number" min="0" step="1" class="prod-batch-qty" data-recipe-id="${r.id}" value="${s?.batch_quantity ?? ""}" placeholder="Ex : 280" ${!canEdit ? "disabled" : ""}>
              <p class="form-note">Laisse vide pour produire la quantité exacte, sans arrondi.</p>
            </div>
          </div>
        </div>
      </div>`;
    }).join("");

    content.innerHTML = `
      <div class="toolbar">
        <select id="prod-location-select">${allLocations.map(l => `<option value="${l.id}" ${l.id === productionConstraintsLocationId ? "selected" : ""}>${escapeHtml(l.name)}</option>`).join("")}</select>
        <div class="toolbar-spacer"></div>
      </div>

      <div class="form-section-title" style="margin-top:20px">📅 Jours travaillés${helpTip("Sert à compter la durée d\u2019une fournée en jours ouvrés. Coche tous les jours pour un décompte en jours calendaires.")}</div>
      <div class="compat-list" style="margin-top:10px">${WEEKDAY_LABELS.map((label, i) => `<label class="compat-list-item"><input type="checkbox" class="prod-working-day" value="${i}" ${workingDays.has(i) ? "checked" : ""} ${!canEdit ? "disabled" : ""}><span>${label}</span></label>`).join("")}</div>

      <div class="form-section-title" style="margin-top:24px">🏭 Capacité de production (lignes en parallèle, par mois)</div>
      <div class="prod-duration-grid">
        <div class="prod-month-header">${monthHeaderRow}</div>
        <div class="prod-month-inputs">${capacityInputsRow}</div>
      </div>

      <div class="form-section-title" style="margin-top:24px">🚚 Expédition vers l’entrepôt / le client</div>
      <div class="form-grid">
        <div class="span-2"><label>Jours de départ possibles</label>
          <div class="compat-list">${WEEKDAY_LABELS.map((label, i) => `<label class="compat-list-item"><input type="checkbox" class="prod-departure-day" value="${i}" ${departureDays.has(i) ? "checked" : ""} ${!canEdit ? "disabled" : ""}><span>${label}</span></label>`).join("")}</div>
        </div>
        <div><label>Durée de trajet (jours)</label><input type="number" id="prod-transit-days" min="0" step="1" value="${location.shipping_transit_days ?? 1}" ${!canEdit ? "disabled" : ""}></div>
        <div><label>Préavis (jours avant le départ)</label><input type="number" id="prod-notice-days" min="0" step="1" value="${location.shipping_notice_days_before ?? 1}" ${!canEdit ? "disabled" : ""}></div>
        <div><label>Heure limite du préavis</label><input type="time" id="prod-notice-time" value="${location.shipping_notice_time?.slice(0, 5) || "13:00"}" ${!canEdit ? "disabled" : ""}></div>
      </div>

      <div class="form-section-title" style="margin-top:24px">🔗 Superposition des étapes${helpTip("Décoche si deux étapes consécutives ne peuvent pas avoir lieu le même jour dans cet atelier.")}</div>
      <div class="compat-list" style="margin-top:10px">
        <label class="compat-list-item"><input type="checkbox" id="prod-same-day-materials" ${location.allow_same_day_materials_production !== false ? "checked" : ""} ${!canEdit ? "disabled" : ""}><span>Les matières premières peuvent arriver le jour même du début de production</span></label>
        <label class="compat-list-item"><input type="checkbox" id="prod-same-day-shipping" ${location.allow_same_day_production_shipping !== false ? "checked" : ""} ${!canEdit ? "disabled" : ""}><span>Le départ peut avoir lieu le dernier jour de production</span></label>
      </div>

      <div class="form-section-title" style="margin-top:28px">🍞 Recettes produites ici, et durée de fournée</div>
      <div class="toolbar" style="margin-top:10px"><input id="prod-recipe-search" class="search" placeholder="Rechercher une recette…"><div class="toolbar-spacer"></div></div>
      <div style="margin-top:10px">${recipeRows}</div>
      ${canEdit ? `<button type="button" id="save-production-constraints" class="button button-primary" style="margin-top:16px">Tout enregistrer</button>` : ""}
    `;

    document.querySelector("#prod-location-select").addEventListener("change", e => {
      productionConstraintsLocationId = e.target.value;
      renderProductionConstraints();
    });
    document.querySelectorAll(".prod-can-produce").forEach(cb => cb.addEventListener("change", () => {
      document.querySelector(`[data-duration-grid="${cb.dataset.recipeId}"]`).classList.toggle("hidden", !cb.checked);
    }));
    document.querySelector("#prod-recipe-search").addEventListener("input", e => {
      const q = e.target.value.trim().toLocaleLowerCase("fr");
      document.querySelectorAll("[data-recipe-row]").forEach(el => { el.hidden = Boolean(q) && !el.textContent.toLocaleLowerCase("fr").includes(q); });
    });

    document.querySelector("#save-production-constraints")?.addEventListener("click", async () => {
      const button = document.querySelector("#save-production-constraints"); submitButtonLoading(button, true);
      try {
        const newWorkingDays = [...document.querySelectorAll(".prod-working-day:checked")].map(el => Number(el.value));
        const newDepartureDays = [...document.querySelectorAll(".prod-departure-day:checked")].map(el => Number(el.value));
        const newCapacity = Array(12).fill(1).map((_, i) => Number(document.querySelector(`.prod-capacity-input[data-month="${i}"]`).value || 1));
        const { error: locationError } = await sb.from("locations").update({
          working_days: newWorkingDays, shipping_departure_days: newDepartureDays, monthly_capacity: newCapacity,
          shipping_transit_days: Number(document.querySelector("#prod-transit-days").value || 0),
          shipping_notice_days_before: Number(document.querySelector("#prod-notice-days").value || 0),
          shipping_notice_time: document.querySelector("#prod-notice-time").value,
          allow_same_day_materials_production: document.querySelector("#prod-same-day-materials").checked,
          allow_same_day_production_shipping: document.querySelector("#prod-same-day-shipping").checked
        }).eq("id", productionConstraintsLocationId);
        if (locationError) throw locationError;

        const rows = (recipes || []).map(r => {
          const canProduce = document.querySelector(`.prod-can-produce[data-recipe-id="${r.id}"]`).checked;
          const durations = Array(12).fill(7).map((_, i) => Number(document.querySelector(`.prod-duration-input[data-recipe-id="${r.id}"][data-month="${i}"]`)?.value || 7));
          const batchRaw = document.querySelector(`.prod-batch-qty[data-recipe-id="${r.id}"]`)?.value;
          return {
            organization_id: profile.organization_id, location_id: productionConstraintsLocationId, recipe_id: r.id,
            can_produce: canProduce, monthly_duration_days: durations,
            batch_quantity: batchRaw === "" || batchRaw == null ? null : Number(batchRaw)
          };
        });
        const { error: recipesError } = await sb.from("location_recipe_settings").upsert(rows, { onConflict: "location_id,recipe_id" });
        if (recipesError) throw recipesError;

        showToast("Contraintes enregistrées."); renderProductionConstraints();
      } catch (err) { showError(err); }
      finally { submitButtonLoading(button, false); }
    });
  }

  async function renderLogisticsSettings() {
    const canEdit = pageCan("locations");
    const { data: providers, error } = await sb.from("logistics_providers").select("*").eq("organization_id", profile.organization_id).order("name");
    if (error) throw error;

    const rows = (providers || []).map(p => `<div class="lot-row">
      <div class="lot-row-main">
        <div class="lot-row-title">${escapeHtml(p.name)} ${!p.active ? badge("Inactif") : badge("Actif", "success")}</div>
        <div class="muted" style="font-size:12.5px">${p.monthly_storage_pallets_included} palette(s) incluse(s) · ${formatMoney(p.daily_storage_rate_per_pallet)}/palette/jour au-delà</div>
      </div>
      <div class="lot-row-actions">
        <button class="icon-button icon-small edit-provider" data-id="${p.id}" title="Modifier">${ICONS.edit}</button>
        <button class="icon-button icon-small danger delete-provider" data-id="${p.id}" title="Supprimer">${ICONS.trash}</button>
      </div>
    </div>`).join("");

    content.innerHTML = `
      <div class="help-inline">${helpTip("La grille tarifaire de ton prestataire logistique externe (entreposage de palettes). Tu peux en créer plusieurs si tu changes de prestataire un jour, sans perdre l’historique de coûts déjà calculés.")}<span class="help-inline-label">À savoir</span></div>
      <div style="margin-top:14px">${rows || emptyState("Aucun prestataire configuré", "")}</div>
      ${canEdit ? `<button type="button" id="add-provider" class="button button-secondary" style="margin-top:10px">${ICONS.plus} Ajouter un prestataire</button>` : ""}
    `;
    document.querySelector("#add-provider")?.addEventListener("click", () => logisticsProviderModal());
    document.querySelectorAll(".edit-provider").forEach(btn => btn.addEventListener("click", () => logisticsProviderModal(providers.find(p => p.id === btn.dataset.id))));
    document.querySelectorAll(".delete-provider").forEach(btn => btn.addEventListener("click", async () => {
      if (!confirm("Supprimer ce prestataire ? Impossible s’il est encore lié à des palettes.")) return;
      const { error: delError } = await sb.from("logistics_providers").delete().eq("id", btn.dataset.id);
      if (delError) return showError(delError);
      showToast("Prestataire supprimé."); renderLogisticsSettings();
    }));
  }

  function logisticsProviderModal(provider = null) {
    const f = (key, def = 0) => provider?.[key] ?? def;
    openModal({
      title: provider ? "Modifier le prestataire" : "Nouveau prestataire logistique",
      kicker: "Logistique externe",
      width: "700px",
      html: `<form id="provider-form" class="form-grid">
        <div class="span-2"><label>Nom *</label><input name="name" required value="${escapeHtml(provider?.name || "")}"></div>
        <div class="checkbox-row span-2"><label class="switch"><input type="checkbox" name="active" ${provider?.active !== false ? "checked" : ""}><span class="switch-slider"></span></label><span>Prestataire actif</span></div>
        <div class="span-2 help-inline">${helpTip("Seul le dépassement est calculé par l’outil. Le forfait mensuel se gère en charge fixe, et les frais d’entrée, de sortie ou de préparation se saisissent en frais annexes au moment de la vente.")}<span class="help-inline-label">À savoir</span></div>
        <div><label>Palettes incluses dans le forfait</label><input name="monthly_storage_pallets_included" type="number" min="0" step="1" value="${f('monthly_storage_pallets_included')}"><p class="form-note">Au-delà, chaque palette est facturée au jour.</p></div>
        <div><label>Tarif au jour par palette en dépassement (€)</label><input name="daily_storage_rate_per_pallet" type="number" min="0" step="0.001" value="${f('daily_storage_rate_per_pallet')}"></div>
        <div class="form-actions span-2"><button type="button" class="button button-ghost" data-close-modal>Annuler</button><button class="button button-primary" type="submit">Enregistrer</button></div>
      </form>`
    });
    modalBody.querySelector("[data-close-modal]").addEventListener("click", closeModal);
    modalBody.querySelector("#provider-form").addEventListener("submit", async event => {
      event.preventDefault();
      const button = event.submitter; submitButtonLoading(button, true);
      const values = formObject(event.currentTarget);
      const payload = {
        organization_id: profile.organization_id, name: values.name.trim(),
        active: modalBody.querySelector('[name="active"]').checked,
        monthly_storage_pallets_included: Number(values.monthly_storage_pallets_included || 0),
        daily_storage_rate_per_pallet: Number(values.daily_storage_rate_per_pallet || 0)
      };
      const query = provider ? sb.from("logistics_providers").update(payload).eq("id", provider.id) : sb.from("logistics_providers").insert(payload);
      const { error } = await query;
      submitButtonLoading(button, false);
      if (error) return showError(error);
      closeModal(); showToast("Prestataire enregistré.");
      // On revient sur la page d'ou l'on vient : Emplacements ou Logistique externe
      renderLocations();
    });
  }

  // Palettes chez le logisticien
  let externalLogisticsViewMode = "products";

  async function renderExternalLogisticsLocationPage(location) {
    const canEdit = pageCan("finished-lots");
    const [{ data: pallets, error }, { data: providers }, { data: lotsHere }, allLocations] = await Promise.all([
      sb.from("pallets").select("*, locations(name), logistics_providers(name), pallet_items(quantity, finished_lot_id, finished_lots(lot_number, unit_cost_storage, recipes(name, sale_unit)))")
        .eq("organization_id", profile.organization_id).eq("location_id", location.id).eq("status", "in_storage").order("entered_at"),
      sb.from("logistics_providers").select("*").eq("organization_id", profile.organization_id).eq("active", true),
      sb.from("finished_lots").select("*, recipes(id, name, code, sale_unit, yield_quantity, production_cost, max_cost_threshold, recipe_items(quantity, unit, ingredients(unit, purchase_price)))").eq("organization_id", profile.organization_id).eq("location_id", location.id).gt("quantity_remaining", 0),
      fetchLocations(true)
    ]);
    if (error) throw error;

    // Association lot -> palette (numero + pleine/entamee), pour la vue Produits
    const palletInfoByLot = new Map();
    (pallets || []).forEach(p => {
      (p.pallet_items || []).forEach(it => {
        palletInfoByLot.set(it.finished_lot_id, { palletLabel: p.pallet_number || p.id.slice(0, 8), isBroken: p.is_broken });
      });
    });

    const palletRows = (pallets || []).map(p => {
      const itemsLabel = (p.pallet_items || []).map(it => `${formatNumber(it.quantity)} × ${it.finished_lots?.recipes?.name || "—"}`).join(", ");
      const daysIn = Math.max(0, Math.round((Date.now() - new Date(`${p.entered_at}T00:00:00`).getTime()) / 86400000));
      const isHetero = new Set((p.pallet_items || []).map(it => it.finished_lots?.recipes?.name)).size > 1;
      const storageCostTotal = (p.pallet_items || []).reduce((s, it) => s + Number(it.quantity || 0) * Number(it.finished_lots?.unit_cost_storage || 0), 0);
      return `<tr data-searchable>
        <td><strong>${escapeHtml(p.pallet_number || p.id.slice(0, 8))}</strong> ${p.is_broken ? badge("Entamée") : badge("Pleine", "success")}</td>
        <td>${escapeHtml(p.logistics_providers?.name || "—")}</td>
        <td>${itemsLabel || "—"}</td>
        <td>${isHetero ? badge("Hétérogène", "warning") : badge("Homogène", "info")}</td>
        <td>${formatDate(p.entered_at)} <span class="muted">(${daysIn} j.)</span></td>
        <td>${formatMoney(storageCostTotal)}</td>
        <td><div class="table-actions">
          ${canEdit ? `<button class="button button-small button-secondary recompose-pallet" data-id="${p.id}">Recomposer</button>` : ""}
          ${canEdit ? `<button class="button button-small button-primary exit-pallet" data-id="${p.id}">Sortir</button>` : ""}
        </div></td>
      </tr>`;
    }).join("");

    // Regroupement par produit, pour la vue Produits (comme les autres emplacements)
    const byRecipe = new Map();
    (lotsHere || []).forEach(lot => {
      const key = lot.recipe_id;
      if (!byRecipe.has(key)) byRecipe.set(key, { recipe: lot.recipes, lots: [] });
      byRecipe.get(key).lots.push(lot);
    });
    const products = [...byRecipe.values()].sort((a, b) => (a.recipe?.name || "").localeCompare(b.recipe?.name || "", "fr"));

    const productRows = products.map(({ recipe, lots }, idx) => {
      const totalQty = lots.reduce((s, l) => s + Number(l.quantity_remaining || 0), 0);
      const hasAlert = lots.some(lot => lot.expiry_date && lot.expiry_date <= plusDaysISO(60) && Number(lot.quantity_remaining) > 0);
      const palletLabels = new Set(lots.map(l => palletInfoByLot.get(l.id)?.palletLabel).filter(Boolean));
      const currentCost = totalQty ? lots.reduce((s, l) => {
        const unitCost = Number(l.unit_cost_mp || 0) + Number(l.unit_cost_production || 0) + Number(l.unit_cost_packaging || 0) + Number(l.unit_cost_transport || 0) + Number(l.unit_cost_storage || 0);
        return s + Number(l.quantity_remaining || 0) * unitCost;
      }, 0) / totalQty : 0;
      const threshold = recipe?.max_cost_threshold;
      const isOverThreshold = threshold != null && currentCost > Number(threshold);
      const lotRows = lots.map(lot => {
        const info = palletInfoByLot.get(lot.id);
        return `<div class="fifo-lot-row">
          <span class="fifo-tag">FIFO</span>
          <span class="lot-pill">${escapeHtml(lot.lot_number || "Sans lot")}</span>
          ${info ? `<span class="lot-pill">${escapeHtml(info.palletLabel)} · ${info.isBroken ? "Entamée" : "Pleine"}</span>` : ""}
          <span class="fifo-qty">${formatNumber(lot.quantity_remaining)} ${escapeHtml(recipe?.sale_unit || "unités")}</span>
          <span class="fifo-dates muted">${lot.produced_at ? formatDate(lot.produced_at) : "—"} → <span class="${lot.expiry_date && lot.expiry_date <= plusDaysISO(60) ? "fifo-date-alert" : "fifo-date-ok"}">${lot.expiry_date ? formatDate(lot.expiry_date) : "—"}</span></span>
        </div>`;
      }).join("");
      return `<div data-searchable data-product-row>
        <div class="finished-product-row with-pallets">
          <button type="button" class="product-row-toggle" data-toggle="ext-product-${idx}">
            <span class="chevron">▾</span>
            <strong>${escapeHtml(recipe?.name || "—")}</strong>
          </button>
          <span class="finished-col-qty">${formatNumber(totalQty)} ${escapeHtml(recipe?.sale_unit || "unités")}</span>
          <span class="finished-col-lots">${badge(`${lots.length} lot${lots.length > 1 ? "s" : ""}`)}</span>
          <span class="finished-col-pallets">${badge(`${palletLabels.size} palette${palletLabels.size > 1 ? "s" : ""}`)}</span>
          <span class="finished-col-exp">${hasAlert ? badge("Alerte", "warning") : badge("OK", "success")}</span>
          <span class="finished-col-cost">
            ${formatMoney(currentCost)}${threshold != null ? ` <span class="muted" style="font-size:11px">/ ${formatMoney(threshold)}</span>` : ""}
            ${isOverThreshold ? badge("Dépassé", "danger") : ""}
          </span>
        </div>
        <div class="fifo-lot-list" id="ext-product-${idx}">
          <div class="fifo-lot-list-title muted">📦 LOTS (FIFO)</div>
          ${lotRows || `<p class="muted" style="padding:8px 0">Aucun lot sur cet emplacement.</p>`}
        </div>
      </div>`;
    }).join("");

    content.innerHTML = `
      <div class="finished-page-head">
        <button type="button" id="pallets-back" class="icon-button" title="Retour">${ICONS.arrowLeft}</button>
        <span class="location-pill-lg">${escapeHtml(location.name)} ${badge("Logistique externe", "purple")}</span>
        <div class="toolbar-spacer"></div>
        <div class="view-toggle">
          <button type="button" class="mode-btn ${externalLogisticsViewMode === "products" ? "active" : ""}" data-ext-view="products">Produits</button>
          <button type="button" class="mode-btn ${externalLogisticsViewMode === "pallets" ? "active" : ""}" data-ext-view="pallets">Palettes</button>
        </div>
        ${canEdit && lotsHere?.length ? `<button type="button" id="open-transfer-drawer" class="button button-primary">→ Transférer</button>` : ""}
      </div>
      <div class="help-inline" style="margin-top:14px">${helpTip("Pour en envoyer une nouvelle, va sur l’emplacement d’origine (atelier) et utilise « Envoyer chez le logisticien ». Pour faire ressortir des produits : vends-les depuis l’onglet Livraisons (origine = cet emplacement), ou transfère-les avec le bouton ci-dessus. « Sortir » une palette (vue Palettes) sert à la clôturer une fois vidée, et applique le coût de sortie du logisticien.")}<span class="help-inline-label">À savoir</span></div>
      <div class="toolbar" style="margin-top:14px"><input id="pallets-search" class="search" placeholder="Rechercher une palette, un produit…"><div class="toolbar-spacer"></div></div>
      ${externalLogisticsViewMode === "products"
        ? `<div class="finished-list">
            <div class="finished-list-head with-pallets"><span>Produit</span><span class="finished-col-qty">Quantité</span><span class="finished-col-lots">Lots</span><span class="finished-col-pallets">Palettes</span><span class="finished-col-exp">Expiration</span><span class="finished-col-cost">Coût / seuil</span></div>
            ${productRows || emptyState("Aucun produit chez ce prestataire", "")}
          </div>`
        : `<div class="table-wrap">${palletRows ? `<table><thead><tr><th>Palette</th><th>Prestataire</th><th>Contenu</th><th>Type</th><th>Entrée</th><th>Stockage encouru</th><th></th></tr></thead><tbody>${palletRows}</tbody></table>` : emptyState("Aucune palette en stock chez ce prestataire", "")}</div>`}
    `;
    document.querySelector("#pallets-back").addEventListener("click", () => {
      finishedGoodsLocationKey = null;
      renderFinishedLots();
    });
    document.querySelectorAll("[data-ext-view]").forEach(btn => btn.addEventListener("click", () => {
      externalLogisticsViewMode = btn.dataset.extView;
      renderExternalLogisticsLocationPage(location);
    }));
    document.querySelector("#pallets-search")?.addEventListener("input", e => {
      const q = e.target.value.trim().toLocaleLowerCase("fr");
      document.querySelectorAll("[data-searchable]").forEach(el => { el.hidden = Boolean(q) && !el.textContent.toLocaleLowerCase("fr").includes(q); });
    });
    document.querySelectorAll("[data-toggle]").forEach(btn => btn.addEventListener("click", () => {
      document.querySelector(`#${btn.dataset.toggle}`).classList.toggle("open");
      btn.querySelector(".chevron").classList.toggle("open");
    }));
    document.querySelector("#open-transfer-drawer")?.addEventListener("click", () => {
      transferFinishedLotsDrawer(lotsHere, allLocations, location);
    });
    document.querySelectorAll(".exit-pallet").forEach(btn => btn.addEventListener("click", async () => {
      if (!confirm("Sortir cette palette du prestataire ? Le type (homogène/hétérogène) et le coût de sortie seront calculés automatiquement.")) return;
      const { error: exitError } = await sb.rpc("exit_pallet", { p_pallet_id: btn.dataset.id, p_exited_at: todayISO() });
      if (exitError) return showError(exitError);
      showToast("Palette sortie."); renderExternalLogisticsLocationPage(location);
    }));
    document.querySelectorAll(".recompose-pallet").forEach(btn => btn.addEventListener("click", () => recomposePalletModal(pallets.find(p => p.id === btn.dataset.id), pallets, providers || [], location)));
  }

  async function sendPalletModal(sourceLots, sourceLocation) {
    const [{ data: externalLocations }, { data: providers }] = await Promise.all([
      sb.from("locations").select("*").eq("organization_id", profile.organization_id).eq("is_external_logistics", true),
      sb.from("logistics_providers").select("*").eq("organization_id", profile.organization_id).eq("active", true)
    ]);
    if (!externalLocations?.length) return showToast("Créez d’abord un emplacement marqué « logistique externe » dans Paramètres → Emplacements.", "error");
    // Fournitures réellement disponibles sur l'emplacement d'origine
    const { data: palletSupplyLots } = await sb.from("supply_lots")
      .select("supply_id, quantity_remaining, supplies(id, name, unit)")
      .eq("organization_id", profile.organization_id)
      .eq("location_id", sourceLocation.id).gt("quantity_remaining", 0);
    const supplyStock = new Map();
    (palletSupplyLots || []).forEach(l => {
      const s = l.supplies; if (!s) return;
      if (!supplyStock.has(s.id)) supplyStock.set(s.id, { ...s, dispo: 0 });
      supplyStock.get(s.id).dispo += Number(l.quantity_remaining || 0);
    });
    const availableSupplies = [...supplyStock.values()].sort((a, b) => a.name.localeCompare(b.name, "fr"));
    const lines = [];
    openModal({
      title: "Envoyer une palette chez le logisticien",
      kicker: sourceLocation.name,
      width: "700px",
      html: `<form id="pallet-form" class="form-grid">
        <div><label>Destination *</label><select id="pallet-destination" name="destination_location_id">${externalLocations.map(l => `<option value="${l.id}" data-provider="${l.logistics_provider_id || ""}">${escapeHtml(l.name)}</option>`).join("")}</select></div>
        <div><label>Prestataire</label><select name="logistics_provider_id"><option value="">Aucun</option>${providers.map(p => `<option value="${p.id}">${escapeHtml(p.name)}</option>`).join("")}</select></div>
        <div class="span-2"><label>N° de palette (optionnel)</label><input name="pallet_number" placeholder="Étiquette, référence interne…"></div>
        <div><label>Date d’envoi</label><input name="entered_at" type="date" value="${todayISO()}"></div>
        <div><label>Coût de transport (€)</label><input name="transport_cost" type="number" min="0" step="0.01" value="0"></div>
        <div class="form-section-title span-2" style="margin-top:8px">Fournitures consommées${helpTip("Palette bois, film étirable, cornières… Elles sont sorties du stock de l’emplacement d’origine et leur coût est ajouté à la palette.")}</div>
        ${availableSupplies.length
          ? `<div class="compat-list span-2">${availableSupplies.map(s => `
              <label class="compat-list-item">
                <span style="flex:1">${escapeHtml(s.name)} <span class="muted" style="font-size:12px">— ${formatNumber(s.dispo)} ${escapeHtml(s.unit || "")} dispo.</span></span>
                <input type="number" min="0" max="${s.dispo}" step="0.001" class="pallet-supply-qty" data-supply-id="${s.id}" placeholder="0" style="width:110px">
              </label>`).join("")}</div>`
          : `<p class="form-note span-2">Aucune fourniture en stock sur cet emplacement.</p>`}
      </form>
      <div class="form-section-title" style="margin-top:16px">☰ Produits envoyés sur cette palette (depuis ${escapeHtml(sourceLocation.name)})</div>
      <div class="form-grid">
        <div class="span-2"><label>Lot</label><select id="pallet-lot">${sourceLots.map(l => `<option value="${l.id}">${escapeHtml(l.recipes?.name || "—")} — ${escapeHtml(l.lot_number || "sans lot")} (${formatNumber(l.quantity_remaining)} dispo.)</option>`).join("")}</select></div>
        <div><label>Quantité</label><input id="pallet-qty" type="number" min="0.001" step="0.001" value="1"></div>
        <div style="align-self:end"><button type="button" id="pallet-add-line" class="button button-primary button-full">＋ Ajouter</button></div>
      </div>
      <div class="table-wrap" style="margin-top:12px"><table><thead><tr><th>Produit</th><th>Quantité</th><th></th></tr></thead><tbody id="pallet-lines-body"></tbody></table></div>
      <div class="form-actions" style="margin-top:18px"><button type="button" class="button button-ghost" data-close-modal>Annuler</button><button type="button" id="save-pallet" class="button button-primary">Envoyer la palette</button></div>
      `
    });
    modalBody.querySelector("[data-close-modal]").addEventListener("click", closeModal);
    modalBody.querySelector("#pallet-destination").addEventListener("change", e => {
      const providerId = e.target.selectedOptions[0].dataset.provider;
      if (providerId) modalBody.querySelector('[name="logistics_provider_id"]').value = providerId;
    });
    modalBody.querySelector("#pallet-destination").dispatchEvent(new Event("change"));
    function renderLines() {
      modalBody.querySelector("#pallet-lines-body").innerHTML = lines.map((l, idx) => `<tr>
        <td>${escapeHtml(l.name)}</td><td>${formatNumber(l.quantity)}</td>
        <td><button type="button" class="icon-button icon-small danger pallet-remove-line" data-idx="${idx}">${ICONS.trash}</button></td>
      </tr>`).join("") || `<tr><td colspan="3" class="muted" style="text-align:center;padding:12px">Aucun produit</td></tr>`;
      modalBody.querySelectorAll(".pallet-remove-line").forEach(btn => btn.addEventListener("click", () => { lines.splice(Number(btn.dataset.idx), 1); renderLines(); }));
    }
    renderLines();
    modalBody.querySelector("#pallet-add-line").addEventListener("click", () => {
      const lotId = modalBody.querySelector("#pallet-lot").value;
      const lot = sourceLots.find(l => l.id === lotId);
      const qty = Number(modalBody.querySelector("#pallet-qty").value || 0);
      if (!lot || qty <= 0) return showToast("Choisissez un lot et une quantité.", "error");
      const alreadyUsed = lines.filter(l => l.finishedLotId === lotId).reduce((s, l) => s + l.quantity, 0);
      if (alreadyUsed + qty > Number(lot.quantity_remaining)) return showToast("Quantité supérieure au stock disponible.", "error");
      lines.push({ finishedLotId: lotId, name: `${lot.recipes?.name || "—"} (${lot.lot_number || "sans lot"})`, quantity: qty });
      renderLines();
    });
    modalBody.querySelector("#save-pallet").addEventListener("click", async () => {
      if (!lines.length) return showToast("Ajoutez au moins un produit.", "error");
      const values = formObject(modalBody.querySelector("#pallet-form"));
      const button = modalBody.querySelector("#save-pallet"); submitButtonLoading(button, true);
      const { data: newPalletId, error } = await sb.rpc("create_pallet", {
        p_source_location_id: sourceLocation.id, p_destination_location_id: values.destination_location_id,
        p_logistics_provider_id: values.logistics_provider_id || null,
        p_pallet_number: values.pallet_number.trim() || null, p_entered_at: values.entered_at || todayISO(),
        p_transport_cost: Number(values.transport_cost || 0),
        p_items: lines.map(l => ({ finished_lot_id: l.finishedLotId, quantity: l.quantity }))
      });
      if (error) { submitButtonLoading(button, false); return showError(error); }

      // Fournitures consommées pour préparer la palette
      const supplyItems = [...modalBody.querySelectorAll(".pallet-supply-qty")]
        .map(el => ({ supply_id: el.dataset.supplyId, quantity: Number(el.value || 0) }))
        .filter(s => s.quantity > 0);
      if (supplyItems.length && newPalletId) {
        const { error: supErr } = await sb.rpc("consume_pallet_supplies", {
          p_pallet_id: newPalletId, p_source_location_id: sourceLocation.id, p_supply_items: supplyItems
        });
        if (supErr) {
          submitButtonLoading(button, false);
          return showError(new Error("Palette créée, mais les fournitures n’ont pas pu être décomptées : " + supErr.message));
        }
      }
      submitButtonLoading(button, false);
      closeModal(); showToast("Palette envoyée."); renderFinishedLots();
    });
  }

  function recomposePalletModal(currentPallet, allPallets, providers, location) {
    if (!currentPallet) return;
    const sourceCandidates = allPallets.filter(p => p.id !== currentPallet.id);
    const allCandidatePallets = [currentPallet, ...sourceCandidates];
    const lines = [];
    openModal({
      title: "Recomposer une palette",
      kicker: "Prélève des produits sur une ou plusieurs palettes existantes pour en créer une nouvelle",
      width: "720px",
      html: `<form id="recompose-form" class="form-grid">
        <div><label>Prestataire</label><select name="logistics_provider_id"><option value="">Aucun</option>${providers.map(p => `<option value="${p.id}" ${currentPallet.logistics_provider_id === p.id ? "selected" : ""}>${escapeHtml(p.name)}</option>`).join("")}</select></div>
        <div><label>Emplacement</label><input type="text" value="${escapeHtml(currentPallet.locations?.name || "—")}" disabled></div>
      </form>
      <div class="checkbox-row" style="margin-top:14px"><label class="switch"><input type="checkbox" id="recompose-supplied"><span class="switch-slider"></span></label><span>Nouvelle palette physique fournie par le prestataire</span></div>
      <div class="form-section-title" style="margin-top:16px">☰ Produits à prélever</div>
      <div class="form-grid">
        <div class="span-2"><label>Palette source</label><select id="recompose-pallet">${allCandidatePallets.map(p => `<option value="${p.id}">${escapeHtml(p.pallet_number || p.id.slice(0, 8))} — ${escapeHtml(p.locations?.name || "—")}</option>`).join("")}</select></div>
        <div class="span-2"><label>Produit</label><select id="recompose-item"></select></div>
        <div><label>Quantité</label><input id="recompose-qty" type="number" min="0.001" step="0.001" value="1"></div>
        <div style="align-self:end"><button type="button" id="recompose-add-line" class="button button-primary button-full">＋ Ajouter</button></div>
      </div>
      <div class="table-wrap" style="margin-top:12px"><table><thead><tr><th>Produit</th><th>Depuis</th><th>Quantité</th><th></th></tr></thead><tbody id="recompose-lines-body"></tbody></table></div>
      <div class="form-actions" style="margin-top:18px"><button type="button" class="button button-ghost" data-close-modal>Annuler</button><button type="button" id="save-recompose" class="button button-primary">Créer la nouvelle palette</button></div>
      `
    });
    modalBody.querySelector("[data-close-modal]").addEventListener("click", closeModal);
    function syncItemOptions() {
      const palletId = modalBody.querySelector("#recompose-pallet").value;
      const pallet = allCandidatePallets.find(p => p.id === palletId);
      modalBody.querySelector("#recompose-item").innerHTML = (pallet?.pallet_items || []).map(it =>
        `<option value="${it.finished_lot_id}" data-name="${escapeHtml(it.finished_lots?.recipes?.name || "—")}">${escapeHtml(it.finished_lots?.recipes?.name || "—")} (${formatNumber(it.quantity)} dispo.)</option>`
      ).join("");
    }
    syncItemOptions();
    modalBody.querySelector("#recompose-pallet").addEventListener("change", syncItemOptions);
    function renderLines() {
      modalBody.querySelector("#recompose-lines-body").innerHTML = lines.map((l, idx) => `<tr>
        <td>${escapeHtml(l.name)}</td><td>${escapeHtml(l.sourceLabel)}</td><td>${formatNumber(l.quantity)}</td>
        <td><button type="button" class="icon-button icon-small danger recompose-remove-line" data-idx="${idx}">${ICONS.trash}</button></td>
      </tr>`).join("") || `<tr><td colspan="4" class="muted" style="text-align:center;padding:12px">Aucun produit</td></tr>`;
      modalBody.querySelectorAll(".recompose-remove-line").forEach(btn => btn.addEventListener("click", () => { lines.splice(Number(btn.dataset.idx), 1); renderLines(); }));
    }
    renderLines();
    modalBody.querySelector("#recompose-add-line").addEventListener("click", () => {
      const palletId = modalBody.querySelector("#recompose-pallet").value;
      const pallet = allCandidatePallets.find(p => p.id === palletId);
      const itemSelect = modalBody.querySelector("#recompose-item");
      const finishedLotId = itemSelect.value;
      const qty = Number(modalBody.querySelector("#recompose-qty").value || 0);
      if (!finishedLotId || qty <= 0) return showToast("Choisissez un produit et une quantité.", "error");
      lines.push({ sourcePalletId: palletId, finishedLotId, name: itemSelect.selectedOptions[0].dataset.name, sourceLabel: pallet.pallet_number || pallet.id.slice(0, 8), quantity: qty });
      renderLines();
    });
    modalBody.querySelector("#save-recompose").addEventListener("click", async () => {
      if (!lines.length) return showToast("Ajoutez au moins un produit.", "error");
      const values = formObject(modalBody.querySelector("#recompose-form"));
      const button = modalBody.querySelector("#save-recompose"); submitButtonLoading(button, true);
      const { error } = await sb.rpc("recompose_pallet", {
        p_location_id: currentPallet.location_id || null,
        p_logistics_provider_id: values.logistics_provider_id || null,
        p_items: lines.map(l => ({ source_pallet_id: l.sourcePalletId, finished_lot_id: l.finishedLotId, quantity: l.quantity })),
        p_new_pallet_supplied: modalBody.querySelector("#recompose-supplied").checked
      });
      submitButtonLoading(button, false);
      if (error) return showError(error);
      closeModal(); showToast("Palette recomposée."); renderExternalLogisticsLocationPage(location);
    });
  }

  // Mouvements — ventes, transferts, pertes, échantillons, dons
  const MOVEMENT_TYPE_INFO = {
    vente: { label: "Vente", tone: "success" },
    transfert: { label: "Transfert", tone: "info" },
    perte: { label: "Perte", tone: "danger" },
    echantillon: { label: "Échantillon", tone: "purple" },
    ajustement: { label: "Correction", tone: "warning" },
    suppression: { label: "Suppression", tone: "danger" },
    don: { label: "Don", tone: "warning" }
  };

  async function renderMovements() {
    const [stockMoves, deliveryItems, peopleRes] = await Promise.all([
      fetchAllRows(() => sb.from("stock_movements").select("*").eq("organization_id", profile.organization_id).order("created_at", { ascending: false })),
      fetchAllRows(() => sb.from("delivery_items").select("quantity, deliveries!inner(organization_id, status, delivered_at, delivery_date, locations(name), clients(name,company)), finished_lots(lot_number, expiry_date, recipes(name, sale_unit))")
        .eq("deliveries.organization_id", profile.organization_id).eq("deliveries.status", "delivered")),
      sb.from("profiles").select("user_id, full_name").eq("organization_id", profile.organization_id)
    ]);
    const nameOf = new Map((peopleRes?.data || []).map(p => [p.user_id, p.full_name]));

    const rows = [];
    (stockMoves || []).forEach(m => rows.push({
      date: m.created_at, type: m.movement_type, itemName: m.item_name, lotNumber: m.lot_number,
      expiryDate: m.expiry_date, quantity: m.quantity, unit: m.unit,
      origin: m.origin_location_name || "—", destination: m.destination_location_name || "—",
      reason: m.reason || "", by: m.created_by_name || nameOf.get(m.created_by) || "",
      // Correction : sens de la variation
      sign: m.movement_type === "ajustement" && m.quantity_before != null && m.quantity_after != null
        ? (Number(m.quantity_after) > Number(m.quantity_before) ? "+" : Number(m.quantity_after) < Number(m.quantity_before) ? "−" : "") : ""
    }));
    (deliveryItems || []).forEach(i => {
      const d = i.deliveries;
      rows.push({
        date: d.delivered_at || d.delivery_date, type: "vente", itemName: i.finished_lots?.recipes?.name || "—",
        lotNumber: i.finished_lots?.lot_number, expiryDate: i.finished_lots?.expiry_date,
        quantity: i.quantity, unit: i.finished_lots?.recipes?.sale_unit || "",
        origin: d.locations?.name || "—", destination: d.clients?.company || d.clients?.name || "—", reason: "", by: "", sign: ""
      });
    });
    rows.sort((a, b) => (b.date || "").localeCompare(a.date || ""));

    const tableRows = rows.map(r => {
      const info = MOVEMENT_TYPE_INFO[r.type] || { label: r.type, tone: "" };
      return `<tr data-searchable>
        <td>${r.date ? formatDate(r.date.slice(0, 10)) : "—"}</td>
        <td>${badge(info.label, info.tone)}</td>
        <td><strong>${escapeHtml(r.itemName)}</strong></td>
        <td><span class="lot-pill">${escapeHtml(r.lotNumber || "Sans lot")}</span></td>
        <td>${r.expiryDate ? formatDate(r.expiryDate) : "—"}</td>
        <td>${r.sign}${formatNumber(r.quantity)} ${escapeHtml(r.unit || "")}</td>
        <td>${escapeHtml(r.origin)}</td>
        <td>${escapeHtml(r.destination)}</td>
        <td class="movement-reason">${escapeHtml(r.reason)}</td>
        <td>${escapeHtml(r.by)}</td>
      </tr>`;
    }).join("");

    content.innerHTML = `
      <div class="toolbar"><input id="movements-search" class="search" placeholder="Rechercher un produit, un ingrédient, un lot, un emplacement…"><div class="toolbar-spacer"></div></div>
      <div class="table-wrap">${tableRows ? `<table><thead><tr><th>Date</th><th>Type</th><th>Produit / Ingrédient</th><th>N° de lot</th><th>DDM</th><th>Quantité</th><th>Origine</th><th>Destination</th><th>Motif</th><th>Par</th></tr></thead><tbody>${tableRows}</tbody></table>` : emptyState("Aucun mouvement", "Les ventes, transferts, pertes, corrections et suppressions apparaîtront ici.")}</div>
    `;
    document.querySelector("#movements-search").addEventListener("input", e => {
      const q = e.target.value.trim().toLocaleLowerCase("fr");
      document.querySelectorAll("[data-searchable]").forEach(el => { el.hidden = Boolean(q) && !el.textContent.toLocaleLowerCase("fr").includes(q); });
    });
  }



  // Prévisionnel — simple et sans dependance a l'historique lointain :
  // commandes des 3 derniers mois, x croissance manuelle, x alea manuel.
  // --- Aides de calcul de dates pour le rétroplanning (respectent les
  // jours fixes reels, jamais un simple "date - X jours") ---
  function addCalendarDays(date, n) {
    const d = new Date(date); d.setDate(d.getDate() + n); return d;
  }
  function isAllowedDay(date, allowedDays) {
    return !allowedDays || !allowedDays.length || allowedDays.includes(date.getDay());
  }
  function nextAllowedDate(fromDate, allowedDays) {
    if (!allowedDays || !allowedDays.length) return new Date(fromDate);
    let d = new Date(fromDate);
    for (let i = 0; i < 14; i++) { if (isAllowedDay(d, allowedDays)) return d; d = addCalendarDays(d, 1); }
    return d;
  }
  function previousAllowedDate(fromDate, allowedDays) {
    if (!allowedDays || !allowedDays.length) return new Date(fromDate);
    let d = new Date(fromDate);
    for (let i = 0; i < 14; i++) { if (isAllowedDay(d, allowedDays)) return d; d = addCalendarDays(d, -1); }
    return d;
  }
  function subtractWorkingDays(fromDate, n, workingDays) {
    let d = new Date(fromDate);
    let remaining = n;
    let guard = 0;
    while (remaining > 0 && guard < 400) {
      d = addCalendarDays(d, -1);
      if (isAllowedDay(d, workingDays)) remaining--;
      guard++;
    }
    return d;
  }
  function addWorkingDays(fromDate, n, workingDays) {
    let d = new Date(fromDate);
    let remaining = n;
    let guard = 0;
    while (remaining > 0 && guard < 400) {
      d = addCalendarDays(d, 1);
      if (isAllowedDay(d, workingDays)) remaining--;
      guard++;
    }
    return d;
  }

  // Rétroplanning — moteur de calcul (source : Prévisionnel + commandes fermes)
  // Moteur du rétroplanning — calcule les besoins, partage par renderRetroplanning
  // et par l'onglet Tâches (qui en tire les rappels d'actions a faire).
  async function computeRetroplanning() {
    const [
      { data: recipes, error: recipesError },
      { data: locationRecipeSettings },
      { data: recipeItemsRaw },
      { data: ingredientLocations },
      { data: suppliers },
      { data: allLocationsRaw },
      finishedLotsRaw,
      { data: productionsInProgress },
      ingredientLotsRaw,
      supplyLotsRaw,
      { data: recipePackagings },
      { data: supplyLocations }
    ] = await Promise.all([
      sb.from("recipes").select("id, name, sale_unit, yield_quantity, target_stock_days, manual_growth_rate, safety_margin_pct, material_loss_pct").eq("organization_id", profile.organization_id).order("name"),
      sb.from("location_recipe_settings").select("*").eq("organization_id", profile.organization_id).eq("can_produce", true),
      sb.from("recipe_items").select("recipe_id, ingredient_id, quantity, unit"),
      sb.from("ingredient_locations").select("ingredient_id, location_id, supplier_id"),
      sb.from("suppliers").select("*, supplier_locations(location_id, delivery_days, order_deadline_days_before, order_deadline_time)").eq("organization_id", profile.organization_id),
      sb.from("locations").select("id, name, working_days, shipping_departure_days, shipping_transit_days, shipping_notice_days_before, allow_same_day_materials_production, allow_same_day_production_shipping"),
      fetchAllRows(() => sb.from("finished_lots").select("recipe_id, quantity_remaining").eq("organization_id", profile.organization_id).gt("quantity_remaining", 0)),
      sb.from("productions").select("recipe_id, location_id, quantity_produced, production_date, status, archived").eq("organization_id", profile.organization_id).neq("status", "completed"),
      fetchAllRows(() => sb.from("ingredient_lots").select("ingredient_id, location_id, quantity_remaining").eq("organization_id", profile.organization_id).gt("quantity_remaining", 0)),
      fetchAllRows(() => sb.from("supply_lots").select("supply_id, location_id, quantity_remaining").eq("organization_id", profile.organization_id).gt("quantity_remaining", 0)),
      sb.from("recipe_packagings").select("recipe_id, packagings(id, name, units_per_pack, packaging_components(quantity, supplies(id, name, unit)))"),
      sb.from("supply_locations").select("supply_id, location_id, supplier_id").eq("organization_id", profile.organization_id)
    ]);
    if (recipesError) throw recipesError;

    // Ordre des étapes à jour, et productions archivées écartées
    await loadProductionStages();
    const activeProductions = (productionsInProgress || []).filter(p => !p.archived);

    // À partir de quelle étape une production fait taire le rétroplanning
    const { data: orgSettings } = await sb.from("organizations")
      .select("retro_silence_from_status").eq("id", profile.organization_id).single();
    // Si l'étape réglée n'existe plus (supprimée), on retombe sur la première
    // étape existante : sinon la comparaison échouerait et les relances ne
    // s'arrêteraient jamais, sans aucune erreur visible.
    const savedSilence = orgSettings?.retro_silence_from_status;
    const retroSilenceFrom = PRODUCTION_STAGE_ORDER.includes(savedSilence)
      ? savedSilence : (PRODUCTION_CUSTOM_STAGES[0]?.key || "in_progress");

    const locationsById = new Map((allLocationsRaw || []).map(l => [l.id, l]));
    const stockByRecipe = new Map();
    (finishedLotsRaw || []).forEach(l => stockByRecipe.set(l.recipe_id, (stockByRecipe.get(l.recipe_id) || 0) + Number(l.quantity_remaining || 0)));

    // Prevu par le prevsionnel : ventes 3 derniers mois (reutilise la meme fenetre que l'onglet Prévisionnel)
    const forecastCutoff = new Date(); forecastCutoff.setDate(1); forecastCutoff.setMonth(forecastCutoff.getMonth() - 4);
    const { data: recentItems } = await sb.from("delivery_items").select("quantity, finished_lots(recipe_id), deliveries!inner(delivered_at, status, organization_id)")
      .eq("deliveries.organization_id", profile.organization_id).eq("deliveries.status", "delivered").gte("deliveries.delivered_at", forecastCutoff.toISOString().slice(0, 10));
    const today = new Date(); today.setHours(0, 0, 0, 0);
    const lastFullMonth = new Date(today.getFullYear(), today.getMonth() - 1, 1);
    const last3MonthKeys = [2, 1, 0].map(i => { const d = new Date(lastFullMonth.getFullYear(), lastFullMonth.getMonth() - i, 1); return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}`; });
    const monthlyByRecipe = new Map();
    (recentItems || []).forEach(i => {
      const rid = i.finished_lots?.recipe_id; if (!rid || !i.deliveries?.delivered_at) return;
      if (!monthlyByRecipe.has(rid)) monthlyByRecipe.set(rid, new Map());
      const key = i.deliveries.delivered_at.slice(0, 7);
      monthlyByRecipe.get(rid).set(key, (monthlyByRecipe.get(rid).get(key) || 0) + Number(i.quantity || 0));
    });

    // --- Section Prévisionnel : reutilise les memes ventes 3 derniers mois que le Rétroplanning ---
    const canEditForecast = pageCan("recipes");
    const monthLabel = key => `${MONTH_LABELS[Number(key.slice(5, 7)) - 1]} ${key.slice(0, 4)}`;
    const forecastRows = recipes.map((recipe, idx) => {
      const monthly = monthlyByRecipe.get(recipe.id) || new Map();
      const last3Sum = last3MonthKeys.reduce((s, k) => s + (monthly.get(k) || 0), 0);
      const growth = Number(recipe.manual_growth_rate ?? 0);
      const alea = Number(recipe.safety_margin_pct ?? 0.15);
      const horizonDays = recipe.target_stock_days || 30;
      const baseMonthlyRate = last3Sum / 3;
      const projectedMonthlyRate = baseMonthlyRate * (1 + growth);
      const targetStockQty = projectedMonthlyRate * (horizonDays / 30) * (1 + alea);
      const currentStockFc = stockByRecipe.get(recipe.id) || 0;
      const toProduce = Math.max(0, targetStockQty - currentStockFc);
      const chartHtml = svgLineChart(
        last3MonthKeys.map(monthLabel),
        [{ name: recipe.name, values: last3MonthKeys.map(k => monthly.get(k) || 0), color: CHART_COLORS[0] }]
      );
      return `<div data-searchable-fc data-product-row>
        <div class="finished-product-row forecast-row">
          <button type="button" class="product-row-toggle" data-toggle="forecast-${idx}">
            <span class="chevron">▾</span><strong>${escapeHtml(recipe.name)}</strong>
          </button>
          <span class="finished-col-qty">${formatNumber(last3Sum)} ${escapeHtml(recipe.sale_unit || "u.")}</span>
          <span>${badge(`${growth >= 0 ? "+" : ""}${formatNumber(growth * 100, 0)}%`, growth >= 0 ? "success" : "warning")}</span>
          <span>${badge(`+${formatNumber(alea * 100, 0)}%`, "info")}</span>
          <span class="finished-col-qty">${formatNumber(currentStockFc)} ${escapeHtml(recipe.sale_unit || "u.")}</span>
          <span class="finished-col-qty"><strong>${toProduce > 0.5 ? formatNumber(toProduce, 0) : "—"}</strong></span>
        </div>
        <div class="fifo-lot-list" id="forecast-${idx}">
          <div class="fifo-lot-list-title muted">3 derniers mois (${last3MonthKeys.map(monthLabel).join(" · ")})</div>
          <div class="chart-wrap">${chartHtml}</div>
          <div class="help-box" style="margin-top:12px"><strong>Calcul :</strong> ${formatNumber(last3Sum, 0)} (3 derniers mois) ÷ 3 = ${formatNumber(baseMonthlyRate, 0)} base mensuelle × (1 ${growth >= 0 ? "+" : ""}${formatNumber(growth * 100, 0)}% croissance) × ${formatNumber(horizonDays / 30, 2)} mois × (1 + ${formatNumber(alea * 100, 0)}% aléa) = <strong>${formatNumber(targetStockQty, 0)}</strong> visé, moins ${formatNumber(currentStockFc, 0)} déjà en stock.</div>
          <div class="form-grid" style="margin-top:14px">
            <div><label>Jours de stock cible</label><input type="number" min="1" step="1" class="forecast-target-days" data-recipe-id="${recipe.id}" value="${horizonDays}" ${!canEditForecast ? "disabled" : ""}></div>
            <div><label>Croissance (%)</label><input type="number" step="1" class="forecast-manual-growth" data-recipe-id="${recipe.id}" value="${formatNumber(growth * 100, 0)}" ${!canEditForecast ? "disabled" : ""}></div>
            <div><label>Aléa (%)</label><input type="number" min="0" step="1" class="forecast-safety-margin" data-recipe-id="${recipe.id}" value="${formatNumber(alea * 100, 0)}" ${!canEditForecast ? "disabled" : ""}></div>
            ${canEditForecast ? `<div style="align-self:end"><button type="button" class="button button-primary button-full save-forecast-settings" data-recipe-id="${recipe.id}">Enregistrer</button></div>` : ""}
          </div>
        </div>
      </div>`;
    }).join("");

    // Commandes fermes futures (livraisons deja saisies, pas encore livrees)
    const firmByRecipeDate = new Map(); // recipe_id -> Map(dateISO -> qty)
    // (les delivery_items n'ont pas de recipe_id direct sans lot ; on rejoint separement)
    const { data: firmItemsWithRecipe } = await sb.from("delivery_items").select("quantity, finished_lots(recipe_id), deliveries!inner(organization_id, status, delivered_at, delivery_date, estimated_delivery_date)")
      .eq("deliveries.organization_id", profile.organization_id).neq("deliveries.status", "delivered");
    (firmItemsWithRecipe || []).forEach(i => {
      const rid = i.finished_lots?.recipe_id; if (!rid) return;
      const dateStr = i.deliveries.estimated_delivery_date || i.deliveries.delivery_date;
      if (!dateStr || dateStr < todayISO()) return;
      if (!firmByRecipeDate.has(rid)) firmByRecipeDate.set(rid, new Map());
      firmByRecipeDate.get(rid).set(dateStr, (firmByRecipeDate.get(rid).get(dateStr) || 0) + Number(i.quantity || 0));
    });

    // Productions deja lancees : le stock n'arrive qu'a la FIN de la fournee, pas le
    // jour ou la production demarre. On ajoute donc la duree de fournee configuree
    // pour cet emplacement plutot que de compter l'arrivage trop tot.
    const settingsByLocRecipe = new Map((locationRecipeSettings || []).map(s => [`${s.location_id}:${s.recipe_id}`, s]));
    const plannedArrivalsByRecipe = new Map();
    activeProductions.forEach(p => {
      if (!plannedArrivalsByRecipe.has(p.recipe_id)) plannedArrivalsByRecipe.set(p.recipe_id, new Map());
      const m = plannedArrivalsByRecipe.get(p.recipe_id);
      const loc = locationsById.get(p.location_id);
      const setg = settingsByLocRecipe.get(`${p.location_id}:${p.recipe_id}`);
      const startDate = new Date(`${p.production_date}T00:00:00`);
      const duree = (setg?.monthly_duration_days || [])[startDate.getMonth()] ?? 0;
      const arrivee = duree > 0 && loc
        ? addWorkingDays(startDate, Math.max(0, duree - 1), loc.working_days)
        : startDate;
      const key = dateToStr(arrivee);
      m.set(key, (m.get(key) || 0) + Number(p.quantity_produced || 0));
    });

    const recipeItemsByRecipe = new Map();
    (recipeItemsRaw || []).forEach(ri => { if (!recipeItemsByRecipe.has(ri.recipe_id)) recipeItemsByRecipe.set(ri.recipe_id, []); recipeItemsByRecipe.get(ri.recipe_id).push(ri); });
    const ingredientLocationMap = new Map((ingredientLocations || []).map(il => [`${il.ingredient_id}:${il.location_id}`, il]));
    const suppliersById = new Map((suppliers || []).map(s => [s.id, s]));
    // Stock de matieres premieres reellement disponible, par ingredient ET par emplacement
    const ingredientStockMap = new Map();
    (ingredientLotsRaw || []).forEach(lot => {
      const key = `${lot.ingredient_id}:${lot.location_id}`;
      ingredientStockMap.set(key, (ingredientStockMap.get(key) || 0) + Number(lot.quantity_remaining || 0));
    });
    // Idem pour les fournitures (conditionnements) : toujours par emplacement
    const supplyStockMap = new Map();
    (supplyLotsRaw || []).forEach(lot => {
      const key = `${lot.supply_id}:${lot.location_id}`;
      supplyStockMap.set(key, (supplyStockMap.get(key) || 0) + Number(lot.quantity_remaining || 0));
    });
    const supplyLocationMap = new Map((supplyLocations || []).map(sl => [`${sl.supply_id}:${sl.location_id}`, sl]));
    // Besoin en fournitures par recette : recette -> conditionnement -> composants
    const supplyNeedsByRecipe = new Map();
    (recipePackagings || []).forEach(rp => {
      const pack = rp.packagings;
      if (!pack) return;
      const unitsPerPack = Number(pack.units_per_pack || 1) || 1;
      (pack.packaging_components || []).forEach(comp => {
        const supply = comp.supplies;
        if (!supply) return;
        if (!supplyNeedsByRecipe.has(rp.recipe_id)) supplyNeedsByRecipe.set(rp.recipe_id, []);
        // quantite de fourniture par UNITE de produit fini
        supplyNeedsByRecipe.get(rp.recipe_id).push({
          supply_id: supply.id, name: supply.name,
          qtyPerUnit: Number(comp.quantity || 0) / unitsPerPack
        });
      });
    });

    const rows = (locationRecipeSettings || []).map(setting => {
      const recipe = recipes.find(r => r.id === setting.recipe_id);
      const location = locationsById.get(setting.location_id);
      if (!recipe || !location) return null;

      const monthly = monthlyByRecipe.get(recipe.id) || new Map();
      const last3Sum = last3MonthKeys.reduce((s, k) => s + (monthly.get(k) || 0), 0);
      const growth = Number(recipe.manual_growth_rate ?? 0);
      const dailyRate = Math.max(0, (last3Sum / 3) * (1 + growth) / 30);
      const targetStockDays = recipe.target_stock_days || 30;
      const thresholdStock = dailyRate * targetStockDays;
      const currentStock = stockByRecipe.get(recipe.id) || 0;
      const firmDates = firmByRecipeDate.get(recipe.id) || new Map();
      const plannedArrivals = plannedArrivalsByRecipe.get(recipe.id) || new Map();

      // Simulation jour par jour : commande ferme prioritaire sur l'estimation, jamais les deux.
      // Les productions deja lancees viennent regarnir le stock a leur date d'arrivee.
      let stock = currentStock;
      let dateSeuilAtteint = null;
      let productionsEnCoursQty = 0;
      for (let i = 0; i <= 180; i++) {
        const d = addCalendarDays(today, i);
        const dISO = dateToStr(d);
        const arrivee = Number(plannedArrivals.get(dISO) || 0);
        stock += arrivee;
        productionsEnCoursQty += arrivee;
        if (i > 0) {
          const firmQty = firmDates.get(dISO);
          stock -= firmQty != null ? firmQty : dailyRate;
        }
        if (stock <= thresholdStock) { dateSeuilAtteint = d; break; }
      }
      // Une production déjà engagée pour ce produit et cet atelier fait taire
      // la recommandation, dès l'étape configurée dans les paramètres.
      const cycleEngage = activeProductions.some(p =>
        p.recipe_id === recipe.id && p.location_id === location.id
        && productionReached(p.status, retroSilenceFrom));

      // Si rien ne descend sous le seuil sur 180 jours, aucune action n'est requise
      const aucuneActionRequise = !dateSeuilAtteint || cycleEngage;

      const yieldQty = Number(recipe.yield_quantity || 1) || 1;
      // Taille de fournee propre a cet emplacement : on arrondit toujours au multiple
      // superieur (on ne sait pas produire une demi-fournee).
      const batchQty = Number(setting.batch_quantity || 0);
      const besoinBrut = Math.max(0, thresholdStock - currentStock);
      const quantiteRecommandee = batchQty > 0
        ? Math.max(batchQty, Math.ceil(besoinBrut / batchQty) * batchQty)
        : Math.ceil(thresholdStock);
      const nbFournees = batchQty > 0 ? Math.ceil(quantiteRecommandee / batchQty) : 1;

      // Rétroplanning a rebours, verrouille sur des jours reellement possibles a chaque etape.
      // Le stock doit etre CHEZ LE CLIENT a la date du seuil : on retire donc le
      // temps de transport avant de chercher un jour de depart possible.
      const transitDays = Number(location.shipping_transit_days || 0);
      const targetDate = dateSeuilAtteint || addCalendarDays(today, 180);
      const targetDepart = transitDays > 0 ? addCalendarDays(targetDate, -transitDays) : targetDate;
      const finProductionTarget = (location.shipping_departure_days || []).length
        ? previousAllowedDate(targetDepart, location.shipping_departure_days)
        : targetDepart;

      const month = finProductionTarget.getMonth();
      const fourneeDuration = (setting.monthly_duration_days || [])[month] ?? 7;
      const sameDayMaterials = location.allow_same_day_materials_production !== false;
      const sameDayShipping = location.allow_same_day_production_shipping !== false;
      // Une fournee de N jours occupe N jours travailles EN COMPTANT le dernier :
      // on recule donc de N-1, pas de N (sinon le planning gagne un jour de trop).
      const dureeReculee = Math.max(0, fourneeDuration - 1);
      const finProdEffective = sameDayShipping ? finProductionTarget : previousAllowedDate(addCalendarDays(finProductionTarget, -1), location.working_days);
      const debutProductionNaive = subtractWorkingDays(finProdEffective, dureeReculee, location.working_days);

      // Pour chaque ingredient : est-il DEJA en stock en quantite suffisante pour cette
      // production ? Si oui, aucune commande n'est necessaire pour lui. Sinon, on calcule
      // sa contrainte d'approvisionnement (jours de livraison + deadline).
      const ingredientNeeds = recipeItemsByRecipe.get(recipe.id) || [];
      let ingredientsSansFournisseur = 0;
      let ingredientsEnStock = 0;
      const manquants = [];
      const ingredientConstraints = [];
      // Meme echelle que le Calculateur de besoin : les quantites de recette sont
      // exprimees pour une fournee (yield_quantity), on met a l'echelle de la production.
      const scale = quantiteRecommandee / yieldQty;
      ingredientNeeds.forEach(ri => {
        // Majoré de l'écart matière : c'est ce que la production consommera vraiment
        const besoinTotal = Number(ri.quantity || 0) * scale * (1 + Number(recipe.material_loss_pct || 0) / 100);
        const dispo = ingredientStockMap.get(`${ri.ingredient_id}:${location.id}`) || 0;
        if (dispo >= besoinTotal) { ingredientsEnStock++; return; }
        const il = ingredientLocationMap.get(`${ri.ingredient_id}:${location.id}`);
        const supplier = il?.supplier_id ? suppliersById.get(il.supplier_id) : null;
        const sl = supplier?.supplier_locations?.find(x => x.location_id === location.id);
        manquants.push({ type: "ingredient", manquant: besoinTotal - dispo });
        if (!sl || !(sl.delivery_days || []).length) { ingredientsSansFournisseur++; return; }
        ingredientConstraints.push({
          deadlineDaysBefore: sl.order_deadline_days_before ?? 1, deliveryDays: sl.delivery_days,
          manquant: besoinTotal - dispo
        });
      });
      // Fournitures (conditionnements) : meme raisonnement, meme emplacement.
      // Elles doivent etre la AVANT la fin de production, pas avant le debut.
      let fournituresSansFournisseur = 0;
      let fournituresManquantes = 0;
      let fournituresTotal = 0;
      const supplyConstraints = [];
      (supplyNeedsByRecipe.get(recipe.id) || []).forEach(sn => {
        fournituresTotal++;
        const besoinTotal = sn.qtyPerUnit * quantiteRecommandee;
        const dispo = supplyStockMap.get(`${sn.supply_id}:${location.id}`) || 0;
        if (dispo >= besoinTotal) return;
        fournituresManquantes++;
        const sloc = supplyLocationMap.get(`${sn.supply_id}:${location.id}`);
        const supplier = sloc?.supplier_id ? suppliersById.get(sloc.supplier_id) : null;
        const sl = supplier?.supplier_locations?.find(x => x.location_id === location.id);
        if (!sl || !(sl.delivery_days || []).length) { fournituresSansFournisseur++; return; }
        supplyConstraints.push({
          deadlineDaysBefore: sl.order_deadline_days_before ?? 1, deliveryDays: sl.delivery_days,
          manquant: besoinTotal - dispo
        });
      });
      const toutEnStock = ingredientConstraints.length === 0 && fournituresManquantes === 0;
      // Les fournitures doivent etre la avant la FIN de production (conditionnement),
      // pas avant le debut : leur commande se calcule donc separement.

      // Construction du planning. Deux cas :
      //  - le plan a rebours tient encore dans le futur : on le garde
      //  - il tomberait dans le passe (ou tout est deja en stock) : on planifie au plus tot
      //    a partir d'aujourd'hui, ce qui est la seule chose reellement faisable.
      let commandeFournisseur = null, matieresDisponibles = null, debutProduction = null, finProduction = null;

      function planifierAuPlusTot() {
        if (toutEnStock) {
          commandeFournisseur = null;
          matieresDisponibles = today;
          debutProduction = nextAllowedDate(today, location.working_days);
        } else {
          commandeFournisseur = today;
          let arrivage = null;
          // Ingredients et fournitures : on attend le plus tardif des deux
          [...ingredientConstraints, ...supplyConstraints].forEach(c => {
            const premier = nextAllowedDate(addCalendarDays(today, c.deadlineDaysBefore), c.deliveryDays);
            if (!arrivage || premier > arrivage) arrivage = premier;
          });
          matieresDisponibles = arrivage;
          // Production le jour meme de l'arrivage, ou le lendemain si l'atelier ne
          // superpose pas les deux etapes.
          debutProduction = nextAllowedDate(sameDayMaterials ? arrivage : addCalendarDays(arrivage, 1), location.working_days);
        }
        finProduction = addWorkingDays(debutProduction, dureeReculee, location.working_days);
        if ((location.shipping_departure_days || []).length) {
          const depuis = sameDayShipping ? finProduction : addCalendarDays(finProduction, 1);
          finProduction = nextAllowedDate(depuis, location.shipping_departure_days);
        } else if (!sameDayShipping) {
          finProduction = nextAllowedDate(addCalendarDays(finProduction, 1), location.working_days);
        }
      }

      if (toutEnStock) {
        // Rien a commander : la production demarre des que l'atelier travaille.
        debutProduction = nextAllowedDate(debutProductionNaive, location.working_days);
        matieresDisponibles = debutProduction;
      } else {
        // Chaque ingredient manquant doit etre arrive a temps : on prend l'arrivage le plus
        // tardif possible qui laisse encore demarrer la production a la date voulue.
        const limiteArrivage = sameDayMaterials ? debutProductionNaive : addCalendarDays(debutProductionNaive, -1);
        let arrivagePlusTardif = null;
        // Ingredients ET fournitures doivent etre la au demarrage : les deux peuvent
        // donc repousser la date de debut si leur fournisseur livre plus tard.
        [...ingredientConstraints, ...supplyConstraints].forEach(c => {
          const dernier = previousAllowedDate(limiteArrivage, c.deliveryDays);
          if (!arrivagePlusTardif || dernier > arrivagePlusTardif) arrivagePlusTardif = dernier;
        });
        matieresDisponibles = arrivagePlusTardif;
        // La production commence a la date visee, sauf si l'arrivage la repousse plus tard.
        const debutPossible = nextAllowedDate(sameDayMaterials ? arrivagePlusTardif : addCalendarDays(arrivagePlusTardif, 1), location.working_days);
        debutProduction = debutPossible > debutProductionNaive ? debutPossible : nextAllowedDate(debutProductionNaive, location.working_days);
        // Commande : la deadline propre a chaque fournisseur, avant son arrivage retenu.
        ingredientConstraints.forEach(c => {
          const arrivageReel = previousAllowedDate(matieresDisponibles, c.deliveryDays);
          const dateCommande = addCalendarDays(arrivageReel, -c.deadlineDaysBefore);
          if (!commandeFournisseur || dateCommande < commandeFournisseur) commandeFournisseur = dateCommande;
        });
      }
      finProduction = addWorkingDays(debutProduction, dureeReculee, location.working_days);
      if ((location.shipping_departure_days || []).length) {
        const depuis = sameDayShipping ? finProduction : addCalendarDays(finProduction, 1);
        finProduction = nextAllowedDate(depuis, location.shipping_departure_days);
      } else if (!sameDayShipping) {
        finProduction = nextAllowedDate(addCalendarDays(finProduction, 1), location.working_days);
      }

      // Regle absolue : aucune etape ne peut etre proposee dans le passe. Si c'est le cas,
      // le plan theorique est inatteignable, on repart d'aujourd'hui.
      // Fournitures : elles doivent etre disponibles des le DEBUT de la production.
      let commandeFournitures = null, receptionFournitures = null;
      supplyConstraints.forEach(sc => {
        const arrivage = previousAllowedDate(debutProduction, sc.deliveryDays);
        const dateCommande = addCalendarDays(arrivage, -sc.deadlineDaysBefore);
        if (!receptionFournitures || arrivage > receptionFournitures) receptionFournitures = arrivage;
        if (!commandeFournitures || dateCommande < commandeFournitures) commandeFournitures = dateCommande;
      });
      if (commandeFournitures && dateToStr(commandeFournitures) < todayISO()) {
        commandeFournitures = today;
        let arrivage = null;
        supplyConstraints.forEach(sc => {
          const premier = nextAllowedDate(addCalendarDays(today, sc.deadlineDaysBefore), sc.deliveryDays);
          if (!arrivage || premier > arrivage) arrivage = premier;
        });
        receptionFournitures = arrivage;
      }

      const premiereEtape = commandeFournisseur || matieresDisponibles || debutProduction;
      const replanifieAuPlusTot = Boolean(premiereEtape && dateToStr(premiereEtape) < todayISO());
      if (replanifieAuPlusTot) planifierAuPlusTot();

      const risqueDeRetard = dateSeuilAtteint && finProduction > dateSeuilAtteint;
      const commandeUrgente = replanifieAuPlusTot && !toutEnStock;
      const isUrgent = dateSeuilAtteint && dateToStr(dateSeuilAtteint) <= todayISO();

      return {
        recipe, location, currentStock, dailyRate, thresholdStock, dateSeuilAtteint, isUrgent,
        finProduction, debutProduction, matieresDisponibles, commandeFournisseur, commandeUrgente,
        quantiteRecommandee, fourneeDuration, risqueDeRetard, ingredientsSansFournisseur, ingredientsEnStock,
        toutEnStock, productionsEnCoursQty, aucuneActionRequise, cycleEngage,
        fournituresManquantes, fournituresSansFournisseur, fournituresTotal, transitDays, nbFournees, batchQty,
        commandeFournitures, receptionFournitures,
        arriveeClient: transitDays > 0 ? addCalendarDays(finProduction, transitDays) : finProduction,
        workingDays: location.working_days, replanifieAuPlusTot,
        deliveryDaysBySupplierIngredient: ingredientConstraints, shippingDepartureDays: location.shipping_departure_days
      };
    }).filter(Boolean).sort((a, b) => (a.dateSeuilAtteint || new Date(9999, 0)) - (b.dateSeuilAtteint || new Date(9999, 0)));

    return { rows, forecastRows, recipes, locationsById };
  }

  // Historique des modifications de coûts — alimenté par des déclencheurs
  // en base, donc exhaustif quelle que soit la façon dont la modification
  // a été faite.
  async function renderCostHistory() {
    const data = await fetchAllRows(() => sb.from("cost_change_log")
      .select("*").eq("organization_id", profile.organization_id)
      .order("changed_at", { ascending: false }));

    const TYPE_LABELS = {
      ingredient: "Ingrédient", supply: "Fourniture", recipe: "Recette",
      recipe_item: "Composition", recipe_location_cost: "Coût par emplacement",
      ingredient_location: "Prix par emplacement"
    };
    const TYPE_TONES = {
      ingredient: "info", supply: "warning", recipe: "success",
      recipe_item: "success", recipe_location_cost: "info", ingredient_location: "info"
    };

    const rows = (data || []).map(m => `<tr data-searchable>
        <td class="retro-nowrap">${formatDate(m.changed_at.slice(0, 10))}<div class="muted" style="font-size:11.5px">${m.changed_at.slice(11, 16)}</div></td>
        <td>${badge(TYPE_LABELS[m.entity_type] || m.entity_type, TYPE_TONES[m.entity_type] || "")}</td>
        <td><strong>${escapeHtml(m.entity_label || "—")}</strong></td>
        <td>${escapeHtml(m.field_label)}</td>
        <td class="retro-nowrap muted">${m.old_value == null ? "—" : escapeHtml(m.old_value)}</td>
        <td class="retro-nowrap"><strong>${m.new_value == null ? "—" : escapeHtml(m.new_value)}</strong></td>
        <td>${escapeHtml(m.changed_by_name || "—")}</td>
      </tr>`).join("");

    content.innerHTML = `
      <div class="help-inline">${helpTip("Chaque modification d'un prix, d'un coût de fabrication ou d'une composition de recette est enregistrée ici, avec son auteur. Les coûts d'un lot restent figés à sa création : une modification n'affecte que les lots produits ensuite.")}<span class="help-inline-label">À savoir</span></div>
      <div class="toolbar" style="margin-top:14px"><input id="cost-history-search" class="search" placeholder="Rechercher un produit, un champ, une personne…"><div class="toolbar-spacer"></div></div>
      <div class="table-wrap">${rows
        ? `<table class="retro-table"><thead><tr><th>Date</th><th>Type</th><th>Élément</th><th>Champ</th><th>Avant</th><th>Après</th><th>Par</th></tr></thead><tbody>${rows}</tbody></table>`
        : emptyState("Aucune modification enregistrée", "Le suivi démarre à l'installation : les changements antérieurs ne peuvent pas être reconstitués.")}</div>
    `;
    document.querySelector("#cost-history-search")?.addEventListener("input", e => {
      const q = e.target.value.trim().toLocaleLowerCase("fr");
      document.querySelectorAll("[data-searchable]").forEach(el => {
        el.hidden = Boolean(q) && !el.textContent.toLocaleLowerCase("fr").includes(q);
      });
    });
  }

  async function renderRetroplanning() {
    const { rows, forecastRows } = await computeRetroplanning();
    // Regroupe par emplacement de fabrication (un produit peut etre fabrique a plusieurs endroits)
    const rowsByLocation = new Map();
    rows.forEach((r, idx) => {
      if (!rowsByLocation.has(r.location.id)) rowsByLocation.set(r.location.id, { location: r.location, items: [] });
      rowsByLocation.get(r.location.id).items.push({ ...r, idx });
    });

    const tableRows = [...rowsByLocation.values()].map(group => {
      const body = group.items.map(r => `<tr data-searchable>
        <td><strong>${escapeHtml(r.recipe.name)}</strong></td>
        <td class="retro-nowrap">${formatNumber(r.currentStock)} ${escapeHtml(r.recipe.sale_unit || "u.")}${r.productionsEnCoursQty > 0 ? ` <span class="muted" style="font-size:11.5px">+${formatNumber(r.productionsEnCoursQty)} en prod.</span>` : ""}</td>
        <td class="retro-nowrap">${r.cycleEngage ? badge("Production engagée", "success") : (r.aucuneActionRequise ? badge("Couvert > 180 j.", "success") : (r.isUrgent ? badge("Seuil déjà atteint", "danger") : formatDate(dateToStr(r.dateSeuilAtteint))))}</td>
        <td class="retro-nowrap">${r.aucuneActionRequise ? "—" : (r.toutEnStock ? badge("MP + fournitures en stock", "success") : (r.commandeFournisseur ? `${formatDate(dateToStr(r.commandeFournisseur))}${r.commandeUrgente ? ` ${badge("Aujourd’hui", "danger")}` : ""}${r.fournituresManquantes > 0 ? ` ${badge(`${r.fournituresManquantes} fourn.`, "info")}` : ""}` : badge("Fournisseur manquant", "warning")))}</td>
        <td class="retro-nowrap">${r.aucuneActionRequise ? "—" : `${formatDate(dateToStr(r.debutProduction))}${r.risqueDeRetard ? ` ${badge("Retard", "warning")}` : ""}`}</td>
        <td class="retro-nowrap">${r.aucuneActionRequise ? "—" : `<strong>${formatNumber(r.quantiteRecommandee)}</strong> ${escapeHtml(r.recipe.sale_unit || "u.")}`}</td>
        <td class="retro-nowrap">${r.aucuneActionRequise ? "" : `<button type="button" class="button button-small button-secondary view-gantt" data-idx="${r.idx}">Planning</button>`}</td>
      </tr>`).join("");
      return `<tr class="retro-location-header"><td colspan="7"><span class="retro-location-name">${escapeHtml(group.location.name)}</span><span class="retro-location-count">${group.items.length} produit${group.items.length > 1 ? "s" : ""}</span></td></tr>${body}`;
    }).join("");

    content.innerHTML = `
      <div class="retro-section">
        <div class="retro-section-title retro-section-title-forecast">Prévisionnel${helpTip("Basé uniquement sur les commandes des 3 derniers mois, sans comparaison à l'historique lointain. La croissance et l'aléa se règlent à la main, produit par produit.")}</div>
        <div class="toolbar" style="margin-top:14px"><input id="forecast-search" class="search" placeholder="Rechercher un produit…"><div class="toolbar-spacer"></div></div>
        <div class="finished-list">
          <div class="finished-list-head forecast-row"><span>Produit</span><span class="finished-col-qty">3 derniers mois</span><span>Croissance</span><span>Aléa</span><span class="finished-col-qty">Stock actuel</span><span class="finished-col-qty">À produire</span></div>
          ${forecastRows || emptyState("Aucune recette", "")}
        </div>
      </div>

      <div class="retro-section retro-section-divider">
        <div class="retro-section-title retro-section-title-retro">Rétroplanning${helpTip("Recommandation basée sur le stock réel actuel, les commandes déjà saisies (prioritaires) et la tendance du Prévisionnel pour le reste. Recalculé à chaque consultation : rien n'est déclenché automatiquement, à toi de lancer la production le moment venu.")}</div>
        <div class="toolbar" style="margin-top:14px"><input id="retro-search" class="search" placeholder="Rechercher un produit…"><div class="toolbar-spacer"></div></div>
        <div class="table-wrap">${tableRows ? `<table class="retro-table"><thead><tr><th>Produit</th><th>Stock actuel</th><th>Seuil atteint le</th><th>Commander le</th><th>Début production</th><th>À produire</th><th></th></tr></thead><tbody>${tableRows}</tbody></table>` : emptyState("Aucune recette configurée", "Coche « Point de production » sur un emplacement, puis configure ses recettes via le bouton « Contraintes de production ».")}</div>
      </div>
    `;

    // Evenements — section Prévisionnel
    document.querySelector("#forecast-search")?.addEventListener("input", e => {
      const q = e.target.value.trim().toLocaleLowerCase("fr");
      document.querySelectorAll("[data-searchable-fc]").forEach(el => { el.hidden = Boolean(q) && !el.textContent.toLocaleLowerCase("fr").includes(q); });
    });
    document.querySelectorAll("[data-toggle]").forEach(btn => btn.addEventListener("click", () => {
      document.querySelector(`#${btn.dataset.toggle}`).classList.toggle("open");
      btn.querySelector(".chevron").classList.toggle("open");
    }));
    document.querySelectorAll(".save-forecast-settings").forEach(btn => btn.addEventListener("click", async () => {
      const recipeId = btn.dataset.recipeId;
      const targetDays = Number(document.querySelector(`.forecast-target-days[data-recipe-id="${recipeId}"]`).value || 30);
      const growthRaw = document.querySelector(`.forecast-manual-growth[data-recipe-id="${recipeId}"]`).value;
      const aleaRaw = document.querySelector(`.forecast-safety-margin[data-recipe-id="${recipeId}"]`).value;
      const { error: saveError } = await sb.from("recipes").update({
        target_stock_days: targetDays, manual_growth_rate: Number(growthRaw || 0) / 100, safety_margin_pct: Number(aleaRaw || 0) / 100
      }).eq("id", recipeId);
      if (saveError) return showError(saveError);
      showToast("Réglages enregistrés."); renderRetroplanning();
    }));

    // Evenements — section Rétroplanning
    document.querySelector("#retro-search")?.addEventListener("input", e => {
      const q = e.target.value.trim().toLocaleLowerCase("fr");
      document.querySelectorAll("[data-searchable]").forEach(el => { el.hidden = Boolean(q) && !el.textContent.toLocaleLowerCase("fr").includes(q); });
    });
    document.querySelectorAll(".view-gantt").forEach(btn => btn.addEventListener("click", () => retroplanningGanttModal(rows[Number(btn.dataset.idx)])));
  }

  function retroplanningGanttModal(plan) {
    const today = new Date(); today.setHours(0, 0, 0, 0);
    const dCommande = plan.commandeFournisseur;
    const dMatieres = plan.matieresDisponibles;
    const dDebut = plan.debutProduction;
    const dFin = plan.finProduction;
    const dDepart = plan.finProduction;

    const etapes = [dCommande, dMatieres, dDebut, dFin, dDepart, plan.arriveeClient, plan.dateSeuilAtteint, plan.commandeFournitures, plan.receptionFournitures].filter(Boolean);
    const rangeStart = addCalendarDays(new Date(Math.min(...etapes.map(d => d.getTime()))), -3);
    const rangeEnd = addCalendarDays(new Date(Math.max(...etapes.map(d => d.getTime()))), 3);
    const totalDays = Math.max(1, Math.round((rangeEnd - rangeStart) / 86400000) + 1);
    const dayList = Array.from({ length: totalDays }, (_, i) => addCalendarDays(rangeStart, i));
    const DOW_SHORT = ["D", "L", "M", "M", "J", "V", "S"];

    function dayHeader() {
      return dayList.map(d => {
        const isWeekend = d.getDay() === 0 || d.getDay() === 6;
        const isToday = dateToStr(d) === dateToStr(today);
        return `<div class="gantt-day-cell ${isWeekend ? "gantt-weekend" : ""} ${isToday ? "gantt-today" : ""}">
          <span class="gantt-day-dow">${DOW_SHORT[d.getDay()]}</span><span class="gantt-day-num">${d.getDate()}</span>
        </div>`;
      }).join("");
    }

    openModal({
      title: `${plan.recipe.name} — ${plan.location.name}`,
      kicker: "Planning",
      width: "min(1150px, 96vw)",
      html: `
        ${plan.replanifieAuPlusTot ? `<div class="warning-box"><strong>Le délai idéal est déjà passé.</strong> Ce planning est calculé <strong>au plus tôt à partir d’aujourd’hui</strong>. ${plan.toutEnStock ? `Les matières premières étant en stock, la production peut démarrer le ${formatDate(dateToStr(plan.debutProduction))}` : `En commandant aujourd’hui, la production démarrerait le ${formatDate(dateToStr(plan.debutProduction))}`} et se terminerait le ${formatDate(dateToStr(plan.finProduction))}.</div>` : ""}
        ${plan.isUrgent && !plan.replanifieAuPlusTot ? `<div class="warning-box">Le seuil de stock est déjà atteint aujourd’hui — cette production est prioritaire.</div>` : ""}
        ${plan.toutEnStock ? `<div class="help-box">Toutes les matières premières <strong>et les fournitures</strong> nécessaires sont déjà en stock sur cet emplacement — aucune commande n’est requise.</div>` : ""}
        ${plan.productionsEnCoursQty > 0 ? `<div class="help-box">${formatNumber(plan.productionsEnCoursQty)} ${escapeHtml(plan.recipe.sale_unit || "u.")} sont déjà en production — c’est pris en compte dans le calcul.</div>` : ""}
        ${plan.ingredientsSansFournisseur > 0 ? `<div class="help-box">${plan.ingredientsSansFournisseur} ingrédient(s) manquant(s) n’ont pas de fournisseur configuré sur cet emplacement — leur délai n’est pas pris en compte.</div>` : ""}
        ${plan.fournituresTotal === 0 ? `<div class="help-box">Aucune fourniture de conditionnement n’est reliée à cette recette — vérifie son conditionnement dans l’onglet Conditionnements pour que le rétroplanning en tienne compte.</div>` : ""}
        ${plan.fournituresManquantes > 0 ? `<div class="help-box">${plan.fournituresManquantes} fourniture(s) de conditionnement manquent sur cet emplacement${plan.fournituresSansFournisseur > 0 ? `, dont ${plan.fournituresSansFournisseur} sans fournisseur configuré (délai non pris en compte)` : ""}. Elles doivent être là avant la fin de production.</div>` : ""}

        <div class="grid grid-4" style="margin-bottom:22px">
          <div class="card metric-card"><small>Stock actuel</small><div class="metric">${formatNumber(plan.currentStock)}</div><div class="metric-detail">${escapeHtml(plan.recipe.sale_unit || "u.")}</div></div>
          <div class="card metric-card"><small>Rythme estimé</small><div class="metric">${formatNumber(plan.dailyRate, 1)}</div><div class="metric-detail">${escapeHtml(plan.recipe.sale_unit || "u.")} / jour</div></div>
          <div class="card metric-card"><small>Seuil cible (stock mini)</small><div class="metric">${formatNumber(plan.thresholdStock, 0)}</div><div class="metric-detail">${escapeHtml(plan.recipe.sale_unit || "u.")}</div></div>
          <div class="card metric-card"><small>Quantité à produire</small><div class="metric">${formatNumber(plan.quantiteRecommandee)}</div><div class="metric-detail">${escapeHtml(plan.recipe.sale_unit || "u.")} · ${plan.batchQty > 0 ? `${plan.nbFournees} fournée(s) de ${formatNumber(plan.batchQty)}` : "sans arrondi"} · ${plan.fourneeDuration} j.</div></div>
        </div>

        <div class="gantt-wrap">
          <div class="gantt-row"><div class="gantt-row-label"></div><div class="gantt-row-cells" style="display:grid;grid-template-columns:repeat(${totalDays},1fr);gap:3px">${dayHeader()}</div></div>
          ${dCommande ? ganttStepRow("Commande ingrédients", "gantt-color-order", dCommande, "gantt-color-order", dayList, today) : ""}
          ${ganttStepRow("Réception ingrédients", "gantt-color-materials", dMatieres, "gantt-color-materials", dayList, today)}
          ${plan.commandeFournitures ? ganttStepRow("Commande fournitures", "gantt-color-supply-order", plan.commandeFournitures, "gantt-color-supply-order", dayList, today) : ""}
          ${plan.receptionFournitures ? ganttStepRow("Réception fournitures", "gantt-color-supply", plan.receptionFournitures, "gantt-color-supply", dayList, today)
            : (plan.fournituresManquantes > 0 ? ganttStepRow("Fournitures nécessaires", "gantt-color-supply", plan.debutProduction, "gantt-color-supply", dayList, today) : "")}
          ${ganttProductionRow("Production", "gantt-color-production", dDebut, dFin, plan.workingDays, dayList, today)}
          ${ganttStepRow("Départ de l’atelier", "gantt-color-target", dDepart, "gantt-color-target", dayList, today)}
          ${plan.transitDays > 0 ? ganttStepRow("Arrivée chez le client", "gantt-color-client", plan.arriveeClient, "gantt-color-client", dayList, today) : ""}
        </div>

        `
    });

  }

  function ganttStepRow(label, icon, actualDate, colorClass, dayList, today, actionsHtml = "") {
    const cells = dayList.map(d => {
      const isActual = dateToStr(d) === dateToStr(actualDate);
      const isToday = dateToStr(d) === dateToStr(today);
      return `<div class="gantt-cell ${isActual ? `gantt-cell-actual ${colorClass}` : "gantt-cell-empty"} ${isToday ? "gantt-cell-today" : ""}" title="${formatDate(dateToStr(d))}"></div>`;
    }).join("");
    return `<div class="gantt-row"><div class="gantt-row-label"><span class="gantt-legend-dot ${icon}"></span> ${escapeHtml(label)} <span class="muted" style="font-weight:400;font-size:11px">(${formatDate(dateToStr(actualDate))})</span>${actionsHtml ? `<div class="gantt-step-actions">${actionsHtml}</div>` : ""}</div><div class="gantt-row-cells" style="display:grid;grid-template-columns:repeat(${dayList.length},1fr);gap:3px">${cells}</div></div>`;
  }

  function ganttProductionRow(label, icon, from, to, workingDays, dayList, today, actionsHtml = "") {
    const cells = dayList.map(d => {
      const inSpan = d >= from && d <= to;
      const isWorking = isAllowedDay(d, workingDays);
      const isToday = dateToStr(d) === dateToStr(today);
      return `<div class="gantt-cell ${inSpan && isWorking ? "gantt-cell-actual gantt-color-production" : "gantt-cell-empty"} ${isToday ? "gantt-cell-today" : ""}" title="${formatDate(dateToStr(d))}"></div>`;
    }).join("");
    return `<div class="gantt-row"><div class="gantt-row-label"><span class="gantt-legend-dot ${icon}"></span> ${escapeHtml(label)} <span class="muted" style="font-weight:400;font-size:11px">(${formatDate(dateToStr(from))} → ${formatDate(dateToStr(to))})</span>${actionsHtml ? `<div class="gantt-step-actions">${actionsHtml}</div>` : ""}</div><div class="gantt-row-cells" style="display:grid;grid-template-columns:repeat(${dayList.length},1fr);gap:3px">${cells}</div></div>`;
  }


  async function renderFinishedLots() {
    const canEdit = pageCan("finished-lots");
    setHeader("finished-lots", canEdit ? `<button id="add-finished-lot" class="button button-primary">＋ Ajout manuel</button>` : "");
    const { error: accrualError } = await sb.rpc("accrue_pallet_storage_costs");
    if (accrualError) console.error("Accrual coût de stockage :", accrualError.message);
    const [allLots, allLocations, allRecipes, thresholds] = await Promise.all([
      fetchFinishedLots(), fetchLocations(),
      sb.from("recipes").select("id,name,sale_unit,recipe_categories(name,sort_order)").eq("organization_id", profile.organization_id).order("name").then(r => r.data || []),
      fetchFinishedThresholds()
    ]);
    const byLocation = groupFinishedLotsByLocation(allLots, allLocations);

    document.querySelector("#add-finished-lot")?.addEventListener("click", () => manualFinishedLotModal());

    if (finishedGoodsLocationKey && byLocation.has(finishedGoodsLocationKey)) {
      const entry = byLocation.get(finishedGoodsLocationKey);
      if (entry.location.is_external_logistics) {
        renderExternalLogisticsLocationPage(entry.location);
      } else {
        renderFinishedLotsLocationPage(entry, allLocations, allRecipes, thresholds);
      }
      return;
    }

    // Résumé global : valeur totale, alertes DDM, stock critique (produit x emplacement sous son seuil)
    let criticalCount = 0;
    [...byLocation.entries()].forEach(([key, { lots }]) => {
      if (key === "none") return;
      const byRecipeQty = new Map();
      lots.forEach(lot => byRecipeQty.set(lot.recipe_id, (byRecipeQty.get(lot.recipe_id) || 0) + Number(lot.quantity_remaining || 0)));
      allRecipes.forEach(recipe => {
        const threshold = thresholds.get(`${recipe.id}:${key}`);
        if (threshold == null) return;
        const qty = byRecipeQty.get(recipe.id) || 0;
        if (qty <= threshold) criticalCount += 1;
      });
    });
    const globalSummary = computeFinishedGoodsSummary(allLots, allRecipes, thresholds, null);
    globalSummary.criticalCount = criticalCount;

    const entries = [...byLocation.values()];
    const cards = entries.map(({ location, lots }) => {
      const totalQty = lots.reduce((sum, lot) => sum + Number(lot.quantity_remaining || 0), 0);
      const locValue = lots.reduce((sum, lot) => sum + Number(lot.quantity_remaining || 0) * finishedLotUnitCost(lot), 0);
      const hasAlert = lots.some(lot => lot.expiry_date && lot.expiry_date <= plusDaysISO(60) && Number(lot.quantity_remaining) > 0);
      const byRecipeQty = new Map();
      lots.forEach(lot => byRecipeQty.set(lot.recipe_id, (byRecipeQty.get(lot.recipe_id) || 0) + Number(lot.quantity_remaining || 0)));
      const hasCritical = location.id && allRecipes.some(recipe => {
        const threshold = thresholds.get(`${recipe.id}:${location.id}`);
        return threshold != null && (byRecipeQty.get(recipe.id) || 0) <= threshold;
      });
      return `<article class="card location-summary-card" data-location-key="${location.id || "none"}">
        <div class="location-summary-head">
          <h3 class="location-summary-name">${escapeHtml(location.name)} ${location.is_external_logistics ? badge("Logistique externe", "purple") : ""}</h3>
          <div class="stock-badges">
            ${hasCritical ? `<span class="stock-dot stock-dot-critical" title="Stock critique sur au moins un produit">!</span>` : ""}
            ${hasAlert ? `<span class="stock-dot stock-dot-warning" title="DDM proche sur au moins un lot">!</span>` : ""}
          </div>
        </div>
        <div class="location-summary-meta">${formatNumber(totalQty)} unités · ${lots.length} lot${lots.length > 1 ? "s" : ""} · Valeur : ${formatMoneyRoundUp(locValue)}</div>
        <button type="button" class="button button-secondary button-full view-location-products" data-key="${location.id || "none"}" style="margin-top:10px">Voir les produits</button>
      </article>`;
    }).join("");

    content.innerHTML = `
      ${renderFinishedSummaryCards(globalSummary)}
      <div id="finished-grid" class="grid grid-3">${cards || emptyState("Aucun emplacement", "Créez un emplacement dans Paramètres pour commencer.")}</div>`;

    document.querySelectorAll(".view-location-products").forEach(btn => btn.addEventListener("click", () => {
      finishedGoodsLocationKey = btn.dataset.key;
      renderFinishedLots();
    }));
  }

  function renderFinishedLotsLocationPage(entry, allLocations, allRecipes, thresholds) {
    const { location, lots } = entry;
    const byRecipe = new Map();
    allRecipes.forEach(recipe => byRecipe.set(recipe.id, { recipe, lots: [] }));
    lots.forEach(lot => {
      if (!lot.recipe_id) return;
      if (!byRecipe.has(lot.recipe_id)) byRecipe.set(lot.recipe_id, { recipe: lot.recipes, lots: [] });
      byRecipe.get(lot.recipe_id).lots.push(lot);
    });
    // Par catégorie (ordre des paramètres), puis par nom
    const categoryOf = pr => pr.recipe?.recipe_categories || null;
    const products = [...byRecipe.values()].sort((a, b) =>
      compareCategories(categoryOf(a), categoryOf(b)) || (a.recipe?.name || "").localeCompare(b.recipe?.name || "", "fr"));
    // Intitulé de catégorie au-dessus du premier produit de chaque groupe
    const categoryHeader = (idx, cls) => {
      const cat = categoryOf(products[idx]);
      const prev = idx > 0 ? categoryOf(products[idx - 1]) : undefined;
      if (idx > 0 && (prev?.name || "") === (cat?.name || "")) return "";
      return `<div class="${cls}">${escapeHtml(cat ? cat.name : "Sans catégorie")}</div>`;
    };
    const canEditThreshold = pageCan("finished-lots") && location.id;
    const locationSummary = computeFinishedGoodsSummary(lots, allRecipes, thresholds, location.id);

    const listRows = products.map(({ recipe, lots: prodLots }, idx) => {
      const totalQty = prodLots.reduce((sum, lot) => sum + Number(lot.quantity_remaining || 0), 0);
      const hasAlert = prodLots.some(lot => lot.expiry_date && lot.expiry_date <= plusDaysISO(60) && Number(lot.quantity_remaining) > 0);
      const threshold = location.id ? thresholds.get(`${recipe.id}:${location.id}`) : null;
      const isCritical = threshold != null && totalQty <= threshold;
      const lotRows = prodLots.map(lot => `<div class="fifo-lot-row">
        <span class="fifo-tag">FIFO</span>
        <span class="lot-pill">${escapeHtml(lot.lot_number || "Sans lot")}</span>
        <span class="fifo-qty">${formatNumber(lot.quantity_remaining)} ${escapeHtml(recipe?.sale_unit || "unités")}</span>
        <span class="fifo-dates muted">${lot.produced_at ? formatDate(lot.produced_at) : "—"} → <span class="${lot.expiry_date && lot.expiry_date <= plusDaysISO(60) ? "fifo-date-alert" : "fifo-date-ok"}">${lot.expiry_date ? formatDate(lot.expiry_date) : "—"}</span></span>
        <button type="button" class="icon-button icon-small edit-finished-lot" data-id="${lot.id}" title="Modifier ce lot">✎</button>
      </div>`).join("");
      return categoryHeader(idx, "fg-category-title") + `<div data-searchable data-product-row>
        <div class="finished-product-row">
          <button type="button" class="product-row-toggle" data-toggle="fg-product-${idx}">
            <span class="chevron">▾</span>
            <strong>${escapeHtml(recipe?.name || "—")}</strong>
            ${isCritical ? `<span class="stock-dot stock-dot-critical" title="Stock critique">!</span>` : ""}
          </button>
          <span class="finished-col-qty">${formatNumber(totalQty)} ${escapeHtml(recipe?.sale_unit || "unités")}</span>
          <span class="finished-col-lots">${badge(`${prodLots.length} lot${prodLots.length > 1 ? "s" : ""}`)}</span>
          <span class="finished-col-exp">${hasAlert ? badge("Alerte", "warning") : badge("OK", "success")}</span>
          <span class="finished-col-threshold">
            ${canEditThreshold ? `<button type="button" class="button button-small button-ghost set-threshold" data-recipe-id="${recipe.id}" title="Définir le seuil critique">${threshold != null ? formatNumber(threshold) : "Seuil"}</button>` : (threshold != null ? `<span class="muted" style="font-size:12px">Seuil : ${formatNumber(threshold)}</span>` : "")}
          </span>
        </div>
        <div class="fifo-lot-list" id="fg-product-${idx}">
          <div class="fifo-lot-list-title muted">📦 LOTS (FIFO)</div>
          ${lotRows || `<p class="muted" style="padding:8px 0">Aucun lot sur cet emplacement.</p>`}
        </div>
      </div>`;
    }).join("");

    const gridCards = products.map(({ recipe, lots: prodLots }, idx) => {
      const totalQty = prodLots.reduce((sum, lot) => sum + Number(lot.quantity_remaining || 0), 0);
      const threshold = location.id ? thresholds.get(`${recipe.id}:${location.id}`) : null;
      const isCritical = threshold != null && totalQty <= threshold;
      return categoryHeader(idx, "fg-category-title fg-category-title-grid") + `<article class="card" data-searchable>
        <div class="stock-card-head"><h3>${escapeHtml(recipe?.name || "—")}</h3>${isCritical ? `<span class="stock-dot stock-dot-critical" title="Stock critique">!</span>` : ""}</div>
        <div class="stock-card-qty">${formatNumber(totalQty)} ${escapeHtml(recipe?.sale_unit || "unités")}</div>
        <div class="muted">${prodLots.length} lot${prodLots.length > 1 ? "s" : ""}</div>
        ${canEditThreshold ? `<button type="button" class="button button-small button-ghost set-threshold" data-recipe-id="${recipe.id}" style="margin-top:8px">${threshold != null ? formatNumber(threshold) : "Définir un seuil"}</button>` : ""}
      </article>`;
    }).join("");

    content.innerHTML = `
      ${renderFinishedSummaryCards(locationSummary)}
      <div class="finished-page-head">
        <button type="button" id="finished-back" class="icon-button" title="Retour">←</button>
        <span class="location-pill-lg">${escapeHtml(location.name)}</span>
        <div class="toolbar-spacer"></div>
        <div class="view-toggle">
          <button type="button" class="mode-btn ${finishedGoodsViewMode === "list" ? "active" : ""}" data-fg-view="list">☰</button>
          <button type="button" class="mode-btn ${finishedGoodsViewMode === "grid" ? "active" : ""}" data-fg-view="grid">▦</button>
        </div>
        ${lots.length ? `<button type="button" id="open-transfer-drawer" class="button button-primary">→ Transférer</button>` : ""}
        ${lots.length && !location.is_external_logistics ? `<button type="button" id="send-to-logistician" class="button button-secondary">📦 Envoyer chez le logisticien</button>` : ""}
      </div>
      <div class="toolbar" style="margin-top:14px">
        <input id="finished-search" class="search" placeholder="Rechercher un produit…">
      </div>
      ${finishedGoodsViewMode === "list"
        ? `<div class="finished-list">
            <div class="finished-list-head"><span>Produit</span><span class="finished-col-qty">Quantité</span><span class="finished-col-lots">Lots</span><span class="finished-col-exp">Expiration</span><span class="finished-col-threshold">Seuil critique</span></div>
            ${listRows || emptyState("Aucun produit", "")}
          </div>`
        : `<div class="grid grid-3">${gridCards || emptyState("Aucun produit", "")}</div>`}
    `;

    document.querySelector("#finished-back").addEventListener("click", () => {
      finishedGoodsLocationKey = null;
      renderFinishedLots();
    });
    document.querySelectorAll("[data-fg-view]").forEach(btn => btn.addEventListener("click", () => {
      finishedGoodsViewMode = btn.dataset.fgView;
      renderFinishedLotsLocationPage(entry, allLocations, allRecipes, thresholds);
    }));
    document.querySelector("#finished-search").addEventListener("input", event => {
      const q = event.target.value.trim().toLocaleLowerCase("fr");
      document.querySelectorAll("[data-searchable]").forEach(el => {
        el.hidden = Boolean(q) && !el.textContent.toLocaleLowerCase("fr").includes(q);
      });
    });
    document.querySelectorAll("[data-toggle]").forEach(btn => btn.addEventListener("click", () => {
      document.querySelector(`#${btn.dataset.toggle}`).classList.toggle("open");
      btn.querySelector(".chevron").classList.toggle("open");
    }));
    document.querySelectorAll(".edit-finished-lot").forEach(btn => btn.addEventListener("click", () => {
      editFinishedLotModal(lots.find(l => l.id === btn.dataset.id));
    }));
    document.querySelectorAll(".set-threshold").forEach(btn => btn.addEventListener("click", () => {
      const recipe = allRecipes.find(r => r.id === btn.dataset.recipeId);
      setFinishedThresholdModal(recipe, location, thresholds.get(`${btn.dataset.recipeId}:${location.id}`));
    }));
    document.querySelector("#open-transfer-drawer")?.addEventListener("click", () => {
      transferFinishedLotsDrawer(lots, allLocations, location);
    });
    document.querySelector("#send-to-logistician")?.addEventListener("click", () => sendPalletModal(lots, location));
  }

  function setFinishedThresholdModal(recipe, location, currentThreshold) {
    openModal({
      title: "Seuil de stock critique",
      kicker: `${recipe.name} — ${location.name}`,
      html: `<form id="threshold-form" class="form-grid">
        <div class="span-2"><label>Seuil critique (${escapeHtml(recipe.sale_unit || "unités")}) * ${helpTip("En dessous ou à cette quantité sur cet emplacement, ce produit sera signalé comme \"Stock critique\".")}</label><input name="threshold" type="number" min="0" step="0.001" required value="${currentThreshold ?? 0}"></div>
        <div class="form-actions span-2"><button type="button" class="button button-ghost" data-close-modal>Annuler</button><button class="button button-primary" type="submit">Enregistrer</button></div>
      </form>`
    });
    modalBody.querySelector("[data-close-modal]").addEventListener("click", closeModal);
    modalBody.querySelector("#threshold-form").addEventListener("submit", async event => {
      event.preventDefault();
      const button = event.submitter; submitButtonLoading(button, true);
      const values = formObject(event.currentTarget);
      const { error } = await sb.from("finished_stock_thresholds").upsert({
        organization_id: profile.organization_id, recipe_id: recipe.id, location_id: location.id, threshold: Number(values.threshold)
      }, { onConflict: "recipe_id,location_id" });
      submitButtonLoading(button, false);
      if (error) return showError(error);
      closeModal(); showToast("Seuil enregistré."); renderFinishedLots();
    });
  }

  function editFinishedLotModal(lot) {
    if (!lot) return;
    openModal({
      title: "Modifier le lot",
      kicker: lot.recipes?.name || "",
      html: `<form id="edit-finished-lot-form" class="form-grid">
        <div><label>Numéro de lot</label><input name="lot_number" value="${escapeHtml(lot.lot_number || "")}" placeholder="Laisser vide si sans lot"></div>
        <div><label>Quantité restante *</label><input name="quantity_remaining" type="number" min="0" step="0.001" required value="${lot.quantity_remaining}"></div>
        <div><label>Date de production</label><input name="produced_at" type="date" value="${lot.produced_at || ""}"></div>
        <div><label>DDM</label><input name="expiry_date" type="date" value="${lot.expiry_date || ""}"></div>
        <div class="span-2"><label>Motif de l’ajustement (obligatoire si la quantité change)</label><input name="reason" placeholder="Recomptage, casse, erreur de saisie…"></div>
        <p class="form-note span-2">Toute variation de quantité est enregistrée dans les mouvements de stock, avec son motif.</p>
        <div class="form-actions span-2"><button type="button" class="button button-ghost" data-close-modal>Annuler</button><button class="button button-primary" type="submit">Enregistrer</button></div>
      </form>`
    });
    modalBody.querySelector("[data-close-modal]").addEventListener("click", closeModal);
    modalBody.querySelector("#edit-finished-lot-form").addEventListener("submit", async event => {
      event.preventDefault();
      const button = event.submitter;
      const values = formObject(event.currentTarget);
      if (Number(values.quantity_remaining) !== Number(lot.quantity_remaining) && !values.reason?.trim()) {
        return showToast("Indique le motif de l’ajustement.", "error");
      }
      submitButtonLoading(button, true);
      // Passe par une fonction dédiée : la table n'autorise pas
      // l'écriture directe, qui échouait sans message.
      const { error } = await sb.rpc("update_finished_lot", {
        p_lot_id: lot.id,
        p_lot_number: values.lot_number.trim() || null,
        p_quantity_remaining: Number(values.quantity_remaining),
        p_produced_at: values.produced_at || null,
        p_expiry_date: values.expiry_date || null,
        p_reason: values.reason?.trim() || null
      });
      submitButtonLoading(button, false);
      if (error) return showError(error);
      showToast("Lot mis à jour."); closeModal(); renderFinishedLots();
    });
  }

  function transferFinishedLotsDrawer(lots, allLocations, currentLocation) {
    const available = lots.filter(lot => Number(lot.quantity_remaining) > 0);
    if (!available.length) return showToast("Aucun lot disponible à transférer.", "error");
    const destinations = allLocations.filter(loc => loc.id !== currentLocation.id);

    const lotRows = available.map(lot => `<div class="transfer-lot-row">
      <input type="checkbox" name="lot_ids" value="${lot.id}" data-max="${lot.quantity_remaining}">
      <span class="transfer-lot-info">
        <span class="lot-pill">${escapeHtml(lot.lot_number || "Sans lot")}</span>
        <strong>${escapeHtml(lot.recipes?.name || "—")}</strong>
        <div class="muted">Stock : ${formatNumber(lot.quantity_remaining)} ${escapeHtml(lot.recipes?.sale_unit || "unités")}</div>
      </span>
      <input type="number" class="transfer-lot-qty" name="qty_${lot.id}" min="0.001" step="0.001" max="${lot.quantity_remaining}" value="${lot.quantity_remaining}" disabled>
    </div>`).join("");

    openDrawer({
      title: "Transférer du stock",
      kicker: currentLocation.name,
      html: `<form id="transfer-drawer-form">
        <div class="drawer-section-title">📦 Lots à transférer <button type="button" id="select-all-lots" class="link-button">Tout sélectionner</button></div>
        <div class="transfer-lot-list">${lotRows}</div>
        <p id="selected-count" class="muted" style="margin:8px 0 0">0 lot sélectionné</p>

        <div class="drawer-section-title" style="margin-top:24px">⚙ Mode</div>
        <div class="checkbox-row"><label class="switch"><input type="checkbox" id="write-off-toggle"><span class="switch-slider"></span></label><span>Sortie de stock (perte, échantillon, don)</span></div>

        <div id="destination-block" class="drawer-section-title" style="margin-top:24px">📍 Destination</div>
        <div id="destination-field">
          <label>Vers l’emplacement *</label>
          <select name="destination_location_id">
            <option value="">Sélectionner…</option>
            ${destinations.map(loc => `<option value="${loc.id}">${escapeHtml(loc.name)}</option>`).join("")}
          </select>
        </div>
        <div id="write-off-field" class="hidden">
          <label>Type de sortie *</label>
          <select name="write_off_type">
            <option value="perte">Perte</option>
            <option value="echantillon">Échantillon</option>
            <option value="don">Don</option>
          </select>
          <label style="margin-top:10px">Précision (optionnel)</label>
          <input name="reason" placeholder="Ex : casse, dégustation client…">
        </div>
        <div id="transport-field" style="margin-top:14px">
          <label>Coût de transport (€)</label>
          <input name="transport_cost" type="number" min="0" step="0.01" value="0">
        </div>

        <div class="form-actions" style="margin-top:24px"><button type="button" class="button button-ghost" data-close-drawer>Annuler</button><button class="button button-primary" type="submit">Valider</button></div>
      </form>`
    });

    const drawerForm = drawerBody.querySelector("#transfer-drawer-form");
    drawerBody.querySelector("[data-close-drawer]").addEventListener("click", closeDrawer);
    const checkboxes = () => [...drawerForm.querySelectorAll('input[name="lot_ids"]')];
    const qtyFieldFor = cb => drawerForm.querySelector(`input[name="qty_${cb.value}"]`);
    const updateCount = () => { drawerBody.querySelector("#selected-count").textContent = `${checkboxes().filter(c => c.checked).length} lot(s) sélectionné(s)`; };
    checkboxes().forEach(cb => cb.addEventListener("change", () => {
      qtyFieldFor(cb).disabled = !cb.checked;
      updateCount();
    }));
    drawerBody.querySelector("#select-all-lots").addEventListener("click", () => {
      const allChecked = checkboxes().every(c => c.checked);
      checkboxes().forEach(c => { c.checked = !allChecked; qtyFieldFor(c).disabled = allChecked; });
      updateCount();
    });
    const writeOffToggle = drawerBody.querySelector("#write-off-toggle");
    writeOffToggle.addEventListener("change", () => {
      drawerBody.querySelector("#destination-field").classList.toggle("hidden", writeOffToggle.checked);
      drawerBody.querySelector("#write-off-field").classList.toggle("hidden", !writeOffToggle.checked);
      drawerBody.querySelector("#transport-field").classList.toggle("hidden", writeOffToggle.checked);
    });

    drawerForm.addEventListener("submit", async event => {
      event.preventDefault();
      const button = event.submitter; submitButtonLoading(button, true);
      try {
        const selectedBoxes = checkboxes().filter(c => c.checked);
        if (!selectedBoxes.length) throw new Error("Sélectionnez au moins un lot.");
        const values = formObject(event.currentTarget);
        const isWriteOff = writeOffToggle.checked;
        if (!isWriteOff && !values.destination_location_id) throw new Error("Choisissez un emplacement de destination.");

        if (isWriteOff) {
          for (const cb of selectedBoxes) {
            const lot = available.find(l => l.id === cb.value);
            const qty = Number(qtyFieldFor(cb).value);
            if (!qty || qty <= 0) throw new Error(`Indiquez une quantité pour ${lot.recipes?.name || "ce lot"}.`);
            if (qty > Number(lot.quantity_remaining)) throw new Error(`Quantité trop élevée pour ${lot.recipes?.name || "ce lot"}.`);
            const { error } = await sb.rpc("write_off_finished_lot", {
              p_finished_lot_id: cb.value,
              p_quantity: qty,
              p_reason: values.reason?.trim() || null
            });
            if (error) throw error;
            await sb.rpc("log_stock_movement", {
              p_movement_type: values.write_off_type, p_item_kind: "finished_good", p_item_name: lot.recipes?.name || "—",
              p_lot_number: lot.lot_number || null, p_expiry_date: lot.expiry_date || null,
              p_quantity: qty, p_unit: lot.recipes?.sale_unit || null,
              p_origin_location_id: currentLocation.id || null, p_destination_location_id: null, p_reason: values.reason?.trim() || null
            });
          }
        } else {
          const items = selectedBoxes.map(cb => {
            const lot = available.find(l => l.id === cb.value);
            const qty = Number(qtyFieldFor(cb).value);
            if (!qty || qty <= 0) throw new Error(`Indiquez une quantité pour ${lot.recipes?.name || "ce lot"}.`);
            if (qty > Number(lot.quantity_remaining)) throw new Error(`Quantité trop élevée pour ${lot.recipes?.name || "ce lot"}.`);
            return { finished_lot_id: cb.value, quantity: qty };
          });
          const { error } = await sb.rpc("transfer_finished_lots_batch", {
            p_items: items,
            p_destination_location_id: values.destination_location_id,
            p_transport_cost: values.transport_cost ? Number(values.transport_cost) : 0
          });
          if (error) throw error;
          for (const cb of selectedBoxes) {
            const lot = available.find(l => l.id === cb.value);
            await sb.rpc("log_stock_movement", {
              p_movement_type: "transfert", p_item_kind: "finished_good", p_item_name: lot.recipes?.name || "—",
              p_lot_number: lot.lot_number || null, p_expiry_date: lot.expiry_date || null,
              p_quantity: Number(qtyFieldFor(cb).value), p_unit: lot.recipes?.sale_unit || null,
              p_origin_location_id: currentLocation.id || null, p_destination_location_id: values.destination_location_id, p_reason: null
            });
          }
        }
        closeDrawer();
        showToast(isWriteOff ? "Sortie de stock enregistrée." : "Produits transférés.");
        renderFinishedLots();
      } catch (err) { showError(err); }
      finally { submitButtonLoading(button, false); }
    });
  }

  async function manualFinishedLotModal() {
    const [recipesRes, locationsList, allItems, costCtx] = await Promise.all([
      sb.from("recipes").select("id,name,code,sale_unit,yield_quantity,production_cost,material_loss_pct,recipe_categories(name,sort_order)").eq("organization_id", profile.organization_id).order("name"),
      fetchLocations(),
      fetchAllRows(() => sb.from("recipe_items").select("recipe_id, quantity, unit, ingredients(id, unit, purchase_price)")),
      loadRecipeCostContext()
    ]);
    if (recipesRes.error) return showError(recipesRes.error);
    const recipes = recipesRes.data || [];
    if (!recipes.length) return showToast("Créez d’abord une recette.", "error");
    const itemsByRecipe = new Map();
    (allItems || []).forEach(it => {
      if (!itemsByRecipe.has(it.recipe_id)) itemsByRecipe.set(it.recipe_id, []);
      itemsByRecipe.get(it.recipe_id).push(it);
    });
    // Coût proposé : dans un atelier de production, son propre coût ; dans un
    // entrepôt, le coût moyen des ateliers qui fabriquent réellement le produit.
    // Toujours avec le calcul unique de la fiche produit.
    const suggestCost = (recipeId, locationId) => {
      const recipe = recipes.find(r => r.id === recipeId);
      if (!recipe) return null;
      const items = itemsByRecipe.get(recipeId) || [];
      const site = costCtx.locations.find(l => l.id === locationId);
      if (site && site.is_production_site) {
        // Même calcul, restreint à cet atelier : une seule production fictive
        // le désigne comme unique atelier de référence
        const siteCtx = { ...costCtx, productionsOf: new Map([[recipeId, [{ recipe_id: recipeId, location_id: site.id, quantity_produced: 1, production_date: costCtx.since }]]]) };
        const one = computeRecipeCostProfile(recipe, items, siteCtx).locations[0];
        return { mp: one.mp, prod: one.prod, total: one.total, label: `coût de la fiche produit à ${site.name}` };
      }
      const prof = computeRecipeCostProfile(recipe, items, costCtx);
      return { mp: prof.mp, prod: prof.prod, total: prof.total, label: "coût moyen de la fiche produit" };
    };
    openModal({
      title: "Ajouter un produit fini",
      kicker: "Ajout manuel (hors production)",
      html: `<form id="manual-finished-form" class="form-grid">
        <div class="span-2"><label>Produit *</label><select name="recipe_id" id="manual-fg-recipe" required>${optionsByCategory(recipes, r => r.recipe_categories, r => `<option value="${r.id}">${escapeHtml(r.name)}${r.code ? ` — ${escapeHtml(r.code)}` : ""}</option>`, r => r.name)}</select></div>
        <div><label>Numéro de lot</label><input name="lot_number" placeholder="Laisser vide si sans lot"></div>
        <div><label>Quantité *</label><input name="quantity" type="number" min="0.001" step="0.001" required></div>
        <div><label>Date de production</label><input id="manual-fg-date" name="production_date" type="date" value="${todayISO()}"></div>
        <div><label>DDM</label><input id="manual-fg-expiry" name="expiry_date" type="date" value="${plusDaysISO(365)}"></div>
        <div class="span-2"><label>Emplacement</label><select name="location_id" id="manual-fg-location">${locationOptions(locationsList, null)}</select></div>
        <div class="span-2"><label>Coût de fabrication unitaire (€)</label><input id="manual-fg-cost" name="unit_cost" type="number" min="0" step="0.0001" placeholder="Laisser vide si inconnu">
          <p class="form-note" id="manual-fg-cost-note"></p></div>
        <div class="form-actions span-2"><button type="button" class="button button-ghost" data-close-modal>Annuler</button><button class="button button-primary" type="submit">Ajouter</button></div>
      </form>`
    });
    modalBody.querySelector("[data-close-modal]").addEventListener("click", closeModal);
    const dateField = modalBody.querySelector("#manual-fg-date");
    const expiryField = modalBody.querySelector("#manual-fg-expiry");
    let expiryAuto = true;
    expiryField.addEventListener("input", () => { expiryAuto = false; });
    dateField.addEventListener("change", () => { if (expiryAuto) expiryField.value = plusDaysISO(365, dateField.value); });
    const recipeSel = modalBody.querySelector("#manual-fg-recipe");
    const locationSel = modalBody.querySelector("#manual-fg-location");
    const costField = modalBody.querySelector("#manual-fg-cost");
    const costNote = modalBody.querySelector("#manual-fg-cost-note");
    let costAuto = true;
    const refreshCost = () => {
      const s = suggestCost(recipeSel.value, locationSel.value);
      if (!s || !(s.total > 0)) {
        costNote.textContent = "Aucun coût sur la fiche de ce produit : saisis-le si tu le connais.";
        if (costAuto) costField.value = "";
        return;
      }
      costNote.textContent = `Pré-rempli avec le ${s.label} : ${formatMoney(s.mp)} de matières + ${formatMoney(s.prod)} de production.`;
      if (costAuto) costField.value = Math.round(s.total * 10000) / 10000;
    };
    costField.addEventListener("input", () => { costAuto = false; });
    recipeSel.addEventListener("change", refreshCost);
    locationSel.addEventListener("change", refreshCost);
    refreshCost();
    modalBody.querySelector("#manual-finished-form").addEventListener("submit", async event => {
      event.preventDefault();
      const button = event.submitter; submitButtonLoading(button, true);
      try {
        const values = formObject(event.currentTarget);
        const { error } = await sb.rpc("create_manual_finished_lot", {
          p_recipe_id: values.recipe_id,
          p_lot_number: values.lot_number.trim() || null,
          p_quantity: Number(values.quantity),
          p_production_date: values.production_date || null,
          p_expiry_date: values.expiry_date || null,
          p_location_id: values.location_id || null,
          ...manualCostSplit(values.unit_cost, suggestCost(values.recipe_id, values.location_id || null))
        });
        if (error) throw error;
        closeModal(); showToast("Produit fini ajouté."); renderFinishedLots();
      } catch (err) { showError(err); }
      finally { submitButtonLoading(button, false); }
    });
  }

  // Clients
  async function clientDetailModal(client) {
    if (!client) return;
    const [{ data: deliveries, error }, { data: items, error: itemsError }] = await Promise.all([
      sb.from("deliveries").select("id, delivered_at, revenue_total, cost_total, delivery_count").eq("organization_id", profile.organization_id).eq("client_id", client.id).eq("status", "delivered").order("delivered_at"),
      sb.from("delivery_items").select("quantity, unit_price, deliveries!inner(client_id, organization_id, status), finished_lots(recipes(name, sale_unit))")
        .eq("deliveries.organization_id", profile.organization_id).eq("deliveries.client_id", client.id).eq("deliveries.status", "delivered")
    ]);
    if (error) throw error;
    if (itemsError) throw itemsError;

    const totalRevenue = deliveries.reduce((s, d) => s + Number(d.revenue_total || 0), 0);
    const totalOrders = deliveries.reduce((s, d) => s + Number(d.delivery_count || 1), 0);
    const panierMoyen = totalOrders ? totalRevenue / totalOrders : 0;

    const today = new Date(); today.setHours(0, 0, 0, 0);
    const last12MonthKeys = [];
    for (let i = 11; i >= 0; i--) {
      const d = new Date(today.getFullYear(), today.getMonth() - i, 1);
      last12MonthKeys.push(`${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}`);
    }
    const revenueByMonth = new Map();
    deliveries.forEach(d => {
      if (!d.delivered_at) return;
      const key = d.delivered_at.slice(0, 7);
      revenueByMonth.set(key, (revenueByMonth.get(key) || 0) + Number(d.revenue_total || 0));
    });
    const last12MonthsRevenue = last12MonthKeys.reduce((s, k) => s + (revenueByMonth.get(k) || 0), 0);
    const caMoyenMensuel = last12MonthsRevenue / 12;

    const cutoff12m = dateToStr(new Date(today.getFullYear(), today.getMonth() - 12, today.getDate()));
    const ordersLast12m = deliveries.filter(d => d.delivered_at >= cutoff12m).reduce((s, d) => s + Number(d.delivery_count || 1), 0);
    const avgIntervalDays = ordersLast12m > 0 ? 365 / ordersLast12m : null;
    const lastOrderDate = deliveries.length ? deliveries[deliveries.length - 1].delivered_at : null;
    const daysSinceLastOrder = lastOrderDate ? Math.round((today - new Date(`${lastOrderDate}T00:00:00`)) / 86400000) : null;
    const isSlowingDown = avgIntervalDays && daysSinceLastOrder != null && daysSinceLastOrder > avgIntervalDays * 1.5;

    const productStats = new Map();
    (items || []).forEach(i => {
      const name = i.finished_lots?.recipes?.name || "—";
      if (!productStats.has(name)) productStats.set(name, { qty: 0, revenue: 0, unit: i.finished_lots?.recipes?.sale_unit || "u." });
      const p = productStats.get(name);
      p.qty += Number(i.quantity || 0);
      p.revenue += Number(i.quantity || 0) * Number(i.unit_price || 0);
    });
    const productRows = [...productStats.entries()].sort((a, b) => b[1].revenue - a[1].revenue);

    const chartHtml = svgLineChart(
      last12MonthKeys.map(k => `${MONTH_LABELS[Number(k.slice(5, 7)) - 1]} ${k.slice(2, 4)}`),
      [{ name: "CA (HT)", values: last12MonthKeys.map(k => Math.round(revenueByMonth.get(k) || 0)), color: CHART_COLORS[0] }]
    );

    openModal({
      title: client.company || client.name,
      kicker: "Détail client",
      width: "820px",
      html: `
        <div class="detail-grid detail-grid-cost">
          <div><small>Panier moyen / commande</small><div class="detail-value">${formatMoney(panierMoyen)}</div></div>
          <div><small>CA moyen mensuel (12 derniers mois)</small><div class="detail-value">${formatMoney(caMoyenMensuel)}</div></div>
          <div><small>Fréquence de commande</small><div class="detail-value">${avgIntervalDays ? `~${formatNumber(avgIntervalDays, 0)} j.` : "—"}</div></div>
          <div><small>Dernière commande</small><div class="detail-value">${daysSinceLastOrder != null ? `il y a ${daysSinceLastOrder} j.` : "—"} ${isSlowingDown ? badge("Ralentit ?", "warning") : ""}</div></div>
        </div>
        <div class="form-section-title" style="margin-top:20px">📈 Évolution du CA — 12 derniers mois glissants</div>
        <div class="chart-wrap">${chartHtml}</div>
        <div class="form-section-title" style="margin-top:20px">📦 Produits commandés (historique complet)</div>
        <div class="table-wrap"><table><thead><tr><th>Produit</th><th>Quantité</th><th>CA généré</th></tr></thead><tbody>
          ${productRows.map(([name, p]) => `<tr><td>${escapeHtml(name)}</td><td>${formatNumber(p.qty)} ${escapeHtml(p.unit)}</td><td>${formatMoney(p.revenue)}</td></tr>`).join("") || `<tr><td colspan="3" class="muted" style="text-align:center;padding:16px">Aucune commande</td></tr>`}
        </tbody></table></div>
      `
    });
  }

  async function renderClients() {
    const canEdit = pageCan("clients");
    setHeader("clients", canEdit ? `<button id="add-client" class="button button-primary">＋ Ajouter un client</button>` : "");
    const [{ data: clients, error }, deliveries, clientCategoriesList] = await Promise.all([
      sb.from("clients").select("*, client_categories(name)").eq("organization_id", profile.organization_id).order("name"),
      fetchAllRows(() => sb.from("deliveries").select("client_id, revenue_total, cost_total, status, delivery_count").eq("organization_id", profile.organization_id).eq("status", "delivered")),
      fetchClientCategories()
    ]);
    if (error) throw error;

    const statsByClient = new Map();
    (deliveries || []).forEach(d => {
      if (!statsByClient.has(d.client_id)) statsByClient.set(d.client_id, { orders: 0, revenue: 0, cost: 0 });
      const s = statsByClient.get(d.client_id);
      s.orders += Number(d.delivery_count || 1);
      s.revenue += Number(d.revenue_total || 0);
      s.cost += Number(d.cost_total || 0);
    });

    const cards = (clients || []).map(client => {
      const stats = statsByClient.get(client.id) || { orders: 0, revenue: 0, cost: 0 };
      const marginEur = stats.revenue - stats.cost;
      const marginPct = stats.revenue ? (marginEur / stats.revenue) * 100 : 0;
      const isLost = Boolean(client.collaboration_end) && client.collaboration_end < todayISO();
      return `<article class="card client-card" data-searchable data-id="${client.id}" data-category-id="${client.category_id || ""}" data-status="${isLost ? "lost" : "active"}">
        <div class="client-card-badges">
          ${client.client_categories?.name ? `<span class="ref-badge">${escapeHtml(client.client_categories.name)}</span>` : ""}
          ${isLost ? badge("Perdu", "danger") : badge("Client", "success")}
        </div>
        <h3 class="client-card-name">${escapeHtml(client.company || client.name)}</h3>
        <div class="client-card-metrics">
          <div><small>Commandes livrées</small><div class="client-card-value">${stats.orders}</div></div>
          <div><small>CA généré</small><div class="client-card-value">${formatMoney(stats.revenue)}</div></div>
          <div><small>Marge moy.</small><div class="client-card-value">${formatMoney(marginEur)}</div></div>
          <div><small>Marge moy. %</small><div class="client-card-value">${formatNumber(marginPct, 0)}%</div></div>
        </div>
        <div class="stock-card-actions">
          <button class="icon-button icon-small view-client-detail" data-id="${client.id}" title="Voir le détail">${ICONS.eye}</button>
          ${canEdit ? `<button class="icon-button icon-small edit-client" data-id="${client.id}" title="Modifier">${ICONS.edit}</button>` : ""}
          ${canEdit ? `<button class="icon-button icon-small danger delete-client" data-id="${client.id}" title="Supprimer">${ICONS.trash}</button>` : ""}
        </div>
      </article>`;
    }).join("");

    content.innerHTML = `
      <div class="toolbar">
        <input id="clients-search" class="search" placeholder="Rechercher un client…">
        <select id="clients-category-filter" class="filter-select">
          <option value="">Toutes les catégories</option>
          ${clientCategoriesList.map(cat => `<option value="${cat.id}">${escapeHtml(cat.name)}</option>`).join("")}
        </select>
        <select id="clients-status-filter" class="filter-select">
          <option value="">Clients et perdus</option>
          <option value="active">Clients uniquement</option>
          <option value="lost">Perdus uniquement</option>
        </select>
        <div class="toolbar-spacer"></div>
      </div>
      <div id="clients-grid" class="grid grid-3">${cards || emptyState("Aucun client", "Ajoutez un client avant d’enregistrer une livraison.")}</div>`;

    function applyFilters() {
      const q = document.querySelector("#clients-search").value.trim().toLocaleLowerCase("fr");
      const categoryId = document.querySelector("#clients-category-filter").value;
      const statusFilter = document.querySelector("#clients-status-filter").value;
      document.querySelectorAll("#clients-grid [data-searchable]").forEach(el => {
        const matchesSearch = !q || el.textContent.toLocaleLowerCase("fr").includes(q);
        const matchesCategory = !categoryId || el.dataset.categoryId === categoryId;
        const matchesStatus = !statusFilter || el.dataset.status === statusFilter;
        el.hidden = !(matchesSearch && matchesCategory && matchesStatus);
      });
    }
    document.querySelector("#clients-search").addEventListener("input", applyFilters);
    document.querySelector("#clients-category-filter").addEventListener("change", applyFilters);
    document.querySelector("#clients-status-filter").addEventListener("change", applyFilters);
    document.querySelector("#add-client")?.addEventListener("click", () => clientModal());
    document.querySelectorAll(".view-client-detail").forEach(btn => btn.addEventListener("click", () => clientDetailModal(clients.find(item => item.id === btn.dataset.id))));
    document.querySelectorAll(".edit-client").forEach(btn => btn.addEventListener("click", () => clientModal(clients.find(item => item.id === btn.dataset.id))));
    document.querySelectorAll(".delete-client").forEach(btn => btn.addEventListener("click", async () => {
      if (!confirm("Supprimer ce client ?")) return;
      const { error: deleteError } = await sb.from("clients").delete().eq("id", btn.dataset.id);
      if (deleteError) return showError(deleteError);
      showToast("Client supprimé."); renderClients();
    }));
  }

  async function clientModal(client = null) {
    const [categoriesList, clientCategoriesList] = await Promise.all([fetchCategories(), fetchClientCategories()]);
    let categoryPrices = [];
    if (client) {
      const { data } = await sb.from("client_category_prices").select("category_id, unit_price").eq("client_id", client.id);
      categoryPrices = data || [];
    }
    const priceByCategory = new Map(categoryPrices.map(p => [p.category_id, p.unit_price]));

    openModal({
      title: client ? "Modifier le client" : "Nouveau client",
      kicker: "Répertoire commercial",
      width: "760px",
      html: `<form id="client-form" class="form-grid">
        <div class="span-2"><label>Entreprise *</label><input name="company" required value="${escapeHtml(client?.company || "")}" placeholder="Raison sociale"></div>
        <div><label>Nom du contact</label><input name="name" value="${escapeHtml(client?.name || "")}"></div>
        <div><label>Catégorie de client</label><select name="category_id"><option value="">Aucune</option>${clientCategoriesList.map(cat => `<option value="${cat.id}" ${client?.category_id === cat.id ? "selected" : ""}>${escapeHtml(cat.name)}</option>`).join("")}</select></div>
        <div><label>E-mail</label><input name="email" type="email" value="${escapeHtml(client?.email || "")}"></div>
        <div><label>Téléphone</label><input name="phone" value="${escapeHtml(client?.phone || "")}"></div>
        <div><label>SIRET</label><input name="siret" value="${escapeHtml(client?.siret || "")}"></div>
        <div><label>N° TVA intracommunautaire</label><input name="vat_number" value="${escapeHtml(client?.vat_number || "")}"></div>
        <div class="span-2"><label>Adresse</label><textarea name="address">${escapeHtml(client?.address || "")}</textarea></div>

        <div class="span-2 form-section-title">🤝 Collaboration</div>
        <div><label>Début de collaboration</label><input name="collaboration_start" type="date" value="${client?.collaboration_start || ""}"></div>
        <div><label>Fin de collaboration</label><input name="collaboration_end" type="date" value="${client?.collaboration_end || ""}"></div>

        <div class="span-2 form-section-title">€ Tarifs par défaut, par catégorie</div>
        <div class="span-2 help-inline">${helpTip("Pré-remplit le prix unitaire lors de la création d’une livraison pour ce client. Modifiable ligne par ligne à chaque livraison.")}<span class="help-inline-label">À savoir</span></div>
        ${categoriesList.map(cat => `<div><label>${escapeHtml(cat.name)} (€ HT / unité)</label><input name="cat_price_${cat.id}" type="number" min="0" step="0.01" value="${priceByCategory.get(cat.id) ?? ""}"></div>`).join("")}

        <div class="form-actions span-2"><button type="button" class="button button-ghost" data-close-modal>Annuler</button><button class="button button-primary" type="submit">Enregistrer</button></div>
      </form>
      ${client ? `<div id="recurring-orders-section" style="margin-top:8px"></div>` : `<div class="help-box" style="margin-top:16px">Enregistrez d’abord le client pour pouvoir lui ajouter une commande récurrente.</div>`}
      `
    });
    modalBody.querySelector("[data-close-modal]").addEventListener("click", closeModal);
    if (client) renderRecurringOrdersSection(client);
    modalBody.querySelector("#client-form").addEventListener("submit", async event => {
      event.preventDefault();
      const values = formObject(event.currentTarget);
      const payload = { organization_id: profile.organization_id, company: values.company.trim(), name: values.name.trim() || values.company.trim(), category_id: values.category_id || null, email: values.email.trim() || null, phone: values.phone.trim() || null, siret: values.siret.trim() || null, vat_number: values.vat_number.trim() || null, address: values.address.trim() || null, collaboration_start: values.collaboration_start || null, collaboration_end: values.collaboration_end || null };
      const button = event.submitter; submitButtonLoading(button, true);
      const query = client ? sb.from("clients").update(payload).eq("id", client.id).select().single() : sb.from("clients").insert(payload).select().single();
      const { data: saved, error } = await query;
      if (error) { submitButtonLoading(button, false); return showError(error); }
      for (const cat of categoriesList) {
        const raw = values[`cat_price_${cat.id}`];
        if (raw === "" || raw == null) continue;
        const { error: priceError } = await sb.from("client_category_prices").upsert({ client_id: saved.id, category_id: cat.id, unit_price: Number(raw) }, { onConflict: "client_id,category_id" });
        if (priceError) { submitButtonLoading(button, false); return showError(priceError); }
      }
      submitButtonLoading(button, false);
      if (!client) { showToast("Client enregistré."); renderClients(); clientModal(saved); return; }
      closeModal(); showToast("Client enregistré."); renderClients();
    });
  }

  const WEEKDAY_LABELS = ["Dimanche", "Lundi", "Mardi", "Mercredi", "Jeudi", "Vendredi", "Samedi"];

  async function renderRecurringOrdersSection(client) {
    const container = modalBody.querySelector("#recurring-orders-section");
    if (!container) return;
    const canEdit = pageCan("deliveries");
    const [{ data: orders, error }, shippingModes] = await Promise.all([
      sb.from("recurring_orders")
        .select("*, locations(name), recurring_order_items(quantity, unit_price, recipes(name, sale_unit))")
        .eq("client_id", client.id)
        .order("day_of_week"),
      fetchShippingModes()
    ]);
    if (error) return showError(error);
    const modeLabel = key => shippingModes.find(m => m.key === key)?.label || key;

    const rows = (orders || []).map(ro => {
      const itemsLabel = (ro.recurring_order_items || []).map(it => `${formatNumber(it.quantity)} ${escapeHtml(it.recipes?.name || "—")}`).join(", ");
      return `<div class="lot-row">
        <div class="lot-row-main">
          <div class="lot-row-title">${escapeHtml(WEEKDAY_LABELS[ro.day_of_week])} · ${escapeHtml(modeLabel(ro.shipping_mode))}${ro.locations?.name ? ` · ${escapeHtml(ro.locations.name)}` : ""} ${!ro.active ? badge("Suspendue") : ""}</div>
          <div class="muted" style="font-size:12.5px">${itemsLabel || "Aucun produit"}</div>
        </div>
        <div class="lot-row-actions">
          <button class="icon-button icon-small edit-recurring-order" data-id="${ro.id}" title="Modifier">${ICONS.edit}</button>
          <button class="icon-button icon-small danger delete-recurring-order" data-id="${ro.id}" title="Supprimer">${ICONS.trash}</button>
        </div>
      </div>`;
    }).join("");

    container.innerHTML = `
      <div class="form-section-title">🔁 Commandes récurrentes ${helpTip("Génère automatiquement une livraison « À préparer » avant chaque échéance, selon le délai de préparation habituel (Paramètres → Paramètres livraison). Tu complètes ensuite les vrais lots disponibles.")}</div>
      <div class="lot-list" style="margin-top:10px">${rows || `<p class="muted" style="padding:8px 0">Aucune récurrence pour ce client.</p>`}</div>
      ${canEdit ? `<button type="button" id="add-recurring-order" class="button button-secondary" style="margin-top:10px">${ICONS.plus} Ajouter une récurrence</button>` : ""}
    `;
    container.querySelector("#add-recurring-order")?.addEventListener("click", () => recurringOrderModal(client));
    container.querySelectorAll(".edit-recurring-order").forEach(btn => btn.addEventListener("click", () => recurringOrderModal(client, orders.find(o => o.id === btn.dataset.id))));
    container.querySelectorAll(".delete-recurring-order").forEach(btn => btn.addEventListener("click", async () => {
      if (!confirm("Supprimer cette commande récurrente ? Les livraisons déjà générées ne sont pas affectées.")) return;
      const { error: deleteError } = await sb.from("recurring_orders").delete().eq("id", btn.dataset.id);
      if (deleteError) return showError(deleteError);
      showToast("Récurrence supprimée."); renderRecurringOrdersSection(client);
    }));
  }

  async function recurringOrderModal(client, existing = null) {
    const [{ data: recipes }, allLocations, shippingModes] = await Promise.all([
      sb.from("recipes").select("id,name,sale_unit,recipe_categories(name,sort_order)").eq("organization_id", profile.organization_id).order("name"),
      fetchLocations(),
      fetchShippingModes()
    ]);
    if (!recipes?.length) return showToast("Créez d’abord une recette.", "error");
    if (!shippingModes.length) return showToast("Créez d’abord un mode d’expédition (Paramètres → Paramètres livraison).", "error");

    const lines = [];
    if (existing) {
      const { data: items } = await sb.from("recurring_order_items").select("id, quantity, unit_price, recipes(id,name,sale_unit)").eq("recurring_order_id", existing.id);
      (items || []).forEach(it => lines.push({ id: it.id, recipeId: it.recipes?.id, recipeName: it.recipes?.name || "—", saleUnit: it.recipes?.sale_unit || "", quantity: Number(it.quantity), unitPrice: Number(it.unit_price) }));
    }

    openModal({
      title: existing ? "Modifier la commande récurrente" : "Nouvelle commande récurrente",
      kicker: client.company || client.name,
      width: "620px",
      html: `<form id="recurring-order-form" class="form-grid">
        <div><label>Jour de la semaine *</label><select name="day_of_week">${WEEKDAY_LABELS.map((label, i) => `<option value="${i}" ${existing?.day_of_week === i ? "selected" : ""}>${label}</option>`).join("")}</select></div>
        <div><label>Mode d’expédition</label><select name="shipping_mode">
          ${shippingModes.map(m => `<option value="${m.key}" ${(existing ? existing.shipping_mode === m.key : m === shippingModes[0]) ? "selected" : ""}>${escapeHtml(m.label)}</option>`).join("")}
        </select></div>
        <div class="span-2"><label>Emplacement de départ *</label><select name="location_id" required><option value="">Sélectionner…</option>${allLocations.map(l => `<option value="${l.id}" ${existing?.location_id === l.id ? "selected" : ""}>${escapeHtml(l.name)}</option>`).join("")}</select></div>
        ${existing ? `<div class="checkbox-row span-2"><label class="switch"><input type="checkbox" name="active" ${existing.active ? "checked" : ""}><span class="switch-slider"></span></label><span>Récurrence active</span></div>` : ""}
      </form>
      <div class="form-section-title" style="margin-top:20px">☰ Produits commandés chaque semaine</div>
      <div class="form-grid">
        <div class="span-2"><label>Produit</label><select id="ro-recipe">${optionsByCategory(recipes, r => r.recipe_categories, r => `<option value="${r.id}">${escapeHtml(r.name)}</option>`, r => r.name)}</select></div>
        <div><label>Quantité</label><input id="ro-qty" type="number" min="0.001" step="0.001" value="1"></div>
        <div><label>Prix HT / unité (€)</label><input id="ro-price" type="number" min="0" step="0.01" value="0"></div>
        <div style="align-self:end"><button type="button" id="ro-add-line" class="button button-primary button-full">＋ Ajouter</button></div>
      </div>
      <div class="table-wrap" style="margin-top:12px"><table><thead><tr><th>Produit</th><th>Quantité</th><th>Prix HT</th><th></th></tr></thead><tbody id="ro-lines-body"></tbody></table></div>
      <div class="form-actions" style="margin-top:20px"><button type="button" class="button button-ghost" data-close-modal>Annuler</button><button type="button" id="save-recurring-order" class="button button-primary">Enregistrer</button></div>
      `
    });
    modalBody.querySelector("[data-close-modal]").addEventListener("click", closeModal);

    function renderRoLines() {
      modalBody.querySelector("#ro-lines-body").innerHTML = lines.map((l, idx) => `<tr>
        <td>${escapeHtml(l.recipeName)}</td>
        <td>${formatNumber(l.quantity)} ${escapeHtml(l.saleUnit)}</td>
        <td>${formatMoney(l.unitPrice)}</td>
        <td><button type="button" class="icon-button icon-small danger ro-remove-line" data-idx="${idx}">${ICONS.trash}</button></td>
      </tr>`).join("") || `<tr><td colspan="4" class="muted" style="text-align:center;padding:14px">Aucun produit</td></tr>`;
      modalBody.querySelectorAll(".ro-remove-line").forEach(btn => btn.addEventListener("click", () => { lines.splice(Number(btn.dataset.idx), 1); renderRoLines(); }));
    }
    renderRoLines();

    modalBody.querySelector("#ro-add-line").addEventListener("click", () => {
      const recipeId = modalBody.querySelector("#ro-recipe").value;
      const recipe = recipes.find(r => r.id === recipeId);
      const qty = Number(modalBody.querySelector("#ro-qty").value || 0);
      const price = Number(modalBody.querySelector("#ro-price").value || 0);
      if (!recipe || qty <= 0) return showToast("Choisissez un produit et une quantité.", "error");
      lines.push({ recipeId, recipeName: recipe.name, saleUnit: recipe.sale_unit || "", quantity: qty, unitPrice: price });
      renderRoLines();
    });

    modalBody.querySelector("#save-recurring-order").addEventListener("click", async () => {
      if (!lines.length) return showToast("Ajoutez au moins un produit.", "error");
      const values = formObject(modalBody.querySelector("#recurring-order-form"));
      if (!values.location_id) return showToast("Choisissez un emplacement de départ : sans lui, la commande ne sera jamais générée automatiquement.", "error");
      const button = modalBody.querySelector("#save-recurring-order");
      submitButtonLoading(button, true);
      try {
        const payload = {
          organization_id: profile.organization_id, client_id: client.id,
          day_of_week: Number(values.day_of_week), shipping_mode: values.shipping_mode,
          location_id: values.location_id || null,
          active: existing ? modalBody.querySelector('[name="active"]').checked : true
        };
        let recurringOrderId = existing?.id;
        if (existing) {
          const { error } = await sb.from("recurring_orders").update(payload).eq("id", existing.id);
          if (error) throw error;
          // Si cette suppression échouait en silence, les lignes seraient
          // recréées par-dessus : chaque livraison récurrente serait doublée.
          const { error: itemsDelError } = await sb.from("recurring_order_items").delete().eq("recurring_order_id", existing.id);
          if (itemsDelError) throw itemsDelError;
        } else {
          const { data: saved, error } = await sb.from("recurring_orders").insert(payload).select().single();
          if (error) throw error;
          recurringOrderId = saved.id;
        }
        const { error: itemsError } = await sb.from("recurring_order_items").insert(
          lines.map(l => ({ recurring_order_id: recurringOrderId, recipe_id: l.recipeId, quantity: l.quantity, unit_price: l.unitPrice }))
        );
        if (itemsError) throw itemsError;
        closeModal(); showToast("Commande récurrente enregistrée."); clientModal(client);
      } catch (err) { showError(err); }
      finally { submitButtonLoading(button, false); }
    });
  }

  // Livraisons
  async function fetchDeliveryStatuses() {
    const { data, error } = await sb.from("delivery_statuses").select("*").eq("organization_id", profile.organization_id).order("sort_order");
    if (error) { showError(error); return []; }
    return data || [];
  }

  // Mentions de conservation. En cas d'échec (migration 99 pas encore passée),
  // on renvoie une liste vide : les livraisons s'affichent simplement sans
  // mentions, au lieu de faire tomber toute la page.
  async function fetchDeliveryTags() {
    const { data, error } = await sb.from("delivery_tags").select("*").eq("organization_id", profile.organization_id).order("sort_order");
    if (error) { console.warn("Mentions de conservation indisponibles :", error.message); return null; }
    return data || [];
  }
  async function fetchDeliveryTagLinks() {
    try { return await fetchAllRows(() => sb.from("delivery_tag_links").select("delivery_id, tag_id")); }
    catch (e) { return []; }
  }
  function deliveryTagChips(tags) {
    if (!tags || !tags.length) return "";
    return `<div class="delivery-tag-chips">${tags.map(t => `<span class="dash-section-badge stat-cat-pill kanban-status-pill-${t.tone}">${escapeHtml(t.label)}</span>`).join("")}</div>`;
  }

  function deliveryTagModal(tag, all) {
    openModal({
      title: tag ? "Modifier la mention" : "Nouvelle mention",
      kicker: "Paramètres livraison",
      html: `<form id="delivery-tag-form" class="form-grid">
        <div class="span-2"><label>Libellé *</label><input name="label" required maxlength="40" value="${escapeHtml(tag?.label || "")}" placeholder="Froid négatif, Fragile…"></div>
        <div class="span-2"><label>Couleur</label><select name="tone">${TONE_OPTIONS.map(o => `<option value="${o.key}" ${(tag?.tone || "neutral") === o.key ? "selected" : ""}>${o.label}</option>`).join("")}</select></div>
        <div class="form-actions span-2"><button type="button" class="button button-ghost" data-close-modal>Annuler</button><button class="button button-primary" type="submit">Enregistrer</button></div>
      </form>`
    });
    modalBody.querySelector("[data-close-modal]").addEventListener("click", closeModal);
    modalBody.querySelector("#delivery-tag-form").addEventListener("submit", async event => {
      event.preventDefault();
      const button = event.submitter; submitButtonLoading(button, true);
      const values = formObject(event.currentTarget);
      const payload = { label: values.label.trim(), tone: values.tone };
      let error;
      if (tag) ({ error } = await sb.from("delivery_tags").update(payload).eq("id", tag.id));
      else {
        const maxOrder = Math.max(0, ...(all || []).map(t => t.sort_order || 0));
        ({ error } = await sb.from("delivery_tags").insert({ ...payload, organization_id: profile.organization_id, sort_order: maxOrder + 10 }));
      }
      submitButtonLoading(button, false);
      if (error) return showError(error);
      closeModal(); showToast("Mention enregistrée."); renderDeliverySettings();
    });
  }

  async function fetchShippingModes() {
    const { data, error } = await sb.from("delivery_shipping_modes").select("*").eq("organization_id", profile.organization_id).order("sort_order");
    if (error) { showError(error); return []; }
    return data || [];
  }

  async function fetchDeliveryReminderRules() {
    const { data, error } = await sb.from("delivery_reminder_rules").select("*").eq("organization_id", profile.organization_id);
    if (error) { showError(error); return []; }
    return data || [];
  }

  function statusIndexOf(statuses, key) { return statuses.findIndex(s => s.key === key); }

  let deliveriesViewMode = "kanban";
  let deliveriesArchiveFilter = "active";

  async function generateDueRecurringDeliveries() {
    const [{ data: recurringOrders, error }, statuses, rules] = await Promise.all([
      sb.from("recurring_orders").select("id, day_of_week, shipping_mode, location_id").eq("organization_id", profile.organization_id).eq("active", true),
      fetchDeliveryStatuses(),
      fetchDeliveryReminderRules()
    ]);
    if (error || !recurringOrders?.length || !statuses.length) return;
    const firstStatusKey = statuses[0].key;
    const todayDow = new Date().getDay();
    for (const ro of recurringOrders) {
      const diff = (ro.day_of_week - todayDow + 7) % 7;
      const nextDate = plusDaysISO(diff);
      const rule = rules.find(r => r.active && r.status_key === firstStatusKey && (r.shipping_mode_key === ro.shipping_mode || r.shipping_mode_key === null));
      const triggerDate = subtractBusinessDaysISO(nextDate, rule ? rule.reminder_days : 0);
      if (todayISO() < triggerDate) continue;
      const { error: genError } = await sb.rpc("generate_recurring_delivery", { p_recurring_order_id: ro.id, p_target_date: nextDate });
      if (genError) console.error("Génération commande récurrente", ro.id, genError.message);
    }
  }

  async function renderDeliveries() {
    const canCreate = pageCan("deliveries");
    setHeader("deliveries", canCreate ? `<button id="add-delivery" class="button button-primary">＋ Nouvelle livraison</button>` : "");
    await generateDueRecurringDeliveries();
    const [data, statuses] = await Promise.all([
      fetchAllRows(() => sb.from("deliveries").select("*, clients(name,company)").eq("organization_id", profile.organization_id)),
      fetchDeliveryStatuses()
    ]);
    // Chargées à part : leur absence ne doit jamais bloquer la page
    const [allTags, tagLinks] = await Promise.all([fetchDeliveryTags(), fetchDeliveryTagLinks()]);
    const tagById = new Map((allTags || []).map(t => [t.id, t]));
    const tagsByDelivery = new Map();
    tagLinks.forEach(l => {
      const t = tagById.get(l.tag_id);
      if (!t) return;
      if (!tagsByDelivery.has(l.delivery_id)) tagsByDelivery.set(l.delivery_id, []);
      tagsByDelivery.get(l.delivery_id).push(t);
    });
    tagsByDelivery.forEach(list => list.sort((a, b) => a.sort_order - b.sort_order));
    (data || []).forEach(d => { d._tags = tagsByDelivery.get(d.id) || []; });
    const allDeliveries = (data || []).filter(d => canSeeLocation(d.location_id)).sort((a, b) => {
      if (!a.estimated_delivery_date && !b.estimated_delivery_date) return 0;
      if (!a.estimated_delivery_date) return 1;
      if (!b.estimated_delivery_date) return -1;
      return a.estimated_delivery_date.localeCompare(b.estimated_delivery_date);
    });
    const deliveries = deliveriesArchiveFilter === "all" ? allDeliveries
      : deliveriesArchiveFilter === "archived" ? allDeliveries.filter(d => d.archived)
      : allDeliveries.filter(d => !d.archived);

    content.innerHTML = `
      <div class="toolbar">
        <input id="deliveries-search" class="search" placeholder="Rechercher un BL, un client…">
        ${deliveriesViewMode === "list" ? `<select id="deliveries-archive-filter" class="filter-select">
          <option value="active" ${deliveriesArchiveFilter === "active" ? "selected" : ""}>Actives</option>
          <option value="archived" ${deliveriesArchiveFilter === "archived" ? "selected" : ""}>Archivées</option>
          <option value="all" ${deliveriesArchiveFilter === "all" ? "selected" : ""}>Toutes</option>
        </select>` : ""}
        <div class="view-toggle">
          <button type="button" class="mode-btn ${deliveriesViewMode === "list" ? "active" : ""}" data-dview="list">☰ Liste</button>
          <button type="button" class="mode-btn ${deliveriesViewMode === "kanban" ? "active" : ""}" data-dview="kanban">▦ Kanban</button>
        </div>
        <div class="toolbar-spacer"></div>
      </div>
      <div id="deliveries-body"></div>`;

    document.querySelector("#deliveries-search").addEventListener("input", e => {
      const q = e.target.value.trim().toLocaleLowerCase("fr");
      document.querySelectorAll("#deliveries-body [data-searchable]").forEach(el => { el.hidden = Boolean(q) && !el.textContent.toLocaleLowerCase("fr").includes(q); });
    });
    document.querySelector("#deliveries-archive-filter")?.addEventListener("change", e => {
      deliveriesArchiveFilter = e.target.value;
      renderDeliveries();
    });
    document.querySelectorAll("[data-dview]").forEach(btn => btn.addEventListener("click", () => {
      deliveriesViewMode = btn.dataset.dview;
      renderDeliveries();
    }));
    document.querySelector("#add-delivery")?.addEventListener("click", () => renderNewDeliveryPage());

    const body = document.querySelector("#deliveries-body");
    if (deliveriesViewMode === "kanban") renderDeliveriesKanban(body, allDeliveries, canCreate, statuses);
    else renderDeliveriesList(body, deliveries, canCreate, statuses);
  }

  function renderDeliveriesList(container, deliveries, canCreate, statuses) {
    const rows = deliveries.map(delivery => {
      const idx = statusIndexOf(statuses, delivery.status);
      const statusInfo = statuses[idx] || { label: delivery.status, tone: "success", is_terminal: false };
      const nextStatus = statuses[idx + 1];
      const margin = delivery.revenue_total != null && delivery.cost_total != null ? delivery.revenue_total - delivery.cost_total : null;
      return `<tr data-searchable>
        <td><strong>${escapeHtml(delivery.delivery_number)}</strong></td>
        <td>${delivery.estimated_delivery_date ? formatDate(delivery.estimated_delivery_date) : "—"}</td>
        <td><strong>${escapeHtml(delivery.clients?.company || delivery.clients?.name || "—")}</strong>${deliveryTagChips(delivery._tags)}</td>
        <td>${delivery.revenue_total != null ? formatMoney(delivery.revenue_total) : "—"}</td>
        <td>${margin != null ? formatMoney(margin) : "—"}</td>
        <td>${badge(statusInfo.label, statusInfo.tone)}</td>
        <td><div class="table-actions">
          <button class="icon-button icon-small view-delivery" data-id="${delivery.id}" title="Voir le détail">${ICONS.eye}</button>
          ${canCreate && !statusInfo.is_terminal ? `<button class="icon-button icon-small edit-delivery" data-id="${delivery.id}" title="Modifier">${ICONS.edit}</button>` : ""}
          ${canCreate && idx > 0 ? `<button class="icon-button icon-small revert-delivery" data-id="${delivery.id}" title="Revenir à l’étape précédente">${ICONS.arrowLeft}</button>` : ""}
          ${canCreate && nextStatus && !nextStatus.is_terminal ? `<button class="button button-small button-secondary advance-delivery" data-id="${delivery.id}">Étape suivante</button>` : ""}
          ${canCreate && nextStatus && nextStatus.is_terminal ? `<button class="button button-small button-primary mark-delivered" data-id="${delivery.id}">Marquer livrée</button>` : ""}
          ${canCreate ? `<button class="icon-button icon-small duplicate-delivery" data-id="${delivery.id}" title="Dupliquer">${ICONS.duplicate}</button>` : ""}
          ${delivery.attachment_path ? `<button class="button button-small button-ghost view-delivery-file" data-path="${escapeHtml(delivery.attachment_path)}">BL</button>` : ""}
          ${canCreate ? `<button class="icon-button icon-small danger delete-delivery" data-id="${delivery.id}" title="Supprimer">${ICONS.trash}</button>` : ""}
        </div></td>
      </tr>`;
    }).join("");
    container.innerHTML = `<div class="table-wrap">${rows ? `<table><thead><tr><th>N° livraison</th><th>Livraison prévue</th><th>Client</th><th>Total HT</th><th>Marge</th><th>Statut</th><th></th></tr></thead><tbody>${rows}</tbody></table>` : emptyState("Aucune livraison", "Enregistrez une sortie de produits finis.")}</div>`;
    wireDeliveryActions(container, deliveries);
  }

  function computeClientSequenceLabels(deliveries) {
    const labels = new Map();
    const sorted = [...deliveries].sort((a, b) => (a.created_at || "").localeCompare(b.created_at || ""));
    const counters = new Map();
    sorted.forEach(d => {
      const clientName = d.clients?.company || d.clients?.name || "Client";
      const count = (counters.get(clientName) || 0) + 1;
      counters.set(clientName, count);
      labels.set(d.id, `${clientName} - ${String(count).padStart(3, "0")}`);
    });
    return labels;
  }

  function renderDeliveriesKanban(container, deliveries, canCreate, statuses) {
    const clientLabels = computeClientSequenceLabels(deliveries);
    container.innerHTML = `<div class="kanban-board" style="grid-template-columns: repeat(${statuses.length || 1}, 1fr)">
      ${statuses.map((status, idx) => {
        const items = deliveries.filter(d => d.status === status.key && !d.archived);
        const nextStatus = statuses[idx + 1];
        return `<div class="kanban-column">
          <div class="kanban-column-head">
            <span class="kanban-status-pill kanban-status-pill-${status.tone}">${escapeHtml(status.label)} <strong>${items.length}</strong></span>
            <span class="kanban-column-total">${formatMoney(items.reduce((s, d) => s + Number(d.revenue_total || 0), 0))} HT</span>
          </div>
          <div class="kanban-cards">${items.map(d => `
            <article class="card kanban-card-v2" data-searchable>
              <div class="kanban-card-icon-row">📄 <strong>${escapeHtml(clientLabels.get(d.id))}</strong></div>
              <div class="muted kanban-card-date">📅 ${d.estimated_delivery_date ? formatDate(d.estimated_delivery_date) : "—"}</div>
              <div>${d.revenue_total != null ? formatMoney(d.revenue_total) : "—"} <span class="muted" style="font-size:11px">HT</span></div>
              ${deliveryTagChips(d._tags)}
              <div class="kanban-card-actions kanban-card-actions-nowrap">
                <button class="icon-button icon-small view-delivery" data-id="${d.id}" title="Voir le détail">${ICONS.eye}</button>
                ${canCreate && idx > 0 ? `<button class="icon-button icon-small revert-delivery" data-id="${d.id}" title="Revenir à l’étape précédente">${ICONS.arrowLeft}</button>` : ""}
                ${canCreate && nextStatus && !nextStatus.is_terminal ? `<button class="icon-button icon-small advance-delivery" data-id="${d.id}" title="Étape suivante">${ICONS.arrowRight}</button>` : ""}
                ${canCreate && nextStatus && nextStatus.is_terminal ? `<button class="icon-button icon-small mark-delivered" data-id="${d.id}" title="Marquer livrée">${ICONS.check}</button>` : ""}
                ${canCreate && status.is_terminal ? `<button class="icon-button icon-small archive-delivery" data-id="${d.id}" title="Archiver">${ICONS.archive}</button>` : ""}
                ${canCreate && !status.is_terminal ? `<button class="icon-button icon-small edit-delivery" data-id="${d.id}" title="Modifier">${ICONS.edit}</button>` : ""}
                ${canCreate ? `<button class="icon-button icon-small duplicate-delivery" data-id="${d.id}" title="Dupliquer">${ICONS.duplicate}</button>` : ""}
                ${canCreate ? `<button class="icon-button icon-small danger delete-delivery" data-id="${d.id}" title="Supprimer">${ICONS.trash}</button>` : ""}
              </div>
            </article>`).join("") || `<p class="muted kanban-empty">Aucune</p>`}
          </div>
        </div>`;
      }).join("")}
    </div>`;
    wireDeliveryActions(container, deliveries);
    container.querySelectorAll(".archive-delivery").forEach(btn => btn.addEventListener("click", async () => {
      const { error } = await sb.rpc("archive_delivery", { p_delivery_id: btn.dataset.id });
      if (error) return showError(error);
      showToast("Livraison archivée."); renderDeliveries();
    }));
  }

  function wireDeliveryActions(container, deliveries) {
    container.querySelectorAll(".view-delivery-file").forEach(btn => btn.addEventListener("click", () => openPrivateFile("delivery-files", btn.dataset.path)));
    container.querySelectorAll(".view-delivery").forEach(btn => btn.addEventListener("click", () => deliveryDetailModal(deliveries.find(d => d.id === btn.dataset.id))));
    container.querySelectorAll(".edit-delivery").forEach(btn => btn.addEventListener("click", () => renderNewDeliveryPage(deliveries.find(d => d.id === btn.dataset.id))));
    container.querySelectorAll(".mark-delivered").forEach(btn => btn.addEventListener("click", () => markDeliveredModal(btn.dataset.id)));
    container.querySelectorAll(".advance-delivery").forEach(btn => btn.addEventListener("click", async () => {
      const { error } = await sb.rpc("advance_delivery_status", { p_delivery_id: btn.dataset.id });
      if (error) return showError(error);
      showToast("Livraison passée à l’étape suivante."); renderDeliveries();
    }));
    container.querySelectorAll(".revert-delivery").forEach(btn => btn.addEventListener("click", async () => {
      const delivery = deliveries.find(d => d.id === btn.dataset.id);
      const warning = " Si elle était déjà livrée, elle sera retirée de la facturation.";
      if (!confirm(`Revenir à l’étape précédente ?${warning}`)) return;
      const { error } = await sb.rpc("revert_delivery_status", { p_delivery_id: btn.dataset.id });
      if (error) return showError(error);
      showToast("Retour à l’étape précédente."); renderDeliveries();
    }));
    container.querySelectorAll(".duplicate-delivery").forEach(btn => btn.addEventListener("click", async () => {
      if (!confirm("Dupliquer cette commande ? Une nouvelle livraison sera créée à la première étape, en reconsommant le stock actuel.")) return;
      const { error } = await sb.rpc("duplicate_delivery", { p_delivery_id: btn.dataset.id });
      if (error) return showError(error);
      showToast("Commande dupliquée."); renderDeliveries();
    }));
    container.querySelectorAll(".delete-delivery").forEach(btn => btn.addEventListener("click", async () => {
      if (!confirm("Supprimer cette livraison ? Le stock de produits finis et fournitures sera restitué.")) return;
      const { error: deleteError } = await sb.rpc("delete_delivery", { p_delivery_id: btn.dataset.id });
      if (deleteError) return showError(deleteError);
      showToast("Livraison supprimée."); renderDeliveries();
    }));
  }

  function markDeliveredModal(deliveryId) {
    openModal({
      title: "Marquer comme livrée",
      kicker: "Livraison",
      html: `<form id="mark-delivered-form" class="form-grid">
        <div class="span-2"><label>Date de livraison *</label><input name="delivered_at" type="date" required value="${todayISO()}"></div>
        <div class="form-actions span-2"><button type="button" class="button button-ghost" data-close-modal>Annuler</button><button class="button button-primary" type="submit">Valider</button></div>
      </form>`
    });
    modalBody.querySelector("[data-close-modal]").addEventListener("click", closeModal);
    modalBody.querySelector("#mark-delivered-form").addEventListener("submit", async event => {
      event.preventDefault();
      const button = event.submitter; submitButtonLoading(button, true);
      const values = formObject(event.currentTarget);
      const { error } = await sb.rpc("mark_delivery_delivered", { p_delivery_id: deliveryId, p_delivered_at: values.delivered_at });
      submitButtonLoading(button, false);
      if (error) return showError(error);
      closeModal(); showToast("Livraison marquée comme livrée."); renderDeliveries();
    });
  }

  async function deliveryDetailModal(delivery) {
    if (!delivery) return;
    const [{ data: items }, { data: supplyItems }, { data: statusRow }] = await Promise.all([
      sb.from("delivery_items").select("quantity, unit_price, unit_cost, unit_cost_mp, unit_cost_production, unit_cost_packaging, unit_cost_transport, unit_cost_storage, ordered_recipe_id, finished_lots(lot_number, recipes(name, sale_unit)), recipes:ordered_recipe_id(name, sale_unit)").eq("delivery_id", delivery.id),
      sb.from("delivery_supply_items").select("quantity, unit_cost, supplies(name, unit)").eq("delivery_id", delivery.id),
      sb.from("delivery_statuses").select("label, tone").eq("organization_id", profile.organization_id).eq("key", delivery.status).maybeSingle()
    ]);
    const statusInfo = statusRow || { label: delivery.status, tone: "success" };
    const itemRows = (items || []).map(i => `<tr>
      <td>${escapeHtml(i.finished_lots?.recipes?.name || i.recipes?.name || "—")}</td>
      <td><span class="lot-pill${!i.finished_lots ? " lot-pill-pending" : ""}">${escapeHtml(i.finished_lots?.lot_number || (i.ordered_recipe_id ? "À produire" : "—"))}</span></td>
      <td>${formatNumber(i.quantity)} ${escapeHtml(i.finished_lots?.recipes?.sale_unit || i.recipes?.sale_unit || "")}</td>
      <td>${formatMoney(i.unit_price)}</td>
      <td>${formatMoney(i.unit_cost)}</td>
    </tr>`).join("");
    const supplyRows = (supplyItems || []).map(s => `<tr><td>${escapeHtml(s.supplies?.name || "—")}</td><td>${formatNumber(s.quantity)} ${escapeHtml(s.supplies?.unit || "")}</td><td>${formatMoney(s.unit_cost)}</td></tr>`).join("");
    const margin = delivery.revenue_total != null && delivery.cost_total != null ? delivery.revenue_total - delivery.cost_total : null;
    const marginPct = margin != null && delivery.revenue_total ? (margin / delivery.revenue_total) * 100 : null;

    const mpTotal = (items || []).reduce((s, i) => s + Number(i.quantity || 0) * Number(i.unit_cost_mp || 0), 0);
    const productionTotal = (items || []).reduce((s, i) => s + Number(i.quantity || 0) * Number(i.unit_cost_production || 0), 0);
    const packagingTotal = (items || []).reduce((s, i) => s + Number(i.quantity || 0) * Number(i.unit_cost_packaging || 0), 0);
    const priorTransportTotal = (items || []).reduce((s, i) => s + Number(i.quantity || 0) * Number(i.unit_cost_transport || 0), 0);
    const priorStorageTotal = (items || []).reduce((s, i) => s + Number(i.quantity || 0) * Number(i.unit_cost_storage || 0), 0);
    const supplyTotal = (supplyItems || []).reduce((s, i) => s + Number(i.quantity || 0) * Number(i.unit_cost || 0), 0);

    openModal({
      title: delivery.delivery_number,
      kicker: escapeHtml(delivery.clients?.company || delivery.clients?.name || ""),
      width: "780px",
      html: `
        <div class="prod-detail-head">${badge(statusInfo.label, statusInfo.tone)}</div>
        <div class="detail-grid detail-grid-4" style="margin-bottom:22px">
          <div><small>Date</small><div class="detail-value">${formatDate(delivery.delivery_date)}</div></div>
          <div><small>Livrée le</small><div class="detail-value">${delivery.delivered_at ? formatDate(delivery.delivered_at) : "—"}</div></div>
          <div><small>Transport (coût)</small><div class="detail-value">${formatMoney(delivery.transport_cost)}</div></div>
          <div><small>Transport (facturé)</small><div class="detail-value">${delivery.transport_price != null ? formatMoney(delivery.transport_price) : "—"}</div></div>
        </div>
        <div class="detail-block">
          <div class="detail-block-title">☰ Produits livrés</div>
          <div class="table-wrap">${itemRows ? `<table><thead><tr><th>Produit</th><th>Lot</th><th>Quantité</th><th>Prix HT</th><th>Coût de revient</th></tr></thead><tbody>${itemRows}</tbody></table>` : emptyState("Aucun produit", "")}</div>
        </div>
        ${supplyRows ? `<div class="detail-block"><div class="detail-block-title">📦 Fournitures ajoutées</div><div class="table-wrap"><table><thead><tr><th>Fourniture</th><th>Quantité</th><th>Coût</th></tr></thead><tbody>${supplyRows}</tbody></table></div></div>` : ""}
        <div class="detail-block">
          <div class="detail-block-title">€ Récapitulatif financier</div>
          <div class="detail-grid detail-grid-cost">
            <div>
              <small>Coût de revient</small>
              <div class="detail-value">${formatMoney(delivery.cost_total)}</div>
              <details class="cost-breakdown">
                <summary>Voir le détail</summary>
                <div class="cost-breakdown-body">
                  <div><span>Matières premières</span><strong>${formatMoney(mpTotal)}</strong></div>
                  <div><span>Fabrication</span><strong>${formatMoney(productionTotal)}</strong></div>
                  <div><span>Conditionnement (production)</span><strong>${formatMoney(packagingTotal)}</strong></div>
                  <div><span>Transport déjà encouru sur ces lots</span><strong>${formatMoney(priorTransportTotal)}</strong></div>
                  <div><span>Entreposage externe déjà encouru sur ces lots</span><strong>${formatMoney(priorStorageTotal)}</strong></div>
                  <div><span>Fournitures ajoutées à cette livraison</span><strong>${formatMoney(supplyTotal)}</strong></div>
                  <div><span>Transport de cette livraison</span><strong>${formatMoney(delivery.transport_cost)}</strong></div>
                  <div><span>Frais annexes</span><strong>${formatMoney((delivery.extra_costs || []).reduce((s, c) => s + Number(c.amount || 0), 0))}</strong></div>
                </div>
              </details>
            </div>
            <div><small>Total HT</small><div class="detail-value">${formatMoney(delivery.revenue_total)}</div></div>
            <div class="detail-total"><small>Marge</small><div class="detail-value">${margin != null ? formatMoney(margin) : "—"}${marginPct != null ? ` <span class="muted" style="font-size:13px">(${formatNumber(marginPct, 0)}%)</span>` : ""}</div></div>
          </div>
        </div>
        ${delivery.notes ? `<div class="detail-block"><div class="detail-block-title">📝 Notes</div><p>${escapeHtml(delivery.notes)}</p></div>` : ""}
      `
    });
  }

  async function renderNewDeliveryPage(existingDelivery = null) {
    const [{ data: clients }, allLocations, { data: categories }, shippingModes] = await Promise.all([
      sb.from("clients").select("id,name,company").eq("organization_id", profile.organization_id).order("company"),
      fetchLocations(),
      sb.from("recipe_categories").select("id,name,sort_order").eq("organization_id", profile.organization_id),
      fetchShippingModes()
    ]);
    const deliveryTags = await fetchDeliveryTags();
    let initialTagIds = [];
    if (existingDelivery && deliveryTags) {
      const { data: links } = await sb.from("delivery_tag_links").select("tag_id").eq("delivery_id", existingDelivery.id);
      initialTagIds = (links || []).map(l => l.tag_id);
    }
    if (!clients?.length) return showToast("Ajoutez d’abord un client.", "error");
    if (!allLocations.length) return showToast("Créez d’abord un emplacement.", "error");
    if (!shippingModes.length) return showToast("Créez d’abord un mode d’expédition (Paramètres → Paramètres livraison).", "error");

    const state = {
      tagIds: new Set(initialTagIds),
      clientId: existingDelivery?.client_id || "", locationId: existingDelivery?.location_id || "",
      categoryPrices: new Map(), lines: [], supplyLines: [],
      extraCosts: Array.isArray(existingDelivery?.extra_costs) ? existingDelivery.extra_costs.map(c => ({ label: c.label, amount: Number(c.amount || 0) })) : [],
      transportCost: Number(existingDelivery?.transport_cost || 0),
      transportPrice: existingDelivery?.transport_price ?? null,
      transportVatRate: Number(existingDelivery?.transport_vat_rate ?? 20),
      shippingMode: existingDelivery?.shipping_mode || shippingModes[0]?.key,
      estimatedDeliveryDate: existingDelivery?.estimated_delivery_date || "",
      availableLots: [], availableSupplies: []
    };

    if (existingDelivery) {
      const [{ data: existingItems }, { data: existingSupplyItems }] = await Promise.all([
        sb.from("delivery_items").select("quantity, unit_price, vat_rate, unit_cost_mp, unit_cost_production, unit_cost_packaging, unit_cost_transport, unit_cost_storage, ordered_recipe_id, finished_lots(id, lot_number, recipes(name, sale_unit)), recipes:ordered_recipe_id(id, name, sale_unit)").eq("delivery_id", existingDelivery.id),
        sb.from("delivery_supply_items").select("quantity, unit_cost, supplies(id, name, unit)").eq("delivery_id", existingDelivery.id)
      ]);
      (existingItems || []).forEach(i => state.lines.push({
        // Ligne sans lot : le produit vient de ordered_recipe_id (commande passee avant fabrication)
        finishedLotId: i.finished_lots?.id || null, recipeId: i.ordered_recipe_id || null,
        recipeName: i.finished_lots?.recipes?.name || i.recipes?.name || "—",
        lotNumber: i.finished_lots?.lot_number || (i.ordered_recipe_id ? "À produire" : "Sans lot"),
        saleUnit: i.finished_lots?.recipes?.sale_unit || i.recipes?.sale_unit || "", quantity: Number(i.quantity), unitPrice: Number(i.unit_price), vatRate: Number(i.vat_rate ?? 5.5),
        unitCost: Number(i.unit_cost_mp || 0) + Number(i.unit_cost_production || 0) + Number(i.unit_cost_packaging || 0) + Number(i.unit_cost_transport || 0) + Number(i.unit_cost_storage || 0),
        unitCostMp: Number(i.unit_cost_mp || 0), unitCostProduction: Number(i.unit_cost_production || 0),
        unitCostPackaging: Number(i.unit_cost_packaging || 0), unitCostTransport: Number(i.unit_cost_transport || 0), unitCostStorage: Number(i.unit_cost_storage || 0),
        isOriginal: true
      }));
      (existingSupplyItems || []).forEach(s => state.supplyLines.push({
        supplyId: s.supplies?.id, supplyName: s.supplies?.name || "—", quantity: Number(s.quantity), unit: s.supplies?.unit || "", unitCost: Number(s.unit_cost || 0),
        isOriginal: true
      }));
    }

    content.innerHTML = `
      <div class="finished-page-head">
        <button type="button" id="new-delivery-back" class="icon-button" title="Retour">←</button>
        <strong>${existingDelivery ? `Modifier la livraison ${escapeHtml(existingDelivery.delivery_number)}` : "Nouvelle livraison"}</strong>
      </div>
      <div class="form-grid" style="margin-top:18px">
        <div><label>Client *</label><select id="delivery-client" ${existingDelivery ? "disabled" : ""}><option value="">Sélectionner…</option>${clients.map(c => `<option value="${c.id}" ${state.clientId === c.id ? "selected" : ""}>${escapeHtml(c.company || c.name)}</option>`).join("")}</select></div>
        <div><label>Emplacement de départ *</label><select id="delivery-location">${allLocations.map(l => `<option value="${l.id}" ${state.locationId === l.id ? "selected" : ""}>${escapeHtml(l.name)}</option>`).join("")}</select></div>
        <div><label>Mode d’expédition</label><select id="delivery-shipping-mode">
          ${shippingModes.map(m => `<option value="${m.key}" ${state.shippingMode === m.key ? "selected" : ""}>${escapeHtml(m.label)}</option>`).join("")}
        </select></div>
        ${deliveryTags && deliveryTags.length ? `<div class="span-2 delivery-tag-field"><label>Conservation</label>
          <div class="delivery-tag-picker">${deliveryTags.map(t => `<label class="checkbox-pill"><input type="checkbox" class="delivery-tag-cb" value="${t.id}" ${state.tagIds.has(t.id) ? "checked" : ""}> ${escapeHtml(t.label)}</label>`).join("")}</div>
          <p class="form-note">Plusieurs choix possibles : une même livraison peut mêler produits congelés et décongelés.</p></div>` : ""}
        <div><label>Date de livraison estimée</label><input id="delivery-estimated-date" type="date" value="${state.estimatedDeliveryDate}"><p class="form-note">Sert à générer un rappel dans l’onglet Tâches, selon les délais définis dans Paramètres → Paramètres livraison.</p></div>
      </div>
      ${existingDelivery ? `<div class="help-inline" style="margin-top:12px">${helpTip("Le client d’une livraison déjà créée ne peut plus être changé. Ajoute ou retire des lignes, puis enregistre.")}<span class="help-inline-label">À savoir</span></div>` : ""}

      <div class="form-section-title" style="margin-top:26px">☰ Produits à livrer</div>
      <div id="delivery-add-line" class="help-box">Choisissez un client et un emplacement pour voir les produits disponibles.</div>
      <div class="table-wrap" style="margin-top:12px"><table id="delivery-lines-table"><thead><tr><th>Produit</th><th>Lot</th><th>Quantité</th><th>Prix HT / unité</th><th>Total</th><th></th></tr></thead><tbody id="delivery-lines-body"></tbody></table></div>

      <div class="form-section-title" style="margin-top:26px">🚚 Transport</div>
      <div class="form-grid">
        <div><label>Coût de transport réel (€)</label><input id="delivery-transport-cost" type="number" min="0" step="0.01" value="${state.transportCost}"></div>
        <div><label>Prix refacturé au client (€, optionnel)</label><input id="delivery-transport-price" type="number" min="0" step="0.01" value="${state.transportPrice ?? ""}"></div>
        <div><label>TVA transport (%)</label><input id="delivery-transport-vat" type="number" min="0" step="0.1" value="${state.transportVatRate}"></div>
      </div>

      <div class="form-section-title" style="margin-top:26px">📦 Fournitures additionnelles <span class="muted" style="font-weight:600;text-transform:none;font-size:12px">(en plus de celles déjà consommées en production)</span></div>
      <div id="delivery-add-supply"></div>
      <div class="table-wrap" style="margin-top:12px"><table id="delivery-supplies-table"><thead><tr><th>Fourniture</th><th>Quantité</th><th></th></tr></thead><tbody id="delivery-supplies-body"></tbody></table></div>

      <div class="form-section-title" style="margin-top:26px">💶 Frais annexes <span class="muted" style="font-weight:600;text-transform:none;font-size:12px">(préparation colis, sortie palette, tout coût ponctuel à ajouter librement)</span></div>
      <div class="form-grid">
        <div class="span-2"><label>Libellé</label><input id="extra-cost-label" placeholder="Ex : Sortie palette homogène"></div>
        <div><label>Montant (€)</label><input id="extra-cost-amount" type="number" min="0" step="0.01" value="0"></div>
        <div style="align-self:end"><button type="button" id="add-extra-cost" class="button button-primary button-full">＋ Ajouter</button></div>
      </div>
      <div class="table-wrap" style="margin-top:12px"><table><thead><tr><th>Libellé</th><th>Montant</th><th></th></tr></thead><tbody id="extra-costs-body"></tbody></table></div>

      <div class="detail-block" style="margin-top:26px">
        <div class="detail-block-title">€ Récapitulatif financier</div>
        <div class="detail-grid detail-grid-cost" id="delivery-summary">
          <div><small>Coût de revient</small><div class="detail-value">0,00 €</div></div>
          <div><small>Total HT</small><div class="detail-value">0,00 €</div></div>
          <div class="detail-total"><small>Marge</small><div class="detail-value">0,00 €</div></div>
        </div>
      </div>

      <div class="span-2" style="margin-top:10px"><label>Bon de livraison (PDF ou image)</label><input id="delivery-attachment" type="file" accept=".pdf,image/*"></div>
      <div class="span-2"><label>Notes</label><textarea id="delivery-notes">${escapeHtml(existingDelivery?.notes || "")}</textarea></div>
      <div class="form-actions" style="margin-top:20px"><button type="button" id="cancel-new-delivery" class="button button-ghost">Annuler</button><button type="button" id="save-new-delivery" class="button button-primary">${existingDelivery ? "Enregistrer les modifications" : "Enregistrer"}</button></div>
    `;

    document.querySelector("#new-delivery-back").addEventListener("click", () => { unsavedDeliveryDraft = false; renderDeliveries(); });
    document.querySelector("#cancel-new-delivery").addEventListener("click", () => { unsavedDeliveryDraft = false; renderDeliveries(); });

    function recomputeSummary() {
      const mpTotal = state.lines.reduce((s, l) => s + l.quantity * l.unitCostMp, 0);
      const productionTotal = state.lines.reduce((s, l) => s + l.quantity * l.unitCostProduction, 0);
      const packagingTotal = state.lines.reduce((s, l) => s + l.quantity * l.unitCostPackaging, 0);
      const priorTransportTotal = state.lines.reduce((s, l) => s + l.quantity * l.unitCostTransport, 0);
      const priorStorageTotal = state.lines.reduce((s, l) => s + l.quantity * (l.unitCostStorage || 0), 0);
      const productCost = mpTotal + productionTotal + packagingTotal + priorTransportTotal + priorStorageTotal;
      const productRevenue = state.lines.reduce((s, l) => s + l.quantity * l.unitPrice, 0);
      const supplyCost = state.supplyLines.reduce((s, l) => s + l.quantity * l.unitCost, 0);
      const extraCostsTotal = state.extraCosts.reduce((s, c) => s + Number(c.amount || 0), 0);
      const deliveryTransportCost = Number(state.transportCost || 0);
      const costTotal = productCost + supplyCost + deliveryTransportCost + extraCostsTotal;
      const revenueTotal = productRevenue + Number(state.transportPrice || 0);
      const margin = revenueTotal - costTotal;
      const marginPct = revenueTotal ? (margin / revenueTotal) * 100 : 0;
      document.querySelector("#delivery-summary").innerHTML = `
        <div>
          <small>Coût de revient</small>
          <div class="detail-value">${formatMoney(costTotal)}</div>
          <details class="cost-breakdown">
            <summary>Voir le détail</summary>
            <div class="cost-breakdown-body">
              <div><span>Matières premières</span><strong>${formatMoney(mpTotal)}</strong></div>
              <div><span>Fabrication</span><strong>${formatMoney(productionTotal)}</strong></div>
              <div><span>Conditionnement (production)</span><strong>${formatMoney(packagingTotal)}</strong></div>
              <div><span>Transport déjà encouru sur ces lots</span><strong>${formatMoney(priorTransportTotal)}</strong></div>
              <div><span>Entreposage externe déjà encouru sur ces lots</span><strong>${formatMoney(priorStorageTotal)}</strong></div>
              <div><span>Fournitures ajoutées à cette livraison</span><strong>${formatMoney(supplyCost)}</strong></div>
              <div><span>Transport de cette livraison</span><strong>${formatMoney(deliveryTransportCost)}</strong></div>
              <div><span>Frais annexes</span><strong>${formatMoney(extraCostsTotal)}</strong></div>
            </div>
          </details>
        </div>
        <div><small>Total HT</small><div class="detail-value">${formatMoney(revenueTotal)}</div></div>
        <div class="detail-total"><small>Marge</small><div class="detail-value">${formatMoney(margin)} <span class="muted" style="font-size:13px">(${formatNumber(marginPct, 0)}%)</span></div></div>
      `;
    }

    function renderLines() {
      document.querySelector("#delivery-lines-body").innerHTML = state.lines.map((l, idx) => `<tr>
        <td>${escapeHtml(l.recipeName)}</td>
        <td><span class="lot-pill${!l.finishedLotId ? " lot-pill-pending" : ""}">${escapeHtml(l.lotNumber)}</span></td>
        <td>${formatNumber(l.quantity)} ${escapeHtml(l.saleUnit)}</td>
        <td>${formatMoney(l.unitPrice)} <span class="muted" style="font-size:12px">(TVA ${formatNumber(l.vatRate)}%)</span></td>
        <td>${formatMoney(l.quantity * l.unitPrice)}</td>
        <td><button type="button" class="icon-button icon-small danger remove-line" data-idx="${idx}">🗑</button></td>
      </tr>`).join("") || `<tr><td colspan="6" class="muted" style="text-align:center;padding:16px">Aucun produit ajouté</td></tr>`;
      document.querySelectorAll(".remove-line").forEach(btn => btn.addEventListener("click", () => {
        const idx = Number(btn.dataset.idx);
        const removed = state.lines[idx];
        state.lines.splice(idx, 1);
        // Une ligne sans lot n'a jamais consomme de stock : rien a restituer.
        if (removed?.isOriginal && removed.finishedLotId) {
          const existingAvailable = state.availableLots.find(l => l.id === removed.finishedLotId);
          if (existingAvailable) {
            existingAvailable.quantity_remaining = Number(existingAvailable.quantity_remaining) + removed.quantity;
          } else {
            state.availableLots.push({
              id: removed.finishedLotId, lot_number: removed.lotNumber === "Sans lot" ? null : removed.lotNumber,
              quantity_remaining: removed.quantity,
              unit_cost_mp: removed.unitCostMp, unit_cost_production: removed.unitCostProduction,
              unit_cost_packaging: removed.unitCostPackaging, unit_cost_transport: removed.unitCostTransport,
              recipes: { name: removed.recipeName, sale_unit: removed.saleUnit }
            });
          }
          loadAddLineForm(true);
        }
        renderLines(); recomputeSummary();
      }));
    }

    function renderSupplyLines() {
      document.querySelector("#delivery-supplies-body").innerHTML = state.supplyLines.map((l, idx) => `<tr>
        <td>${escapeHtml(l.supplyName)}</td>
        <td>${formatNumber(l.quantity)} ${escapeHtml(l.unit)}</td>
        <td><button type="button" class="icon-button icon-small danger remove-supply-line" data-idx="${idx}">🗑</button></td>
      </tr>`).join("") || `<tr><td colspan="3" class="muted" style="text-align:center;padding:16px">Aucune fourniture ajoutée</td></tr>`;
      document.querySelectorAll(".remove-supply-line").forEach(btn => btn.addEventListener("click", () => {
        state.supplyLines.splice(Number(btn.dataset.idx), 1);
        renderSupplyLines(); recomputeSummary();
      }));
    }

    function renderExtraCosts() {
      document.querySelector("#extra-costs-body").innerHTML = state.extraCosts.map((c, idx) => `<tr>
        <td>${escapeHtml(c.label)}</td>
        <td>${formatMoney(c.amount)}</td>
        <td><button type="button" class="icon-button icon-small danger remove-extra-cost" data-idx="${idx}">${ICONS.trash}</button></td>
      </tr>`).join("") || `<tr><td colspan="3" class="muted" style="text-align:center;padding:16px">Aucun frais ajouté</td></tr>`;
      document.querySelectorAll(".remove-extra-cost").forEach(btn => btn.addEventListener("click", () => {
        state.extraCosts.splice(Number(btn.dataset.idx), 1);
        renderExtraCosts(); recomputeSummary();
      }));
    }

    async function loadAddLineForm(skipFetch = false) {
      const container = document.querySelector("#delivery-add-line");
      if (!state.clientId || !state.locationId) {
        container.innerHTML = `<div class="help-box">Choisissez un client et un emplacement pour voir les produits disponibles.</div>`;
        return;
      }
      if (!skipFetch) {
        const [{ data: lots, error }, { data: allRecipesForOrder }] = await Promise.all([
          sb.from("finished_lots")
            .select("id, lot_number, quantity_remaining, unit_cost_mp, unit_cost_production, unit_cost_packaging, unit_cost_transport, unit_cost_storage, recipes(id, name, sale_unit, category_id)")
            .eq("organization_id", profile.organization_id)
            .eq("location_id", state.locationId)
            .gt("quantity_remaining", 0)
            .order("expiry_date"),
          sb.from("recipes").select("id, name, sale_unit, category_id").eq("organization_id", profile.organization_id).order("name")
        ]);
        if (error) return showError(error);
        state.availableLots = lots || [];
        state.orderableRecipes = allRecipesForOrder || [];
      }
      // On autorise la saisie meme sans stock : une commande peut etre enregistree
      // avant que la production n'ait eu lieu (statut « Commandé »).
      // Deux parties distinctes : d'abord ce qui est en stock, puis ce qui est à
      // produire, chacune rangée par catégorie (ordre des paramètres). Dans un
      // même produit, les lots gardent leur ordre : le plus ancien d'abord.
      const catById = new Map((categories || []).map(cat => [cat.id, cat]));
      const stockOptions = optionsByCategory(
        state.availableLots, lot => catById.get(lot.recipes?.category_id),
        lot => `<option value="${lot.id}">${escapeHtml(lot.recipes?.name || "—")} — ${escapeHtml(lot.lot_number || "sans lot")} — ${formatNumber(lot.quantity_remaining)} ${escapeHtml(lot.recipes?.sale_unit || "")} dispo.</option>`,
        lot => lot.recipes?.name || "", { groupLabel: name => `En stock — ${name}`, forceGroups: true });
      // La mention « à produire » reste sur chaque produit : une fois la liste
      // refermée, l'intitulé du groupe n'est plus visible
      const orderOptions = optionsByCategory(
        state.orderableRecipes || [], r => catById.get(r.category_id),
        r => `<option value="recipe:${r.id}">${escapeHtml(r.name)} — à produire</option>`,
        r => r.name, { groupLabel: name => `À produire — ${name}`, forceGroups: true });
      const pickerOptions = stockOptions + orderOptions;
      container.innerHTML = `
      ${!state.availableLots.length ? `<div class="help-box">Aucun stock disponible sur cet emplacement. Tu peux quand même enregistrer la commande : les produits seront à produire.</div>` : ""}
      <div class="form-grid">
        <div class="span-2"><label>Produit (lot)</label><select id="line-lot">${pickerOptions}</select></div>
        <div><label>Quantité</label><input id="line-qty" type="number" min="0.001" step="0.001" value="1"></div>
        <div><label>Prix HT / unité (€)</label><input id="line-price" type="number" min="0" step="0.01" value="0"></div>
        <div><label>TVA (%)</label><input id="line-vat" type="number" min="0" step="0.1" value="5.5"></div>
        <div style="align-self:end"><button type="button" id="line-add" class="button button-primary button-full">＋ Ajouter</button></div>
      </div>`;
      const lotSelect = container.querySelector("#line-lot");
      const priceInput = container.querySelector("#line-price");
      const vatInput = container.querySelector("#line-vat");
      function syncDefaultPrice() {
        const val = lotSelect.value || "";
        const catId = val.startsWith("recipe:")
          ? (state.orderableRecipes || []).find(r => r.id === val.slice(7))?.category_id
          : state.availableLots.find(l => l.id === val)?.recipes?.category_id;
        const defaultPrice = catId ? state.categoryPrices.get(catId) : null;
        priceInput.value = defaultPrice ?? 0;
      }
      lotSelect.addEventListener("change", syncDefaultPrice);
      syncDefaultPrice();
      container.querySelector("#line-add").addEventListener("click", () => {
        const val = lotSelect.value || "";
        const qty = Number(container.querySelector("#line-qty").value || 0);
        const price = Number(priceInput.value || 0);
        if (qty <= 0) return showToast("Indiquez une quantité.", "error");

        // Produit commande sans stock : ligne sans lot, a produire.
        if (val.startsWith("recipe:")) {
          const recipe = (state.orderableRecipes || []).find(r => r.id === val.slice(7));
          if (!recipe) return showToast("Choisissez un produit.", "error");
          state.lines.push({
            finishedLotId: null, recipeId: recipe.id, recipeName: recipe.name, lotNumber: "À produire",
            saleUnit: recipe.sale_unit || "", quantity: qty, unitPrice: price, unitCost: 0,
            vatRate: Number(vatInput.value || 0),
            unitCostMp: 0, unitCostProduction: 0, unitCostPackaging: 0, unitCostTransport: 0, unitCostStorage: 0
          });
          unsavedDeliveryDraft = true;
          renderLines(); recomputeSummary();
          return;
        }

        const lot = state.availableLots.find(l => l.id === val);
        if (!lot) return showToast("Choisissez un produit.", "error");
        const alreadyUsed = state.lines.filter(l => l.finishedLotId === lot.id).reduce((s, l) => s + l.quantity, 0);
        if (alreadyUsed + qty > Number(lot.quantity_remaining)) return showToast("Quantité supérieure au stock disponible.", "error");
        const unitCost = Number(lot.unit_cost_mp || 0) + Number(lot.unit_cost_production || 0) + Number(lot.unit_cost_packaging || 0) + Number(lot.unit_cost_transport || 0) + Number(lot.unit_cost_storage || 0);
        state.lines.push({
          finishedLotId: lot.id, recipeName: lot.recipes?.name || "—", lotNumber: lot.lot_number || "Sans lot", saleUnit: lot.recipes?.sale_unit || "",
          quantity: qty, unitPrice: price, unitCost, vatRate: Number(vatInput.value || 0),
          unitCostMp: Number(lot.unit_cost_mp || 0), unitCostProduction: Number(lot.unit_cost_production || 0),
          unitCostPackaging: Number(lot.unit_cost_packaging || 0), unitCostTransport: Number(lot.unit_cost_transport || 0), unitCostStorage: Number(lot.unit_cost_storage || 0)
        });
        unsavedDeliveryDraft = true;
        renderLines(); recomputeSummary();
      });
    }

    async function loadAddSupplyForm() {
      const container = document.querySelector("#delivery-add-supply");
      const { data: supplies, error } = await sb.from("supplies").select("id,name,unit").eq("organization_id", profile.organization_id).order("name");
      if (error) return showError(error);
      state.availableSupplies = supplies || [];
      if (!state.availableSupplies.length) {
        container.innerHTML = `<div class="help-box">Aucune fourniture créée.</div>`;
        return;
      }
      container.innerHTML = `<div class="form-grid">
        <div class="span-2"><label>Fourniture</label><select id="supply-line-select">${state.availableSupplies.map(s => `<option value="${s.id}">${escapeHtml(s.name)}</option>`).join("")}</select></div>
        <div><label>Quantité</label><input id="supply-line-qty" type="number" min="0.001" step="0.001" value="1"></div>
        <div style="align-self:end"><button type="button" id="supply-line-add" class="button button-primary button-full">＋ Ajouter</button></div>
      </div>`;
      container.querySelector("#supply-line-add").addEventListener("click", async () => {
        const supplyId = container.querySelector("#supply-line-select").value;
        const qty = Number(container.querySelector("#supply-line-qty").value || 0);
        const supply = state.availableSupplies.find(s => s.id === supplyId);
        if (!supply || qty <= 0) return showToast("Choisissez une fourniture et une quantité.", "error");
        state.supplyLines.push({ supplyId, supplyName: supply.name, quantity: qty, unit: supply.unit, unitCost: Number(supply.purchase_price || 0) });
        renderSupplyLines(); recomputeSummary();
      });
    }

    document.querySelector("#delivery-client").addEventListener("change", async e => {
      unsavedDeliveryDraft = true;
      state.clientId = e.target.value;
      state.categoryPrices = new Map();
      if (state.clientId) {
        const { data } = await sb.from("client_category_prices").select("category_id, unit_price").eq("client_id", state.clientId);
        (data || []).forEach(p => state.categoryPrices.set(p.category_id, p.unit_price));
      }
      loadAddLineForm();
    });
    document.querySelector("#delivery-location").addEventListener("change", e => { state.locationId = e.target.value; loadAddLineForm(); });
    document.querySelector("#delivery-transport-cost").addEventListener("input", e => { state.transportCost = Number(e.target.value || 0); unsavedDeliveryDraft = true; recomputeSummary(); });
    document.querySelector("#delivery-transport-price").addEventListener("input", e => { state.transportPrice = e.target.value === "" ? null : Number(e.target.value); unsavedDeliveryDraft = true; recomputeSummary(); });
    document.querySelector("#delivery-transport-vat").addEventListener("input", e => { state.transportVatRate = Number(e.target.value || 0); recomputeSummary(); });
    document.querySelector("#add-extra-cost").addEventListener("click", () => {
      const label = document.querySelector("#extra-cost-label").value.trim();
      const amount = Number(document.querySelector("#extra-cost-amount").value || 0);
      if (!label || amount <= 0) return showToast("Indiquez un libellé et un montant supérieur à zéro.", "error");
      state.extraCosts.push({ label, amount });
      document.querySelector("#extra-cost-label").value = "";
      document.querySelector("#extra-cost-amount").value = "0";
      unsavedDeliveryDraft = true;
      renderExtraCosts(); recomputeSummary();
    });

    loadAddSupplyForm();
    renderLines(); renderSupplyLines(); renderExtraCosts(); recomputeSummary();
    if (existingDelivery) {
      const { data: catPrices } = await sb.from("client_category_prices").select("category_id, unit_price").eq("client_id", state.clientId);
      (catPrices || []).forEach(p => state.categoryPrices.set(p.category_id, p.unit_price));
      if (state.locationId) loadAddLineForm();
    }

    document.querySelector("#save-new-delivery").addEventListener("click", async () => {
      if (!state.clientId) return showToast("Choisissez un client.", "error");
      if (!state.locationId) return showToast("Choisissez un emplacement de départ.", "error");
      if (!state.lines.length) return showToast("Ajoutez au moins un produit.", "error");
      const button = document.querySelector("#save-new-delivery");
      submitButtonLoading(button, true);
      try {
        const file = document.querySelector("#delivery-attachment").files[0];
        const attachmentPath = file ? await uploadPrivateFile("delivery-files", file) : null;
        const items = state.lines.map(l => ({ finished_lot_id: l.finishedLotId, ordered_recipe_id: l.recipeId || null, quantity: l.quantity, unit_price: l.unitPrice, vat_rate: l.vatRate }));
        const supplyItems = state.supplyLines.map(l => ({ supply_id: l.supplyId, quantity: l.quantity }));
        const shippingMode = document.querySelector("#delivery-shipping-mode").value;
        const estimatedDeliveryDate = document.querySelector("#delivery-estimated-date").value || null;
        const { data: newDeliveryId, error } = existingDelivery
          ? await sb.rpc("update_delivery", {
              p_delivery_id: existingDelivery.id,
              p_location_id: state.locationId,
              p_delivery_date: existingDelivery?.delivery_date || todayISO(),
              p_items: items,
              p_supply_items: supplyItems,
              p_transport_cost: Number(state.transportCost || 0),
              p_transport_price: state.transportPrice,
              p_transport_vat_rate: state.transportVatRate,
              p_attachment_path: attachmentPath,
              p_notes: document.querySelector("#delivery-notes").value.trim() || null,
              p_shipping_mode: shippingMode,
              p_estimated_delivery_date: estimatedDeliveryDate,
              p_extra_costs: state.extraCosts
            })
          : await sb.rpc("create_delivery", {
              p_client_id: state.clientId,
              p_location_id: state.locationId,
              p_delivery_date: existingDelivery?.delivery_date || todayISO(),
              p_delivery_number: null,
              p_items: items,
              p_supply_items: supplyItems,
              p_transport_cost: Number(state.transportCost || 0),
              p_transport_price: state.transportPrice,
              p_transport_vat_rate: state.transportVatRate,
              p_attachment_path: attachmentPath,
              p_notes: document.querySelector("#delivery-notes").value.trim() || null,
              p_shipping_mode: shippingMode,
              p_estimated_delivery_date: estimatedDeliveryDate,
              p_extra_costs: state.extraCosts
            });
        if (error) throw error;
        const savedDeliveryId = existingDelivery ? existingDelivery.id : newDeliveryId;
        if (savedDeliveryId && deliveryTags) {
          state.tagIds = new Set([...document.querySelectorAll(".delivery-tag-cb:checked")].map(cb => cb.value));
          const { error: tagError } = await sb.rpc("set_delivery_tags", { p_delivery_id: savedDeliveryId, p_tag_ids: [...state.tagIds] });
          if (tagError) showToast(`Livraison enregistrée, mais pas ses mentions de conservation : ${tagError.message}`, "error");
        }
        if (!existingDelivery && newDeliveryId) {
          const { error: departureError } = await sb.rpc("process_sale_pallet_departure", { p_delivery_id: newDeliveryId, p_items: items });
          if (departureError) console.error("Coût de sortie palette :", departureError.message);
        }
        showToast(existingDelivery ? "Livraison mise à jour." : "Livraison enregistrée (Programmée).");
        unsavedDeliveryDraft = false;
        renderDeliveries();
      } catch (err) { showError(err); }
      finally { submitButtonLoading(button, false); }
    });
  }

  // Facturation
  const INVOICE_PENDING_DAYS = 30;

  function invoiceDisplayStatus(invoiceStatus, pendingSince) {
    if (invoiceStatus === "pending" && pendingSince) {
      const elapsedMs = Date.now() - new Date(pendingSince).getTime();
      if (elapsedMs > INVOICE_PENDING_DAYS * 24 * 60 * 60 * 1000) return "late";
    }
    return invoiceStatus || "to_invoice";
  }

  const INVOICE_STATUSES = {
    to_invoice: { label: "À facturer", tone: "info" },
    pending: { label: "En attente", tone: "warning" },
    late: { label: "Retard", tone: "danger" },
    paid: { label: "Payée", tone: "success" }
  };

  async function renderInvoicing() {
    setHeader("invoicing");
    const canEdit = pageCan("invoicing");
    const { data, error } = await sb.from("deliveries")
      .select("id, client_id, delivery_number, delivery_date, delivered_at, amount_ttc, revenue_total, invoice_status, invoice_pending_since, invoice_number, clients(name,company)")
      .eq("organization_id", profile.organization_id)
      .eq("status", "delivered")
      .order("delivered_at", { ascending: false });
    if (error) throw error;
    const deliveries = data || [];

    // Livraisons pas encore rattachées à une facture (statut "À facturer")
    const ungrouped = deliveries.filter(d => !d.invoice_number && (d.invoice_status || "to_invoice") === "to_invoice");
    // Regroupement par numéro de facture pour tout le reste
    const groups = new Map();
    deliveries.filter(d => d.invoice_number).forEach(d => {
      if (!groups.has(d.invoice_number)) groups.set(d.invoice_number, []);
      groups.get(d.invoice_number).push(d);
    });

    let toInvoiceTotal = 0, pendingTotal = 0, lateTotal = 0;
    ungrouped.forEach(d => { toInvoiceTotal += Number(d.revenue_total || 0); });

    const groupRows = [...groups.entries()].map(([invoiceNumber, items]) => {
      const first = items[0];
      const displayStatus = invoiceDisplayStatus(first.invoice_status, first.invoice_pending_since);
      const amountHt = items.reduce((s, d) => s + Number(d.revenue_total || 0), 0);
      if (displayStatus === "pending") pendingTotal += amountHt;
      else if (displayStatus === "late") lateTotal += amountHt;
      const latestDate = items.reduce((max, d) => (d.delivered_at || "") > max ? d.delivered_at : max, items[0].delivered_at || "");
      const clientNames = [...new Set(items.map(d => d.clients?.company || d.clients?.name || "—"))];
      return { invoiceNumber, items, displayStatus, amountHt, latestDate, clientLabel: clientNames.join(", "), invoiceStatus: first.invoice_status };
    }).sort((a, b) => (b.latestDate || "").localeCompare(a.latestDate || ""));

    const groupRowsHtml = groupRows.map(g => {
      const info = INVOICE_STATUSES[g.displayStatus];
      return `<tr data-searchable>
        <td><strong>${escapeHtml(g.invoiceNumber)}</strong></td>
        <td><strong>${escapeHtml(g.clientLabel)}</strong>${g.items.length > 1 ? ` <span class="muted">(${g.items.length} livraisons)</span>` : ""}</td>
        <td>${formatDate(g.latestDate)}</td>
        <td>${formatMoney(g.amountHt)}</td>
        <td>${badge(info.label, info.tone)}</td>
        <td><div class="table-actions">
          <button class="icon-button icon-small view-invoice-products" data-invoice="${escapeHtml(g.invoiceNumber)}" title="Voir les produits">👁</button>
          ${canEdit && (g.displayStatus === "pending" || g.displayStatus === "late") ? `<button class="button button-small button-primary mark-group-paid" data-invoice="${escapeHtml(g.invoiceNumber)}">Marquer payée</button>` : ""}
          ${canEdit ? `<button class="icon-button icon-small revert-group" data-invoice="${escapeHtml(g.invoiceNumber)}" title="Revenir à l’étape précédente">${ICONS.arrowLeft}</button>` : ""}
        </div></td>
      </tr>`;
    }).join("");

    const ungroupedRows = ungrouped.map(d => `<tr data-searchable class="${canEdit ? "invoice-selectable" : ""}">
        <td>${canEdit ? `<input type="checkbox" class="select-to-invoice" data-id="${d.id}" data-amount="${Number(d.revenue_total || 0)}" data-client="${escapeHtml(d.client_id || "")}" data-client-name="${escapeHtml(d.clients?.company || d.clients?.name || "")}" aria-label="Sélectionner ${escapeHtml(d.delivery_number)}">` : ""}</td>
        <td><strong>${escapeHtml(d.delivery_number)}</strong></td>
        <td><strong>${escapeHtml(d.clients?.company || d.clients?.name || "—")}</strong></td>
        <td>${formatDate(d.delivered_at)}</td>
        <td>${formatMoney(Number(d.revenue_total || 0))}</td>
        <td>${badge("À facturer", "info")}</td>
      </tr>`).join("");

    content.innerHTML = `
      <div class="grid grid-3 stock-summary">
        <article class="card metric-card metric-card-flip"><div class="metric metric-info">${formatMoney(toInvoiceTotal)}</div><small>À facturer</small></article>
        <article class="card metric-card metric-card-flip"><div class="metric metric-warning">${formatMoney(pendingTotal)}</div><small>En attente</small></article>
        <article class="card metric-card metric-card-flip"><div class="metric metric-critical">${formatMoney(lateTotal)}</div><small>En retard</small></article>
      </div>

      ${ungrouped.length ? `
      <div class="form-section-title" style="margin-top:22px">☰ Livraisons à facturer</div>
      <div class="toolbar">
        <input id="invoice-search" class="search" placeholder="Rechercher une livraison, un client…">
        ${canEdit ? `<button type="button" id="assign-invoice-number" class="button button-primary" disabled>Attribuer un numéro de facture</button>
        <span id="invoice-selection-summary" class="invoice-selection-summary"></span>` : ""}
        <div class="toolbar-spacer"></div>
      </div>
      <div class="table-wrap">${ungroupedRows ? `<table><thead><tr><th>${canEdit ? `<input type="checkbox" id="select-all-invoices" title="Tout sélectionner" aria-label="Tout sélectionner">` : ""}</th><th>Livraison</th><th>Client</th><th>Livrée le</th><th>Montant HT</th><th>Statut</th></tr></thead><tbody id="to-invoice-body">${ungroupedRows}</tbody></table>` : ""}</div>
      ` : ""}

      <div class="form-section-title" style="margin-top:26px">📄 Factures</div>
      <div class="toolbar"><input id="invoicing-search" class="search" placeholder="Rechercher un client, un numéro de facture…"><div class="toolbar-spacer"></div></div>
      <div class="table-wrap">${groupRowsHtml ? `<table><thead><tr><th>N° facture</th><th>Client(s)</th><th>Livrée le</th><th>Montant HT</th><th>Statut</th><th></th></tr></thead><tbody>${groupRowsHtml}</tbody></table>` : emptyState("Aucune facture émise", "Sélectionnez des livraisons ci-dessus et attribuez-leur un numéro.")}</div>
    `;

    document.querySelector("#invoicing-search")?.addEventListener("input", e => {
      const q = e.target.value.trim().toLocaleLowerCase("fr");
      document.querySelectorAll("[data-searchable]").forEach(el => { el.hidden = Boolean(q) && !el.textContent.toLocaleLowerCase("fr").includes(q); });
    });

    const assignBtn = document.querySelector("#assign-invoice-number");
    const allBoxes = () => [...document.querySelectorAll(".select-to-invoice")];
    // Seules les lignes visibles comptent (la recherche peut en masquer)
    const visibleBoxes = () => allBoxes().filter(cb => !cb.closest("tr")?.hidden);
    function syncAssignButton() {
      const checked = allBoxes().filter(cb => cb.checked);
      if (assignBtn) assignBtn.disabled = checked.length === 0;
      allBoxes().forEach(cb => cb.closest("tr")?.classList.toggle("is-selected", cb.checked));
      const summary = document.querySelector("#invoice-selection-summary");
      if (summary) {
        const total = checked.reduce((s, cb) => s + Number(cb.dataset.amount || 0), 0);
        const clients = new Set(checked.map(cb => cb.dataset.client));
        // Une livraison cochée puis masquée par la recherche reste sélectionnée :
        // on le dit, pour ne jamais facturer sans le savoir ce qu'on ne voit plus
        const hiddenChecked = checked.filter(cb => cb.closest("tr")?.hidden).length;
        summary.innerHTML = checked.length
          ? `${checked.length} livraison${checked.length > 1 ? "s" : ""} · <strong>${formatMoney(total)} HT</strong>${clients.size > 1 ? ` <span class="invoice-multi-client">· ${clients.size} clients différents</span>` : ""}${hiddenChecked ? ` <span class="invoice-multi-client">· dont ${hiddenChecked} masquée${hiddenChecked > 1 ? "s" : ""} par la recherche</span>` : ""}`
          : "";
      }
      const all = document.querySelector("#select-all-invoices");
      if (all) {
        const vis = visibleBoxes();
        all.checked = vis.length > 0 && vis.every(cb => cb.checked);
        all.indeterminate = vis.some(cb => cb.checked) && !all.checked;
      }
    }
    allBoxes().forEach(cb => cb.addEventListener("change", syncAssignButton));
    document.querySelector("#invoice-search")?.addEventListener("input", e => {
      const q = e.target.value.trim().toLocaleLowerCase("fr");
      document.querySelectorAll("#to-invoice-body [data-searchable]").forEach(el => {
        el.hidden = Boolean(q) && !el.textContent.toLocaleLowerCase("fr").includes(q);
      });
      // « Tout sélectionner » et le résumé tiennent compte des lignes visibles
      syncAssignButton();
    });
    document.querySelector("#select-all-invoices")?.addEventListener("change", e => {
      visibleBoxes().forEach(cb => { cb.checked = e.target.checked; });
      syncAssignButton();
    });
    // Toute la ligne sert de zone de clic, pas seulement la petite case
    document.querySelectorAll("tr.invoice-selectable").forEach(tr => tr.addEventListener("click", e => {
      if (e.target.closest("input, button, a, select, label")) return;
      const cb = tr.querySelector(".select-to-invoice");
      if (cb) { cb.checked = !cb.checked; syncAssignButton(); }
    }));
    assignBtn?.addEventListener("click", () => {
      const checked = allBoxes().filter(cb => cb.checked);
      if (!checked.length) return;
      // Une facture n'a qu'un destinataire : on prévient avant de mélanger des clients
      const names = [...new Set(checked.map(cb => cb.dataset.clientName).filter(Boolean))];
      if (names.length > 1 && !confirm(`Ces livraisons concernent ${names.length} clients différents :\n\n${names.join("\n")}\n\nUne facture ne peut avoir qu’un seul destinataire. Continuer quand même ?`)) return;
      // Récapitulatif d'abord, pour saisir la facture dans Qonto ; le numéro ensuite
      invoiceRecapModal(checked.map(cb => cb.dataset.id));
    });

    document.querySelectorAll(".view-invoice-products").forEach(btn => btn.addEventListener("click", () => invoiceProductsModal(btn.dataset.invoice)));
    document.querySelectorAll(".mark-group-paid").forEach(btn => btn.addEventListener("click", async () => {
      const { error: rpcError } = await sb.rpc("mark_invoice_group_paid", { p_invoice_number: btn.dataset.invoice });
      if (rpcError) return showError(rpcError);
      showToast("Facture marquée comme payée."); renderInvoicing();
    }));
    document.querySelectorAll(".revert-group").forEach(btn => btn.addEventListener("click", async () => {
      const { error: rpcError } = await sb.rpc("revert_invoice_group_status", { p_invoice_number: btn.dataset.invoice });
      if (rpcError) return showError(rpcError);
      showToast("Retour à l’étape précédente."); renderInvoicing();
    }));
  }


  // Récapitulatif de facturation : ce qu'il faut saisir dans Qonto, avant
  // d'attribuer un numéro. Les lignes d'un même produit au même prix et à la
  // même TVA sont regroupées (une livraison peut avoir une ligne par lot).
  function unitPriceText(p) {
    // Un prix à 3 ou 4 décimales s'affiche en entier : l'arrondir au centime
    // fausserait la facture saisie
    const v = Number(p || 0);
    return Math.abs(v * 100 - Math.round(v * 100)) < 1e-9
      ? formatMoney(v)
      : `${v.toLocaleString("fr-FR", { minimumFractionDigits: 2, maximumFractionDigits: 4 })} €`;
  }

  function buildInvoiceRecap(deliveries, items) {
    const lines = new Map();
    items.forEach(it => {
      const rec = it.finished_lots?.recipes || it.recipes || null;
      const recipeKey = it.finished_lots?.recipe_id || it.ordered_recipe_id || rec?.name || "?";
      const price = Number(it.unit_price || 0), vat = Number(it.vat_rate ?? 5.5), qty = Number(it.quantity || 0);
      const key = `${recipeKey}|${price}|${vat}`;
      const l = lines.get(key) || { name: rec?.name || "Produit", unit: rec?.sale_unit || "", price, vat, qty: 0 };
      l.qty += qty;
      lines.set(key, l);
    });
    const productLines = [...lines.values()].sort((a, b) => a.name.localeCompare(b.name, "fr") || a.price - b.price);
    const transport = new Map();
    deliveries.forEach(d => {
      const price = Number(d.transport_price || 0);
      if (!(price > 0)) return;
      const vat = Number(d.transport_vat_rate ?? 20), key = `${price}|${vat}`;
      const t = transport.get(key) || { name: "Transport", unit: "livraison", price, vat, qty: 0 };
      t.qty += 1;
      transport.set(key, t);
    });
    transport.forEach(t => { t.unit = t.qty > 1 ? "livraisons" : "livraison"; });
    const all = [...productLines, ...transport.values()];
    all.forEach(l => { l.ht = l.price * l.qty; });
    const vatByRate = new Map();
    all.forEach(l => vatByRate.set(l.vat, (vatByRate.get(l.vat) || 0) + l.ht * l.vat / 100));
    const ht = all.reduce((s, l) => s + l.ht, 0);
    const vatTotal = [...vatByRate.values()].reduce((s, v) => s + v, 0);
    // Contrôle : le récapitulatif doit retomber sur les totaux enregistrés
    const storedTtc = deliveries.reduce((s, d) => s + Number(d.amount_ttc || 0), 0);
    const storedHt = deliveries.reduce((s, d) => s + Number(d.revenue_total || 0), 0);
    return {
      productLines, transportLines: [...transport.values()], ht, vatByRate: [...vatByRate.entries()].sort((a, b) => a[0] - b[0]),
      vatTotal, ttc: ht + vatTotal, storedTtc, storedHt,
      matches: Math.abs(ht + vatTotal - storedTtc) < 0.005 && Math.abs(ht - storedHt) < 0.005
    };
  }

  async function invoiceRecapModal(deliveryIds) {
    const [{ data: deliveries, error: dErr }, items] = await Promise.all([
      sb.from("deliveries").select("id, delivery_number, delivery_date, transport_price, transport_vat_rate, amount_ttc, revenue_total, clients(name, company)").in("id", deliveryIds),
      fetchAllRows(() => sb.from("delivery_items").select("delivery_id, quantity, unit_price, vat_rate, ordered_recipe_id, finished_lots(recipe_id, recipes(name, sale_unit)), recipes:ordered_recipe_id(name, sale_unit)").in("delivery_id", deliveryIds))
    ]).catch(err => [{ error: err }, []]);
    if (dErr) return showError(dErr);
    const list = (deliveries || []).sort((a, b) => String(a.delivery_date).localeCompare(String(b.delivery_date)));
    const recap = buildInvoiceRecap(list, items || []);
    const clients = [...new Set(list.map(d => d.clients?.company || d.clients?.name).filter(Boolean))];
    const refsText = list.map(d => `${d.delivery_number} du ${formatDate(d.delivery_date)}`).join(", ");
    const row = l => `<tr>
        <td><strong>${escapeHtml(l.name)}</strong></td>
        <td class="num">${formatNumber(l.qty)} ${escapeHtml(l.unit)}</td>
        <td class="num">${unitPriceText(l.price)}</td>
        <td class="num">${formatNumber(l.vat)} %</td>
        <td class="num"><strong>${formatMoney(l.ht)}</strong></td>
      </tr>`;
    openModal({
      title: "Récapitulatif à facturer",
      kicker: `${clients.join(" · ") || "Client"} — ${list.length} livraison${list.length > 1 ? "s" : ""}`,
      width: "780px",
      html: `
        <div class="invoice-refs">
          <small>Livraisons concernées</small>
          <div class="invoice-refs-line"><span id="invoice-refs-text">${escapeHtml(refsText)}</span>
            <button type="button" class="button button-small button-secondary" id="copy-invoice-refs">Copier</button></div>
        </div>
        <div class="table-wrap"><table class="invoice-recap">
          <thead><tr><th>Désignation</th><th class="num">Quantité</th><th class="num">Prix unitaire HT</th><th class="num">TVA</th><th class="num">Total HT</th></tr></thead>
          <tbody>
            ${recap.productLines.map(row).join("") || `<tr><td colspan="5" class="muted">Aucun produit</td></tr>`}
            ${recap.transportLines.map(row).join("")}
          </tbody>
          <tfoot>
            <tr><td colspan="4">Total HT</td><td class="num">${formatMoney(recap.ht)}</td></tr>
            ${recap.vatByRate.map(([rate, v]) => `<tr><td colspan="4">TVA ${formatNumber(rate)} %</td><td class="num">${formatMoney(v)}</td></tr>`).join("")}
            <tr class="invoice-recap-total"><td colspan="4">Total TTC</td><td class="num">${formatMoney(recap.ttc)}</td></tr>
          </tfoot>
        </table></div>
        ${recap.matches
          ? `<div class="help-box" style="margin-top:12px">Contrôle : ces totaux correspondent exactement aux livraisons enregistrées.</div>`
          : `<div class="warning-box" style="margin-top:12px">Attention : le récapitulatif (${formatMoney(recap.ttc)} TTC) ne correspond pas aux totaux enregistrés sur les livraisons (${formatMoney(recap.storedTtc)} TTC). Vérifie les livraisons avant de facturer.</div>`}
        <div class="form-actions" style="margin-top:18px">
          <button type="button" class="button button-ghost" data-close-modal>Retour</button>
          <button type="button" class="button button-primary" id="recap-continue">Attribuer un numéro de facture</button>
        </div>`
    });
    modalBody.querySelector("[data-close-modal]").addEventListener("click", closeModal);
    modalBody.querySelector("#copy-invoice-refs").addEventListener("click", async () => {
      try { await navigator.clipboard.writeText(refsText); showToast("Références copiées."); }
      catch (e) { showToast("Copie impossible : sélectionne le texte à la main.", "error"); }
    });
    modalBody.querySelector("#recap-continue").addEventListener("click", () => {
      closeModal();
      invoiceNumberModal(deliveryIds);
    });
  }

  function invoiceNumberModal(deliveryIds) {
    const currentYear = new Date().getFullYear();
    openModal({
      title: "Attribuer un numéro de facture",
      kicker: `${deliveryIds.length} livraison${deliveryIds.length > 1 ? "s" : ""} sélectionnée${deliveryIds.length > 1 ? "s" : ""}`,
      html: `<form id="invoice-number-form" class="form-grid">
        <div class="span-2"><label>Numéro de facture</label>
          <div style="display:flex;align-items:center;gap:6px">
            <span class="muted" style="font-weight:700">PRO-${currentYear}-</span>
            <input name="invoice_suffix" required pattern="[0-9]+" placeholder="000" style="max-width:110px">
          </div>
          <p class="form-note">Seul ce numéro est à saisir ; le préfixe et l’année sont automatiques.</p>
        </div>
        <div class="form-actions span-2"><button type="button" class="button button-ghost" data-close-modal>Annuler</button><button class="button button-primary" type="submit">Passer en attente</button></div>
      </form>`
    });
    modalBody.querySelector("[data-close-modal]").addEventListener("click", closeModal);
    modalBody.querySelector("#invoice-number-form").addEventListener("submit", async event => {
      event.preventDefault();
      const button = event.submitter; submitButtonLoading(button, true);
      const values = formObject(event.currentTarget);
      const invoiceNumber = `PRO-${currentYear}-${values.invoice_suffix.trim().padStart(3, "0")}`;
      const { error } = await sb.rpc("set_invoice_pending_bulk", { p_delivery_ids: deliveryIds, p_invoice_number: invoiceNumber });
      submitButtonLoading(button, false);
      if (error) return showError(error);
      closeModal(); showToast(`Facture ${invoiceNumber} créée.`); renderInvoicing();
    });
  }

  async function invoiceProductsModal(invoiceNumber) {
    const { data: deliveries, error } = await sb.from("deliveries").select("id, delivery_number, clients(name,company)").eq("organization_id", profile.organization_id).eq("invoice_number", invoiceNumber);
    if (error) return showError(error);
    const deliveryIds = (deliveries || []).map(d => d.id);
    const { data: items, error: itemsError } = deliveryIds.length
      ? await sb.from("delivery_items").select("delivery_id, quantity, unit_price, finished_lots(lot_number, recipes(name, sale_unit))").in("delivery_id", deliveryIds)
      : { data: [] };
    if (itemsError) return showError(itemsError);
    const deliveryById = new Map((deliveries || []).map(d => [d.id, d]));
    const rows = (items || []).map(i => `<tr>
      <td>${escapeHtml(i.finished_lots?.recipes?.name || "—")}</td>
      <td><span class="lot-pill">${escapeHtml(i.finished_lots?.lot_number || "Sans lot")}</span></td>
      <td>${escapeHtml(deliveryById.get(i.delivery_id)?.delivery_number || "—")}</td>
      <td>${formatNumber(i.quantity)} ${escapeHtml(i.finished_lots?.recipes?.sale_unit || "")}</td>
      <td>${formatMoney(i.unit_price)}</td>
      <td>${formatMoney(Number(i.quantity) * Number(i.unit_price))}</td>
    </tr>`).join("");
    const total = (items || []).reduce((s, i) => s + Number(i.quantity) * Number(i.unit_price), 0);
    openModal({
      title: `Facture ${invoiceNumber}`,
      kicker: [...new Set((deliveries || []).map(d => d.clients?.company || d.clients?.name))].join(", "),
      width: "760px",
      html: `<div class="table-wrap">${rows ? `<table><thead><tr><th>Produit</th><th>Lot</th><th>Livraison</th><th>Quantité</th><th>Prix HT / unité</th><th>Total HT</th></tr></thead><tbody>${rows}</tbody></table>` : emptyState("Aucun produit", "")}</div>
        <div class="lot-total" style="margin-top:12px">Total HT : <strong>${formatMoney(total)}</strong></div>`
    });
  }

  // Paramètres livraison
  const TONE_OPTIONS = [
    { key: "info", label: "Bleu" }, { key: "warning", label: "Orange" }, { key: "purple", label: "Violet" },
    { key: "success", label: "Vert" }, { key: "danger", label: "Rouge" }, { key: "neutral", label: "Gris" }
  ];

  async function renderDeliverySettings() {
    const canEdit = pageCan("delivery-settings");
    const deliveryTags = await fetchDeliveryTags();
    const [statuses, modes, rules, { data: prodReminders }, { data: orgRetro }] = await Promise.all([
      fetchDeliveryStatuses(), fetchShippingModes(), fetchDeliveryReminderRules(),
      sb.from("production_step_reminders").select("*").eq("organization_id", profile.organization_id),
      sb.from("organizations").select("retro_silence_from_status").eq("id", profile.organization_id).single()
    ]);
    const STEP_NAMES = {
      order: "Commande fournisseur", materials: "Réception matières", production_start: "Début production",
      production_end: "Fin production", shipping: "Départ de l'atelier", delivery: "Livraison client"
    };
    const STEP_SORT = ["order", "materials", "production_start", "production_end", "shipping", "delivery"];
    const prodReminderRows = (prodReminders || [])
      .sort((a, b) => STEP_SORT.indexOf(a.step_key) - STEP_SORT.indexOf(b.step_key))
      .map(r => `<tr>
        <td><strong>${escapeHtml(STEP_NAMES[r.step_key] || r.step_key)}</strong></td>
        <td><input class="prod-reminder-label" data-id="${r.id}" value="${escapeHtml(r.label || "")}" ${!canEdit ? "disabled" : ""}></td>
        <td style="white-space:nowrap"><input type="number" min="0" step="1" style="width:70px;display:inline-block" class="prod-reminder-days" data-id="${r.id}" value="${r.days_before}" ${!canEdit ? "disabled" : ""}> j. avant</td>
        <td><label class="switch"><input type="checkbox" class="prod-reminder-active" data-id="${r.id}" ${r.active ? "checked" : ""} ${!canEdit ? "disabled" : ""}><span class="switch-slider"></span></label></td>
      </tr>`).join("");

    const statusRows = statuses.map((s, idx) => `<div class="draggable-row" draggable="${canEdit}" data-id="${s.id}">
      <span class="drag-handle">⠿</span>
      <span class="dash-section-badge stat-cat-pill kanban-status-pill-${s.tone}">${escapeHtml(s.label)}</span>
      ${s.is_terminal ? badge("Étape finale", "success") : ""}
      <div class="table-actions">${canEdit ? `<button class="button button-small button-ghost edit-status" data-id="${s.id}">Modifier</button><button class="button button-small button-danger delete-status" data-id="${s.id}">Supprimer</button>` : ""}</div>
    </div>`).join("");

    const modeRows = modes.map(m => `<div class="draggable-row" draggable="${canEdit}" data-id="${m.id}">
      <span class="drag-handle">⠿</span>
      <strong>${escapeHtml(m.label)}</strong>
      <div class="table-actions">${canEdit ? `<button class="button button-small button-ghost edit-mode" data-id="${m.id}">Modifier</button><button class="button button-small button-danger delete-mode" data-id="${m.id}">Supprimer</button>` : ""}</div>
    </div>`).join("");

    const statusLabel = key => statuses.find(s => s.key === key)?.label || key;
    const modeLabel = key => key ? (modes.find(m => m.key === key)?.label || key) : "Tous les modes";
    const ruleRows = rules.map(r => `<tr data-searchable>
      <td><strong>${escapeHtml(r.label)}</strong></td>
      <td>${escapeHtml(statusLabel(r.status_key))}</td>
      <td>${escapeHtml(modeLabel(r.shipping_mode_key))}</td>
      <td>${r.reminder_days} j. ouvré(s) avant</td>
      <td>${r.active ? badge("Active", "success") : badge("Suspendue")}</td>
      <td><div class="table-actions">
        ${canEdit ? `<button class="button button-small button-ghost edit-rule" data-id="${r.id}">Modifier</button>` : ""}
        ${canEdit ? `<button class="button button-small button-danger delete-rule" data-id="${r.id}">Supprimer</button>` : ""}
      </div></td>
    </tr>`).join("");

    content.innerHTML = `
      <div class="form-section-title">📶 Statuts de livraison ${helpTip("L’ordre définit la progression d’une commande dans le Kanban. Un seul statut doit être marqué « Étape finale » (déclenche la facturation et sort la commande du suivi actif)." + (canEdit ? " Glisse-dépose pour réordonner." : ""))}</div>
      <div id="statuses-list" class="draggable-list" style="margin-top:12px">${statusRows || emptyState("Aucun statut", "")}</div>
      ${canEdit ? `<button type="button" id="add-status" class="button button-secondary" style="margin-top:10px">${ICONS.plus} Ajouter un statut</button>` : ""}

      <div class="form-section-title" style="margin-top:32px">🚚 Modes d’expédition ${helpTip("Utilisés sur chaque livraison et sur les commandes récurrentes.")}</div>
      <div id="modes-list" class="draggable-list" style="margin-top:12px">${modeRows || emptyState("Aucun mode", "")}</div>
      ${canEdit ? `<button type="button" id="add-mode" class="button button-secondary" style="margin-top:10px">${ICONS.plus} Ajouter un mode</button>` : ""}

      <div class="form-section-title" style="margin-top:32px">🌡 Mentions de conservation ${helpTip("Cochées à la main sur chaque livraison, elles s’affichent sur sa carte. Une livraison peut en porter plusieurs.")}</div>
      ${deliveryTags === null
        ? `<div class="warning-box">Les mentions de conservation seront disponibles après la migration 99.</div>`
        : `
      <div id="delivery-tags-list" class="draggable-list" style="margin-top:12px">${deliveryTags.map(t => `<div class="draggable-row" draggable="${canEdit}" data-id="${t.id}">
        <span class="drag-handle">⠿</span>
        <span class="dash-section-badge stat-cat-pill kanban-status-pill-${t.tone}">${escapeHtml(t.label)}</span>
        <div class="table-actions">${canEdit ? `<button class="button button-small button-ghost edit-delivery-tag" data-id="${t.id}">Modifier</button><button class="button button-small button-danger delete-delivery-tag" data-id="${t.id}">Supprimer</button>` : ""}</div>
      </div>`).join("") || emptyState("Aucune mention", "")}</div>
      ${canEdit ? `<button type="button" id="add-delivery-tag" class="button button-secondary" style="margin-top:10px">${ICONS.plus} Ajouter une mention</button>` : ""}`}

      <div class="form-section-title" style="margin-top:32px">🔔 Règles de rappel ${helpTip("Chaque règle génère un rappel dans l’onglet Tâches quand une commande atteint le statut choisi, tant qu’elle y reste. Une règle peut s’appliquer à un mode d’expédition précis ou à tous les modes.")}</div>
      <div class="table-wrap" style="margin-top:12px">${ruleRows ? `<table><thead><tr><th>Libellé</th><th>Statut</th><th>Mode</th><th>Délai</th><th>État</th><th></th></tr></thead><tbody>${ruleRows}</tbody></table>` : emptyState("Aucune règle de rappel", "")}</div>
      ${canEdit ? `<button type="button" id="add-rule" class="button button-secondary" style="margin-top:10px">${ICONS.plus} Ajouter une règle de rappel</button>` : ""}

      <div class="form-section-title" style="margin-top:32px">🏭 Rappels du rétroplanning${helpTip("Chaque étape du rétroplanning génère une tâche le nombre de jours indiqué avant sa date. Le libellé est modifiable pour correspondre à ton vocabulaire.")}</div>
      <div class="table-wrap" style="margin-top:12px">${prodReminderRows ? `<table><thead><tr><th>Étape</th><th>Libellé de la tâche</th><th>Rappel</th><th>État</th></tr></thead><tbody>${prodReminderRows}</tbody></table>` : emptyState("Aucun rappel configuré", "")}</div>
      ${canEdit ? `<button type="button" id="save-prod-reminders" class="button button-primary" style="margin-top:12px">Enregistrer les rappels</button>` : ""}
    `;

    document.querySelector("#save-prod-reminders")?.addEventListener("click", async () => {
      const btn = document.querySelector("#save-prod-reminders"); submitButtonLoading(btn, true);
      const updates = [...document.querySelectorAll(".prod-reminder-label")].map(el => ({
        id: el.dataset.id,
        label: el.value.trim(),
        days_before: Number(document.querySelector(`.prod-reminder-days[data-id="${el.dataset.id}"]`).value || 0),
        active: document.querySelector(`.prod-reminder-active[data-id="${el.dataset.id}"]`).checked
      }));
      for (const u of updates) {
        const { error: upError } = await sb.from("production_step_reminders")
          .update({ label: u.label, days_before: u.days_before, active: u.active }).eq("id", u.id);
        if (upError) { submitButtonLoading(btn, false); return showError(upError); }
      }
      submitButtonLoading(btn, false);
      const silence = document.querySelector("#retro-silence-from")?.value;
      if (silence) {
        const { error: orgErr } = await sb.from("organizations")
          .update({ retro_silence_from_status: silence }).eq("id", profile.organization_id);
        if (orgErr) return showError(orgErr);
      }
      showToast("Rappels enregistrés."); renderDeliverySettings();
    });

    if (canEdit) {
      wireDragReorder("#statuses-list", ".draggable-row", async orderedIds => {
        const { error } = await sb.rpc("reorder_delivery_statuses", { p_ids: orderedIds });
        if (error) return showError(error);
        renderDeliverySettings();
      });
      wireDragReorder("#modes-list", ".draggable-row", async orderedIds => {
        const { error } = await sb.rpc("reorder_shipping_modes", { p_ids: orderedIds });
        if (error) showError(error);
      });
    }

    document.querySelector("#add-status")?.addEventListener("click", () => deliveryStatusModal());
    document.querySelectorAll(".edit-status").forEach(btn => btn.addEventListener("click", () => deliveryStatusModal(statuses.find(s => s.id === btn.dataset.id))));
    document.querySelectorAll(".delete-status").forEach(btn => btn.addEventListener("click", async () => {
      if (!confirm("Supprimer ce statut ? Impossible s’il est encore utilisé par des livraisons.")) return;
      const { error } = await sb.rpc("delete_delivery_status", { p_id: btn.dataset.id });
      if (error) return showError(error);
      showToast("Statut supprimé."); renderDeliverySettings();
    }));

    document.querySelector("#add-delivery-tag")?.addEventListener("click", () => deliveryTagModal(null, deliveryTags));
    document.querySelectorAll(".edit-delivery-tag").forEach(btn => btn.addEventListener("click", () =>
      deliveryTagModal(deliveryTags.find(t => t.id === btn.dataset.id), deliveryTags)));
    document.querySelectorAll(".delete-delivery-tag").forEach(btn => btn.addEventListener("click", async () => {
      const t = deliveryTags.find(x => x.id === btn.dataset.id);
      if (!confirm(`Supprimer la mention « ${t?.label} » ?\n\nElle disparaîtra aussi des livraisons qui la portent.`)) return;
      const { error } = await sb.from("delivery_tags").delete().eq("id", btn.dataset.id);
      if (error) return showError(error);
      showToast("Mention supprimée."); renderDeliverySettings();
    }));
    if (canEdit && deliveryTags) {
      wireDragReorder("#delivery-tags-list", ".draggable-row", async orderedIds => {
        for (let i = 0; i < orderedIds.length; i++) {
          const { error } = await sb.from("delivery_tags").update({ sort_order: (i + 1) * 10 }).eq("id", orderedIds[i]);
          if (error) return showError(error);
        }
        renderDeliverySettings();
      });
    }

    document.querySelector("#add-mode")?.addEventListener("click", () => shippingModeModal());
    document.querySelectorAll(".edit-mode").forEach(btn => btn.addEventListener("click", () => shippingModeModal(modes.find(m => m.id === btn.dataset.id))));
    document.querySelectorAll(".delete-mode").forEach(btn => btn.addEventListener("click", async () => {
      if (!confirm("Supprimer ce mode ? Impossible s’il est encore utilisé par des livraisons.")) return;
      const { error } = await sb.rpc("delete_shipping_mode", { p_id: btn.dataset.id });
      if (error) return showError(error);
      showToast("Mode supprimé."); renderDeliverySettings();
    }));

    document.querySelector("#add-rule")?.addEventListener("click", () => reminderRuleModal(statuses, modes));
    document.querySelectorAll(".edit-rule").forEach(btn => btn.addEventListener("click", () => reminderRuleModal(statuses, modes, rules.find(r => r.id === btn.dataset.id))));
    document.querySelectorAll(".delete-rule").forEach(btn => btn.addEventListener("click", async () => {
      if (!confirm("Supprimer cette règle de rappel ?")) return;
      const { error } = await sb.rpc("delete_reminder_rule", { p_id: btn.dataset.id });
      if (error) return showError(error);
      showToast("Règle supprimée."); renderDeliverySettings();
    }));
  }

  function deliveryStatusModal(status = null) {
    openModal({
      title: status ? "Modifier le statut" : "Nouveau statut de livraison",
      kicker: "Paramètres livraison",
      html: `<form id="status-form" class="form-grid">
        <div class="span-2"><label>Nom *</label><input name="label" required value="${escapeHtml(status?.label || "")}" placeholder="Ex : Contrôle qualité"></div>
        <div><label>Couleur</label><select name="tone">${TONE_OPTIONS.map(t => `<option value="${t.key}" ${status?.tone === t.key ? "selected" : ""}>${t.label}</option>`).join("")}</select></div>
        <div class="checkbox-row" style="align-self:end"><label class="switch"><input type="checkbox" name="is_terminal" ${status?.is_terminal ? "checked" : ""}><span class="switch-slider"></span></label><span>Étape finale (déclenche la facturation)</span></div>
        <div class="span-2 help-inline">${helpTip("Un seul statut doit être « Étape finale ». Cocher celui-ci décochera automatiquement les autres.")}<span class="help-inline-label">À savoir</span></div>
        <div class="form-actions span-2"><button type="button" class="button button-ghost" data-close-modal>Annuler</button><button class="button button-primary" type="submit">Enregistrer</button></div>
      </form>`
    });
    modalBody.querySelector("[data-close-modal]").addEventListener("click", closeModal);
    modalBody.querySelector("#status-form").addEventListener("submit", async event => {
      event.preventDefault();
      const button = event.submitter; submitButtonLoading(button, true);
      const values = formObject(event.currentTarget);
      const isTerminal = modalBody.querySelector('[name="is_terminal"]').checked;
      const { error } = await sb.rpc("upsert_delivery_status", {
        p_id: status?.id || null, p_label: values.label.trim(), p_tone: values.tone, p_is_terminal: isTerminal
      });
      submitButtonLoading(button, false);
      if (error) return showError(error);
      closeModal(); showToast("Statut enregistré."); renderDeliverySettings();
    });
  }

  function shippingModeModal(mode = null) {
    openModal({
      title: mode ? "Modifier le mode" : "Nouveau mode d’expédition",
      kicker: "Paramètres livraison",
      html: `<form id="mode-form" class="form-grid">
        <div class="span-2"><label>Nom *</label><input name="label" required value="${escapeHtml(mode?.label || "")}" placeholder="Ex : Point relais"></div>
        <div class="form-actions span-2"><button type="button" class="button button-ghost" data-close-modal>Annuler</button><button class="button button-primary" type="submit">Enregistrer</button></div>
      </form>`
    });
    modalBody.querySelector("[data-close-modal]").addEventListener("click", closeModal);
    modalBody.querySelector("#mode-form").addEventListener("submit", async event => {
      event.preventDefault();
      const button = event.submitter; submitButtonLoading(button, true);
      const values = formObject(event.currentTarget);
      const { error } = await sb.rpc("upsert_shipping_mode", { p_id: mode?.id || null, p_label: values.label.trim() });
      submitButtonLoading(button, false);
      if (error) return showError(error);
      closeModal(); showToast("Mode enregistré."); renderDeliverySettings();
    });
  }

  function reminderRuleModal(statuses, modes, rule = null) {
    openModal({
      title: rule ? "Modifier la règle de rappel" : "Nouvelle règle de rappel",
      kicker: "Paramètres livraison",
      html: `<form id="rule-form" class="form-grid">
        <div class="span-2"><label>Libellé *</label><input name="label" required value="${escapeHtml(rule?.label || "")}" placeholder="Ex : Préparation, Expédition, Contrôle qualité…"></div>
        <div><label>Statut *</label><select name="status_key">${statuses.map(s => `<option value="${s.key}" ${rule?.status_key === s.key ? "selected" : ""}>${escapeHtml(s.label)}</option>`).join("")}</select></div>
        <div><label>Mode d’expédition</label><select name="shipping_mode_key"><option value="">Tous les modes</option>${modes.map(m => `<option value="${m.key}" ${rule?.shipping_mode_key === m.key ? "selected" : ""}>${escapeHtml(m.label)}</option>`).join("")}</select></div>
        <div><label>Délai (jours ouvrés avant la date de livraison estimée) *</label><input name="reminder_days" type="number" min="0" step="1" required value="${rule?.reminder_days ?? 0}"></div>
        <div class="checkbox-row" style="align-self:end"><label class="switch"><input type="checkbox" name="active" ${rule?.active !== false ? "checked" : ""}><span class="switch-slider"></span></label><span>Règle active</span></div>
        <div class="form-actions span-2"><button type="button" class="button button-ghost" data-close-modal>Annuler</button><button class="button button-primary" type="submit">Enregistrer</button></div>
      </form>`
    });
    modalBody.querySelector("[data-close-modal]").addEventListener("click", closeModal);
    modalBody.querySelector("#rule-form").addEventListener("submit", async event => {
      event.preventDefault();
      const button = event.submitter; submitButtonLoading(button, true);
      const values = formObject(event.currentTarget);
      const { error } = await sb.rpc("upsert_reminder_rule", {
        p_id: rule?.id || null, p_status_key: values.status_key, p_shipping_mode_key: values.shipping_mode_key || null,
        p_reminder_days: Number(values.reminder_days || 0), p_label: values.label.trim(),
        p_active: modalBody.querySelector('[name="active"]').checked
      });
      submitButtonLoading(button, false);
      if (error) return showError(error);
      closeModal(); showToast("Règle enregistrée."); renderDeliverySettings();
    });
  }

  // Objectifs commerciaux
  let salesTargetsYear = new Date().getFullYear();

  async function renderSalesTargets() {
    const canEdit = pageCan("sales-targets");
    const { data, error } = await sb.from("sales_targets").select("*").eq("organization_id", profile.organization_id).eq("year", salesTargetsYear);
    if (error) throw error;
    const byMonth = new Map((data || []).map(t => [t.month, t]));
    const currentYear = new Date().getFullYear();
    const years = [currentYear - 1, currentYear, currentYear + 1];

    const rows = MONTH_LABELS.map((label, idx) => {
      const month = idx + 1;
      const target = byMonth.get(month);
      return `<tr data-month="${month}">
        <td><strong>${label} ${salesTargetsYear}</strong></td>
        <td><input type="number" min="0" step="1" class="target-revenue-input" value="${target?.target_revenue ?? ""}" placeholder="Non défini" ${canEdit ? "" : "disabled"}></td>
        <td><input type="number" min="0" step="1" class="target-margin-input" value="${target?.target_margin ?? ""}" placeholder="Non défini" ${canEdit ? "" : "disabled"}></td>
        <td><input type="number" min="0" step="1" class="target-new-clients-input" value="${target?.target_new_clients ?? ""}" placeholder="Non défini" ${canEdit ? "" : "disabled"}></td>
        ${canEdit ? `<td><button type="button" class="button button-small button-primary save-target">Enregistrer</button></td>` : ""}
      </tr>`;
    }).join("");

    content.innerHTML = `
      <div class="help-inline">${helpTip("Fixe un objectif de chiffre d’affaires, de marge et/ou de nouveaux clients par mois. La progression s’affiche automatiquement sur le Tableau de bord pour le mois en cours.")}<span class="help-inline-label">À savoir</span></div>
      <div class="toolbar" style="margin-top:16px">
        <select id="sales-targets-year" class="filter-select">${years.map(y => `<option value="${y}" ${y === salesTargetsYear ? "selected" : ""}>${y}</option>`).join("")}</select>
        <div class="toolbar-spacer"></div>
      </div>
      <div class="table-wrap" style="margin-top:12px">
        <table><thead><tr><th>Mois</th><th>Objectif CA HT (€)</th><th>Objectif marge (€)</th><th>Objectif nouveaux clients</th>${canEdit ? "<th></th>" : ""}</tr></thead><tbody>${rows}</tbody></table>
      </div>
    `;
    document.querySelector("#sales-targets-year").addEventListener("change", event => {
      salesTargetsYear = Number(event.target.value);
      renderSalesTargets();
    });
    document.querySelectorAll(".save-target").forEach(btn => btn.addEventListener("click", async () => {
      const row = btn.closest("tr");
      const month = Number(row.dataset.month);
      const revenueVal = row.querySelector(".target-revenue-input").value;
      const marginVal = row.querySelector(".target-margin-input").value;
      const newClientsVal = row.querySelector(".target-new-clients-input").value;
      submitButtonLoading(btn, true);
      const { error: upsertError } = await sb.from("sales_targets").upsert({
        organization_id: profile.organization_id,
        year: salesTargetsYear,
        month,
        target_revenue: revenueVal === "" ? null : Number(revenueVal),
        target_margin: marginVal === "" ? null : Number(marginVal),
        target_new_clients: newClientsVal === "" ? null : Number(newClientsVal),
        updated_at: new Date().toISOString()
      }, { onConflict: "organization_id,year,month" });
      submitButtonLoading(btn, false);
      if (upsertError) return showError(upsertError);
      showToast("Objectif enregistré.");
    }));
  }

  // Tâches
  function computeDeliveryTasks(delivery, rules, statuses) {
    if (!delivery.estimated_delivery_date || delivery.task_done) return [];
    const statusInfo = statuses.find(s => s.key === delivery.status);
    if (!statusInfo || statusInfo.is_terminal) return [];
    const today = todayISO();
    const overdueFrom = plusDaysISO(-1, delivery.estimated_delivery_date);
    const applicable = rules.filter(r => r.active && r.status_key === delivery.status && (r.shipping_mode_key === null || r.shipping_mode_key === delivery.shipping_mode));
    const tasks = [];
    applicable.forEach(rule => {
      const reminderDate = subtractBusinessDaysISO(delivery.estimated_delivery_date, rule.reminder_days);
      if (today >= reminderDate) {
        tasks.push({ label: rule.label, reminderDate, status: today >= overdueFrom ? "late" : "todo" });
      }
    });
    return tasks;
  }

  const TASK_STATUSES = {
    todo: { label: "À traiter", tone: "info" },
    late: { label: "En retard", tone: "danger" },
    done: { label: "Traitée", tone: "success" }
  };

  async function updateTasksBadge() {
    const badgeEl = document.querySelector("#tasks-nav-badge");
    if (!badgeEl || !profile) return;
    try {
      const [rules, statuses, { data }] = await Promise.all([
        fetchDeliveryReminderRules(),
        fetchDeliveryStatuses(),
        sb.from("deliveries").select("id, estimated_delivery_date, shipping_mode, status, task_done")
          .eq("organization_id", profile.organization_id)
          .not("estimated_delivery_date", "is", null)
      ]);
      let count = 0;
      (data || []).forEach(d => { count += computeDeliveryTasks(d, rules, statuses).length; });
      badgeEl.textContent = count > 99 ? "99+" : String(count);
      badgeEl.hidden = count === 0;
    } catch (err) {
      // silencieux : ne bloque pas la navigation si le badge échoue à se mettre à jour
    }

    // Pastilles séparées, comptées INDÉPENDAMMENT l'une de l'autre : si le
    // rétroplanning échoue, les signaux clients doivent quand même s'afficher.
    const [prodResult, signalResult] = await Promise.allSettled([
      countProductionTasks(),
      countClientSignals()
    ]);
    const prodEl = document.querySelector("#prod-nav-badge");
    const signalEl = document.querySelector("#signal-nav-badge");
    if (prodEl) {
      const n = prodResult.status === "fulfilled" ? prodResult.value : 0;
      prodEl.textContent = n > 99 ? "99+" : String(n);
      prodEl.hidden = n === 0;
      if (prodResult.status === "rejected") console.warn("Comptage production impossible :", prodResult.reason?.message || prodResult.reason);
    }
    if (signalEl) {
      const n = signalResult.status === "fulfilled" ? signalResult.value : 0;
      signalEl.textContent = n > 99 ? "99+" : String(n);
      signalEl.hidden = n === 0;
      if (signalResult.status === "rejected") console.warn("Comptage signaux impossible :", signalResult.reason?.message || signalResult.reason);
    }
  }

  // Compte les signaux faibles clients, en réutilisant exactement les mêmes
  // règles que l'onglet Tâches (silence et baisse de volume ; la gamme demande
  // le détail produit, trop lourd pour une simple pastille).
  async function countClientSignals() {
    const [{ data: clients }, dels, { data: dismissals }] = await Promise.all([
      sb.from("clients").select("id, category_id, collaboration_end, client_categories(*)").eq("organization_id", profile.organization_id),
      fetchAllRows(() => sb.from("deliveries").select("client_id, delivered_at, revenue_total, delivery_count").eq("organization_id", profile.organization_id).eq("status", "delivered")),
      sb.from("client_signal_dismissals").select("*").eq("organization_id", profile.organization_id)
    ]);
    const nowMs = new Date(todayISO() + "T00:00:00").getTime();
    const monthsAgo = n => { const d = new Date(nowMs); d.setMonth(d.getMonth() - n); return d; };
    const byClient = new Map();
    (dels || []).forEach(d => {
      if (!d.delivered_at) return;
      if (!byClient.has(d.client_id)) byClient.set(d.client_id, []);
      byClient.get(d.client_id).push(d);
    });
    let count = 0;
    (clients || []).forEach(client => {
      const cat = client.client_categories;
      if (!cat) return;
      if (client.collaboration_end && client.collaboration_end < todayISO()) return;
      const list = (byClient.get(client.id) || []).sort((a, b) => a.delivered_at.localeCompare(b.delivered_at));
      if (!list.length) return;
      const dismissed = key => (dismissals || []).some(sd => sd.client_id === client.id && sd.signal_key === key && sd.dismissed_until >= todayISO());

      if (cat.signal_silence_enabled !== false && !dismissed("silence")) {
        const cutoff12 = dateToStr(monthsAgo(12));
        const orders12 = list.filter(d => d.delivered_at >= cutoff12).reduce((s, d) => s + Number(d.delivery_count || 1), 0);
        if (orders12 >= 2) {
          const avgInterval = 365 / orders12;
          const daysSince = Math.round((nowMs - new Date(list[list.length - 1].delivered_at + "T00:00:00").getTime()) / 86400000);
          if (daysSince > avgInterval * Number(cat.signal_silence_factor || 1.5)) count += 1;
        }
      }
      if (cat.signal_revenue_drop_enabled && !dismissed("revenue_drop")) {
        const c3 = dateToStr(monthsAgo(3)), c6 = dateToStr(monthsAgo(6));
        const recent = list.filter(d => d.delivered_at >= c3).reduce((s, d) => s + Number(d.revenue_total || 0), 0);
        const previous = list.filter(d => d.delivered_at >= c6 && d.delivered_at < c3).reduce((s, d) => s + Number(d.revenue_total || 0), 0);
        if (previous > 0 && ((previous - recent) / previous) * 100 >= Number(cat.signal_revenue_drop_pct || 30)) count += 1;
      }
    });
    return count;
  }

  // Compte les actions de production à venir, avec la même logique que
  // l'onglet Tâches (mêmes filtres, mêmes exclusions).
  async function countProductionTasks() {
    let production = 0;
    const [{ data: reminders }, retro, { data: completions }] = await Promise.all([
      sb.from("production_step_reminders").select("*").eq("organization_id", profile.organization_id),
      computeRetroplanning(),
      sb.from("production_task_completions").select("*").eq("organization_id", profile.organization_id)
    ]);
    const ruleByStep = new Map((reminders || []).map(r => [r.step_key, r]));
    (retro?.rows || []).forEach(r => {
      if (r.aucuneActionRequise) return;
      [["order", r.commandeFournisseur], ["materials", r.matieresDisponibles],
       ["production_start", r.debutProduction], ["production_end", r.finProduction],
       ["shipping", r.finProduction], ["delivery", r.arriveeClient]].forEach(([key, date]) => {
        if (!date) return;
        const rule = ruleByStep.get(key);
        if (rule && rule.active === false) return;
        const trigger = addCalendarDays(date, -(rule?.days_before ?? 2));
        if (dateToStr(trigger) > todayISO()) return;
        const done = (completions || []).some(tc => tc.step_key === key && tc.recipe_id === r.recipe.id
          && tc.location_id === r.location.id
          && (tc.target_date >= todayISO() || (tc.completed_at || "").slice(0, 10) >= dateToStr(addCalendarDays(new Date(todayISO() + "T00:00:00"), -10))));
        if (!done) production += 1;
      });
    });
    return production;
  }

  async function renderTasks() {
    const canEdit = pageCan("deliveries");
    setHeader("tasks");
    await generateDueRecurringDeliveries();
    const [rules, statuses, shippingModes, { data: deliveries, error }, { data: allDeliveriesForLabels }, { data: overThresholdLots }, { data: stepReminders }, retro, { data: taskCompletions }, { data: signalClients }, signalDeliveries, { data: signalDismissals }] = await Promise.all([
      fetchDeliveryReminderRules(),
      fetchDeliveryStatuses(),
      fetchShippingModes(),
      sb.from("deliveries").select("id, delivery_number, estimated_delivery_date, shipping_mode, status, task_done, clients(name,company)")
        .eq("organization_id", profile.organization_id)
        .not("estimated_delivery_date", "is", null),
      sb.from("deliveries").select("id, created_at, clients(name,company)").eq("organization_id", profile.organization_id),
      sb.rpc("list_over_threshold_lots"),
      sb.from("production_step_reminders").select("*").eq("organization_id", profile.organization_id),
      computeRetroplanning(),
      sb.from("production_task_completions").select("*").eq("organization_id", profile.organization_id),
      sb.from("clients").select("id, name, company, category_id, collaboration_end, client_categories(*)").eq("organization_id", profile.organization_id),
      fetchAllRows(() => sb.from("deliveries").select("id, client_id, delivered_at, revenue_total, delivery_count").eq("organization_id", profile.organization_id).eq("status", "delivered")),
      sb.from("client_signal_dismissals").select("*").eq("organization_id", profile.organization_id)
    ]);
    if (error) throw error;
    const clientLabels = computeClientSequenceLabels(allDeliveriesForLabels || []);
    const statusByKey = new Map(statuses.map(s => [s.key, s]));
    const modeLabel = key => shippingModes.find(m => m.key === key)?.label || key;

    // Rappels du rétroplanning : chaque etape a faire genere une tache,
    // X jours avant sa date, selon les delais configures.
    const reminderByStep = new Map((stepReminders || []).map(r => [r.step_key, r]));
    const stepTasks = [];
    (retro?.rows || []).forEach(r => {
      if (r.aucuneActionRequise) return;
      const etapes = [
        { key: "order", date: r.commandeFournisseur },
        { key: "materials", date: r.matieresDisponibles },
        { key: "production_start", date: r.debutProduction },
        { key: "production_end", date: r.finProduction },
        { key: "shipping", date: r.finProduction },
        { key: "delivery", date: r.arriveeClient }
      ];
      etapes.forEach(({ key, date }) => {
        if (!date) return;
        const rule = reminderByStep.get(key);
        if (rule && rule.active === false) return;
        const daysBefore = rule?.days_before ?? 2;
        const trigger = addCalendarDays(date, -daysBefore);
        if (dateToStr(trigger) > todayISO()) return; // pas encore le moment
        // Deja traitee ? Une completion couvre la tache si elle visait cette
        // echeance ou une echeance plus tardive (le calcul peut avancer un peu).
        // Une validation reste valable tant que l'échéance qu'elle visait
        // n'est pas passée, OU si elle est très récente. Sans ça, le moindre
        // décalage d'un jour dans le calcul faisait réapparaître la tâche.
        const done = (taskCompletions || []).some(tc =>
          tc.step_key === key && tc.recipe_id === r.recipe.id && tc.location_id === r.location.id
          && (tc.target_date >= todayISO() || (tc.completed_at || "").slice(0, 10) >= dateToStr(addCalendarDays(new Date(todayISO() + "T00:00:00"), -10))));
        if (done) return;
        stepTasks.push({
          key, date, recipe: r.recipe, location: r.location, quantite: r.quantiteRecommandee,
          label: rule?.label || key, isLate: dateToStr(date) < todayISO()
        });
      });
    });
    stepTasks.sort((a, b) => a.date - b.date);

    const stepTaskRows = stepTasks.map(t => `<article class="card task-card ${t.isLate ? "task-card-late" : ""}" data-searchable>
        <div class="task-card-head">
          <strong>${escapeHtml(t.label)}</strong>
          ${t.isLate ? badge("En retard", "danger") : badge("À faire", "info")}
        </div>
        <div class="muted">${escapeHtml(t.recipe.name)} · ${escapeHtml(t.location.name)} · ${formatNumber(t.quantite)} ${escapeHtml(t.recipe.sale_unit || "u.")}</div>
        <div class="muted">Pour le ${formatDate(dateToStr(t.date))}</div>
        <div class="task-card-actions">
          <button type="button" class="button button-small button-primary complete-step-task"
            data-step="${t.key}" data-recipe="${t.recipe.id}" data-location="${t.location.id}" data-date="${dateToStr(t.date)}">Marquer comme traitée</button>
        </div>
      </article>`).join("");

    // --- Signaux faibles clients ---
    // Chaque critere est regle sur la categorie du client. Les clients dont la
    // collaboration est terminee, et ceux sans historique, sont ecartes.
    const nowMs = new Date(todayISO() + "T00:00:00").getTime();
    const monthsAgo = n => { const d = new Date(nowMs); d.setMonth(d.getMonth() - n); return d; };
    const win3 = monthsAgo(3), win6 = monthsAgo(6);

    const byClient = new Map();
    (signalDeliveries || []).forEach(d => {
      if (!d.delivered_at) return;
      if (!byClient.has(d.client_id)) byClient.set(d.client_id, []);
      byClient.get(d.client_id).push(d);
    });

    const clientSignals = [];
    (signalClients || []).forEach(client => {
      const cat = client.client_categories;
      if (!cat) return; // sans categorie, aucun reglage ne s'applique
      if (client.collaboration_end && client.collaboration_end < todayISO()) return; // client deja perdu
      const dels = (byClient.get(client.id) || []).sort((a, b) => a.delivered_at.localeCompare(b.delivered_at));
      if (!dels.length) return;

      const clientName = client.company || client.name;
      const dismissed = key => (signalDismissals || []).some(sd =>
        sd.client_id === client.id && sd.signal_key === key && sd.dismissed_until >= todayISO());

      // 1) Silence anormal, base sur la frequence reelle des 12 derniers mois
      if (cat.signal_silence_enabled !== false && !dismissed("silence")) {
        const cutoff12 = dateToStr(monthsAgo(12));
        const orders12 = dels.filter(d => d.delivered_at >= cutoff12)
          .reduce((s, d) => s + Number(d.delivery_count || 1), 0);
        if (orders12 >= 2) {
          const avgInterval = 365 / orders12;
          const lastDate = dels[dels.length - 1].delivered_at;
          const daysSince = Math.round((nowMs - new Date(lastDate + "T00:00:00").getTime()) / 86400000);
          const factor = Number(cat.signal_silence_factor || 1.5);
          if (daysSince > avgInterval * factor) {
            clientSignals.push({
              key: "silence", clientId: client.id, clientName,
              title: "Silence anormal",
              detail: `Dernière commande il y a ${daysSince} j. — il commande habituellement tous les ${formatNumber(avgInterval, 0)} j.`,
              severity: daysSince > avgInterval * factor * 2 ? "danger" : "warning"
            });
          }
        }
      }

      // 2) Baisse de volume : 3 derniers mois vs 3 precedents
      if (cat.signal_revenue_drop_enabled && !dismissed("revenue_drop")) {
        const c3 = dateToStr(win3), c6 = dateToStr(win6);
        const recent = dels.filter(d => d.delivered_at >= c3).reduce((s, d) => s + Number(d.revenue_total || 0), 0);
        const previous = dels.filter(d => d.delivered_at >= c6 && d.delivered_at < c3).reduce((s, d) => s + Number(d.revenue_total || 0), 0);
        if (previous > 0) {
          const dropPct = ((previous - recent) / previous) * 100;
          if (dropPct >= Number(cat.signal_revenue_drop_pct || 30)) {
            clientSignals.push({
              key: "revenue_drop", clientId: client.id, clientName,
              title: "Baisse de volume",
              detail: `CA en baisse de ${formatNumber(dropPct, 0)}% : ${formatMoney(recent)} sur 3 mois contre ${formatMoney(previous)} avant.`,
              severity: dropPct >= 60 ? "danger" : "warning"
            });
          }
        }
      }
    });

    // 3) Retrecissement de gamme : necessite le detail produit, requete a part
    const rangeCats = (signalClients || []).filter(cl => cl.client_categories?.signal_range_drop_enabled);
    if (rangeCats.length) {
      const { data: rangeItems } = await sb.from("delivery_items")
        .select("finished_lots(recipe_id), ordered_recipe_id, deliveries!inner(client_id, delivered_at, status, organization_id)")
        .eq("deliveries.organization_id", profile.organization_id).eq("deliveries.status", "delivered")
        .gte("deliveries.delivered_at", dateToStr(win6));
      const refsByClient = new Map();
      (rangeItems || []).forEach(i => {
        const cid = i.deliveries?.client_id;
        const rid = i.finished_lots?.recipe_id || i.ordered_recipe_id;
        if (!cid || !rid) return;
        if (!refsByClient.has(cid)) refsByClient.set(cid, { recent: new Set(), previous: new Set() });
        const bucket = i.deliveries.delivered_at >= dateToStr(win3) ? "recent" : "previous";
        refsByClient.get(cid)[bucket].add(rid);
      });
      rangeCats.forEach(client => {
        if (client.collaboration_end && client.collaboration_end < todayISO()) return;
        if ((signalDismissals || []).some(sd => sd.client_id === client.id && sd.signal_key === "range_drop" && sd.dismissed_until >= todayISO())) return;
        const refs = refsByClient.get(client.id);
        if (!refs || refs.previous.size === 0) return;
        const dropPct = ((refs.previous.size - refs.recent.size) / refs.previous.size) * 100;
        if (dropPct >= Number(client.client_categories.signal_range_drop_pct || 40)) {
          clientSignals.push({
            key: "range_drop", clientId: client.id, clientName: client.company || client.name,
            title: "Rétrécissement de gamme",
            detail: `${refs.recent.size} référence(s) commandée(s) sur 3 mois, contre ${refs.previous.size} avant (−${formatNumber(dropPct, 0)}%).`,
            severity: dropPct >= 70 ? "danger" : "warning"
          });
        }
      });
    }

    const signalRows = clientSignals.map(s => `<article class="card task-card ${s.severity === "danger" ? "task-card-late" : ""}" data-searchable>
        <div class="task-card-head"><strong>${escapeHtml(s.clientName)}</strong>${badge(s.title, s.severity)}</div>
        <div class="muted">${escapeHtml(s.detail)}</div>
        <div class="task-card-actions">
          <button type="button" class="button button-small button-secondary dismiss-signal" data-client="${s.clientId}" data-key="${s.key}">Traité — masquer 30 j.</button>
        </div>
      </article>`).join("");

    const thresholdRows = (overThresholdLots || []).map(l => `<article class="card task-card task-card-late" data-searchable>
        <div class="task-card-head">
          <strong>${escapeHtml(l.recipe_name)}</strong>
          ${badge("Coût dépassé", "danger")}
        </div>
        <div class="muted">Lot ${escapeHtml(l.lot_number || "sans numéro")} · ${escapeHtml(l.location_name || "—")}</div>
        <div class="muted">${formatMoney(l.current_cost)} / unité <span style="color:var(--muted)">(seuil : ${formatMoney(l.max_cost_threshold)})</span> · ${formatNumber(l.quantity_remaining)} restant(es)</div>
        <div class="task-card-actions">
          <button type="button" class="button button-small button-ghost go-to-finished-lots" data-recipe="${escapeHtml(l.recipe_name)}">Voir le produit</button>
        </div>
      </article>`).join("");

    const openTasks = [];
    (deliveries || []).forEach(d => {
      computeDeliveryTasks(d, rules, statuses).forEach(task => openTasks.push({ delivery: d, ...task }));
    });
    openTasks.sort((a, b) => a.delivery.estimated_delivery_date.localeCompare(b.delivery.estimated_delivery_date));

    const { data: doneDeliveries } = await sb.from("deliveries").select("id, delivery_number, estimated_delivery_date, shipping_mode, clients(name,company)")
      .eq("organization_id", profile.organization_id).eq("task_done", true).order("estimated_delivery_date", { ascending: false }).limit(30);

    const rows = openTasks.map(({ delivery, status: taskStatus }) => {
      const deliveryStatusInfo = statusByKey.get(delivery.status) || { label: delivery.status, tone: "success" };
      const isLate = taskStatus === "late";
      return `<article class="card task-card ${isLate ? "task-card-late" : ""}" data-searchable>
        <div class="task-card-head">
          <strong>${escapeHtml(clientLabels.get(delivery.id) || delivery.delivery_number)}</strong>
          ${badge(deliveryStatusInfo.label, deliveryStatusInfo.tone)}
        </div>
        <div class="muted">Livraison estimée le ${formatDate(delivery.estimated_delivery_date)}</div>
        <div class="muted">${escapeHtml(modeLabel(delivery.shipping_mode))}</div>
        <div class="task-card-actions">
          <button type="button" class="button button-small button-ghost view-task-delivery" data-id="${delivery.id}">Voir</button>
          ${canEdit ? `<button type="button" class="button button-small button-primary mark-task-done" data-id="${delivery.id}">Marquer traitée</button>` : ""}
        </div>
      </article>`;
    }).join("");

    const doneRows = (doneDeliveries || []).map(d => `<article class="card task-card task-card-done" data-searchable>
        <div class="task-card-head"><strong>${escapeHtml(clientLabels.get(d.id) || d.delivery_number)}</strong>${badge("Traitée", "success")}</div>
        <div class="muted">Livraison estimée le ${formatDate(d.estimated_delivery_date)}</div>
        <div class="muted">${escapeHtml(modeLabel(d.shipping_mode))}</div>
        <div class="task-card-actions">
          <button type="button" class="button button-small button-ghost view-task-delivery" data-id="${d.id}">Voir</button>
          ${canEdit ? `<button type="button" class="button button-small button-ghost reopen-task" data-id="${d.id}">Rouvrir</button>` : ""}
        </div>
      </article>`).join("");

    content.innerHTML = `
      <div class="toolbar"><input id="tasks-search" class="search" placeholder="Rechercher une commande, un client…"><div class="toolbar-spacer"></div></div>
      ${signalRows ? `<div class="task-category">
        <div class="task-category-title task-category-commercial">Commercial${helpTip("Clients qui montrent des signes de désengagement, selon les critères réglés sur leur catégorie (Paramètres → Paramètres clients).")}</div>
        <div class="grid grid-3">${signalRows}</div>
      </div>` : ""}
      ${(stepTaskRows || thresholdRows) ? `<div class="task-category">
        <div class="task-category-title task-category-production">Production</div>
        ${stepTaskRows ? `<div class="task-subsection">Actions à venir</div><div class="grid grid-3">${stepTaskRows}</div>` : ""}
        ${thresholdRows ? `<div class="task-subsection">Alertes coût de revient</div><div class="grid grid-3">${thresholdRows}</div>` : ""}
      </div>` : ""}
      <div class="task-category">
        <div class="task-category-title task-category-livraison">Livraisons</div>
        <div id="tasks-list" class="grid grid-3">${rows || emptyState("Aucune tâche en cours", "Les rappels de livraison apparaîtront ici selon les délais configurés.")}</div>
      </div>
      <details class="span-2" style="margin-top:26px">
        <summary style="cursor:pointer;font-weight:700;color:var(--muted)">Tâches traitées (${(doneDeliveries || []).length})</summary>
        <div class="grid grid-3" style="margin-top:14px">${doneRows || emptyState("Aucune tâche traitée", "")}</div>
      </details>
    `;
    document.querySelectorAll(".go-to-finished-lots").forEach(btn => btn.addEventListener("click", () => {
      finishedGoodsLocationKey = null;
      navigate("finished-lots");
    }));
    document.querySelectorAll(".dismiss-signal").forEach(btn => btn.addEventListener("click", async () => {
      submitButtonLoading(btn, true);
      const until = new Date(); until.setDate(until.getDate() + 30);
      const { error: dErr } = await sb.from("client_signal_dismissals").upsert({
        organization_id: profile.organization_id, client_id: btn.dataset.client,
        signal_key: btn.dataset.key, dismissed_until: dateToStr(until)
      }, { onConflict: "organization_id,client_id,signal_key" });
      submitButtonLoading(btn, false);
      if (dErr) return showError(dErr);
      showToast("Signal masqué pour 30 jours."); renderTasks();
    }));
    document.querySelectorAll(".complete-step-task").forEach(btn => btn.addEventListener("click", async () => {
      submitButtonLoading(btn, true);
      const { error: compError } = await sb.from("production_task_completions").upsert({
        organization_id: profile.organization_id, step_key: btn.dataset.step,
        recipe_id: btn.dataset.recipe, location_id: btn.dataset.location,
        target_date: btn.dataset.date, completed_by: session?.user?.id || null
      }, { onConflict: "organization_id,step_key,recipe_id,location_id,target_date" });
      submitButtonLoading(btn, false);
      if (compError) return showError(compError);
      showToast("Tâche traitée."); renderTasks();
    }));
    document.querySelector("#tasks-search").addEventListener("input", e => {
      const q = e.target.value.trim().toLocaleLowerCase("fr");
      document.querySelectorAll("[data-searchable]").forEach(el => { el.hidden = Boolean(q) && !el.textContent.toLocaleLowerCase("fr").includes(q); });
    });
    document.querySelectorAll(".view-task-delivery").forEach(btn => btn.addEventListener("click", async () => {
      const { data: fullDelivery, error: fetchError } = await sb.from("deliveries").select("*, clients(name,company)").eq("id", btn.dataset.id).single();
      if (fetchError) return showError(fetchError);
      deliveryDetailModal(fullDelivery);
    }));
    document.querySelectorAll(".mark-task-done").forEach(btn => btn.addEventListener("click", async () => {
      const task = openTasks.find(t => t.delivery.id === btn.dataset.id);
      const { error: updateError } = await sb.rpc("set_delivery_task_done", { p_delivery_id: btn.dataset.id, p_done: true });
      if (updateError) return showError(updateError);
      if (task) {
        const idx = statusIndexOf(statuses, task.delivery.status);
        const nextStatus = statuses[idx + 1];
        if (nextStatus) {
          const { error: statusError } = await sb.rpc("advance_delivery_status", nextStatus.is_terminal
            ? { p_delivery_id: btn.dataset.id, p_delivered_at: todayISO() }
            : { p_delivery_id: btn.dataset.id });
          if (statusError) showError(statusError);
        }
      }
      showToast("Tâche marquée traitée."); renderTasks(); updateTasksBadge();
    }));
    document.querySelectorAll(".reopen-task").forEach(btn => btn.addEventListener("click", async () => {
      const { error: updateError } = await sb.rpc("set_delivery_task_done", { p_delivery_id: btn.dataset.id, p_done: false });
      if (updateError) return showError(updateError);
      showToast("Tâche rouverte."); renderTasks(); updateTasksBadge();
    }));
  }

  // ============================================================
  // Statistiques — rapports personnalisables, sauvegardés
  // ============================================================
  const STAT_CATEGORIES = {
    ventes: { label: "Ventes", cls: "stat-cat-ventes" },
    rentabilite: { label: "Rentabilité", cls: "stat-cat-rentabilite" },
    achats: { label: "Achats & coûts", cls: "stat-cat-achats" },
    production: { label: "Production", cls: "stat-cat-production" },
    stock: { label: "Stock", cls: "stat-cat-stock" },
    logistique: { label: "Logistique", cls: "stat-cat-logistique" }
  };
  const STAT_REPORT_TYPES = {
    monthly_revenue: { label: "Évolution du CA mensuel", category: "ventes" },
    products_sold: { label: "Produits vendus", category: "ventes" },
    revenue_by_client: { label: "CA par client", category: "ventes" },
    revenue_by_category: { label: "CA par catégorie de produit", category: "ventes" },
    revenue_by_client_category: { label: "CA par catégorie de client", category: "ventes" },
    avg_basket: { label: "Panier moyen par livraison", category: "ventes" },
    order_frequency: { label: "Fréquence de commande par client", category: "ventes" },
    margin_by_product: { label: "Marge par produit", category: "rentabilite" },
    margin_by_client: { label: "Marge par client", category: "rentabilite" },
    monthly_margin: { label: "Évolution de la marge mensuelle", category: "rentabilite" },
    ingredient_price_evolution: { label: "Évolution du prix d’un ingrédient", category: "achats" },
    spend_by_supplier: { label: "Dépenses MP par fournisseur", category: "achats" },
    production_volume_by_recipe: { label: "Volume produit par recette", category: "production" },
    production_by_location: { label: "Productions par atelier", category: "production" },
    stock_value_by_location: { label: "Valeur de stock par emplacement", category: "stock" },
    shipping_mode_split: { label: "Livraisons Direct vs Indirect", category: "logistique" }
  };
  const CHART_COLORS = ["#255c3d", "#a06a1b", "#1d4ed8", "#a74242"];

  function svgBarChart(labels, series) {
    const width = 640, height = 260;
    const padding = { top: 16, right: 12, bottom: 34, left: 52 };
    const chartW = width - padding.left - padding.right;
    const chartH = height - padding.top - padding.bottom;
    const maxVal = Math.max(1, ...series.flatMap(s => s.values));
    const groupWidth = chartW / Math.max(1, labels.length);
    const barWidth = Math.max(4, (groupWidth * 0.7) / series.length);
    let grid = "";
    for (let g = 0; g <= 4; g++) {
      const y = padding.top + chartH - (g / 4) * chartH;
      grid += `<line x1="${padding.left}" y1="${y.toFixed(1)}" x2="${width - padding.right}" y2="${y.toFixed(1)}" stroke="#dfe6df" stroke-width="1"/>`;
      grid += `<text x="${padding.left - 6}" y="${(y + 3).toFixed(1)}" font-size="10" fill="#66736b" text-anchor="end">${formatNumber(maxVal * g / 4, 0)}</text>`;
    }
    let bars = "";
    labels.forEach((label, i) => {
      const groupX = padding.left + i * groupWidth + groupWidth * 0.15;
      series.forEach((s, si) => {
        const val = s.values[i] || 0;
        const barH = (val / maxVal) * chartH;
        const x = groupX + si * barWidth;
        const y = padding.top + chartH - barH;
        bars += `<rect x="${x.toFixed(1)}" y="${y.toFixed(1)}" width="${barWidth.toFixed(1)}" height="${barH.toFixed(1)}" fill="${s.color || CHART_COLORS[si % CHART_COLORS.length]}" rx="3"/>`;
      });
      bars += `<text x="${(groupX + groupWidth * 0.35 - groupWidth * 0.15).toFixed(1)}" y="${height - 10}" font-size="10" fill="#66736b" text-anchor="middle">${escapeHtml(label)}</text>`;
    });
    const legend = series.length > 1 ? `<div class="chart-legend">${series.map((s, si) => `<span class="chart-legend-item"><span class="chart-legend-dot" style="background:${s.color || CHART_COLORS[si % CHART_COLORS.length]}"></span>${escapeHtml(s.name)}</span>`).join("")}</div>` : "";
    return `${legend}<svg viewBox="0 0 ${width} ${height}" width="100%" height="${height}">${grid}${bars}</svg>`;
  }

  function svgLineChart(labels, series) {
    const width = 640, height = 260;
    const padding = { top: 16, right: 12, bottom: 34, left: 52 };
    const chartW = width - padding.left - padding.right;
    const chartH = height - padding.top - padding.bottom;
    const maxVal = Math.max(1, ...series.flatMap(s => s.values));
    const stepX = labels.length > 1 ? chartW / (labels.length - 1) : 0;
    let grid = "";
    for (let g = 0; g <= 4; g++) {
      const y = padding.top + chartH - (g / 4) * chartH;
      grid += `<line x1="${padding.left}" y1="${y.toFixed(1)}" x2="${width - padding.right}" y2="${y.toFixed(1)}" stroke="#dfe6df" stroke-width="1"/>`;
      grid += `<text x="${padding.left - 6}" y="${(y + 3).toFixed(1)}" font-size="10" fill="#66736b" text-anchor="end">${formatNumber(maxVal * g / 4, 0)}</text>`;
    }
    let lines = "";
    series.forEach((s, si) => {
      const color = s.color || CHART_COLORS[si % CHART_COLORS.length];
      const points = s.values.map((v, i) => `${(padding.left + i * stepX).toFixed(1)},${(padding.top + chartH - (v / maxVal) * chartH).toFixed(1)}`).join(" ");
      lines += `<polyline points="${points}" fill="none" stroke="${color}" stroke-width="2.5"/>`;
      s.values.forEach((v, i) => {
        lines += `<circle cx="${(padding.left + i * stepX).toFixed(1)}" cy="${(padding.top + chartH - (v / maxVal) * chartH).toFixed(1)}" r="3" fill="${color}"/>`;
      });
    });
    const labelsSvg = labels.map((label, i) => `<text x="${(padding.left + i * stepX).toFixed(1)}" y="${height - 10}" font-size="10" fill="#66736b" text-anchor="middle">${escapeHtml(label)}</text>`).join("");
    const legend = `<div class="chart-legend">${series.map((s, si) => `<span class="chart-legend-item"><span class="chart-legend-dot" style="background:${s.color || CHART_COLORS[si % CHART_COLORS.length]}"></span>${escapeHtml(s.name)}</span>`).join("")}</div>`;
    return `${legend}<svg viewBox="0 0 ${width} ${height}" width="100%" height="${height}">${grid}${lines}${labelsSvg}</svg>`;
  }

  const MONTH_LABELS = ["Jan", "Fév", "Mar", "Avr", "Mai", "Juin", "Juil", "Août", "Sep", "Oct", "Nov", "Déc"];

  async function computeMonthlyRevenue(filters) {
    const year = Number(filters.year) || new Date().getFullYear();
    const compare = filters.compareLastYear !== false;
    const years = compare ? [year - 1, year] : [year];
    const start = `${years[0]}-01-01`;
    const end = `${year + 1}-01-01`;
    const { data, error } = await scopeToLocations(sb.from("deliveries").select("delivered_at, revenue_total")).eq("organization_id", profile.organization_id).eq("status", "delivered").gte("delivered_at", start).lt("delivered_at", end);
    if (error) throw error;
    const series = years.map(y => ({ name: String(y), values: new Array(12).fill(0) }));
    (data || []).forEach(d => {
      if (!d.delivered_at) return;
      const y = Number(d.delivered_at.slice(0, 4));
      const m = Number(d.delivered_at.slice(5, 7)) - 1;
      const s = series.find(s => s.name === String(y));
      if (s) s.values[m] += Number(d.revenue_total || 0);
    });
    const table = `<table><thead><tr><th>Mois</th>${series.map(s => `<th>${s.name}</th>`).join("")}</tr></thead><tbody>
      ${MONTH_LABELS.map((label, i) => `<tr><td>${label}</td>${series.map(s => `<td>${formatMoney(s.values[i])}</td>`).join("")}</tr>`).join("")}
      <tr><td><strong>Total</strong></td>${series.map(s => `<td><strong>${formatMoney(s.values.reduce((a, b) => a + b, 0))}</strong></td>`).join("")}</tr>
    </tbody></table>`;
    return { labels: MONTH_LABELS, series, table, chartFn: svgLineChart };
  }

  async function computeProductsSold(filters) {
    const from = filters.from || `${new Date().getFullYear()}-01-01`;
    const to = filters.to || todayISO();
    const { data: deliveries, error } = await scopeToLocations(sb.from("deliveries").select("id")).eq("organization_id", profile.organization_id).eq("status", "delivered").gte("delivered_at", from).lte("delivered_at", to);
    if (error) throw error;
    const ids = (deliveries || []).map(d => d.id);
    if (!ids.length) return { labels: [], series: [{ name: "Valeur", values: [] }], table: emptyState("Aucune vente sur cette période", ""), chartFn: svgBarChart };
    const { data: items, error: itemsError } = await sb.from("delivery_items").select("quantity, unit_price, finished_lots(recipe_id, recipes(id, name, category_id))").in("delivery_id", ids);
    if (itemsError) throw itemsError;
    let filtered = items || [];
    if (filters.recipeId && filters.recipeId !== "all") filtered = filtered.filter(i => i.finished_lots?.recipe_id === filters.recipeId);
    if (filters.categoryId && filters.categoryId !== "all") filtered = filtered.filter(i => i.finished_lots?.recipes?.category_id === filters.categoryId);

    const byProduct = new Map();
    filtered.forEach(i => {
      const name = i.finished_lots?.recipes?.name || "—";
      const entry = byProduct.get(name) || { volume: 0, revenue: 0 };
      entry.volume += Number(i.quantity || 0);
      entry.revenue += Number(i.quantity || 0) * Number(i.unit_price || 0);
      byProduct.set(name, entry);
    });
    const totalRevenue = [...byProduct.values()].reduce((s, e) => s + e.revenue, 0);
    const rows = [...byProduct.entries()].sort((a, b) => b[1].revenue - a[1].revenue);
    const metric = filters.metric || "revenue";
    const metricValue = e => metric === "volume" ? e.volume : metric === "percent" ? (totalRevenue ? (e.revenue / totalRevenue) * 100 : 0) : e.revenue;
    const metricLabel = metric === "volume" ? "Quantité" : metric === "percent" ? "% du CA" : "CA";
    const table = `<table><thead><tr><th>Produit</th><th>Quantité</th><th>CA</th><th>% du CA</th></tr></thead><tbody>
      ${rows.map(([name, e]) => `<tr><td>${escapeHtml(name)}</td><td>${formatNumber(e.volume)}</td><td>${formatMoney(e.revenue)}</td><td>${totalRevenue ? formatNumber((e.revenue / totalRevenue) * 100) : "0"}%</td></tr>`).join("") || `<tr><td colspan="4" class="muted" style="text-align:center;padding:16px">Aucune donnée</td></tr>`}
    </tbody></table>`;
    return { labels: rows.map(([name]) => name), series: [{ name: metricLabel, values: rows.map(([, e]) => metricValue(e)) }], table, chartFn: svgBarChart };
  }

  async function computeRevenueByClient(filters) {
    const from = filters.from || `${new Date().getFullYear()}-01-01`;
    const to = filters.to || todayISO();
    const { data, error } = await scopeToLocations(sb.from("deliveries").select("revenue_total, clients(id, name, company, category_id)")).eq("organization_id", profile.organization_id).eq("status", "delivered").gte("delivered_at", from).lte("delivered_at", to);
    if (error) throw error;
    let filtered = data || [];
    if (filters.clientCategoryId && filters.clientCategoryId !== "all") filtered = filtered.filter(d => d.clients?.category_id === filters.clientCategoryId);
    const byClient = new Map();
    filtered.forEach(d => {
      const name = d.clients?.company || d.clients?.name || "—";
      byClient.set(name, (byClient.get(name) || 0) + Number(d.revenue_total || 0));
    });
    const rows = [...byClient.entries()].sort((a, b) => b[1] - a[1]);
    const total = rows.reduce((s, [, v]) => s + v, 0);
    const table = `<table><thead><tr><th>Client</th><th>CA</th><th>% du total</th></tr></thead><tbody>
      ${rows.map(([name, v]) => `<tr><td>${escapeHtml(name)}</td><td>${formatMoney(v)}</td><td>${total ? formatNumber((v / total) * 100) : "0"}%</td></tr>`).join("") || `<tr><td colspan="3" class="muted" style="text-align:center;padding:16px">Aucune donnée</td></tr>`}
    </tbody></table>`;
    return { labels: rows.map(([name]) => name), series: [{ name: "CA", values: rows.map(([, v]) => v) }], table, chartFn: svgBarChart };
  }

  async function computeRevenueByCategory(filters) {
    const from = filters.from || `${new Date().getFullYear()}-01-01`;
    const to = filters.to || todayISO();
    const { data: deliveries, error } = await scopeToLocations(sb.from("deliveries").select("id")).eq("organization_id", profile.organization_id).eq("status", "delivered").gte("delivered_at", from).lte("delivered_at", to);
    if (error) throw error;
    const ids = (deliveries || []).map(d => d.id);
    if (!ids.length) return { labels: [], series: [{ name: "CA", values: [] }], table: emptyState("Aucune vente sur cette période", ""), chartFn: svgBarChart };
    const { data: items, error: itemsError } = await sb.from("delivery_items").select("quantity, unit_price, finished_lots(recipes(recipe_categories(name)))").in("delivery_id", ids);
    if (itemsError) throw itemsError;
    const byCategory = new Map();
    (items || []).forEach(i => {
      const name = i.finished_lots?.recipes?.recipe_categories?.name || "Sans catégorie";
      byCategory.set(name, (byCategory.get(name) || 0) + Number(i.quantity || 0) * Number(i.unit_price || 0));
    });
    const rows = [...byCategory.entries()].sort((a, b) => b[1] - a[1]);
    const total = rows.reduce((s, [, v]) => s + v, 0);
    const table = `<table><thead><tr><th>Catégorie</th><th>CA</th><th>% du total</th></tr></thead><tbody>
      ${rows.map(([name, v]) => `<tr><td>${escapeHtml(name)}</td><td>${formatMoney(v)}</td><td>${total ? formatNumber((v / total) * 100) : "0"}%</td></tr>`).join("") || `<tr><td colspan="3" class="muted" style="text-align:center;padding:16px">Aucune donnée</td></tr>`}
    </tbody></table>`;
    return { labels: rows.map(([n]) => n), series: [{ name: "CA", values: rows.map(([, v]) => v) }], table, chartFn: svgBarChart };
  }

  async function computeRevenueByClientCategory(filters) {
    const from = filters.from || `${new Date().getFullYear()}-01-01`;
    const to = filters.to || todayISO();
    const { data, error } = await scopeToLocations(sb.from("deliveries").select("revenue_total, clients(client_categories(name))")).eq("organization_id", profile.organization_id).eq("status", "delivered").gte("delivered_at", from).lte("delivered_at", to);
    if (error) throw error;
    const byCategory = new Map();
    (data || []).forEach(d => {
      const name = d.clients?.client_categories?.name || "Sans catégorie";
      byCategory.set(name, (byCategory.get(name) || 0) + Number(d.revenue_total || 0));
    });
    const rows = [...byCategory.entries()].sort((a, b) => b[1] - a[1]);
    const total = rows.reduce((s, [, v]) => s + v, 0);
    const table = `<table><thead><tr><th>Catégorie de client</th><th>CA</th><th>% du total</th></tr></thead><tbody>
      ${rows.map(([name, v]) => `<tr><td>${escapeHtml(name)}</td><td>${formatMoney(v)}</td><td>${total ? formatNumber((v / total) * 100) : "0"}%</td></tr>`).join("") || `<tr><td colspan="3" class="muted" style="text-align:center;padding:16px">Aucune donnée</td></tr>`}
    </tbody></table>`;
    return { labels: rows.map(([n]) => n), series: [{ name: "CA", values: rows.map(([, v]) => v) }], table, chartFn: svgBarChart };
  }

  async function computeAvgBasket(filters) {
    const year = Number(filters.year) || new Date().getFullYear();
    const { data, error } = await scopeToLocations(sb.from("deliveries").select("delivered_at, revenue_total")).eq("organization_id", profile.organization_id).eq("status", "delivered").gte("delivered_at", `${year}-01-01`).lt("delivered_at", `${year + 1}-01-01`);
    if (error) throw error;
    const sums = new Array(12).fill(0);
    const counts = new Array(12).fill(0);
    (data || []).forEach(d => {
      if (!d.delivered_at) return;
      const m = Number(d.delivered_at.slice(5, 7)) - 1;
      sums[m] += Number(d.revenue_total || 0);
      counts[m] += 1;
    });
    const averages = sums.map((s, i) => counts[i] ? s / counts[i] : 0);
    const table = `<table><thead><tr><th>Mois</th><th>Panier moyen HT</th><th>Nb. livraisons</th></tr></thead><tbody>
      ${MONTH_LABELS.map((label, i) => `<tr><td>${label}</td><td>${formatMoney(averages[i])}</td><td>${counts[i]}</td></tr>`).join("")}
    </tbody></table>`;
    return { labels: MONTH_LABELS, series: [{ name: String(year), values: averages }], table, chartFn: svgLineChart };
  }

  async function computeOrderFrequency(filters) {
    const from = filters.from || `${new Date().getFullYear()}-01-01`;
    const to = filters.to || todayISO();
    const { data, error } = await scopeToLocations(sb.from("deliveries").select("client_id, clients(name,company)")).eq("organization_id", profile.organization_id).eq("status", "delivered").gte("delivered_at", from).lte("delivered_at", to);
    if (error) throw error;
    const byClient = new Map();
    (data || []).forEach(d => {
      const name = d.clients?.company || d.clients?.name || "—";
      byClient.set(name, (byClient.get(name) || 0) + 1);
    });
    const rows = [...byClient.entries()].sort((a, b) => b[1] - a[1]);
    const table = `<table><thead><tr><th>Client</th><th>Nombre de commandes</th></tr></thead><tbody>
      ${rows.map(([name, v]) => `<tr><td>${escapeHtml(name)}</td><td>${v}</td></tr>`).join("") || `<tr><td colspan="2" class="muted" style="text-align:center;padding:16px">Aucune donnée</td></tr>`}
    </tbody></table>`;
    return { labels: rows.map(([n]) => n), series: [{ name: "Commandes", values: rows.map(([, v]) => v) }], table, chartFn: svgBarChart };
  }

  async function computeMarginByProduct(filters) {
    const from = filters.from || `${new Date().getFullYear()}-01-01`;
    const to = filters.to || todayISO();
    const { data: deliveries, error } = await scopeToLocations(sb.from("deliveries").select("id")).eq("organization_id", profile.organization_id).eq("status", "delivered").gte("delivered_at", from).lte("delivered_at", to);
    if (error) throw error;
    const ids = (deliveries || []).map(d => d.id);
    if (!ids.length) return { labels: [], series: [{ name: "Marge", values: [] }], table: emptyState("Aucune vente sur cette période", ""), chartFn: svgBarChart };
    const { data: items, error: itemsError } = await sb.from("delivery_items").select("quantity, unit_price, unit_cost, finished_lots(recipes(name))").in("delivery_id", ids);
    if (itemsError) throw itemsError;
    const byProduct = new Map();
    (items || []).forEach(i => {
      const name = i.finished_lots?.recipes?.name || "—";
      const entry = byProduct.get(name) || { revenue: 0, margin: 0 };
      const qty = Number(i.quantity || 0);
      entry.revenue += qty * Number(i.unit_price || 0);
      entry.margin += qty * (Number(i.unit_price || 0) - Number(i.unit_cost || 0));
      byProduct.set(name, entry);
    });
    const rows = [...byProduct.entries()].sort((a, b) => b[1].margin - a[1].margin);
    const table = `<table><thead><tr><th>Produit</th><th>CA</th><th>Marge</th><th>Marge %</th></tr></thead><tbody>
      ${rows.map(([name, e]) => `<tr><td>${escapeHtml(name)}</td><td>${formatMoney(e.revenue)}</td><td>${formatMoney(e.margin)}</td><td>${e.revenue ? formatNumber((e.margin / e.revenue) * 100, 0) : "0"}%</td></tr>`).join("") || `<tr><td colspan="4" class="muted" style="text-align:center;padding:16px">Aucune donnée</td></tr>`}
    </tbody></table>`;
    return { labels: rows.map(([n]) => n), series: [{ name: "Marge", values: rows.map(([, e]) => e.margin) }], table, chartFn: svgBarChart };
  }

  async function computeMarginByClient(filters) {
    const from = filters.from || `${new Date().getFullYear()}-01-01`;
    const to = filters.to || todayISO();
    const { data, error } = await scopeToLocations(sb.from("deliveries").select("revenue_total, cost_total, clients(name,company)")).eq("organization_id", profile.organization_id).eq("status", "delivered").gte("delivered_at", from).lte("delivered_at", to);
    if (error) throw error;
    const byClient = new Map();
    (data || []).forEach(d => {
      const name = d.clients?.company || d.clients?.name || "—";
      const entry = byClient.get(name) || { revenue: 0, margin: 0 };
      entry.revenue += Number(d.revenue_total || 0);
      entry.margin += Number(d.revenue_total || 0) - Number(d.cost_total || 0);
      byClient.set(name, entry);
    });
    const rows = [...byClient.entries()].sort((a, b) => b[1].margin - a[1].margin);
    const table = `<table><thead><tr><th>Client</th><th>CA</th><th>Marge</th><th>Marge %</th></tr></thead><tbody>
      ${rows.map(([name, e]) => `<tr><td>${escapeHtml(name)}</td><td>${formatMoney(e.revenue)}</td><td>${formatMoney(e.margin)}</td><td>${e.revenue ? formatNumber((e.margin / e.revenue) * 100, 0) : "0"}%</td></tr>`).join("") || `<tr><td colspan="4" class="muted" style="text-align:center;padding:16px">Aucune donnée</td></tr>`}
    </tbody></table>`;
    return { labels: rows.map(([n]) => n), series: [{ name: "Marge", values: rows.map(([, e]) => e.margin) }], table, chartFn: svgBarChart };
  }

  async function computeMonthlyMargin(filters) {
    const year = Number(filters.year) || new Date().getFullYear();
    const compare = filters.compareLastYear !== false;
    const years = compare ? [year - 1, year] : [year];
    const start = `${years[0]}-01-01`;
    const end = `${year + 1}-01-01`;
    const { data, error } = await scopeToLocations(sb.from("deliveries").select("delivered_at, revenue_total, cost_total")).eq("organization_id", profile.organization_id).eq("status", "delivered").gte("delivered_at", start).lt("delivered_at", end);
    if (error) throw error;
    const series = years.map(y => ({ name: String(y), values: new Array(12).fill(0) }));
    (data || []).forEach(d => {
      if (!d.delivered_at) return;
      const y = Number(d.delivered_at.slice(0, 4));
      const m = Number(d.delivered_at.slice(5, 7)) - 1;
      const s = series.find(s => s.name === String(y));
      if (s) s.values[m] += Number(d.revenue_total || 0) - Number(d.cost_total || 0);
    });
    const table = `<table><thead><tr><th>Mois</th>${series.map(s => `<th>${s.name}</th>`).join("")}</tr></thead><tbody>
      ${MONTH_LABELS.map((label, i) => `<tr><td>${label}</td>${series.map(s => `<td>${formatMoney(s.values[i])}</td>`).join("")}</tr>`).join("")}
      <tr><td><strong>Total</strong></td>${series.map(s => `<td><strong>${formatMoney(s.values.reduce((a, b) => a + b, 0))}</strong></td>`).join("")}</tr>
    </tbody></table>`;
    return { labels: MONTH_LABELS, series, table, chartFn: svgLineChart };
  }

  async function computeIngredientPriceEvolution(filters) {
    if (!filters.ingredientId) return { labels: [], series: [{ name: "Prix", values: [] }], table: emptyState("Choisissez un ingrédient", ""), chartFn: svgLineChart };
    const { data, error } = await sb.from("ingredient_price_history").select("old_price, new_price, changed_at").eq("ingredient_id", filters.ingredientId).order("changed_at", { ascending: true });
    if (error) throw error;
    const rows = data || [];
    const table = `<table><thead><tr><th>Date</th><th>Ancien prix</th><th>Nouveau prix</th><th>Variation</th></tr></thead><tbody>
      ${rows.map(r => `<tr><td>${formatDate(r.changed_at?.slice(0, 10))}</td><td>${formatMoney(r.old_price)}</td><td>${formatMoney(r.new_price)}</td><td>${trendBadge(pctChange(Number(r.new_price), Number(r.old_price)))}</td></tr>`).join("") || `<tr><td colspan="4" class="muted" style="text-align:center;padding:16px">Aucun changement de prix enregistré</td></tr>`}
    </tbody></table>`;
    return {
      labels: rows.map(r => formatDate(r.changed_at?.slice(0, 10))),
      series: [{ name: "Prix", values: rows.map(r => Number(r.new_price)) }],
      table, chartFn: svgLineChart
    };
  }

  async function computeSpendBySupplier(filters) {
    const from = filters.from || `${new Date().getFullYear()}-01-01`;
    const to = filters.to || todayISO();
    const { data, error } = await scopeToLocations(sb.from("ingredient_lots").select("quantity_received, unit_price, received_at, ingredients(supplier)")).eq("organization_id", profile.organization_id).gte("received_at", from).lte("received_at", to);
    if (error) throw error;
    const bySupplier = new Map();
    (data || []).forEach(lot => {
      const name = lot.ingredients?.supplier?.trim() || "Non renseigné";
      bySupplier.set(name, (bySupplier.get(name) || 0) + Number(lot.quantity_received || 0) * Number(lot.unit_price || 0));
    });
    const rows = [...bySupplier.entries()].sort((a, b) => b[1] - a[1]);
    const total = rows.reduce((s, [, v]) => s + v, 0);
    const table = `<table><thead><tr><th>Fournisseur</th><th>Dépenses</th><th>% du total</th></tr></thead><tbody>
      ${rows.map(([name, v]) => `<tr><td>${escapeHtml(name)}</td><td>${formatMoney(v)}</td><td>${total ? formatNumber((v / total) * 100) : "0"}%</td></tr>`).join("") || `<tr><td colspan="3" class="muted" style="text-align:center;padding:16px">Aucune donnée</td></tr>`}
    </tbody></table>`;
    return { labels: rows.map(([n]) => n), series: [{ name: "Dépenses", values: rows.map(([, v]) => v) }], table, chartFn: svgBarChart };
  }

  async function computeProductionVolumeByRecipe(filters) {
    const from = filters.from || `${new Date().getFullYear()}-01-01`;
    const to = filters.to || todayISO();
    const { data, error } = await scopeToLocations(sb.from("productions").select("quantity_produced, recipes(name)")).eq("organization_id", profile.organization_id).gte("production_date", from).lte("production_date", to);
    if (error) throw error;
    const byRecipe = new Map();
    (data || []).forEach(p => {
      const name = p.recipes?.name || "—";
      byRecipe.set(name, (byRecipe.get(name) || 0) + Number(p.quantity_produced || 0));
    });
    const rows = [...byRecipe.entries()].sort((a, b) => b[1] - a[1]);
    const table = `<table><thead><tr><th>Recette</th><th>Quantité produite</th></tr></thead><tbody>
      ${rows.map(([name, v]) => `<tr><td>${escapeHtml(name)}</td><td>${formatNumber(v)}</td></tr>`).join("") || `<tr><td colspan="2" class="muted" style="text-align:center;padding:16px">Aucune donnée</td></tr>`}
    </tbody></table>`;
    return { labels: rows.map(([n]) => n), series: [{ name: "Quantité", values: rows.map(([, v]) => v) }], table, chartFn: svgBarChart };
  }

  async function computeProductionByLocation(filters) {
    const from = filters.from || `${new Date().getFullYear()}-01-01`;
    const to = filters.to || todayISO();
    const { data, error } = await scopeToLocations(sb.from("productions").select("locations(name)")).eq("organization_id", profile.organization_id).gte("production_date", from).lte("production_date", to);
    if (error) throw error;
    const byLocation = new Map();
    (data || []).forEach(p => {
      const name = p.locations?.name || "Sans emplacement";
      byLocation.set(name, (byLocation.get(name) || 0) + 1);
    });
    const rows = [...byLocation.entries()].sort((a, b) => b[1] - a[1]);
    const table = `<table><thead><tr><th>Atelier</th><th>Nombre de productions</th></tr></thead><tbody>
      ${rows.map(([name, v]) => `<tr><td>${escapeHtml(name)}</td><td>${v}</td></tr>`).join("") || `<tr><td colspan="2" class="muted" style="text-align:center;padding:16px">Aucune donnée</td></tr>`}
    </tbody></table>`;
    return { labels: rows.map(([n]) => n), series: [{ name: "Productions", values: rows.map(([, v]) => v) }], table, chartFn: svgBarChart };
  }

  async function computeStockValueByLocation() {
    const [{ data: ingredientLots, error }, { data: finishedLots, error: flError }, allLocations] = await Promise.all([
      scopeToLocations(sb.from("ingredient_lots").select("quantity_remaining, unit_price, location_id, ingredients(purchase_price)")).eq("organization_id", profile.organization_id).gt("quantity_remaining", 0),
      scopeToLocations(sb.from("finished_lots").select("quantity_remaining, unit_cost_mp, unit_cost_production, unit_cost_packaging, location_id")).eq("organization_id", profile.organization_id).gt("quantity_remaining", 0),
      fetchLocations()
    ]);
    if (error) throw error;
    if (flError) throw flError;
    const locationName = new Map(allLocations.map(l => [l.id, l.name]));
    const byLocation = new Map();
    (ingredientLots || []).forEach(lot => {
      const name = locationName.get(lot.location_id) || "Sans emplacement";
      const value = Number(lot.quantity_remaining || 0) * Number(lot.unit_price ?? lot.ingredients?.purchase_price ?? 0);
      byLocation.set(name, (byLocation.get(name) || 0) + value);
    });
    (finishedLots || []).forEach(lot => {
      const name = locationName.get(lot.location_id) || "Sans emplacement";
      const value = Number(lot.quantity_remaining || 0) * finishedLotUnitCost(lot);
      byLocation.set(name, (byLocation.get(name) || 0) + value);
    });
    const rows = [...byLocation.entries()].sort((a, b) => b[1] - a[1]);
    const table = `<table><thead><tr><th>Emplacement</th><th>Valeur de stock</th></tr></thead><tbody>
      ${rows.map(([name, v]) => `<tr><td>${escapeHtml(name)}</td><td>${formatMoney(v)}</td></tr>`).join("") || `<tr><td colspan="2" class="muted" style="text-align:center;padding:16px">Aucune donnée</td></tr>`}
    </tbody></table>`;
    return { labels: rows.map(([n]) => n), series: [{ name: "Valeur", values: rows.map(([, v]) => v) }], table, chartFn: svgBarChart };
  }

  async function computeShippingModeSplit(filters) {
    const from = filters.from || `${new Date().getFullYear()}-01-01`;
    const to = filters.to || todayISO();
    const [{ data, error }, modes] = await Promise.all([
      scopeToLocations(sb.from("deliveries").select("shipping_mode")).eq("organization_id", profile.organization_id).gte("delivery_date", from).lte("delivery_date", to),
      fetchShippingModes()
    ]);
    if (error) throw error;
    const counts = new Map(modes.map(m => [m.key, 0]));
    (data || []).forEach(d => counts.set(d.shipping_mode, (counts.get(d.shipping_mode) || 0) + 1));
    const total = [...counts.values()].reduce((a, b) => a + b, 0);
    const rows = modes.map(m => [m.label, counts.get(m.key) || 0]);
    const table = `<table><thead><tr><th>Mode</th><th>Nombre</th><th>% du total</th></tr></thead><tbody>
      ${rows.map(([label, n]) => `<tr><td>${escapeHtml(label)}</td><td>${n}</td><td>${total ? formatNumber((n / total) * 100) : "0"}%</td></tr>`).join("")}
    </tbody></table>`;
    return { labels: rows.map(([label]) => label), series: [{ name: "Livraisons", values: rows.map(([, n]) => n) }], table, chartFn: svgBarChart };
  }

  const STAT_COMPUTERS = {
    monthly_revenue: computeMonthlyRevenue, products_sold: computeProductsSold, revenue_by_client: computeRevenueByClient,
    revenue_by_category: computeRevenueByCategory, revenue_by_client_category: computeRevenueByClientCategory,
    avg_basket: computeAvgBasket, order_frequency: computeOrderFrequency,
    margin_by_product: computeMarginByProduct, margin_by_client: computeMarginByClient, monthly_margin: computeMonthlyMargin,
    ingredient_price_evolution: computeIngredientPriceEvolution, spend_by_supplier: computeSpendBySupplier,
    production_volume_by_recipe: computeProductionVolumeByRecipe, production_by_location: computeProductionByLocation,
    stock_value_by_location: computeStockValueByLocation, shipping_mode_split: computeShippingModeSplit
  };

  function statWidgetTitle(widget) {
    return widget.title?.trim() || STAT_REPORT_TYPES[widget.report_type]?.label || "Rapport";
  }

  async function renderStatistics() {
    const canEdit = pageCan("statistics");
    setHeader("statistics", canEdit ? `<button id="add-stat-widget" class="button button-primary">＋ Ajouter un tableau</button>` : "");
    const { data: widgets, error } = await sb.from("saved_stat_widgets").select("*").eq("organization_id", profile.organization_id).order("sort_order", { ascending: true, nullsFirst: false }).order("created_at");
    if (error) throw error;
    content.innerHTML = `
      ${canEdit && widgets.length ? `<div class="help-inline" style="margin-bottom:16px">${helpTip("Glisse-dépose l’icône ⠿ d’un tableau pour réorganiser l’ordre.")}<span class="help-inline-label">À savoir</span></div>` : ""}
      <div id="stat-widgets" class="stat-widgets-list">${!widgets.length ? emptyState("Aucun tableau", "Ajoutez votre premier rapport personnalisé.") : ""}</div>`;
    document.querySelector("#add-stat-widget")?.addEventListener("click", () => statWidgetConfigModal());
    for (const widget of widgets) {
      await renderStatWidgetCard(widget, canEdit);
    }
    if (canEdit && widgets.length) wireDragReorder("#stat-widgets", ".stat-widget-card", async orderedIds => {
      await Promise.all(orderedIds.map((id, idx) => sb.from("saved_stat_widgets").update({ sort_order: idx + 1 }).eq("id", id)));
    });
  }

  async function renderStatWidgetCard(widget, canEdit) {
    const container = document.querySelector("#stat-widgets");
    if (!container) return;
    const card = document.createElement("article");
    card.className = "card stat-widget-card";
    card.dataset.id = widget.id;
    card.draggable = canEdit;
    const categoryInfo = STAT_CATEGORIES[STAT_REPORT_TYPES[widget.report_type]?.category];
    card.innerHTML = `
      <div class="stat-widget-head">
        ${canEdit ? `<span class="drag-handle">⠿</span>` : ""}
        ${categoryInfo ? `<span class="dash-section-badge stat-cat-pill ${categoryInfo.cls}">${categoryInfo.label}</span>` : ""}
        <h3>${escapeHtml(statWidgetTitle(widget))}</h3>
        <div class="view-toggle">
          <button type="button" class="mode-btn ${widget.view_mode !== "chart" ? "active" : ""}" data-mode="table">☰</button>
          <button type="button" class="mode-btn ${widget.view_mode === "chart" ? "active" : ""}" data-mode="chart">📈</button>
        </div>
        ${canEdit ? `<button type="button" class="icon-button icon-small edit-stat-widget" title="Modifier les paramètres">✎</button>` : ""}
        ${canEdit ? `<button type="button" class="icon-button icon-small danger delete-stat-widget">🗑</button>` : ""}
      </div>
      <div class="stat-widget-body"><div class="loading"><div class="spinner"></div>Calcul en cours…</div></div>
    `;
    container.appendChild(card);

    let mode = widget.view_mode === "chart" ? "chart" : "table";
    let result;
    try {
      result = await STAT_COMPUTERS[widget.report_type](widget.filters || {});
    } catch (err) {
      card.querySelector(".stat-widget-body").innerHTML = emptyState("Erreur de calcul", err.message || "");
      return;
    }

    function renderBody() {
      const body = card.querySelector(".stat-widget-body");
      if (mode === "chart") {
        body.innerHTML = result.labels.length ? result.chartFn(result.labels, result.series) : emptyState("Aucune donnée", "");
      } else {
        body.innerHTML = `<div class="table-wrap">${result.table}</div>`;
      }
    }
    renderBody();

    card.querySelectorAll("[data-mode]").forEach(btn => btn.addEventListener("click", async () => {
      mode = btn.dataset.mode;
      card.querySelectorAll("[data-mode]").forEach(b => b.classList.toggle("active", b === btn));
      renderBody();
      await sb.from("saved_stat_widgets").update({ view_mode: mode }).eq("id", widget.id);
    }));
    card.querySelector(".edit-stat-widget")?.addEventListener("click", () => statWidgetConfigModal(widget));
    card.querySelector(".delete-stat-widget")?.addEventListener("click", async () => {
      if (!confirm("Supprimer ce tableau ?")) return;
      const { error } = await sb.from("saved_stat_widgets").delete().eq("id", widget.id);
      if (error) return showError(error);
      card.remove();
    });
  }

  async function statWidgetConfigModal(existingWidget = null) {
    const [recipes, categoriesList, clientCategoriesList, ingredientsList] = await Promise.all([
      sb.from("recipes").select("id,name,recipe_categories(name,sort_order)").eq("organization_id", profile.organization_id).order("name").then(r => r.data || []),
      fetchCategories(),
      fetchClientCategories(),
      sb.from("ingredients").select("id,name").eq("organization_id", profile.organization_id).eq("archived", false).order("name").then(r => r.data || [])
    ]);
    const currentYear = new Date().getFullYear();
    const years = [currentYear, currentYear - 1, currentYear - 2, currentYear - 3];
    const f = existingWidget?.filters || {};
    const isCurrentYearRange = f.from === `${currentYear}-01-01` && f.to === `${currentYear}-12-31`;
    const dateRangeFilterHtml = `
      <div class="checkbox-row span-2"><label class="switch"><input type="checkbox" class="current-year-toggle" ${isCurrentYearRange ? "checked" : ""}><span class="switch-slider"></span></label><span>Année en cours (période complète)</span></div>
      <div><label>Du</label><input name="from" type="date" value="${f.from || `${currentYear}-01-01`}" ${isCurrentYearRange ? "disabled" : ""}></div>
      <div><label>Au</label><input name="to" type="date" value="${f.to || todayISO()}" ${isCurrentYearRange ? "disabled" : ""}></div>
    `;
    const yearCompareFilterHtml = `
      <div><label>Année</label><select name="year">${years.map(y => `<option value="${y}" ${String(f.year) === String(y) ? "selected" : ""}>${y}</option>`).join("")}</select></div>
      <div class="checkbox-row" style="align-self:end"><label class="switch"><input type="checkbox" name="compareLastYear" ${f.compareLastYear === false ? "" : "checked"}><span class="switch-slider"></span></label><span>Comparer avec l’année précédente</span></div>
    `;
    const optionsByCategory = {};
    Object.entries(STAT_REPORT_TYPES).forEach(([key, info]) => {
      if (!optionsByCategory[info.category]) optionsByCategory[info.category] = [];
      optionsByCategory[info.category].push(`<option value="${key}" ${existingWidget?.report_type === key ? "selected" : ""}>${escapeHtml(info.label)}</option>`);
    });

    openModal({
      title: existingWidget ? "Modifier le tableau" : "Ajouter un tableau",
      kicker: "Statistiques",
      width: "620px",
      html: `<form id="stat-widget-form" class="form-grid">
        <div class="span-2"><label>Titre (optionnel)</label><input name="title" placeholder="Nom de ce tableau" value="${escapeHtml(existingWidget?.title || "")}"></div>
        <div class="span-2"><label>Type de rapport *</label><select id="stat-report-type">
          ${Object.entries(optionsByCategory).map(([catKey, opts]) => `<optgroup label="${escapeHtml(STAT_CATEGORIES[catKey].label)}">${opts.join("")}</optgroup>`).join("")}
        </select></div>
        <div id="stat-filters-monthly_revenue" class="span-2 form-grid">${yearCompareFilterHtml}</div>
        <div id="stat-filters-products_sold" class="span-2 form-grid hidden">
          ${dateRangeFilterHtml}
          <div><label>Produit</label><select name="recipeId"><option value="all">Tous les produits</option>${optionsByCategory(recipes, r => r.recipe_categories, r => `<option value="${r.id}" ${f.recipeId === r.id ? "selected" : ""}>${escapeHtml(r.name)}</option>`, r => r.name)}</select></div>
          <div><label>Catégorie</label><select name="categoryId"><option value="all">Toutes les catégories</option>${categoriesList.map(c => `<option value="${c.id}" ${f.categoryId === c.id ? "selected" : ""}>${escapeHtml(c.name)}</option>`).join("")}</select></div>
          <div class="span-2"><label>Mesure</label><select name="metric"><option value="revenue" ${(!f.metric || f.metric === "revenue") ? "selected" : ""}>CA (€)</option><option value="volume" ${f.metric === "volume" ? "selected" : ""}>Volume (quantité)</option><option value="percent" ${f.metric === "percent" ? "selected" : ""}>% du CA</option></select></div>
        </div>
        <div id="stat-filters-revenue_by_client" class="span-2 form-grid hidden">
          ${dateRangeFilterHtml}
          <div class="span-2"><label>Catégorie de client</label><select name="clientCategoryId"><option value="all">Toutes les catégories</option>${clientCategoriesList.map(c => `<option value="${c.id}" ${f.clientCategoryId === c.id ? "selected" : ""}>${escapeHtml(c.name)}</option>`).join("")}</select></div>
        </div>
        <div id="stat-filters-revenue_by_category" class="span-2 form-grid hidden">${dateRangeFilterHtml}</div>
        <div id="stat-filters-revenue_by_client_category" class="span-2 form-grid hidden">${dateRangeFilterHtml}</div>
        <div id="stat-filters-avg_basket" class="span-2 form-grid hidden"><div><label>Année</label><select name="year">${years.map(y => `<option value="${y}" ${String(f.year) === String(y) ? "selected" : ""}>${y}</option>`).join("")}</select></div></div>
        <div id="stat-filters-order_frequency" class="span-2 form-grid hidden">${dateRangeFilterHtml}</div>
        <div id="stat-filters-margin_by_product" class="span-2 form-grid hidden">${dateRangeFilterHtml}</div>
        <div id="stat-filters-margin_by_client" class="span-2 form-grid hidden">${dateRangeFilterHtml}</div>
        <div id="stat-filters-monthly_margin" class="span-2 form-grid hidden">${yearCompareFilterHtml}</div>
        <div id="stat-filters-ingredient_price_evolution" class="span-2 form-grid hidden">
          <div class="span-2"><label>Ingrédient *</label><select name="ingredientId"><option value="">Sélectionner…</option>${ingredientsList.map(i => `<option value="${i.id}" ${f.ingredientId === i.id ? "selected" : ""}>${escapeHtml(i.name)}</option>`).join("")}</select></div>
        </div>
        <div id="stat-filters-spend_by_supplier" class="span-2 form-grid hidden">${dateRangeFilterHtml}</div>
        <div id="stat-filters-production_volume_by_recipe" class="span-2 form-grid hidden">${dateRangeFilterHtml}</div>
        <div id="stat-filters-production_by_location" class="span-2 form-grid hidden">${dateRangeFilterHtml}</div>
        <div id="stat-filters-stock_value_by_location" class="span-2 help-box hidden">Photo du stock actuel, aucune période à choisir.</div>
        <div id="stat-filters-shipping_mode_split" class="span-2 form-grid hidden">${dateRangeFilterHtml}</div>
        <div class="form-actions span-2"><button type="button" class="button button-ghost" data-close-modal>Annuler</button><button class="button button-primary" type="submit">${existingWidget ? "Enregistrer" : "Ajouter"}</button></div>
      </form>`
    });
    modalBody.querySelector("[data-close-modal]").addEventListener("click", closeModal);
    const typeSelect = modalBody.querySelector("#stat-report-type");
    function syncFilterVisibility() {
      Object.keys(STAT_REPORT_TYPES).forEach(key => {
        modalBody.querySelector(`#stat-filters-${key}`).classList.toggle("hidden", typeSelect.value !== key);
      });
    }
    typeSelect.addEventListener("change", syncFilterVisibility);
    syncFilterVisibility();

    modalBody.querySelectorAll(".current-year-toggle").forEach(cb => {
      const block = cb.closest(".form-grid");
      const fromInput = block.querySelector('[name="from"]');
      const toInput = block.querySelector('[name="to"]');
      cb.addEventListener("change", () => {
        if (cb.checked) {
          fromInput.value = `${currentYear}-01-01`;
          toInput.value = `${currentYear}-12-31`;
        }
        fromInput.disabled = cb.checked;
        toInput.disabled = cb.checked;
      });
    });

    modalBody.querySelector("#stat-widget-form").addEventListener("submit", async event => {
      event.preventDefault();
      const reportType = typeSelect.value;
      const scopedForm = modalBody.querySelector(`#stat-filters-${reportType}`);
      const titleValue = modalBody.querySelector('[name="title"]').value;
      const field = name => scopedForm.querySelector(`[name="${name}"]`)?.value;
      let filters = {};
      if (reportType === "monthly_revenue" || reportType === "monthly_margin") {
        filters = { year: field("year"), compareLastYear: scopedForm.querySelector('[name="compareLastYear"]').checked };
      } else if (reportType === "products_sold") {
        filters = { from: field("from"), to: field("to"), recipeId: field("recipeId"), categoryId: field("categoryId"), metric: field("metric") };
      } else if (reportType === "revenue_by_client") {
        filters = { from: field("from"), to: field("to"), clientCategoryId: field("clientCategoryId") };
      } else if (reportType === "avg_basket") {
        filters = { year: field("year") };
      } else if (reportType === "ingredient_price_evolution") {
        if (!field("ingredientId")) return showToast("Choisissez un ingrédient.", "error");
        filters = { ingredientId: field("ingredientId") };
      } else if (reportType === "stock_value_by_location") {
        filters = {};
      } else if (["revenue_by_category", "revenue_by_client_category", "order_frequency", "margin_by_product", "margin_by_client", "spend_by_supplier", "production_volume_by_recipe", "production_by_location", "shipping_mode_split"].includes(reportType)) {
        filters = { from: field("from"), to: field("to") };
      }
      const button = event.submitter; submitButtonLoading(button, true);
      let error;
      if (existingWidget) {
        ({ error } = await sb.from("saved_stat_widgets").update({ title: titleValue.trim() || null, report_type: reportType, filters }).eq("id", existingWidget.id));
      } else {
        const { count } = await sb.from("saved_stat_widgets").select("id", { count: "exact", head: true }).eq("organization_id", profile.organization_id);
        ({ error } = await sb.from("saved_stat_widgets").insert({
          organization_id: profile.organization_id, title: titleValue.trim() || null, report_type: reportType, filters, created_by: session.user.id, sort_order: (count || 0) + 1
        }));
      }
      submitButtonLoading(button, false);
      if (error) return showError(error);
      closeModal(); showToast(existingWidget ? "Tableau mis à jour." : "Tableau ajouté."); renderStatistics();
    });
  }

  // ============================================================
  // Utilisateurs — accès, rôles et invitations (super admin uniquement)
  // ============================================================
  const ACTION_ROLE_LABELS = { admin: "Admin", vente: "Vente", stock: "Stock", production: "Production" };

  async function renderUsers() {
    if (!isSuperAdmin()) {
      content.innerHTML = emptyState("Accès réservé", "Cette page n’est visible que par le super admin.");
      return;
    }
    const [{ data: users, error }, { data: roles, error: rolesError }, { data: invitations }] = await Promise.all([
      sb.rpc("list_organization_users"),
      sb.from("access_roles").select("*").eq("organization_id", profile.organization_id).order("name"),
      sb.rpc("list_pending_invitations")
    ]);
    if (error) throw error;
    if (rolesError) throw rolesError;

    const userRows = (users || []).map(u => `<tr data-searchable>
      <td><strong>${escapeHtml(u.full_name || "—")}</strong></td>
      <td>${escapeHtml(u.email)}</td>
      <td>${u.is_super_admin ? badge("Super admin", "success") : ((u.access_role_names || []).length ? (u.access_role_names || []).map(n => `<span class="ref-badge">${escapeHtml(n)}</span>`).join(" ") : `<span class="muted">Accès complet</span>`)}</td>
      <td><div class="table-actions">
        ${!u.is_super_admin ? `<button class="button button-small button-ghost change-role" data-id="${u.user_id}" data-current="${(u.access_role_ids || []).join(",")}">Changer de rôle</button>` : ""}
        ${!u.is_super_admin ? `<button class="button button-small button-danger revoke-user" data-id="${u.user_id}" data-name="${escapeHtml(u.full_name || u.email)}">Révoquer</button>` : ""}
      </div></td>
    </tr>`).join("");

    const roleRows = (roles || []).map(r => `<div class="lot-row">
      <div class="lot-row-main">
        <div class="lot-row-title">${escapeHtml(r.name)}</div>
        ${permissionSummary(rolePermissions(r))}
        <div class="muted" style="font-size:12.5px">📍 ${(r.allowed_location_ids || []).length ? `${r.allowed_location_ids.length} emplacement(s)` : "Tous les emplacements"}</div>
      </div>
      <div class="lot-row-actions">
        <button class="icon-button icon-small edit-access-role" data-id="${r.id}" title="Modifier">${ICONS.edit}</button>
        <button class="icon-button icon-small danger delete-access-role" data-id="${r.id}" title="Supprimer">${ICONS.trash}</button>
      </div>
    </div>`).join("");

    const inviteRows = (invitations || []).map(i => `<tr data-searchable>
      <td>${escapeHtml(i.email)}</td>
      <td>${(i.access_role_names || []).join(", ") || "Accès complet"}</td>
      <td>${formatDate(i.expires_at?.slice(0, 10))}</td>
      <td><div class="table-actions">
        <button class="button button-small button-secondary copy-invite-link" data-token="${i.token}">Copier le lien</button>
        <button class="icon-button icon-small danger cancel-invite" data-id="${i.id}" data-email="${escapeHtml(i.email)}" title="Annuler l’invitation : le lien ne fonctionnera plus">${ICONS.trash}</button>
      </div></td>
    </tr>`).join("");

    content.innerHTML = `
      <div class="help-inline">${helpTip("Toi seul (super admin) vois cette page. Un utilisateur sans rôle n’a accès à aucune page : attribue-lui au moins un rôle.")}<span class="help-inline-label">À savoir</span></div>

      <div class="form-section-title" style="margin-top:22px">👥 Utilisateurs de l’organisation</div>
      <div class="table-wrap" style="margin-top:12px">${userRows ? `<table><thead><tr><th>Nom</th><th>E-mail</th><th>Accès</th><th></th></tr></thead><tbody>${userRows}</tbody></table>` : emptyState("Aucun utilisateur", "")}</div>

      <div class="form-section-title" style="margin-top:32px">🔑 Rôles d’accès ${helpTip("Un rôle définit, page par page, ce qu’un utilisateur peut voir ou modifier, et sur quels emplacements. Les utilisateurs, les rôles et les invitations restent réservés au super admin.")}</div>
      <div id="access-roles-list" style="margin-top:12px">${roleRows || emptyState("Aucun rôle créé", "")}</div>
      <button type="button" id="add-access-role" class="button button-secondary" style="margin-top:10px">${ICONS.plus} Créer un rôle</button>

      <div class="form-section-title" style="margin-top:32px">✉️ Inviter un utilisateur ${helpTip("Génère un lien à envoyer toi-même par e-mail (l’envoi automatique n’est pas disponible depuis l’application). Le lien expire au bout de 7 jours et ne fonctionne qu’une seule fois, avec l’adresse indiquée.")}</div>
      <form id="invite-form" class="form-grid" style="margin-top:12px">
        <div class="span-2"><label>E-mail *</label><input name="email" type="email" required></div>
        <div class="span-2"><label>Rôles d’accès</label>
          <p class="form-note">Ne coche rien pour un accès complet (comme un compte classique).</p>
          <div class="compat-list">${(roles || []).map(r => `<label class="compat-list-item"><input type="checkbox" name="invite_roles" value="${r.id}"><span>${escapeHtml(r.name)}</span></label>`).join("") || `<span class="muted">Aucun rôle créé</span>`}</div>
        </div>
        <div style="align-self:end"><button type="submit" class="button button-primary button-full">Générer le lien d’invitation</button></div>
      </form>
      <div id="invite-link-result" style="margin-top:12px"></div>

      ${inviteRows ? `<div class="form-section-title" style="margin-top:26px">⏳ Invitations en attente</div>
      <div class="table-wrap" style="margin-top:12px"><table><thead><tr><th>E-mail</th><th>Rôle</th><th>Expire le</th><th></th></tr></thead><tbody>${inviteRows}</tbody></table></div>` : ""}
    `;

    document.querySelector("#add-access-role")?.addEventListener("click", () => accessRoleModal());
    document.querySelectorAll(".edit-access-role").forEach(btn => btn.addEventListener("click", () => accessRoleModal(roles.find(r => r.id === btn.dataset.id))));
    document.querySelectorAll(".delete-access-role").forEach(btn => btn.addEventListener("click", async () => {
      if (!confirm("Supprimer ce rôle ? Les utilisateurs qui l’ont repasseront en accès complet.")) return;
      const { error: delError } = await sb.rpc("delete_access_role", { p_id: btn.dataset.id });
      if (delError) return showError(delError);
      showToast("Rôle supprimé."); renderUsers();
    }));

    document.querySelectorAll(".change-role").forEach(btn => btn.addEventListener("click", () => changeRoleModal(btn.dataset.id, btn.dataset.current, roles)));
    document.querySelectorAll(".revoke-user").forEach(btn => btn.addEventListener("click", async () => {
      if (!confirm(`Révoquer l’accès de ${btn.dataset.name} ? Cette personne perdra immédiatement tout accès à l’application.`)) return;
      const { error: revokeError } = await sb.rpc("revoke_user_access", { p_user_id: btn.dataset.id });
      if (revokeError) return showError(revokeError);
      showToast("Accès révoqué."); renderUsers();
    }));

    document.querySelector("#invite-form").addEventListener("submit", async event => {
      // Gardé dès le départ : après une attente, event.currentTarget ne désigne plus le formulaire
      const inviteForm = event.currentTarget;
      event.preventDefault();
      const button = event.submitter; submitButtonLoading(button, true);
      const values = formObject(event.currentTarget);
      const selectedRoles = [...event.currentTarget.querySelectorAll('input[name="invite_roles"]:checked')].map(el => el.value);
      // Un compte sans rôle n'aurait accès à rien
      if (!selectedRoles.length) { submitButtonLoading(button, false); return showToast("Choisis au moins un rôle pour cette invitation.", "error"); }
      const { data: token, error: inviteError } = await sb.rpc("create_pending_invitation", { p_email: values.email.trim(), p_access_role_ids: selectedRoles });
      submitButtonLoading(button, false);
      if (inviteError) return showError(inviteError);
      const link = `${window.location.origin}${window.location.pathname}?invite=${token}`;
      inviteForm.reset();
      // La page est redessinée pour afficher la nouvelle invitation dans la liste ;
      // le lien est affiché APRÈS, sinon le redessin l'effacerait aussitôt.
      await renderUsers();
      const result = document.querySelector("#invite-link-result");
      if (result) {
        result.innerHTML = `
        <div class="help-box">
          <strong>Lien à envoyer à ${escapeHtml(values.email.trim())} :</strong>
          <div style="display:flex;gap:8px;margin-top:8px"><input readonly value="${escapeHtml(link)}" style="flex:1" onclick="this.select()"><button type="button" id="copy-new-invite" class="button button-secondary">Copier</button></div>
        </div>`;
        document.querySelector("#copy-new-invite").addEventListener("click", () => { navigator.clipboard.writeText(link); showToast("Lien copié."); });
      }
    });

    document.querySelectorAll(".cancel-invite").forEach(btn => btn.addEventListener("click", async () => {
      if (!confirm(`Annuler l’invitation de ${btn.dataset.email} ?\n\nLe lien envoyé ne fonctionnera plus.`)) return;
      const { error: cancelError } = await sb.rpc("cancel_pending_invitation", { p_invitation_id: btn.dataset.id });
      if (cancelError) return showError(cancelError);
      showToast("Invitation annulée.");
      renderUsers();
    }));
    document.querySelectorAll(".copy-invite-link").forEach(btn => btn.addEventListener("click", () => {
      const link = `${window.location.origin}${window.location.pathname}?invite=${btn.dataset.token}`;
      navigator.clipboard.writeText(link);
      showToast("Lien copié.");
    }));
  }

  // Résumé lisible d'une grille : « Modifier : … · Voir : … · Actions : … »
  function permissionSummary(perms) {
    const pick = (v, action) => PERM_PAGES.filter(pg => Boolean(pg.action) === action && perms[pg.key] === v).map(pg => escapeHtml(pg.label));
    const edit = pick("edit", false), view = pick("view", false), actions = pick("edit", true);
    if (!edit.length && !view.length) return `<div class="muted" style="font-size:12.5px">Aucun accès</div>`;
    return `<div class="perm-summary">${edit.length ? `<span><strong>Modifier :</strong> ${edit.join(", ")}</span>` : ""}${view.length ? `<span><strong>Voir :</strong> ${view.join(", ")}</span>` : ""}${actions.length ? `<span><strong>Actions :</strong> ${actions.join(", ")}</span>` : ""}</div>`;
  }

  async function accessRoleModal(role = null) {
    const perms = role ? rolePermissions(role) : {};
    const selectedLocations = new Set(role?.allowed_location_ids || []);
    const allLocations = await fetchLocations(true);
    const option = (pg, value, label) => {
      const on = (perms[pg.key] || "none") === value;
      return `<label class="perm-opt ${on ? "on" : ""}"><input type="radio" name="perm_${pg.key}" value="${value}" ${on ? "checked" : ""}> ${label}</label>`;
    };
    // Trois colonnes alignées : Aucun / Voir / Modifier, ou Non / Oui pour une action
    const options = pg => pg.action
      ? `${option(pg, "none", "Non")}${option(pg, "edit", "Oui")}<span class="perm-opt perm-opt-placeholder"></span>`
      : `${option(pg, "none", "Aucun accès")}${option(pg, "view", "Voir")}${pg.readOnly ? `<span class="perm-opt perm-opt-placeholder"></span>` : option(pg, "edit", "Modifier")}`;
    const rows = PERM_GROUPS.map(group => `
      <div class="perm-group-title">${escapeHtml(group)}</div>
      ${PERM_PAGES.filter(pg => pg.group === group).map(pg => `<div class="perm-row ${pg.action ? "perm-row-action" : ""}">
        <div><strong>${escapeHtml(pg.label)}</strong>${pg.desc ? `<div class="perm-desc">${escapeHtml(pg.desc)}</div>` : ""}</div>
        <div class="perm-opts">${options(pg)}</div>
      </div>`).join("")}`).join("");
    openModal({
      title: role ? "Modifier le rôle" : "Nouveau rôle",
      kicker: "Utilisateurs",
      width: "820px",
      html: `<form id="access-role-form" class="form-grid">
        <div class="span-2"><label>Nom du rôle *</label><input name="name" required value="${escapeHtml(role?.name || "")}" placeholder="Ex : Atelier Nîmes"></div>
        <div class="span-2">${rows}</div>
        <div class="span-2"><div class="form-section-title">Emplacements</div>
          <p class="form-note" style="margin:8px 0 10px">Ne coche rien pour donner accès à tous les emplacements.</p>
          <div class="chips-picker">${allLocations.map(l => `<label class="checkbox-pill"><input type="checkbox" name="locations" value="${l.id}" ${selectedLocations.has(l.id) ? "checked" : ""}> ${escapeHtml(l.name)}</label>`).join("") || `<span class="muted">Aucun emplacement créé</span>`}</div>
        </div>
        <div class="span-2 help-inline">${helpTip("La gestion des utilisateurs, des rôles et des invitations n’apparaît pas ici : elle est réservée au super admin et ne se délègue pas.")}<span class="help-inline-label">À savoir</span></div>
        <div class="form-actions span-2"><button type="button" class="button button-ghost" data-close-modal>Annuler</button><button class="button button-primary" type="submit">Enregistrer</button></div>
      </form>`
    });
    const form = modalBody.querySelector("#access-role-form");
    // La pastille choisie s'allume dans sa ligne
    form.querySelectorAll('input[type="radio"]').forEach(input => input.addEventListener("change", () => {
      input.closest(".perm-opts").querySelectorAll(".perm-opt").forEach(o => o.classList.toggle("on", o.contains(input)));
    }));
    modalBody.querySelector("[data-close-modal]").addEventListener("click", closeModal);
    form.addEventListener("submit", async event => {
      event.preventDefault();
      const button = event.submitter;
      const values = formObject(form);
      const permissions = Object.fromEntries(PERM_PAGES.map(pg => [pg.key, form.querySelector(`input[name="perm_${pg.key}"]:checked`)?.value || "none"]));
      permissions._v = 2;
      if (!PERM_PAGES.some(pg => !pg.action && permissions[pg.key] !== "none")) return showToast("Ce rôle ne donne accès à aucune page : ouvres-en au moins une.", "error");
      const locations = [...form.querySelectorAll('input[name="locations"]:checked')].map(el => el.value);
      submitButtonLoading(button, true);
      const { error } = await sb.rpc("upsert_access_role", {
        p_id: role?.id || null, p_name: values.name.trim(), p_permissions: permissions, p_allowed_location_ids: locations
      });
      submitButtonLoading(button, false);
      if (error) return showError(error);
      closeModal(); showToast("Rôle enregistré."); renderUsers();
    });
  }

  function changeRoleModal(userId, currentRoleIds, roles) {
    const currentSet = new Set((currentRoleIds || "").split(",").filter(Boolean));
    openModal({
      title: "Changer de rôle",
      kicker: "Utilisateurs",
      html: `<form id="change-role-form" class="form-grid">
        <div class="span-2"><label>Rôles d’accès</label>
          <p class="form-note">Ne coche rien pour un accès complet.</p>
          <div class="compat-list">${roles.map(r => `<label class="compat-list-item"><input type="checkbox" name="change_roles" value="${r.id}" ${currentSet.has(r.id) ? "checked" : ""}><span>${escapeHtml(r.name)}</span></label>`).join("") || `<span class="muted">Aucun rôle créé</span>`}</div>
        </div>
        <div class="form-actions span-2"><button type="button" class="button button-ghost" data-close-modal>Annuler</button><button class="button button-primary" type="submit">Enregistrer</button></div>
      </form>`
    });
    modalBody.querySelector("[data-close-modal]").addEventListener("click", closeModal);
    modalBody.querySelector("#change-role-form").addEventListener("submit", async event => {
      event.preventDefault();
      const button = event.submitter; submitButtonLoading(button, true);
      const selectedRoles = [...event.currentTarget.querySelectorAll('input[name="change_roles"]:checked')].map(el => el.value);
      const { error } = await sb.rpc("set_user_access_roles", { p_user_id: userId, p_access_role_ids: selectedRoles });
      submitButtonLoading(button, false);
      if (error) return showError(error);
      closeModal(); showToast("Rôle mis à jour."); renderUsers();
    });
  }
})();